function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import KrpanoWrapper from './krpanoWrapper';
/**
 * VR播放器
 */

var Player = /*#__PURE__*/function () {
  // __pluginPath = 'http://192.168.1.106:5501/dist/plugins/';

  /**
   * 初始化
   * @param {String} krpanoJS 如需使用外部 krpano 地址可在初始化时传入完整路径，默认不传
   * @param {String} baseUrl 如需使用外部资源地址可在初始化时传入完整路径，默认不传
   */
  function Player(krpanoJS, baseUrl) {
    _defineProperty(this, "version", require('../package.json').version);

    _defineProperty(this, "__pluginPath", 'https://ssl-player2.720static.com/krp/1.20.7/plugins/');

    _defineProperty(this, "__skinPath", 'https://ssl-player2.720static.com/krp/1.19-pr16/skin/');

    _defineProperty(this, "__mediaPath", 'https://ssl-media.720static.com/@');

    _defineProperty(this, "__sysMediaPath", 'https://ssl-static2.720static.com');

    _defineProperty(this, "debug", global.window.panoPlayerDebug);

    _defineProperty(this, "type", 0);

    _defineProperty(this, "firstLoad", true);

    _defineProperty(this, "callbacks", undefined);

    _defineProperty(this, "snapshootImageType", 'png');

    _defineProperty(this, "snapshootImageQuality", 0.8);

    _defineProperty(this, "blendModes", ['OPENBLEND(0.5, 0.0, 0.75, 0.05, linear)', 'ZOOMBLEND(2.0, 2.0, easeInOutSine)', 'COLORBLEND(2.0, 0x000000, easeOutSine)', 'LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)', 'SLIDEBLEND(1.0, 0.0, 0.2, linear)', 'SLIDEBLEND(1.0, 135.0, 0.4, linear)', 'OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)', 'OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)', 'OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)']);

    _defineProperty(this, "onPlayerReady", undefined);

    _defineProperty(this, "onIdleCallback", undefined);

    _defineProperty(this, "onUserInteractiveCallback", undefined);

    _defineProperty(this, "needRemove", false);

    _defineProperty(this, "initEnableControlSet", false);

    _defineProperty(this, "hotspotEvents", {
      'moving': {},
      'click': {},
      'moveEnd': {},
      'moveBegan': {},
      'over': {},
      'out': {},
      'down': {},
      'up': {}
    });

    _defineProperty(this, "hotspotClickDelay", false);

    _defineProperty(this, "lineEvents", {
      'moving': {},
      'click': {},
      'moveEnd': {},
      'moveBegan': {}
    });

    _defineProperty(this, "__contorlModeEnabled", true);

    _defineProperty(this, "autoRotateId", '');

    _defineProperty(this, "videoVolume", 0);

    _defineProperty(this, "__viewType", 0);

    _defineProperty(this, "flatFovMax", 1);

    _defineProperty(this, "lensflareData", {});

    KrpanoWrapper.prototype.customKrpanoJS = krpanoJS;

    if (krpanoJS != undefined) {
      this.__pluginPath = krpanoJS.substring(0, krpanoJS.lastIndexOf('/')) + '/plugins/';
      this.__skinPath = krpanoJS.substring(0, krpanoJS.lastIndexOf('/')) + '/skin/';
      this.__sysMediaPath = krpanoJS.substring(0, krpanoJS.lastIndexOf('/'));
    }

    if (baseUrl) {
      this.__mediaPath = baseUrl;
    }
  }

  var _proto = Player.prototype;

  // __snowPlugin = this.__pluginPath + "snow.js";
  // __lensFlarePlugin = "http://127.0.0.1:5501/dist/plugins/lensflarewase";
  _proto.__krpanoExtraXML = function __krpanoExtraXML() {
    return '' + '' + '';
  }
  /**
   * 当前加载类型
   * @description 0全景图片 1全景视频 2矩阵
   */
  ;

  _proto.onIdle = function onIdle() {
    var _this = this;

    if (this.type == 2 && this.krpanoWrapper.autoRotateEnabled) {
      this.autoRotateId = setTimeout(function () {
        _this.callbacks.onAutoRotateOneRound();
      }, this.krpanoWrapper.autoRotateDuration * 1000);
    }

    this.callbacks['onIdle'] && this.callbacks['onIdle']();
  };

  _proto.onUserInteractive = function onUserInteractive() {
    this.stopLookTo();
    this.callbacks['onUserInteractive'] && this.callbacks['onUserInteractive']();
  }
  /**
   * 播放器准备完成回调
   */
  ;

  _proto.toAppScheme = function toAppScheme(url) {
    return url;
  }
  /**
   * 创建播放器
   * @param {string} target - 页面 div id
   * @param {Object} callbacks - 注册回调
   * @param {function} callbacks.onSceneChange - 场景切换回调
   * @param {function} callbacks.onSceneReady - 场景开始显示时回调
   * @param {function} callbacks.onSceneInitComplete - 场景初始化完成回调
   * @param {function} callbacks.onAnimationComplete - 开场动画播放完成回调。加载内容时，没有动画也会调用，可用来显示 UI。
   * @param {function} callbacks.onPlayCustomAnimationComplete - 动画播放完成回调
   * @param {function} callbacks.onLoadComplete - 全景加载完成回调
   * @param {function} callbacks.onPlayerClick ({ath, atv}) - 全景点击回调
   * @param {function} callbacks.onMouseDown ({ath, atv}) - 鼠标按下回调
   * @param {function} callbacks.onMouseUp ({ath, atv}) - 鼠标放开回调
   * @param {function} callbacks.onPlayerSingleClick ({ath, atv}) - 全景单击回调
   * @param {function} callbacks.onPlayerDoubleClick ({ath, atv}) - 全景双击回调
   * @param {function} callbacks.onAutoRotateOneRound - 自动旋转完一圈回调
   * @param {function} callbacks.onSnapshootComplete - 截图完成，第一个参数是图片的数据
   * @param {function} callbacks.onSnapshootError - 截图错误
   * @param {function} callbacks.onVideoReady - 视频准备完成回调
   * @param {function} callbacks.onVideoPlay - 视频开始播放回调
   * @param {function} callbacks.onVideoPaused - 视频暂停回调
   * @param {function} callbacks.onVideoComplete - 视频播放完成回调
   * @param {function} callbacks.onVideoError - 视频出错回调
   * @param {function} callbacks.onHotspotVideoReady ({id}) - 视频热点准备完成回调
   * @param {function} callbacks.onHotspotVideoPlay ({id}) - 视频热点开始播放回调
   * @param {function} callbacks.onHotspotVideoPaused ({id}) - 视频热点暂停回调
   * @param {function} callbacks.onHotspotVideoComplete ({id}) - 视频热点播放完成回调
   * @param {function} callbacks.onHotspotVideoError ({id}) - 视频热点出错回调
   * @param {function} callbacks.onLayerVideoReady ({id}) - 视频贴片准备完成回调
   * @param {function} callbacks.onLayerVideoPlay ({id}) - 视频贴片开始播放回调
   * @param {function} callbacks.onLayerVideoPaused ({id}) - 视频贴片暂停回调
   * @param {function} callbacks.onLayerVideoComplete ({id}) - 视频贴片播放完成回调
   * @param {function} callbacks.onLayerVideoError ({id}) - 视频贴片出错回调 
   * @param {function} callbacks.onHotspotLoaded ({id}) - 热点加载完成回调
   * @param {function} callbacks.onHotspotClick ({id}) - 热点点击回调
   * @param {function} callbacks.onHotspotOver ({id}) - 鼠标移入热点回调
   * @param {function} callbacks.onHotspotHover ({id}) - 热点悬停回调
   * @param {function} callbacks.onHotspotOut ({id}) - 鼠标移出热点回调
   * @param {function} callbacks.onHotspotDown ({id}) - 鼠标在热点上按下回调
   * @param {function} callbacks.onHotspotUp ({id}) - 鼠标在热点上放开回调
   * @param {function} callbacks.onHotspotMoveBegan ({id}) - 热点开始被拖动
   * @param {function} callbacks.onHotspotMoving ({id, ath, atv}) - 热点拖动时回调
   * @param {function} callbacks.onHotspotMoveEnd ({id}) - 热点结束拖动
   * @param {function} callbacks.onHotspotPointClick ({id,index}) - 多边形热点锚点被点击，index 为锚点索引
   * @param {function} callbacks.onHotspotPointMoveBegan ({id,index}) - 多边形热点开始被拖动
   * @param {function} callbacks.onHotspotPointMoveEnd ({id,index}) - 多边形热点结束拖动
   * @param {function} callbacks.onVrAvailable - VR 模式可用回调
   * @param {function} callbacks.onVrUnavailable - VR 模式不可用回调
   * @param {function} callbacks.onEnterVr(success) - 进入 VR 模式成功/失败回调
   * @param {function} callbacks.onExitVr - 退出 VR 模式回调
   * @param {function} callbacks.onIdle - 无用户交互 idleTime 后触发
   * @param {function} callbacks.onUserInteractive - 有用户交互时触发
   * @param {function} callbacks.onViewChanged - 视角发生改变时调用
   * @param {function} callbacks.onViewChange - 视角将要发生改变时调用
   * @param {function} callbacks.onOpenReport - 举报按钮点击时调用
   * @param {function} callbacks.onFullscreen - 全屏按钮点击时调用
   * @param {function} callbacks.onFlatFovChanged(fovmax, fovmin) - 矩阵 fovmax fovmin 会根据不同图片有不同， 值更新后进行回调
   * @param {function} onPlayerReady - 播放器准备完成回调
   * @param {Object} extend - 注册回调
   * @param {bool} extend.enableSnapshoot - 是否打开截图功能，截图功能会对喜能产生影响，默认关闭
   * @param {string} extend.backgroundColor - 全景渲染区域背景色, 默认'#000000', 需要透明则用 wmode = transparent
   * @param {string} extend.wmode - window,opaque,opaque-flash,transparent, transparent-flash, direct 详见 https://krpano.com/docu/html/#wmode
   * @param {bool} extend.lensFlareEnable - 是否开启镜头光晕效果，默认开启
   * @param {bool} extend.customAnimationEnable - 是否开启自定义动画
   * @description 创建一个 Player 实例，然后调用 createPlayer 在目标 div 中创建播放器。
   */
  ;

  _proto.createPlayer = function createPlayer(target, callbacks, onPlayerReady, extend) {
    if (this.debug) {
      console.log('create player target:');
      console.log(target);
      console.log(' callbacks: ');
      console.log(callbacks);
      console.log('onPlayerReady: ');
      console.log(onPlayerReady);
      console.log('extend: ');
      console.log(extend);
    }

    if (global.window.isAlertChanged != true) {
      global.window.originAlert = global.window.alert;

      global.window.alert = function (msg) {
        console.log(msg);

        if (msg != 'ERROR: No Embedding Target') {
          global.window.originAlert(msg);
        } else {
          console.log(msg);
        }
      };

      global.window.isAlertChanged = true;
    }

    this.id = target;
    this.target = target;
    this.onPlayerReady = onPlayerReady;
    this.callbacks = callbacks || {};
    this.extend = extend;

    if (extend == true || extend == false) {
      this.enableSnapshoot = extend || false;
    } else if (extend != undefined) {
      this.enableSnapshoot = extend.enableSnapshoot || false;
      this.backgroundColor = extend.backgroundColor || '#000000';
    }

    KrpanoWrapper.prototype.embedKrp(target, this.enableSnapshoot, this.backgroundColor, extend && extend.wmode, this.krpanoWrapperReady.bind(this), extend && extend.lensFlareEnable === false ? undefined : this.__lensFlarePlugin);
  };

  _proto.krpanoWrapperReady = function krpanoWrapperReady(krpanoWrapper) {
    if (this.debug) {
      console.log('krpanoWrapperReady');
    }

    if (global.window.panoPlayers == undefined) {
      global.window.panoPlayers = {};
    }

    global.window.panoPlayers[this.id] = this;
    this.krpanoWrapper = krpanoWrapper;

    if (this.needRemove) {
      this.removePlayer();
      return;
    }

    this._setupContextMenu();

    this.controlMode({
      mouse: 'moveto',
      touch: 'drag'
    });
    this.enableKeyboardControlMode();
    this.setIdleTime(3);
    this.krpanoWrapper.autorotate.waittime = 3;

    if (this.onPlayerReady !== undefined) {
      this.onPlayerReady();
    }

    this.updateView({
      fovtype: 'MFOV'
    });

    if (this.callbacks) {
      this.krpanoWrapper.events['onClick'] = this.callbacks['onPlayerClick'];
      this.krpanoWrapper.events['onMouseUp'] = this.callbacks['onMouseUp'];
      this.krpanoWrapper.events['onMouseDown'] = this.callbacks['onMouseDown'];
      this.krpanoWrapper.events['onSingleClick'] = this.callbacks['onPlayerSingleClick'];
      this.krpanoWrapper.events['onDoubleClick'] = this.callbacks['onPlayerDoubleClick'];
      var that = this;

      this.krpanoWrapper.events['onAutoRotateOneRound'] = function () {
        if (this.debug) {
          console.log("one round");
        }

        that.callbacks['onAutoRotateOneRound']();
      };

      this.krpanoWrapper.events['onVideoReady'] = this.callbacks['onVideoReady'];
      this.krpanoWrapper.events['onVideoPlay'] = this.callbacks['onVideoPlay'];
      this.krpanoWrapper.events['onVideoPaused'] = this.callbacks['onVideoPaused'];
      this.krpanoWrapper.events['onVideoComplete'] = this.callbacks['onVideoComplete'];
      this.krpanoWrapper.events['onVideoError'] = this.callbacks['onVideoError'];
      this.krpanoWrapper.events['onOpenReport'] = this.callbacks['onOpenReport'];
      this.krpanoWrapper.events['onFullscreen'] = this.callbacks['onFullscreen'];
      this.krpanoWrapper.events['onHotspotVideoReady'] = this.callbacks['onHotspotVideoReady'];
      this.krpanoWrapper.events['onHotspotVideoPlay'] = this.callbacks['onHotspotVideoPlay'];
      this.krpanoWrapper.events['onHotspotVideoPaused'] = this.callbacks['onHotspotVideoPaused'];
      this.krpanoWrapper.events['onHotspotVideoComplete'] = this.callbacks['onHotspotVideoComplete'];
      this.krpanoWrapper.events['onHotspotVideoError'] = this.callbacks['onHotspotVideoError'];
      this.krpanoWrapper.events['onLayerVideoReady'] = this.callbacks['onLayerVideoReady'];
      this.krpanoWrapper.events['onLayerVideoPlay'] = this.callbacks['onLayerVideoPlay'];
      this.krpanoWrapper.events['onLayerVideoPaused'] = this.callbacks['onLayerVideoPaused'];
      this.krpanoWrapper.events['onLayerVideoComplete'] = this.callbacks['onLayerVideoComplete'];
      this.krpanoWrapper.events['onLayerVideoError'] = this.callbacks['onLayerVideoError'];
      this.krpanoWrapper.events['onSnapshootComplete'] = this.callbacks['onSnapshootComplete'];
      this.krpanoWrapper.events['onVrAvailable'] = this.callbacks['onVrAvailable'];
      this.krpanoWrapper.events['onVrUnavailable'] = this.callbacks['onVrUnavailable'];
      this.krpanoWrapper.events['onEnterVr'] = this.callbacks['onEnterVr'];
      this.krpanoWrapper.events['onExitVr'] = this.callbacks['onExitVr'];
      this.krpanoWrapper.events['onPreviewComplete'] = this._onPreviewComplete.bind(this);
      this.krpanoWrapper.events['onLoadComplete'] = this._onLoadComplete.bind(this); //this.callbacks['onLoadComplete'];

      this.krpanoWrapper.events['onFlatFovChanged'] = this.callbacks['onFlatFovChanged'];
      this.krpanoWrapper.events['onViewChanged'] = this.callbacks['onViewChanged'];
      this.krpanoWrapper.events['onViewChange'] = this.callbacks['onViewChange'];
      this.krpanoWrapper.events['onControlModeChanged'] = this.callbacks['onControlModeChanged'];
      this.krpanoWrapper.events['onHotspotMoving'] = this.onHotspotMoving.bind(this);
      this.krpanoWrapper.events['onHotspotClick'] = this.onHotspotClick.bind(this);
      this.krpanoWrapper.events['onHotspotUp'] = this.onHotspotUp.bind(this);
      this.krpanoWrapper.events['onHotspotDown'] = this.onHotspotDown.bind(this);
      this.krpanoWrapper.events['onHotspotOver'] = this.onHotspotOver.bind(this);
      this.krpanoWrapper.events['onHotspotOut'] = this.onHotspotOut.bind(this);
      this.krpanoWrapper.events['onHotspotMoveEnd'] = this.onHotspotMoveEnd.bind(this);
      this.krpanoWrapper.events['onHotspotMoveBegan'] = this.onHotspotMoveBegan.bind(this);
      this.krpanoWrapper.events['onMouseDown'] = this.onUserInteractive.bind(this); // this.callbacks['onUserInteractive'];

      this.krpanoWrapper.events['onMouseWheel'] = this.onUserInteractive.bind(this); // this.callbacks['onUserInteractive'];
    }

    this.krpanoWrapper.events['onIdle'] = this.onIdle.bind(this);
    this.krpanoWrapper.set('display.loadwhilemoving', true);
    this.krpanoWrapper.set('__skinPath', this.__skinPath);
    this.krpanoWrapper.set('__pluginPath', this.__pluginPath);

    if (this.krpanoWrapper.get('browser.useragent').includes('MicroMessenger') && !this.krpanoWrapper.get('device.android')) {
      this.krpanoWrapper.set('device.wechat', true);
    }

    if (this.krpanoWrapper.get('browser.useragent').includes('AppleWebKit') && !this.krpanoWrapper.get('browser.useragent').includes('Android')) {// 只在 安卓 app 中打开
      // this.krpanoWrapper.set('device.ioswebkit', true);
    } // let callbackKeys = {
    //     'onPlayerClick': 'onClick',
    //     'onMouseUp': 'onMouseUp',
    //     'onMouseDown': 'onMouseDown',
    //     'onPlayerSingleClick': 'onSingleClick',
    //     'onPlayerDoubleClick': 'onDoubleClick',
    //     'onAutoRotateOneRound': 'onAutoRotateOneRound',
    //     'onVideoReady': 'onVideoReady',
    //     'onVideoPlay': 'onVideoPlay',
    //     'onVideoPaused': 'onVideoPaused',
    //     'onVideoComplete': 'onVideoComplete',
    //     'onVideoError': 'onVideoError',
    //     'onHotspotVideoReady': 'onHotspotVideoReady',
    //     'onHotspotVideoPlay': 'onHotspotVideoPlay',
    //     'onHotspotVideoPaused': 'onHotspotVideoPaused',
    //     'onHotspotVideoComplete': 'onHotspotVideoComplete',
    //     'onHotspotVideoError': 'onHotspotVideoError',
    //     'onSnapshootComplete': 'onSnapshootComplete',
    //     'onVrAvailable': 'onVrAvailable',
    //     'onVrUnavailable': 'onVrUnavailable',
    //     'onEnterVr': 'onEnterVr',
    //     'onExitVr': 'onExitVr',
    //     'onSceneReady': 'onPreviewComplete'
    // }
    // for (const key in callbackKeys) {
    //     if (callbackKeys.hasOwnProperty(key)) {
    //         const property = callbackKeys[key];
    //         var that = this;
    //         Object.defineProperty(this.callbacks, key, {
    //             get: function() {
    //                 return that.krpanoWrapper.events[property];
    //             },
    //             set: function(value) {
    //                 console.log(`add callbacks ${key}`, value);
    //                 that.krpanoWrapper.events[property] = value;
    //             },
    //         });
    //     }
    // };
    // let callbackHotspotKeys = {
    //     'onHotspotLoaded': 'onLoaded',
    //     'onHotspotClick': 'onClick',
    //     'onHotspotOver': 'onOver',
    //     'onHotspotOut': 'onOut',
    //     'onHotspotDown': 'onDown',
    //     'onHotspotUp': 'onUp',
    // }
    // for (const key in callbackHotspotKeys) {
    //     if (callbackHotspotKeys.hasOwnProperty(key)) {
    //         const property = callbackHotspotKeys[key];
    //         var that = this;
    //         Object.defineProperty(this.callbacks, key, {
    //             get: function() {
    //                 for (const key in that.krpanoWrapper.hotspots) {
    //                     let hotspot = that.getHotspotById(key);
    //                     if (hotspot) {
    //                         return hotspot.events[property]
    //                     }
    //                 }
    //                 return undefined;
    //             },
    //             set: function(value) {
    //                 for (const key in that.krpanoWrapper.hotspots) {
    //                     let hotspot = that.getHotspotById(key);
    //                     if (hotspot) {
    //                         hotspot.events[property] = value;
    //                     }
    //                 }
    //             },
    //         });
    //     }
    // };


    if (this.get('plugin[video]') == null) {
      this.krpanoWrapper.call("\n                addplugin(video);\n                set(plugin[video].keep, true);\n                set(plugin[video].url, " + this.__videoPlugin + ");\n                set(plugin[video].pausedonstart, false);\n                set(plugin[video].html5preload, metadata);\n                set(plugin[video].x5-video-player-fullscreen,true);\n                set(plugin[video].devices, panovideosupport);\n                set(plugin[video].onvideoready, jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoReady();window.players['" + this.krpanoWrapper.id + "'].events.onPreviewComplete(););\"';\n                set(plugin[video].onvideoplay, jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoPlay(););\"';\n                set(plugin[video].onvideopaused, jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoPaused(););\"';\n                set(plugin[video].onvideocomplete, jscall(if(window.players['" + this.krpanoWrapper.id + "'].events.onVideoComplete){window.players['" + this.krpanoWrapper.id + "'].events.onVideoComplete();};);\"';\n                set(plugin[video].onerror, jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoError(););\"';\n            ");
    }
  };

  _proto._setupContextMenu = function _setupContextMenu() {
    this.krpanoWrapper.call('set(contextmenu.fullscreen, false);');
    this.krpanoWrapper.call('set(contextmenu.versioninfo, false);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodedrag].caption, 切换拖拽方式为正向);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodedrag].enabled, true);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodedrag].visible, true);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodedrag].showif, device.desktop);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodedrag].onclick, set(control.mouse,drag);set(contextmenu.item[controlmodedrag].visible,false);set(contextmenu.item[controlmodemoveto].visible,true); jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onControlModeChanged({mouse: "drag"});););');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodemoveto].caption, 切换拖拽方式为反向);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodemoveto].enabled, true);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodemoveto].visible, false);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodemoveto].showif, device.desktop);');
    this.krpanoWrapper.call('set(contextmenu.item[controlmodemoveto].onclick, set(control.mouse,moveto);set(contextmenu.item[controlmodedrag].visible,true);set(contextmenu.item[controlmodemoveto].visible,false); jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onControlModeChanged({mouse: "moveto"});););');
    this.krpanoWrapper.call('set(contextmenu.item[fullscreen].caption, 全屏);');
    this.krpanoWrapper.call('set(contextmenu.item[fullscreen].enabled, true);');
    this.krpanoWrapper.call('set(contextmenu.item[fullscreen].visible, false);');
    this.krpanoWrapper.call('set(contextmenu.item[fullscreen].showif, device.desktop);');
    this.krpanoWrapper.call("set(contextmenu.item[fullscreen].onclick, jscall(\"window.players['" + this.krpanoWrapper.id + "'].events.onFullscreen();\"););");
    this.krpanoWrapper.call('set(contextmenu.item[report].caption, 举报);');
    this.krpanoWrapper.call('set(contextmenu.item[report].enabled, true);');
    this.krpanoWrapper.call('set(contextmenu.item[report].visible, false);');
    this.krpanoWrapper.call("set(contextmenu.item[report].onclick, jscall(\"window.players['" + this.krpanoWrapper.id + "'].events.onOpenReport();\"););");
  };

  _proto._onLoadComplete = function _onLoadComplete() {
    if (this.debug) {
      console.log("onLoadComplete");
    }

    if (this.callbacks['onLoadComplete']) {
      this.callbacks['onLoadComplete'](this.partnerId, this.sceneId);
    }

    if (this.sceneReady == true) {
      return;
    }

    this._onPreviewComplete();
  };

  _proto._onPreviewComplete = function _onPreviewComplete() {
    var _this2 = this;

    if (this.debug) {
      console.log("onPreviewComplete, type " + this.type + ", isVideoReady " + this.krpanoWrapper.get('plugin[video].isvideoready'));
    }

    if (this.debug) {
      console.log(this.krpanoWrapper.view['fov'], this.krpanoWrapper.view['fovmin'], this.krpanoWrapper.view['fovmax']);
    }

    if (this.type == 1 && this.krpanoWrapper.get('plugin[video].isvideoready') != true) {
      setTimeout(function () {
        _this2._onPreviewComplete();
      }, 500);
      return;
    }

    if (this.sceneReady == true) {
      return;
    }

    if (this.type == 2 && this.flatFovView !== true) {
      setTimeout(function () {
        _this2._onPreviewComplete();
      }, 100);
      return;
    }

    if (this.debug) {
      console.log("onPreviewComplete pass");
    }

    if (this.callbacks['onSceneReady']) {
      this.callbacks['onSceneReady'](this.partnerId, this.sceneId);
    }

    if (this.type == 2) {
      this.initFlatAnimation();
    } else {
      this.initPanoAnimation();
    }

    this.sceneReady = true;
  }
  /**
   * 清空当前内容
   */
  ;

  _proto.clearPlayer = function clearPlayer() {
    if (this.debug) {
      console.log('clearPlayer', this.id);
    }

    this.krpanoWrapper && (this.krpanoWrapper.display.autofullscreen = false);
    this && this.hideVideo();
    this && this.call("loadxml('<krpano></krpano>');");
  }
  /**
   * 添加回调
   * @param {string} eventType - 事件类型, 有效值 'onPlayerClick' | 'onMouseUp' | 'onMouseDown' | 'onPlayerSingleClick' | 'onPlayerDoubleClick' | 'onIdle' | 'onUserInteractive'
   * @param {function} callback - 回调事件函数, 
   */
  ;

  _proto.addEventListener = function addEventListener(eventType, callback) {
    switch (eventType) {
      case 'onPlayerClick':
        this.callbacks['onPlayerClick'] = callback;
        this.krpanoWrapper.events['onClick'] = callback;
        break;

      case 'onMouseUp':
        this.callbacks['onMouseUp'] = callback;
        this.krpanoWrapper.events['onMouseUp'] = callback;
        break;

      case 'onMouseDown':
        this.callbacks['onMouseDown'] = callback;
        this.krpanoWrapper.events['onMouseDown'] = callback;
        break;

      case 'onPlayerSingleClick':
        this.callbacks['onPlayerSingleClick'] = callback;
        this.krpanoWrapper.events['onSingleClick'] = callback;
        break;

      case 'onPlayerDoubleClick':
        this.callbacks['onPlayerDoubleClick'] = callback;
        this.krpanoWrapper.events['onDoubleClick'] = callback;
        break;

      case 'onIdle':
        this.onIdleCallback = this.callbacks['onIdle'];
        this.callbacks['onIdle'] = callback;
        break;

      case 'onUserInteractive':
        this.onUserInteractiveCallback = this.callbacks['onUserInteractive'];
        this.callbacks['onUserInteractive'] = callback;
        break;

      default:
        break;
    }
  }
  /**
   * 添加回调
   * @param {string} eventType - 事件类型
   * @param {function} callback - 回调事件函数, 
   */
  ;

  _proto.removeEventListener = function removeEventListener(eventType, callback) {
    switch (eventType) {
      case 'onPlayerClick':
        delete this.callbacks['onPlayerClick'];
        this.krpanoWrapper.events['onClick'] = this.callbacks['onPlayerClick'];
        break;

      case 'onMouseUp':
        delete this.callbacks['onMouseUp'];
        this.krpanoWrapper.events['onMouseUp'] = this.callbacks['onMouseUp'];
        break;

      case 'onMouseDown':
        delete this.callbacks['onMouseDown'];
        this.krpanoWrapper.events['onMouseDown'] = this.callbacks['onMouseDown'];
        break;

      case 'onPlayerSingleClick':
        delete this.callbacks['onPlayerSingleClick'];
        this.krpanoWrapper.events['onSingleClick'] = this.callbacks['onPlayerSingleClick'];
        break;

      case 'onPlayerDoubleClick':
        delete this.callbacks['onPlayerDoubleClick'];
        this.krpanoWrapper.events['onDoubleClick'] = this.callbacks['onPlayerDoubleClick'];
        break;

      case 'onIdle':
        this.callbacks['onIdle'] = this.onIdleCallback;
        this.onIdleCallback = undefined;
        break;

      case 'onUserInteractive':
        this.callbacks['onUserInteractive'] = this.onUserInteractiveCallback;
        this.onUserInteractiveCallback = undefined;
        break;

      default:
        break;
    }
  }
  /**
   * 移除播放器
   */
  ;

  _proto.removePlayer = function removePlayer() {
    if (this.debug) {
      console.log('removePlayer', this.id);
    }

    this.clearPlayer();
    this.removeAllHotspots();
    this.callbacks = undefined;
    this.onPlayerReady = undefined;
    global.window.panoPlayers[this.id] = undefined;

    if (this.krpanoWrapper == undefined) {
      this.needRemove = true;
      return;
    }

    this.krpanoWrapper && this.krpanoWrapper.krpano && this.krpanoWrapper.unload && this.krpanoWrapper.krpano.unload();
    this.krpanoWrapper.removePlayer(this.target);
  }
  /**
   * 打开/关闭播放器内日志显示
   * @param {bool} toggle - true打开，false关闭
   */
  ;

  _proto.showLog = function showLog(toggle) {
    this.krpanoWrapper.showLog(toggle);
  };

  _proto.showFPS = function showFPS(toggle) {
    if (toggle) {
      this.krpanoWrapper.call("\n            setinterval(fps_plugin, 0.5,\n                showlog();\n                calc(fps_value, 'FPS: ' + ((display.currentfps+0.5) BOR 0));\n                trace(fps_value);\n            );\n            ");
    } else {
      this.krpanoWrapper.call("\n            clearinterval(fps_plugin);\n            showlog(false);\n        ");
    }
  };

  _proto.call = function call(action) {
    this.krpanoWrapper.call("\n            " + action + "\n            ");
  }
  /**
   * 设置无操作时开始自动播放的延迟时间
   * @param {Number} idleTime - 秒为单位，默认为3
   */
  ;

  _proto.setIdleTime = function setIdleTime(idleTime) {
    if (this.debug) {
      console.log('setIdleTime', idleTime);
    }

    this.krpanoWrapper.idletime = idleTime;
  }
  /**
   * 获取无操作时开始自动播放的延迟时间，单位秒
   */
  ;

  _proto.getIdleTime = function getIdleTime() {
    if (this.debug) {
      console.log('getIdleTime', this.krpanoWrapper.idletime);
    }

    return this.krpanoWrapper.idletime;
  };

  /**
   * 打开/关闭播放器操作
   * @param {bool} toggle - true打开，false关闭
   */
  _proto.enableControl = function enableControl(toggle) {
    if (this.debug) {
      console.log('enableControl', toggle);
    }

    this.initEnableControlSet = true;
    this.krpanoWrapper.control.usercontrol = toggle ? 'all' : 'off';
  }
  /**
   * 打开/关闭拖动回弹效果
   * @param {bool} toggle - true打开，false关闭
   */
  ;

  _proto.enableBouncing = function enableBouncing(toggle) {
    if (this.debug) {
      console.log('bouncinglimits', toggle);
    }

    this.krpanoWrapper.control.bouncinglimits = toggle;
  };

  _proto.onHotspotMoving = function onHotspotMoving(_ref) {
    var id = _ref.id,
        ath = _ref.ath,
        atv = _ref.atv;

    if (this.debug) {
      console.log('onHotspotMoving', id);
    }

    if (this.hotspotEvents['moving'] && this.hotspotEvents['moving'][id]) {
      this.hotspotEvents['moving'][id]({
        id: id,
        ath: ath,
        atv: atv
      });
    } else if (this.callbacks['onHotspotMoving']) {
      this.callbacks['onHotspotMoving']({
        id: id,
        ath: ath,
        atv: atv
      });
    }
  };

  _proto.onHotspotClick = function onHotspotClick(_ref2) {
    var _this3 = this;

    var id = _ref2.id;

    if (this.debug) {
      console.log('onHotspotClick', id);
    }

    if (this.hotspotClickDelay) {
      return;
    }

    this.hotspotClickDelay = true;
    setTimeout(function () {
      _this3.hotspotClickDelay = false;
    }, 200);
    var hotspot = this.getHotspotById(id);
    var targetId = hotspot.clickTargetId;

    if (targetId && this.hotspotEvents['click'] && this.hotspotEvents['click'][targetId]) {
      this.hotspotEvents['click'][targetId]({
        id: targetId
      });
      return;
    } else if (targetId && this.callbacks['onHotspotClick']) {
      this.callbacks['onHotspotClick']({
        id: targetId
      });
      return;
    }

    if (this.hotspotEvents['click'] && this.hotspotEvents['click'][id]) {
      this.hotspotEvents['click'][id]({
        id: id
      });
    } else if (this.callbacks['onHotspotClick']) {
      this.callbacks['onHotspotClick']({
        id: id
      });
    }
  };

  _proto.onHotspotOver = function onHotspotOver(_ref3) {
    var id = _ref3.id;

    if (this.hotspotEvents['over'] && this.hotspotEvents['over'][id]) {
      this.hotspotEvents['over'][id]({
        id: id
      });
    } else if (this.callbacks['onHotspotOver']) {
      this.callbacks['onHotspotOver']({
        id: id
      });
    }
  };

  _proto.onHotspotOut = function onHotspotOut(_ref4) {
    var id = _ref4.id;

    if (this.hotspotEvents['out'] && this.hotspotEvents['out'][id]) {
      this.hotspotEvents['out'][id]({
        id: id
      });
    } else if (this.callbacks['onHotspotOut']) {
      this.callbacks['onHotspotOut']({
        id: id
      });
    }
  };

  _proto.onHotspotDown = function onHotspotDown(_ref5) {
    var id = _ref5.id;

    if (this.hotspotEvents['down'] && this.hotspotEvents['down'][id]) {
      this.hotspotEvents['down'][id]({
        id: id
      });
    } else if (this.callbacks['onHotspotDown']) {
      this.callbacks['onHotspotDown']({
        id: id
      });
    }
  };

  _proto.onHotspotUp = function onHotspotUp(_ref6) {
    var id = _ref6.id;

    if (this.hotspotEvents['up'] && this.hotspotEvents['up'][id]) {
      this.hotspotEvents['up'][id]({
        id: id
      });
    } else if (this.callbacks['onHotspotUp']) {
      this.callbacks['onHotspotUp']({
        id: id
      });
    }
  };

  _proto.onHotspotMoveBegan = function onHotspotMoveBegan(_ref7) {
    var id = _ref7.id,
        ath = _ref7.ath,
        atv = _ref7.atv;
    var hotspot = this.getHotspotById(id);

    if (hotspot.isLine) {
      this.onLineMoveBegan({
        id: id
      });
      return;
    }

    if (this.hotspotEvents['moveBegan'] && this.hotspotEvents['moveBegan'][id]) {
      this.hotspotEvents['moveBegan'][id]({
        id: id,
        ath: hotspot.ath,
        atv: hotspot.atv
      });
    } else if (this.callbacks['onHotspotMoveBegan']) {
      this.callbacks['onHotspotMoveBegan']({
        id: id,
        ath: hotspot.ath,
        atv: hotspot.atv
      });
    }
  };

  _proto.onHotspotMoveEnd = function onHotspotMoveEnd(_ref8) {
    var id = _ref8.id,
        ath = _ref8.ath,
        atv = _ref8.atv;

    if (this.debug) {
      console.log('onHotspotMoveEnd', id);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot.isLine) {
      this.onLineMoveEnd({
        id: id
      });
      return;
    }

    if (this.hotspotEvents['moveEnd'] && this.hotspotEvents['moveEnd'][id]) {
      this.hotspotEvents['moveEnd'][id]({
        id: id,
        ath: hotspot.ath,
        atv: hotspot.atv
      });
    } else if (this.callbacks['onHotspotMoveEnd']) {
      this.callbacks['onHotspotMoveEnd']({
        id: id,
        ath: hotspot.ath,
        atv: hotspot.atv
      });
    }
  };

  _proto.onHotspotPointMoveEnd = function onHotspotPointMoveEnd(_ref9) {
    var id = _ref9.id,
        index = _ref9.index;
    var hotspot = this.getHotspotById(id);

    if (hotspot.isLine) {
      this.onLineMoveEnd({
        id: id
      });
      return;
    }

    this.callbacks['onHotspotPointMoveEnd']({
      id: id,
      index: index
    });
  };

  _proto.onHotspotPointMoveBegan = function onHotspotPointMoveBegan(_ref10) {
    var id = _ref10.id;
    var hotspot = this.getHotspotById(id);

    if (hotspot.isLine) {
      this.onLineMoveBegan({
        id: id
      });
      return;
    }

    this.callbacks['onHotspotPointMoveBegan']({
      id: id,
      index: index
    });
  };

  _proto.onHotspotPointClick = function onHotspotPointClick(_ref11) {
    var id = _ref11.id;
    this.callbacks['onHotspotPointClick']({
      id: id,
      index: index
    });
  };

  _proto.onLineMoving = function onLineMoving(_ref12) {
    var id = _ref12.id;
    var hotspot = this.getHotspotById(id);

    if (this.lineEvents['moving'][id]) {
      this.lineEvents['moving'][id]({
        id: id,
        points: hotspot.points
      });
    } // else if (this.callbacks['onHotspotMoveEnd']) {
    //     this.callbacks['onHotspotMoveEnd']({ id, points: hotspot.points });
    // }

  };

  _proto.onLineMoveBegan = function onLineMoveBegan(_ref13) {
    var id = _ref13.id;
    var hotspot = this.getHotspotById(id);

    if (hotspot && this.lineEvents['moveBegan'][id]) {
      this.lineEvents['moveBegan'][id]({
        id: id,
        points: hotspot.points
      });
    }
  };

  _proto.onLineMoveEnd = function onLineMoveEnd(_ref14) {
    var id = _ref14.id;
    var hotspot = this.getHotspotById(id);

    if (hotspot && this.lineEvents['moveEnd'][id]) {
      this.lineEvents['moveEnd'][id]({
        id: id,
        points: hotspot.points
      });
    }
  }
  /**
   * 全景控制方式，默认鼠标反向，触摸正向
   * @param {string} mouse - 鼠标操作，取值：drag 正向，moveto 反向，follow 跟随
   * @param {string} touch - 触摸设备操作，取值：drag 正向，moveto 反向，follow 跟随
   */
  ;

  _proto.controlMode = function controlMode(_ref15) {
    var mouse = _ref15.mouse,
        touch = _ref15.touch;

    if (this.debug) {
      console.log('control mode', arguments[0]);
    }

    if (mouse != undefined) {
      this.krpanoWrapper.control.mouse = mouse || 'moveto';

      if (this.__contorlModeEnabled) {
        this.krpanoWrapper.call("set(contextmenu.item[controlmodedrag].visible, " + (this.krpanoWrapper.control.mouse == 'moveto') + ");");
        this.krpanoWrapper.call("set(contextmenu.item[controlmodemoveto].visible, " + (this.krpanoWrapper.control.mouse == 'drag') + ");");
      }
    }

    if (touch != undefined) {
      this.krpanoWrapper.control.touch = touch || 'drag';
    }
  };

  /**
   * 打开/关闭拖拽方式右键菜单
   * @param {bool} toggle - true打开，false关闭
   */
  _proto.enableControlMode = function enableControlMode(toggle) {
    if (this.debug) {
      console.log('enable control mode', arguments[0]);
    }

    this.__contorlModeEnabled = toggle;

    if (this.krpanoWrapper.control.mouse == 'moveto') {
      this.krpanoWrapper.call("set(contextmenu.item[controlmodedrag].visible, " + toggle + ");");
      this.krpanoWrapper.call("set(contextmenu.item[controlmodemoveto].visible, false);");
    } else if (this.krpanoWrapper.control.mouse == 'drag') {
      this.krpanoWrapper.call("set(contextmenu.item[controlmodemoveto].visible, " + toggle + ");");
      this.krpanoWrapper.call("set(contextmenu.item[controlmodedrag].visible, false);");
    }
  }
  /**
   * 打开/关闭举报右键菜单
   * @param {bool} toggle - true打开，false关闭
   */
  ;

  _proto.enableReport = function enableReport(toggle) {
    if (this.debug) {
      console.log('enable report', arguments[0]);
    }

    this.krpanoWrapper.call("set(contextmenu.item[report].visible, " + toggle + ");");
  }
  /**
   * 打开/关闭举报右键菜单
   * @param {bool} toggle - true打开，false关闭
   */
  ;

  _proto.enableFullscreen = function enableFullscreen(toggle) {
    if (this.debug) {
      console.log('enable fullscreen', arguments[0]);
    }

    this.krpanoWrapper.call("set(contextmenu.item[fullscreen].visible, " + toggle + ");");
  };

  _proto.enableKeyboardControlMode = function enableKeyboardControlMode() {
    this.krpanoWrapper.control.keycodesin = "16,65,107";
    this.krpanoWrapper.control.keycodesout = "17,89,90,109";
  }
  /**
   * 更新右键中全景控制方式的文案
   * @param {string} drag - 切换到 drag 正向对应文案
   * @param {string} moveto - 切换到 moveto 反向对应文案
   * @param {string} follow - 切换到follow 跟随对应文案
   * @param {string} report - 举报 对应文案
   * @param {string} fullscreen - 全景 对应文案
   */
  ;

  _proto.updateControlModeText = function updateControlModeText(_ref16) {
    var drag = _ref16.drag,
        moveto = _ref16.moveto,
        follow = _ref16.follow,
        report = _ref16.report,
        fullscreen = _ref16.fullscreen;

    if (this.debug) {
      console.log('control text', arguments[0]);
    }

    if (drag != undefined) {
      this.krpanoWrapper.call("set(contextmenu.item[controlmodedrag].caption, " + drag + ");");
    }

    if (moveto != undefined) {
      this.krpanoWrapper.call("set(contextmenu.item[controlmodemoveto].caption, " + moveto + ");");
    }

    if (follow != undefined) {
      this.krpanoWrapper.call("set(contextmenu.item[controlmodefollow].caption, " + follow + ");");
    }

    if (report != undefined) {
      this.krpanoWrapper.call("set(contextmenu.item[report].caption, " + report + ");");
    }

    if (fullscreen != undefined) {
      this.krpanoWrapper.call("set(contextmenu.item[fullscreen].caption, " + fullscreen + ");");
    }
  }
  /**
   * 打开/关闭陀螺仪
   * @param {bool} toggle - true打开，false关闭
   */
  ;

  _proto.enableGyro = function enableGyro(toggle) {
    var _this4 = this;

    if (this.debug) {
      console.log('enableGyro', toggle);
    }

    this.krpanoWrapper.gyroEnabled = toggle;

    if (this.type != 2 || !toggle) {
      this.krpanoWrapper.set('plugin[gyro_plugin].enabled', toggle);
      setTimeout(function () {
        if (toggle && !_this4.krpanoWrapper.get('plugin[gyro_plugin].enabled')) {
          var enableGyro = function enableGyro() {
            _this4.krpanoWrapper.set('plugin[gyro_plugin].enabled', true);

            setTimeout(function () {
              if (_this4.krpanoWrapper.get('plugin[gyro_plugin].enabled')) {
                document.body.removeEventListener('touchend', enableGyro);
              }
            }, 300);
          };

          document.body.addEventListener('touchend', enableGyro);
        }
      }, 300);
    }
  }
  /**
   * 进入VR模式
   * @param {function} onEnterVr - 进入成功/失败回调，参数 true/false
   */
  ;

  _proto.enableVr = function enableVr(onEnterVr) {
    var _this5 = this;

    if (this.debug) {
      console.log('enableVr');
    }

    if (onEnterVr) {
      this.callbacks['onEnterVr'] = onEnterVr;
      this.krpanoWrapper.events['onEnterVr'] = this.callbacks['onEnterVr'];
    }

    this.krpanoWrapper.call('webvr.enterVR();');
    setTimeout(function () {
      if (_this5.krpanoWrapper.get('webvr.isenabled')) {} else if (_this5.callbacks['onEnterVr']) {
        if (_this5.debug) {
          console.log('enableVr failed');
        }

        if (_this5.callbacks['onEnterVr']) {
          _this5.callbacks['onEnterVr'](false);
        }
      }
    }, 500);
  }
  /**
   * 退出VR模式
   */
  ;

  _proto.exitVr = function exitVr() {
    if (this.debug) {
      console.log('exitVr');
    }

    this.krpanoWrapper.call('webvr.exitVR();');
  };

  /**
   * 开始自动旋转
   * @param {number} duration - 旋转一圈的时间，单位 秒, 正数向右,负数向左
   * @description 配合回调 onAutoRotateOneRound 一起使用
   */
  _proto.autoRotateStart = function autoRotateStart(duration) {
    var _this6 = this;

    if (this.debug) {
      console.log('autoRotateStart', duration);
    }

    duration = duration == undefined ? 360 / this.krpanoWrapper.autorotate.speed : duration;
    this.krpanoWrapper.autoRotateDuration = duration; // this.krpanoWrapper.autorotate.waittime = this.getIdleTime();

    this.krpanoWrapper.autorotate.accel = 10;
    this.krpanoWrapper.autorotate.speed = 360 / duration;
    clearTimeout(this.autoRotateId);

    if (this.type == 2) {
      // this.krpanoWrapper.autorotate.horizon = 0.0;
      // this.krpanoWrapper.autorotate.tofov = 1;
      this.krpanoWrapper.autoRotateStop();
      setTimeout(function () {
        _this6.krpanoWrapper.autoRotateInterrupt();
      }, 10);
    }

    if (this.type == 0 || this.type == 1) {
      this.krpanoWrapper.autoRotateStart();
      setTimeout(function () {
        _this6.krpanoWrapper.autoRotateInterrupt();
      }, 10);
    }

    this.krpanoWrapper.autoRotateEnabled = true;
  }
  /**
   * 停止自动旋转
   */
  ;

  _proto.autoRotateStop = function autoRotateStop() {
    if (this.debug) {
      console.log('autoRotateStop');
    }

    clearTimeout(this.autoRotateId);
    this.krpanoWrapper.autoRotateStop();
    this.krpanoWrapper.autoRotateEnabled = false;
  }
  /**
   * 更新自动旋转的参数
   * @param {Objec} data - 参数对象
   * @param {number} data.duration - 旋转一圈用时, 单位 秒, 正数向右,负数向左
   * @param {number} data.horizon - 旋转时自动回到某个水平角度, 默认 0, 若不需要自动回到某个水平角度设 off
   * @param {number} data.tofov - 旋转时自动回到某个 fov, 默认 off, 设置时 (0,180)
   * @param {number} data.waitTime - 开始自动旋转前的等待时间, 单位 秒, 默认 3
   */
  ;

  _proto.updateAutoRotate = function updateAutoRotate(_ref17) {
    var duration = _ref17.duration,
        horizon = _ref17.horizon,
        tofov = _ref17.tofov,
        waitTime = _ref17.waitTime;

    if (this.debug) {
      console.log('updateAutoRotate', arguments[0]);
    }

    if (duration != undefined) {
      this.krpanoWrapper.autoRotateDuration = duration || 180;
      this.krpanoWrapper.autorotate.speed = 360 / duration;
    }

    if (horizon != undefined) {
      this.krpanoWrapper.autorotate.horizon = horizon;
    }

    if (tofov != undefined) {
      this.krpanoWrapper.autorotate.tofov = tofov;
    }

    if (waitTime != undefined) {
      this.krpanoWrapper.autorotate.waittime = waitTime;
    }
  }
  /**
   * 打断自动旋转,经过 idletime 后再继续
   */
  ;

  _proto.interruptAutoRotate = function interruptAutoRotate() {
    this.krpanoWrapper.autoRotateInterrupt();
  }
  /**
   * 加载六面体全景
   * @param {Object} data - 全景图片数据
   * @param {string} data.url - 图片地址路径 [ "" ]，域名 + 原始数据的 path 字段
   * @param {string} data.view - 初始视角数据 + 原始数据的 view 字段
   * @param {Object} data.multires - 碎片图数据，原始数据的 multires 
   * @param {string} data.depthmap - 深度图地址 (暂时不用管)
   * @param {number} data.animationType - 开场动画类型, 取值 1,2,3,4,5。动画播放完成后会回调 onAnimationComplete
   * @param {bool} data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {bool} data.keepView - 是否保持视角
   * @param {number} data.blendType - 切换效果，取值 0,1,2,3,4,5
   * @param {function} onLoadComplete - 加载完成且动画完成回调
   */
  ;

  _proto.loadCube = function loadCube(_ref18, onLoadComplete) {
    var sceneId = _ref18.sceneId,
        partnerId = _ref18.partnerId,
        url = _ref18.url,
        view = _ref18.view,
        viewOffset = _ref18.viewOffset,
        multires = _ref18.multires,
        depthmap = _ref18.depthmap,
        animationType = _ref18.animationType,
        pauseAnimation = _ref18.pauseAnimation,
        keepView = _ref18.keepView,
        blendType = _ref18.blendType;

    if (this.debug) {
      console.log('loadCube', arguments[0]);
    }

    this.clearComparePanos();
    this.hideVideo();
    this.set('view.maxpixelzoom', 'NaN');
    var cubeData = {
      previewUrl: url + "/imgs/preview.jpg"
    };

    if (depthmap) {
      cubeData["depthmap"] = depthmap;
    }

    if (animationType) {
      cubeData["animationType"] = animationType;
    }

    if (pauseAnimation) {
      cubeData["pauseAnimation"] = pauseAnimation;
    }

    if (keepView) {
      cubeData["keepView"] = keepView;
    }

    if (blendType) {
      cubeData["blendType"] = this.blendModes[blendType];
    }

    if (this.get('device.mobilevr')) {
      cubeData["blendType"] = 'NOBLEND';
    }

    if (view) {
      cubeData["view"] = view;
    }

    if (viewOffset) {
      cubeData["viewOffset"] = viewOffset;
    }

    if (this.krpanoWrapper.viewOffset) {
      if (viewOffset == undefined) {
        cubeData["viewOffset"] = {
          hLookAt: -this.krpanoWrapper.viewOffset.hLookAt,
          vLookAt: -this.krpanoWrapper.viewOffset.vLookAt,
          fov: -this.krpanoWrapper.viewOffset.fov
        };
      } else {
        cubeData["viewOffset"] = {
          hLookAt: viewOffset.hLookAt - this.krpanoWrapper.viewOffset.hLookAt,
          vLookAt: viewOffset.vLookAt - this.krpanoWrapper.viewOffset.vLookAt,
          fov: viewOffset.fov - this.krpanoWrapper.viewOffset.fov
        };
      }
    }

    this.krpanoWrapper.viewOffset = viewOffset;

    if (onLoadComplete) {
      this['onLoadComplete'] = onLoadComplete;
    }

    if (multires == undefined || Object.keys(multires).length === 0 || Object.keys(multires.tiledimage) === 0) {
      cubeData["cubeUrl"] = url + "/imgs/mobile_%s.jpg";
      this.loadMobileCube(cubeData);
    } else {
      cubeData["multiresPath"] = url;
      cubeData["multires"] = multires;
      this.loadMultiresCube(cubeData);
    }

    if (this.krpanoWrapper.autoRotateEnabled) {
      this.autoRotateStart(this.krpanoWrapper.autoRotateDuration);
    }

    if (this.krpanoWrapper.gyroEnabled) {
      this.enableGyro(true);
    }

    this.firstLoad = false;
    this.sceneId = "" + sceneId;
    this.partnerId = partnerId;

    if (this.callbacks['onSceneChange']) {
      this.callbacks['onSceneChange'](this.partnerId, this.sceneId);
    }
  };

  _proto._generateViewXml = function _generateViewXml(view, viewOffset) {
    if (view == undefined) {
      return '<view limitview="off" />';
    }

    var xml = "<view limitview=\"" + (view.limitview ? view.limitview : "off") + "\" ";

    if (view.hlookat != undefined || view.hLookAt != undefined) {
      var _ref19;

      xml += "hlookat=\"" + ((view.hlookat !== undefined ? view.hlookat : view.hLookAt) + ((_ref19 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hLookAt)) !== null && _ref19 !== void 0 ? _ref19 : 0)) + "\" ";
    }

    if (view.vlookat != undefined || view.vLookAt) {
      var _ref20;

      xml += "vlookat=\"" + ((view.vlookat !== undefined ? view.vlookat : view.vLookAt) + ((_ref20 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vLookAt)) !== null && _ref20 !== void 0 ? _ref20 : 0)) + "\" ";
    }

    if (view.fov != undefined) {
      var _viewOffset$fov;

      xml += "fov=\"" + (view.fov + ((_viewOffset$fov = viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.fov) !== null && _viewOffset$fov !== void 0 ? _viewOffset$fov : 0)) + "\" ";
    }

    if (view.hlookatmin != undefined || view.hLookAtMin != undefined) {
      var _ref21;

      xml += "hlookatmin=\"" + ((view.hlookatmin || view.hLookAtMin) + ((_ref21 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hLookAt)) !== null && _ref21 !== void 0 ? _ref21 : 0)) + "\" ";
    }

    if (view.hlookatmax != undefined || view.hLookAtMax != undefined) {
      var _ref22;

      xml += "hlookatmax=\"" + ((view.hlookatmax || view.hLookAtMax) + ((_ref22 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hLookAt)) !== null && _ref22 !== void 0 ? _ref22 : 0)) + "\" ";
    }

    if (view.vlookatmin != undefined || view.vLookAtMin != undefined) {
      var _ref23;

      xml += "vlookatmin=\"" + ((view.vlookatmin || view.vLookAtMin) + ((_ref23 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vLookAt)) !== null && _ref23 !== void 0 ? _ref23 : 0)) + "\" ";
    }

    if (view.vlookatmax != undefined || view.vLookAtMax != undefined) {
      var _ref24;

      xml += "vlookatmax=\"" + ((view.vlookatmax || view.vLookAtMax) + ((_ref24 = (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vlookat) || (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vLookAt)) !== null && _ref24 !== void 0 ? _ref24 : 0)) + "\" ";
    }

    if (view.fovmax != undefined || view.fovMax != undefined) {
      var _viewOffset$fov2;

      xml += "fovmax=\"" + ((view.fovmax || view.fovMax) + ((_viewOffset$fov2 = viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.fov) !== null && _viewOffset$fov2 !== void 0 ? _viewOffset$fov2 : 0)) + "\" ";
    }

    if (view.fovmin != undefined || view.fovMin != undefined) {
      var _viewOffset$fov3;

      xml += "fovmin=\"" + ((view.fovmin || view.fovMin) + ((_viewOffset$fov3 = viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.fov) !== null && _viewOffset$fov3 !== void 0 ? _viewOffset$fov3 : 0)) + "\" ";
    }

    if (view.fovType != undefined || view.fovtype) {
      xml += "fovtype=\"" + (view.fovType || view.fovtype) + "\" ";
    }

    xml += ' maxpixelzoom="NaN" />';
    return xml;
  }
  /**
   * 加载手机六面体全景
   * @param {Object} data - 全景图片数据
   * @param {string} data.previewUrl - 预览图地址
   * @param {string} data.cubeUrl - 六面图地址
   * @param {string} data.depthmapUrl - 深度图地址
   * @param {number} data.animationType - 开场动画类型, 取值 1,2,3,4,5。动画播放完成后会回调 onAnimationComplete
   * @param {bool} data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {bool} data.keepView - 是否保持视角
   * @param {number} data.blendType - 切换效果，取值 0,1,2,3,4,5
   */
  ;

  _proto.loadMobileCube = function loadMobileCube(_ref25) {
    var previewUrl = _ref25.previewUrl,
        cubeUrl = _ref25.cubeUrl,
        view = _ref25.view,
        viewOffset = _ref25.viewOffset,
        depthmapUrl = _ref25.depthmapUrl,
        animationType = _ref25.animationType,
        pauseAnimation = _ref25.pauseAnimation,
        keepView = _ref25.keepView,
        blendType = _ref25.blendType;

    if (this.debug) {
      console.log('loadMobileCube', arguments[0]);
    }

    this.sceneReady = false;
    this.type = 0;
    var xml = '<krpano>';

    if (this.extend && this.extend.customAnimationEnable) {
      xml += "<plugin url=\"" + this.__customAnimationPlugin + "\" preload=\"true\"/>";
    }

    if (previewUrl) {
      xml += '<preview url="' + previewUrl + '" />';
    }

    if (cubeUrl) {
      xml += '<image><cube url="' + cubeUrl + '" />';

      if (depthmapUrl) {
        xml += '<depthmap url="' + depthmapUrl + '" />';
      }

      xml += '</image>';
    }

    xml += this._generateViewXml(view, viewOffset);
    xml += this.__krpanoCommonXML();
    xml += '</krpano>';
    var flags = 'MERGE|KEEPVIEW';
    var blend = 'BLEND(0.5)';

    if (blendType) {
      blend = blendType;
    }

    if (animationType == undefined) {
      animationType = 0;
    }

    this.animationType = animationType;
    this.pauseAnimation = pauseAnimation;
    this.krpanoWrapper.loadXml(xml, 'null', flags, this.firstLoad ? '' : blend);
    this.firstLoad = false;

    var viewCopy = _extends({}, view, {
      hLookAt: parseFloat(view.hlookat === undefined && view.hLookAt === undefined ? this.getView().hlookat : view.hlookat !== undefined ? view.hlookat : view.hLookAt) + parseFloat(viewOffset && viewOffset.hLookAt ? viewOffset.hLookAt : 0),
      vLookAt: parseFloat(view.vlookat === undefined && view.vLookAt === undefined ? this.getView().vlookat : view.vLookAt !== undefined ? view.vLookAt : view.vlookat) + parseFloat(viewOffset && viewOffset.vLookAt ? viewOffset.vLookAt : 0),
      fov: parseFloat(view.fov || this.getView().fov) + parseFloat(viewOffset && viewOffset.fov ? viewOffset.fov : 0)
    });

    if (keepView) {
      viewCopy.hlookat = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.hLookAt = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.vlookat = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.vLookAt = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.fov = this.getView().fov;
    }

    this.updateView(viewCopy);

    if (previewUrl == undefined) {
      this._onPreviewComplete();

      if (this.debug) {
        console.log("_onPreviewComplete 0");
      }
    }
  }
  /**
   * 加载单张六面体全景示例
   */
  ;

  _proto.loadMobileCubeSample = function loadMobileCubeSample() {
    var panoMobileImage = {
      url: "http://192.168.1.110:5502/dist",
      // url: "https://ssl-panoimg136.720static.com/resource/prod/75d30dd7s8d/9bfjOO4yka5/53978011",
      multires: {},
      animationType: 0,
      view: {
        fovMax: 120,
        fovMin: 10,
        fov: 95,
        fovType: "MFOV",
        loadSceneKeepView: 0,
        autoRotateKeepView: 0,
        vLookAt: 0,
        vLookAtMax: 90,
        vLookAtMin: -90,
        hLookAt: 0,
        hLookAtMax: 180,
        hLookAtMin: -180,
        flatFovType: 0,
        maxPixelZoom: 2
      }
    };
    this.loadCube(panoMobileImage, function () {
      console.log("load complete from anonymous function");
    });
  }
  /**
   * 加载碎片图全景
   * @param {Object} data - 全景图片数据
   * @param {string} data.previewUrl - 预览图地址，域名 + 原始数据的 path + /preview.jpg
   * @param {string} data.multiresPath - 碎片图地址路径 [ "" ]，域名 + 原始数据的 path 字段
   * @param {Object} data.multires - 碎片图数据，原始数据的 multires 
   * @param {string} data.depthmap - 深度图地址 (暂时不用管)
   * @param {number} data.animationType - 开场动画类型, 取值 1,2,3,4,5。动画播放完成后会回调 onAnimationComplete
   * @param {bool} data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {bool} data.keepView - 是否保持视角
   * @param {number} data.blendType - 切换效果，取值 0,1,2,3,4,5
   */
  ;

  _proto.loadMultiresCube = function loadMultiresCube(_ref26) {
    var previewUrl = _ref26.previewUrl,
        multiresPath = _ref26.multiresPath,
        view = _ref26.view,
        viewOffset = _ref26.viewOffset,
        multires = _ref26.multires,
        depthmap = _ref26.depthmap,
        animationType = _ref26.animationType,
        pauseAnimation = _ref26.pauseAnimation,
        keepView = _ref26.keepView,
        blendType = _ref26.blendType;

    if (this.debug) {
      console.log('loadMultiresCube', arguments[0]);
    }

    this.sceneReady = false;
    this.type = 0;
    var xml = '<krpano>';

    if (this.extend && this.extend.customAnimationEnable) {
      xml += "<plugin url=\"" + this.__customAnimationPlugin + "\" preload=\"true\"/>";
    }

    if (previewUrl) {
      xml += '<preview url="' + previewUrl + '" />';
    }

    if (multiresPath && multires) {
      xml += '<image tilesize="512">';

      if (multires.tiledimage != undefined) {
        multires.tiledimage.forEach(function (element) {
          xml += '<level tiledimagewidth="' + element.w + '" tiledimageheight="' + element.h + '" ><cube url="' + multiresPath + element.url + '" /></level>';
        });
      }

      xml += '</image>';

      if (depthmap) {
        xml += '<depthmap url="' + depthmap + '" />';
      }
    }

    xml += this._generateViewXml(view, viewOffset);
    xml += this.__krpanoCommonXML();
    xml += '</krpano>';
    var flags = "MERGE|KEEPVIEW";
    var blend = 'BLEND(0.5)';

    if (blendType) {
      blend = blendType;
    }

    if (animationType == undefined) {
      animationType = 0;
    }

    this.animationType = animationType;
    this.pauseAnimation = pauseAnimation;
    this.krpanoWrapper.loadXml(xml, 'null', flags, this.firstLoad ? '' : blend);
    this.firstLoad = false;

    var viewCopy = _extends({}, view, {
      hLookAt: parseFloat(view.hlookat === undefined && view.hLookAt === undefined ? this.getView().hlookat : view.hlookat !== undefined ? view.hlookat : view.hLookAt) + parseFloat(viewOffset && viewOffset.hLookAt ? viewOffset.hLookAt : 0),
      vLookAt: parseFloat(view.vlookat === undefined && view.vLookAt === undefined ? this.getView().vlookat : view.vLookAt !== undefined ? view.vLookAt : view.vlookat) + parseFloat(viewOffset && viewOffset.vLookAt ? viewOffset.vLookAt : 0),
      fov: parseFloat(view.fov || this.getView().fov) + parseFloat(viewOffset && viewOffset.fov ? viewOffset.fov : 0)
    });

    if (keepView) {
      viewCopy.hlookat = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.hLookAt = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.vlookat = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.vLookAt = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.fov = this.getView().fov;
    }

    this.updateView(viewCopy);

    if (previewUrl == undefined) {
      this._onPreviewComplete();

      if (this.debug) {
        console.log("_onPreviewComplete 1");
      }
    }
  }
  /**
   * 加载碎片图全景示例
   */
  ;

  _proto.loadMultiresCubeSample = function loadMultiresCubeSample() {
    var panoImage = {
      "url": "http://192.168.1.110:5502/dist",
      multires: {
        tiledimage: [{
          url: "/imgs/%s/l2/%v/l2_%s_%v_%h.jpg",
          h: "1664",
          w: "1664"
        }, {
          url: "/imgs/%s/l1/%v/l1_%s_%v_%h.jpg",
          h: "768",
          w: "768"
        }],
        level: 4
      },
      "view": {
        "fovMax": 120,
        "fovMin": 70,
        "fov": 95,
        "fovType": "MFOV",
        "loadSceneKeepView": 0,
        "autoRotateKeepView": 0,
        "vLookAt": 0,
        "vLookAtMax": 90,
        "vLookAtMin": -90,
        "hLookAt": 0,
        "hLookAtMax": 180,
        "hLookAtMin": -180,
        "flatFovType": 0,
        "maxPixelZoom": 2
      },
      "blendType": 2
    };
    this.loadCube(panoImage);
  }
  /**
   * 加载单张2:1全景
   * @param {Object} data - 全景图片数据
   * @param {string} data.previewUrl - 预览图地址
   * @param {string} data.url - 单张2:1全景图地址
   * @param {string} data.depthmap - 深度图地址
   * @param {number} data.animationType - 开场动画类型, 取值 1,2,3,4,5。动画播放完成后会回调 onAnimationComplete
   * @param {bool} data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {bool} data.keepView - 是否保持视角
   * @param {number} data.blendType - 切换效果，取值 0,1,3,4,5,5
   * @param {function} onLoadComplete - 加载完成且动画完成回调
   */
  ;

  _proto.loadSphere = function loadSphere(_ref27, onLoadComplete) {
    var sceneId = _ref27.sceneId,
        partnerId = _ref27.partnerId,
        previewUrl = _ref27.previewUrl,
        url = _ref27.url,
        view = _ref27.view,
        depthmap = _ref27.depthmap,
        animationType = _ref27.animationType,
        pauseAnimation = _ref27.pauseAnimation,
        keepView = _ref27.keepView,
        blendType = _ref27.blendType;

    if (this.debug) {
      console.log('loadSphere', arguments[0]);
    }

    if (onLoadComplete) {
      this['onLoadComplete'] = onLoadComplete;
    }

    this.sceneReady = false;

    if (this.krpanoWrapper.autoRotateEnabled) {
      this.autoRotateStart(this.krpanoWrapper.autoRotateDuration);
    }

    this.type = 0;
    var xml = '<krpano>';

    if (previewUrl) {
      xml += '<preview type="SPHERE" url="' + previewUrl + '" />';
    } else {
      xml += '<preview type="SPHERE" url="' + url + '" />';
    }

    if (url) {
      xml += '<image><sphere url="' + url + '"/>';

      if (depthmap) {
        xml += '<depthmap url="' + depthmap + '" />';
      }

      xml += '</image>';
    }

    xml += this._generateViewXml(view);
    xml += this.__krpanoCommonXML();
    xml += '</krpano>';
    var flags = "MERGE|KEEPVIEW";
    var blend = 'BLEND(0.5)';

    if (blendType) {
      blend = blendType;
    }

    if (animationType == undefined) {
      animationType = 0;
    }

    this.animationType = animationType;
    this.pauseAnimation = pauseAnimation;
    this.krpanoWrapper.loadXml(xml, 'null', flags, this.firstLoad ? '' : blend);
    this.firstLoad = false;
    this.sceneId = "" + sceneId;
    this.partnerId = partnerId;

    var viewCopy = _extends({}, view, {
      hLookAt: parseFloat(view.hlookat === undefined && view.hLookAt === undefined ? this.getView().hlookat : view.hlookat !== undefined ? view.hlookat : view.hLookAt) + parseFloat(viewOffset && viewOffset.hLookAt ? viewOffset.hLookAt : 0),
      vLookAt: parseFloat(view.vlookat === undefined && view.vLookAt === undefined ? this.getView().vlookat : view.vLookAt !== undefined ? view.vLookAt : view.vlookat) + parseFloat(viewOffset && viewOffset.vLookAt ? viewOffset.vLookAt : 0),
      fov: parseFloat(view.fov || this.getView().fov) + parseFloat(viewOffset && viewOffset.fov ? viewOffset.fov : 0)
    });

    if (keepView) {
      viewCopy.hlookat = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.hLookAt = this.getView().hlookat + (viewOffset && (viewOffset.hlookat !== undefined || viewOffset.hLookAt !== undefined) ? parseFloat(viewOffset.hlookat || viewOffset.hLookAt) : 0);
      viewCopy.vlookat = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.vLookAt = this.getView().vlookat + (viewOffset && (viewOffset.vlookat !== undefined || viewOffset.vLookAt !== undefined) ? parseFloat(viewOffset.vlookat || viewOffset.vLookAt) : 0);
      viewCopy.fov = this.getView().fov;
    }

    this.updateView(viewCopy);

    if (this.callbacks['onSceneChange']) {
      this.callbacks['onSceneChange'](this.partnerId, this.sceneId);
    }
  };

  _proto.loadSphereSample = function loadSphereSample() {
    var panoImage = {
      url: "https://resource.720think.com/v/Data/upload/think720/201612/995909376/media/201901/thumb/302308.jpg",
      animationType: 1
    };
    this.loadSphere(panoImage);
  }
  /**
   * 加载高清平面图
   * @param {Object} data - 平面图片数据
   * @param {string} data.url - 高清图地址
   * @param {string} data.singleImageUrl - 显示单张图片
   * @param {Object} data.multires - 原始碎片图数据
   * @param {Object} data.matrixFov - 初始视角类型数据
   * @param {Object} data.view - 初识视角数据
   * @param {number} data.view.fov - 初始fov
   * @param {number} data.view.hLookAt - 水平初始视角
   * @param {number} data.view.vLookAt - 垂直初始视角
   * @param {number} data.view.flatFovType - 初始视角类型
   * @param {number} data.animationType - 开场动画, 取值 0关闭1打开。动画播放完成后会回调 onAnimationComplete
   * @param {bool}   data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {bool}   data.keepView - 是否保持视角
   * @param {number} data.blendType - 切换效果，取值 0,1,3,4,5,5
   * @param {function} onLoadComplete - 加载完成且动画完成回调
   */
  ;

  _proto.loadFlat = function loadFlat(_ref28, onLoadComplete) {
    var _arguments = arguments,
        _this7 = this;

    var sceneId = _ref28.sceneId,
        partnerId = _ref28.partnerId,
        url = _ref28.url,
        multires = _ref28.multires,
        singleImageUrl = _ref28.singleImageUrl,
        matrixFov = _ref28.matrixFov,
        view = _ref28.view,
        animationType = _ref28.animationType,
        pauseAnimation = _ref28.pauseAnimation,
        keepView = _ref28.keepView,
        blendType = _ref28.blendType;

    if (this.debug) {
      console.log('loadFlat', arguments[0]);
    }

    this.clearComparePanos();
    this.hideVideo();

    if (onLoadComplete) {
      this['onLoadComplete'] = onLoadComplete;
    }

    this.sceneReady = false;
    this.type = 2;
    this.sceneId = "" + sceneId;
    this.partnerId = partnerId;

    if (this.krpanoWrapper.get('stagewidth') <= 0 || this.krpanoWrapper.get('stageheight') <= 0) {
      setTimeout(function () {
        _this7.loadFlat(_arguments[0]);
      }, 100);
      return;
    }

    if (this.krpanoWrapper.autoRotateEnabled) {
      this.autoRotateStart(this.krpanoWrapper.autoRotateDuration);
    }

    if (this.krpanoWrapper.gyroEnabled && !this.krpanoWrapper.get('webvr.isenabled')) {
      this.enableGyro(false);
      this.krpanoWrapper.gyroEnabled = true;
    }

    var xml = '<krpano>';

    if (singleImageUrl) {
      xml += '<image><flat url="' + singleImageUrl + '" /></image>'; // 加入 preview 会导致背景透明不生效
      // xml += '<preview url="' + singleImageUrl + '" />';
    } else if (url) {
      xml += '<preview url="' + url + '/imgs/preview.jpg' + '" />';
    }

    if (url && multires && matrixFov) {
      // this.hvRatio = matrixFov.hfov / matrixFov.vfov;
      xml += '<image tilesize="512" multires="true" ';
      xml += 'hfov="' + matrixFov.hfov + '" ';
      xml += 'vfov="' + matrixFov.vfov + '" ';
      xml += 'voffset="' + matrixFov.voffset + '" ';
      xml += '>';

      if (multires.tiledimage != undefined) {
        multires.tiledimage.forEach(function (element) {
          xml += '<level tiledimagewidth="' + element.w + '" tiledimageheight="' + element.h + '" ><flat url="' + url + element.url + '" /></level>';
        });
      }

      xml += '</image>';
    }

    xml += "<view maxpixelzoom=\"" + view.maxpixelzoom + "\" ";
    xml += ' />';
    xml += this.__krpanoCommonXML();
    xml += '</krpano>';
    var flags = 'MERGE|';

    if (keepView == true) {
      flags += "KEEPVIEW|";
    }

    var blend = 'BLEND(0.5)';

    if (blendType) {
      blend = this.blendModes[blendType];
    }

    if (this.get('device.mobilevr')) {
      blend = 'NOBLEND';
    }

    if (animationType == undefined) {
      animationType = 0;
    }

    this.animationType = animationType;
    this.pauseAnimation = pauseAnimation;
    this.krpanoWrapper.loadXml(xml, 'null', flags, this.firstLoad ? '' : blend);
    this.firstLoad = false;
    this.updateView(view); // setTimeout(() => {
    //     // this.initFlatAnimation();
    //     if (animationType == 0) {
    //         this.enableControl(true);
    //     }
    // }, 20);

    if (this.callbacks['onSceneChange']) {
      this.callbacks['onSceneChange'](this.partnerId, this.sceneId);
    }
  }
  /**
   * 加载高清平面图示例
   */
  ;

  _proto.loadFlatSample = function loadFlatSample() {
    var panoImage = {
      "url": "https://ssl-panoimg0.720static.com/resource/matrix/0ce31cf1s24/b46jOdsmOf9/1517",
      "multires": {
        "tiledimage": [{
          "url": "/imgs/l6/%0v/l6_%0v_%0h.jpg",
          "h": "6976",
          "w": "13952"
        }, {
          "url": "/imgs/l5/%0v/l5_%0v_%0h.jpg",
          "h": "3456",
          "w": "6912"
        }, {
          "url": "/imgs/l4/%0v/l4_%0v_%0h.jpg",
          "h": "1792",
          "w": "3584"
        }, {
          "url": "/imgs/l3/%0v/l3_%0v_%0h.jpg",
          "h": "896",
          "w": "1792"
        }, {
          "url": "/imgs/l2/%0v/l2_%0v_%0h.jpg",
          "h": "384",
          "w": "768"
        }, {
          "url": "/imgs/l1/%0v/l1_%0v_%0h.jpg",
          "h": "256",
          "w": "512"
        }],
        "level": 6
      },
      "matrixFov": {
        "voffset": "0.00",
        "vfov": "0.500000",
        "hfov": "1.00"
      },
      "view": {
        "fovMax": 120,
        "fovMin": 70,
        "fov": 95,
        "fovType": "MFOV",
        "loadSceneKeepView": 0,
        "autoRotateKeepView": 0,
        "vLookAt": 0,
        "vLookAtMax": 90,
        "vLookAtMin": -90,
        "hLookAt": 0,
        "hLookAtMax": 180,
        "hLookAtMin": -180,
        "flatFovType": 0,
        "maxPixelZoom": 3.333
      },
      "blendType": 0
    };
    this.loadFlat(panoImage);
  };

  _proto.loadSingleFlatSample = function loadSingleFlatSample() {
    var panoImage = {
      "singleImageUrl": "https://ssl-media.720static.com/@/328jkpeusw7/2/287922789c7d132c72ce960a6496d0d0v5.png",
      "matrixFov": {
        "voffset": "0.00",
        "vfov": "32.377470",
        "hfov": "1.00"
      },
      "view": {
        "fovMin": 70,
        "fovType": "MFOV",
        "vLookAt": -15.754,
        "hLookAtMax": 180,
        "vLookAtMin": -90,
        "fov": 2.041,
        "flatFovType": 0,
        "loadSceneKeepView": 0,
        "autoRotateKeepView": 0,
        "maxPixelZoom": 2,
        "fovMax": 120,
        "hLookAtMin": -180,
        "hLookAt": 0,
        "vLookAtMax": 90
      },
      "animationType": 0,
      "pauseAnimation": false
    };
    this.loadFlat(panoImage);
  }
  /**
   * 加载全景视频
   * @param {Object} data - 全景视频数据
   * @param {string} data.videoUrl - 视频地址
   * @param {string} data.posterUrl - 封面地址
   * @param {Object} data.view - 初始视角数据 + 原始数据的 view 字段
   * @param {bool} data.pausedOnStart - 开始时暂停（默认 true ）
   * @param {bool} data.loop - 是否循环播放（默认 false ）
   * @param {number} data.volume - 视频音量 0.0-1.0（默认 1.0）
   * @param {bool} data.muted - 视频静音
   * @param {number} data.startTime - 开始播放位置（秒）（默认 0.0）
   * @param {bool} data.keepView - 是否保持视角 （默认 false）
   * @param {number} data.animationType - 开场动画类型, 取值 0,1,2,3。动画播放完成后会回调 onAnimationComplete
   * @param {bool} data.pauseAnimation - 加载完后暂停开场动画，需要手动调用 playAnimation() 开始播放
   * @param {number} data.blendType - 切换效果，取值 0,1,3,4,5,5
   * @param {bool} [data.autoPause=true] - 浏览器标签页隐藏后自动暂停
   * @param {bool} [data.autoResume=true] - 浏览器标签页恢复后自动播放
   * @param {function} onLoadComplete - 加载完成且动画完成回调
   */
  ;

  _proto.loadVideo = function loadVideo(_ref29, onLoadComplete) {
    var _arguments2 = arguments;
    var sceneId = _ref29.sceneId,
        partnerId = _ref29.partnerId,
        videoUrl = _ref29.videoUrl,
        posterUrl = _ref29.posterUrl,
        view = _ref29.view,
        pausedOnStart = _ref29.pausedOnStart,
        loop = _ref29.loop,
        muted = _ref29.muted,
        volume = _ref29.volume,
        autoPause = _ref29.autoPause,
        autoResume = _ref29.autoResume,
        startTime = _ref29.startTime,
        keepView = _ref29.keepView,
        animationType = _ref29.animationType,
        pauseAnimation = _ref29.pauseAnimation,
        blendType = _ref29.blendType;
    this.clearComparePanos();
    this.call('removeplugin(video);');

    if (this.get('plugin[video]') && !this.get('plugin[video].loaded')) {
      var that = this;
      setTimeout(function () {
        that.loadVideo(_arguments2[0], onLoadComplete);
      }, 500);
      return;
    }

    if (this.debug) {
      console.log('loadVideo', arguments[0]);
    }

    if (onLoadComplete) {
      this['onLoadComplete'] = onLoadComplete;
    }

    this.sceneReady = false;
    this.type = 1;

    if (animationType == undefined) {
      animationType = 0;
    }

    if (autoPause == undefined) {
      autoPause = true;
    }

    if (autoResume == undefined) {
      autoResume = true;
    }

    this.animationType = animationType;
    this.pauseAnimation = pauseAnimation;

    if (this.krpanoWrapper.autoRotateEnabled) {
      this.krpanoWrapper.autoRotateStop();
    }

    pausedOnStart = pausedOnStart == undefined ? true : pausedOnStart;

    if ((this.iOS() || this.Android()) && pausedOnStart != true) {
      pausedOnStart = false;
    }

    loop = loop == undefined ? false : loop;
    volume = volume == undefined ? 1.0 : volume;
    muted = muted == undefined ? false : muted;
    startTime = startTime == undefined ? 0 : startTime;
    var xml = '<krpano>';
    xml += '<image><sphere url="plugin:video"/></image>';
    xml += this._generateViewXml(view);

    if (this.get('plugin[video]') == null) {
      xml += '<plugin name="video" keep="true" time="0" url="' + this.__videoPlugin + '" pausedonstart="' + pausedOnStart + '" loop="' + loop + '" volume="' + volume + '" muted="' + muted + '" html5preload="metadata" devices="panovideosupport" videourl="' + videoUrl + '" autoPause="' + autoPause + '" autoResume="' + autoResume + '" posterurl="' + posterUrl + '" ';
      xml += ' onvideoready="delayedcall(0.1,jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoReady();window.players[\'' + this.krpanoWrapper.id + '\'].events.onPreviewComplete();););"';
      xml += ' onvideoplay="jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoPlay(););"';
      xml += ' onvideopaused="jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoPaused(););"'; // xml += ' onvideocomplete="jscall(if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoComplete){window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoComplete();};if(window.players[\'' + this.krpanoWrapper.id + '\'].autoRotateEnabled){if(window.players[\'' + this.krpanoWrapper.id + '\'].get(\'plugin[video].time\') > 0){window.players[\'' + this.krpanoWrapper.id + '\'].events.onAutoRotateOneRound();};};);"';

      xml += ' onvideocomplete="jscall(if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoComplete){window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoComplete();};);"';
      xml += ' onerror="jscall(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVideoError(););"';
      xml += ' />';
    } else {
      this.set('plugin[video].enabled', true);
      this.set('plugin[video].pauseonstart', pausedOnStart);
      this.set('plugin[video].time', 0);
      this.set('plugin[video].vidible', true);
      this.set('plugin[video].loop', loop);
      this.set('plugin[video].volume', volume);
      this.set('plugin[video].muted', muted);
      this.set('plugin[video].autoResume', autoResume);
      this.set('plugin[video].autoPause', autoPause);
      this.set('plugin[video].onvideoready', "jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoReady();window.players['" + this.krpanoWrapper.id + "'].events.onPreviewComplete(););");
      this.set('plugin[video].onvideoplay', "jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoPlay(););");
      this.set('plugin[video].onvideopaused', "jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoPaused(););");
      this.set('plugin[video].onvideocomplete', "jscall(if(window.players['" + this.krpanoWrapper.id + "'].events.onVideoComplete){window.players['" + this.krpanoWrapper.id + "'].events.onVideoComplete();};);");
      this.set('plugin[video].onerror', "jscall(window.players['" + this.krpanoWrapper.id + "'].events.onVideoError(););");
      this.krpanoWrapper.call("plugin[video].playvideo(" + videoUrl + ", " + posterUrl + ", " + pausedOnStart + ", " + startTime + ");"); // this.set('plugin[video].pausedonstart', pausedOnStart);
      // this.set('plugin[video].videoUrl', videoUrl);
      // this.set('plugin[video].posterUrl', posterUrl);
    }

    xml += '';
    xml += this.__krpanoCommonXML();
    xml += '</krpano>';
    this.videoVolume = volume;
    this.sceneId = "" + sceneId;
    this.partnerId = partnerId;
    var flags = "MERGE|KEEPVIEW";
    var blend = 'BLEND(0.5)';

    if (blendType) {
      blend = this.blendModes[blendType];
    }

    if (this.get('device.mobilevr')) {
      blend = 'NOBLEND';
    }

    if (this.krpanoWrapper.gyroEnabled) {
      this.enableGyro(true);
    }

    this.krpanoWrapper.loadXml(xml, 'null', flags, this.firstLoad ? '' : blend);
    this.firstLoad = false;

    var viewCopy = _extends({}, view);

    if (keepView) {
      viewCopy.hlookat = this.getView().hlookat;
      viewCopy.hLookAt = this.getView().hlookat;
      viewCopy.vlookat = this.getView().vlookat;
      viewCopy.vLookAt = this.getView().vlookat;
      viewCopy.fov = this.getView().fov;
    }

    viewCopy.maxPixelZoom = 'NaN';
    this.updateView(viewCopy);
    Object.defineProperty(this, 'videoVolume', {
      get: function get() {
        return this.krpanoWrapper.get('plugin[video].volume');
      },
      set: function set(value) {
        this.krpanoWrapper.set('plugin[video].volume', value);
      }
    });

    if (this.callbacks['onSceneChange']) {
      this.callbacks['onSceneChange'](this.partnerId, this.sceneId);
    }
  }
  /**
   * 全景视频音量
   */
  ;

  _proto.hideVideo = function hideVideo() {
    if (this.get('plugin[video]')) {
      this.krpanoWrapper.call('plugin[video].stop();');
      this.set('plugin[video].videoUrl', '');
      this.set('plugin[video].posterUrl', '');
      this.set('plugin[video].enabled', false);
      this.set('plugin[video].vidible', false);
    }
  }
  /**
   * 加载全景视频示例
   */
  ;

  _proto.loadVideoSample = function loadVideoSample(onComplete) {
    var videoData = {
      // videoUrl: "https://ssl-video0.720static.com/transcode/0a300959eab046999aad698e5dee5f09/mps/super/81fb2fffd5b23f86a997b1311d075ae8.mp4",
      videoUrl: "http://127.0.0.1:5502/dist/video.mp4",
      posterUrl: "http://127.0.0.1:5502/dist/v2.png",
      view: {
        autoRotateKeepView: 0,
        flatFovType: 0,
        fov: 95,
        fovMax: 120,
        fovMin: 70,
        fovType: "MFOV",
        hLookAt: 0,
        hLookAtMax: 180,
        hLookAtMin: -180,
        loadSceneKeepView: 0,
        maxPixelZoom: 2,
        vLookAt: 0,
        vLookAtMax: 90,
        vLookAtMin: -90
      },
      animationType: 0,
      pausedOnStart: false
    }; // {
    //     posterUrl: '../../dist/poster.png',
    //     videoUrl: '../../dist/video.mp4',
    //     animationType: 1,
    //     pausedOnStart: false,
    //     pauseAnimation: true,
    //     loop: false,
    //     view: {
    //         "fovMax": 139.6,
    //         "fovMin": 70,
    //         "fov": 95,
    //         "fovType": "MFOV",
    //         "loadSceneKeepView": 0,
    //         "autoRotateKeepView": 0,
    //         "vLookAt": 0,
    //         "vLookAtMax": 0,
    //         "vLookAtMin": -90,
    //         "hLookAt": 0,
    //         "hLookAtMax": 180,
    //         "hLookAtMin": 0,
    //         "flatFovType": 0,
    //         "maxPixelZoom": 2
    //     }
    //     // volume: 0,
    // }

    this.loadVideo(videoData, onComplete);
  }
  /**
   * 继续/暂停全景视频
   */
  ;

  _proto.toggleVideo = function toggleVideo() {
    if (this.debug) {
      console.log('toggleVideo');
    }

    if (this.type !== 1) {
      return;
    }

    this.krpanoWrapper.call('plugin[video].togglepause();');
  }
  /**
   * 暂停播放全景视频
   */
  ;

  _proto.pauseVideo = function pauseVideo() {
    if (this.debug) {
      console.log('pauseVideo');
    }

    this.krpanoWrapper.call('plugin[video].pause();');
  }
  /**
   * 设置当前视频时间
   * @param {number} time - 播放位置（秒)
   */
  ;

  _proto.seekVideo = function seekVideo(time) {
    if (this.debug) {
      console.log('seekVideo');
    }

    if (this.type !== 1) {
      return;
    }

    this.krpanoWrapper.call('plugin[video].seek(' + time + ');');
  }
  /**
   * 播放或恢复播放全景视频
   */
  ;

  _proto.playVideo = function playVideo() {
    if (this.debug) {
      console.log('playVideo');
    }

    if (this.type !== 1) {
      return;
    }

    this.krpanoWrapper.call('plugin[video].play();');
  }
  /**
   * 切换视频
   * @param {string} videoUrl - 全景视频数据
   */
  ;

  _proto.switchVideo = function switchVideo(videoUrl) {
    if (this.debug) {
      console.log('switchVideo', videoUrl);
    }

    if (this.type !== 1) {
      return;
    }

    var startTime = this.videoTime();
    var loop = this.krpanoWrapper.get('plugin[video].loop');
    this.krpanoWrapper.call('plugin[video].playvideo(' + videoUrl + ', null, ' + loop + ', ' + startTime + '));');
  }
  /**
   * 当前视频时间，单位 秒
   */
  ;

  _proto.videoTime = function videoTime() {
    return this.krpanoWrapper.get('plugin[video].time');
  }
  /**
   * 视频总时长，单位 秒
   */
  ;

  _proto.videoTotalTime = function videoTotalTime() {
    return this.krpanoWrapper.get('plugin[video].totaltime');
  }
  /**
   * 视频静音
   */
  ;

  _proto.mutedVideo = function mutedVideo() {
    return this.set('plugin[video].muted', true);
  }
  /**
   * 视频非静音
   */
  ;

  _proto.unmutedVideo = function unmutedVideo() {
    return this.set('plugin[video].muted', false);
  }
  /**
   * 移动视角到给定参数
   * @param {Object} data - 视角对象
   * @param {Number} data.hlookat - hlookat
   * @param {Number} data.vlookat - vlookat
   * @param {Number} data.fov - fov
   * @param {string} data.duration - 移动时长
   * @param {string} data.tween - 移动效果
   * @param {bool} data.nonblocking - 是否能打断
   * @param {function} onComplete - 完成回调
   */
  ;

  _proto.lookTo = function lookTo(_ref30, onComplete) {
    var hlookat = _ref30.hlookat,
        vlookat = _ref30.vlookat,
        ath = _ref30.ath,
        atv = _ref30.atv,
        fov = _ref30.fov,
        duration = _ref30.duration,
        tweenType = _ref30.tweenType,
        tween = _ref30.tween,
        shortestway = _ref30.shortestway,
        nonblocking = _ref30.nonblocking;
    this.krpanoWrapper.stopLookTo();

    if (this.debug) {
      console.log('lookTo', arguments[0], onComplete);
    }

    var fovmin = this.getView().fovMin || this.getView().fovmin;
    this.updateView({
      fovmin: fovmin
    });
    this.krpanoWrapper.events['onLookToComplete'] = onComplete;

    if (fov == undefined) {
      fov = this.getView().fov;
    }

    this.krpanoWrapper.call('set(looktoInterrupt, false);');

    if (duration != undefined) {
      var _tweenType = tweenType == undefined ? 'easeinoutquad' : tweenType;

      tween = "tween(" + _tweenType + ", " + duration + ")";
    }

    this.nonblocking = nonblocking;
    this.krpanoWrapper.set('isLookingTo', true);
    this.krpanoWrapper.lookTo(hlookat || ath, vlookat || atv, fov, tween, shortestway, nonblocking, "set(view.fovmin, " + fovmin + ");set(isLookingTo, false);jscall(window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete && window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete(true);window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete=null;);");
  }
  /**
   * 使用 lookTo 视角移动期间的视角计算
   * @param {Object} data - 数据
   * @param {number} data.startHLookAt - 开始移动的 hlookat
   * @param {number} data.startVLookAt - 开始移动的 vlookat
   * @param {number} data.startFov - 开始移动的 fov
   * @param {number} data.endHLookAt - 移动结束的 hlookat
   * @param {number} data.endVLookAt - 移动结束的 vlookat
   * @param {number} data.endFov - 移动结束的 fov
   * @param {number} data.duration - 移动总时长
   * @param {number} data.currentTime - 需要计算的点位时间
   * 
   * @return { hlookat, vlookat, fov }
   */
  ;

  _proto.tracingLookTo = function tracingLookTo(_ref31) {
    var startHLookAt = _ref31.startHLookAt,
        startVLookAt = _ref31.startVLookAt,
        startFov = _ref31.startFov,
        endHLookAt = _ref31.endHLookAt,
        endVLookAt = _ref31.endVLookAt,
        endFov = _ref31.endFov,
        duration = _ref31.duration,
        currentTime = _ref31.currentTime;

    if (duration <= 0 || currentTime >= duration) {
      return {
        hlookat: endHLookAt,
        vlookat: endVLookAt,
        fov: endFov
      };
    }

    var rate = currentTime / duration;
    var hlookat = (endHLookAt - startHLookAt) * rate + startHLookAt;
    var vlookat = (endVLookAt - startVLookAt) * rate + startVLookAt;
    var fov = (endFov - startFov) * rate + startFov;
    return {
      hlookat: hlookat,
      vlookat: vlookat,
      fov: fov
    };
  }
  /**
   * 打断 lookTo
   */
  ;

  _proto.stopLookTo = function stopLookTo() {
    this.krpanoWrapper.stopLookTo();

    if (this.nonblocking == true && this.get('isLookingTo') == true) {
      this.nonblocking = null;
      this.set('isLookingTo', false);
      this.krpanoWrapper.events.onLookToComplete && this.krpanoWrapper.events.onLookToComplete(false);
      this.krpanoWrapper.events.onLookToComplete = null;
    }
  };

  _proto.lookAt = function lookAt(_ref32) {
    var hlookat = _ref32.hlookat,
        vlookat = _ref32.vlookat,
        fov = _ref32.fov;

    if (this.debug) {
      console.log('lookAt', arguments[0]);
    }

    this.krpanoWrapper.lookAt(hlookat, vlookat, fov);
  }
  /**
   * 将热点移动到视野中间
   * @param {Object} data - 数据
   * @param {Number} data.id - 热点id
   * @param {Number} data.fov - 目标 fov, 若不传则取最近视角
   * @param {string} data.tween - 移动效果
   * @param {string} onComplete - 完成回调
   */
  ;

  _proto.zoomToHotspot = function zoomToHotspot(_ref33, onComplete) {
    var id = _ref33.id,
        fov = _ref33.fov,
        tween = _ref33.tween,
        shortestway = _ref33.shortestway,
        nonblocking = _ref33.nonblocking;

    if (this.debug) {
      console.log('zoomToHotspot', arguments[0], onComplete);
    }

    var hlookat = this.get("hotspot[" + id + "].ath");
    var vlookat = this.get("hotspot[" + id + "].atv");

    if (fov == undefined) {
      fov = this.getView().fovMin;
    }

    this.krpanoWrapper.events['onLookToComplete'] = onComplete;
    this.krpanoWrapper.lookTo(hlookat, vlookat, fov, tween, shortestway, nonblocking, "jscall(window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete && window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete();window.players['" + this.krpanoWrapper.id + "'].events.onLookToComplete=null;);");
  }
  /**
   * 获取视角对象
   * @param {string} comparePanoId - 用于获取对比全景的视角数据
   * @returns {Object} 返回视角对象，具体属性参看[updateView]{@link Player#updateView}
   */
  ;

  _proto.getView = function getView(_temp) {
    var _ref34 = _temp === void 0 ? {} : _temp,
        comparePanoId = _ref34.comparePanoId;

    if (comparePanoId) {
      return this.get("layer[" + comparePanoId + "].krpano") ? this.get("layer[" + comparePanoId + "].krpano").get('view') : undefined;
    } else {
      return this.krpanoWrapper.view;
    }
  }
  /**
   * 更新全景视角
   * @see 详细信息可参考 {@link https://krpano.com/docu/xml/#view}
   * @param {Object} view - 全景视角视角
   * @param {number} view.hlookat - 水平视角
   * @param {number} view.vlookat - 垂直视角 [-90, 90]
   * @param {number} view.camroll -
   * @param {number} view.fovtype - fov类型 {MFOV, VFOF}
   * @param {number} view.fov - fov [0, 180]
   * @param {number} view.fovmin - 最小fov
   * @param {number} view.fovmax - 最大fov
  //  * @param {number} view.maxpixelzoom - 最大缩放像素比例
   * @param {number} view.mfovratio -
   * @param {number} view.distortion -
   * @param {number} view.distortionfovlink -
   * @param {number} view.stereographic -
   * @param {number} view.pannini -
   * @param {number} view.architectural -
   * @param {number} view.architecturalonlymiddle -
   * @param {number} view.limitview - 视角限制类型 {off:无限制, auto: 自动（默认）, lookat: 根据 lookat 相关值进行限制, range: 根据 lookat 相关值进行限制, fullrange: 根据 lookat 相关值进行限制, offrange: 不进行限制}
   * @param {number} view.hlookatmin - 最小水平视角
   * @param {number} view.hlookatmax - 最大水平视角
   * @param {number} view.vlookatmin - 最小垂直视角
   * @param {number} view.vlookatmax - 最大垂直视角
   * @param {number} view.flatFovType - 矩阵视角限制类型, 0:显示全部;1:自定义视角;2:铺满屏幕
   * @param {number} view.rx - x轴附加旋转（度）
   * @param {number} view.ry - y轴附加旋转
   * @param {number} view.tx - 视点在x轴上的偏移
   * @param {number} view.ty - 视点在y轴上的偏移
   * @param {number} view.tz - 视点在z轴上的偏移
   * @param {number} view.ox - 视点在x轴上的偏移，但视角的旋转角度不会改变
   * @param {number} view.oy - 视点在x轴上的偏移，但视角的旋转角度不会改变
   * @param {number} view.oz - 视点在x轴上的偏移，但视角的旋转角度不会改变
   *
   *
   */
  ;

  _proto.updateView = function updateView(view) {
    var _this8 = this;

    if (this.debug) {
      console.log('updateView', view);
    }

    for (var key in view) {
      if (Object.hasOwnProperty.call(view, key)) {
        if (key.toLowerCase() != key && view[key.toLowerCase()] != undefined) {
          if (this.type == 2 || key.toLowerCase() != 'maxpixelzoom') {
            view[key] = view[key.toLowerCase()];
          }
        }

        if (this.type == 2 || key.toLowerCase() != 'maxpixelzoom') {
          var value = view[key];
          this.krpanoWrapper.view[key.toLowerCase()] = value;
        }
      }
    } // this.krpanoWrapper.view['fovtype'] = 'MFOV';


    if (this.type == 2 && view && (view.maxpixelzoom != undefined || view.maxPixelZoom != undefined) && view.flatFovType == undefined) {
      setTimeout(function () {
        if (_this8.callbacks.onFlatFovChanged) {
          _this8.callbacks.onFlatFovChanged({
            fovmin: _this8.krpanoWrapper.view['fovmin'],
            fovmax: _this8.krpanoWrapper.view['fovmax'],
            needUpdateFov: false
          });

          if (view.zoomtomaxpixelzoom == true) {
            _this8.updateView({
              fov: _this8.krpanoWrapper.view['fovmin']
            });
          }
        }

        _this8.krpanoWrapper.call('updatescreen();');
      }, 50);
    } else if (this.type == 2 && view && view.flatFovType != undefined) {
      var needUpdateFov = this.flatFovType != view.flatFovType;
      this.flatFovType = view.flatFovType;
      this.krpanoWrapper.view['fovmax'] = undefined;
      this.krpanoWrapper.view['fovmin'] = undefined;
      this.krpanoWrapper.view['hlookatmax'] = undefined;
      this.krpanoWrapper.view['hlookatmin'] = undefined;
      this.krpanoWrapper.view['vlookatmin'] = undefined;
      this.krpanoWrapper.view['vlookatmax'] = undefined;

      if (view.flatFovType == 2) {
        this.krpanoWrapper.view['limitview'] = 'auto';
      } else if (view.flatFovType == 1) {
        this.krpanoWrapper.view['limitview'] = 'fullrange';
      } else {
        this.krpanoWrapper.view['limitview'] = 'fullrange';
      }

      this.krpanoWrapper.view['fov'] = 180;
      setTimeout(function () {
        _this8.flatFovMax = _this8.krpanoWrapper.view['fov'];
        _this8.flatFovView = true;
        _this8.krpanoWrapper.view['fovmax'] = _this8.flatFovMax;

        if (view.flatFovType > 0) {
          if (view['fov'] != undefined) {
            _this8.krpanoWrapper.view['fov'] = view['fov'];
          }

          if (view['hlookat'] || view['hLookAt']) {
            _this8.krpanoWrapper.view['hlookat'] = view['hlookat'] || view['hLookAt'];
          }

          if (view['vlookat'] || view['vLookAt']) {
            _this8.krpanoWrapper.view['vlookat'] = view['vlookat'] || view['vLookAt'];
          }
        } else {
          _this8.krpanoWrapper.view['fov'] = _this8.flatFovMax;
        }

        if ((_this8.flatFovType == 2 || _this8.flatFovType == 0) && view.disableZoom) {
          _this8.krpanoWrapper.view['fovmin'] = _this8.flatFovMax;
          _this8.krpanoWrapper.view['fovmax'] = _this8.flatFovMax;
          _this8.krpanoWrapper.view['maxpixelzoom'] = NaN;
        }

        if (_this8.debug) {
          console.log(_this8.krpanoWrapper.view['fov'], _this8.krpanoWrapper.view['fovmin'], _this8.krpanoWrapper.view['fovmax']);
        }

        setTimeout(function () {
          if (_this8.callbacks.onFlatFovChanged) {
            _this8.callbacks.onFlatFovChanged({
              fovmin: _this8.krpanoWrapper.view['fovmin'],
              fovmax: _this8.krpanoWrapper.view['fovmax'],
              needUpdateFov: needUpdateFov
            });
          }

          _this8.krpanoWrapper.call('updatescreen();');
        }, 50);
      }, 50);
    }
  }
  /**
   * 正常视角
   */
  ;

  _proto.normalView = function normalView() {
    if (this.debug) {
      console.log('normalView');
    }

    this.krpanoWrapper.call("\n        tween(view.architectural, 0.0, 0.5);\n        tween(view.pannini,       0.0, 0.5);\n        tween(view.fisheye,       0.0, 0.5);\n        tween(view.fov,     90, 0.5);\n        tween(view.vlookat, 0, 0.5,easeOutQuad,\n            if(view.old_fovmax !== null, \n                copy(view.fovmax, view.old_fovmax);\n            );\n        );\n        ");
    this.__viewType = 0;
  }
  /**
   * 小行星视角
   */
  ;

  _proto.littlePlanetView = function littlePlanetView() {
    if (this.debug) {
      console.log('littlePlanetView');
    }

    this.krpanoWrapper.call("\n        tween(view.architectural, 0.0, 0.25);\n        tween(view.vlookat,  90, distance(179, 1.50), easeoutquad);\n        set(backtonormalfirst,false);\n        if(view.pannini       == true,  set(backtonormalfirst,true) );\n        if(view.stereographic == false, set(backtonormalfirst,true) );\n        if(backtonormalfirst, tween(view.fisheye, 0.0 ,distance(1.0, 0.25), easeoutquad, WAIT); );\n        set(view.pannini, false);\n        set(view.stereographic, true);\n        copy(view.old_fovmax, view.fovmax);\n        set(view.fovmax, 150);\n        tween(view.fov, 150, distance(179, 0.75),easeoutquad);\n        tween(view.fisheye, 1.0, distance(1.0, 0.75), easeoutquad,\n        );\n        ");
    this.__viewType = 1;
  }
  /**
   * 鱼眼视角
   */
  ;

  _proto.fisheyeView = function fisheyeView() {
    if (this.debug) {
      console.log('fisheyeView');
    }

    this.krpanoWrapper.call("\n        tween(view.architectural, 0.0,  distance(1.0,0.5));\n        tween(view.pannini,       0.0,  distance(1.0,0.5));\n        tween(view.fisheye,       1.0,  distance(1.0,0.5));\n        tween(view.vlookat, 0, 0.5);\n        tween(view.fov,       115,  0.5);\n        tween(view.distortion,    1.0, distance(1.0,0.5),easeOutQuad,\n                \n        );\n        ");
    this.__viewType = 2;
  }
  /**
   * 水晶球视角
   */
  ;

  _proto.ballView = function ballView() {
    if (this.debug) {
      console.log('ballView');
    }

    this.krpanoWrapper.call("\n        tween(view.architectural, 0.0,  distance(1.0,0.5));\n        tween(view.pannini,       0.0,  distance(1.0,0.5));\n        tween(view.fov,     90, 0.5);\n        tween(view.distortion,    2.8, distance(1.0,0.5),easeOutQuad,\n        \n      );\n      ");
    this.__viewType = 3;
  };

  /**
   * 当前视角类型
   * @description 0正常 1小行星 2鱼眼 3水晶球
   */
  _proto.viewType = function viewType() {
    return this.__viewType;
  };

  _proto.callAnimationComplete = function callAnimationComplete() {
    var _this9 = this;

    if (this.debug) {
      console.log('onAnimationComplete');
    }

    if (this.callbacks && this.callbacks.onAnimationComplete) {
      this.callbacks.onAnimationComplete();
    }

    if (this['onLoadComplete']) {
      this['onLoadComplete']();
      delete this['onLoadComplete'];
    }

    if (this.callbacks && this.callbacks.onSceneInitComplete) {
      var that = this;
      setTimeout(function () {
        that.callbacks.onSceneInitComplete(that.partnerId, that.sceneId);
      }, 100);
    }

    if (this.krpanoWrapper.get('webvr.isenabled')) {
      setTimeout(function () {
        _this9.call('update_vr_hotspot()');
      }, 500);
    }
  }
  /**
   * 初始化开场动画
   * @description 无需手动调用。
   */
  ;

  _proto.initPanoAnimation = function initPanoAnimation() {
    var _this10 = this;

    if (this.debug) {
      console.log('initPanoAnimation', this.animationType, this.pauseAnimation);
    }

    if (this.animationType <= 0 && !this.pauseAnimation) {
      setTimeout(function () {
        if (!_this10.initEnableControlSet) {
          _this10.enableControl(true);
        } else {
          _this10.initEnableControlSet = false;
        }

        _this10.krpanoWrapper.view.limitview = 'lookat';

        _this10.callAnimationComplete();
      }, 500);
      return;
    }

    this.krpanoWrapper.call("\n        set(control.usercontrol, off);\n        copy(lp_scene, xml.scene);\n        copy(lp_hlookat, view.hlookat);\n        copy(lp_vlookat, view.vlookat);\n        copy(lp_fov, view.fov);\n        copy(lp_fovmax, view.fovmax);\n        copy(lp_fovmin, view.fovmin);\n        copy(lp_hlookatmax, view.hlookatmax);\n        copy(lp_hlookatmin, view.hlookatmin);\n        copy(lp_vlookatmax, view.vlookatmax);\n        copy(lp_vlookatmin, view.vlookatmin);\n        ");

    switch (this.animationType) {
      case 2:
        this.krpanoWrapper.call("\n\t            sub(view.hlookat, 360);\n                ");
        break;

      case 4:
        this.krpanoWrapper.call("\n                set(view.fov, 70);\n                set(view.vlookat, -40);\n                sub(view.hlookat, 360);\n                ");
        break;

      case 3:
        this.krpanoWrapper.call("\n                set(view.fov, 110);\n                set(view.hlookat, get(lp_hlookat));\n                sub(view.hlookat, 360);\n\n                set(view.architectural, 0.0);\n                set(view.pannini, 0.0);\n                set(view.distortion,    2.8);\n                ");
        break;

      case 5:
        this.krpanoWrapper.call("\n                set(view.fovmax, 150);\n                set(view.fov, 150);\n                set(view.vlookat, -65);\n                add(view.hlookat, 360);\n                set(view.fisheye, 1.0);\n                ");
        break;

      case 1:
        this.krpanoWrapper.call("\n                set(view.fovmax, 170);\n                set(view.vlookatmin, -90);\n                set(view.vlookatmax, 90);\n                lookat(calc(lp_hlookat + 180), 90, 150, 1, 0, 0);\n                ");
        break;
    }

    if (this.pauseAnimation != true) {
      setTimeout(function () {
        _this10.playPanoAnimation();
      }, 1000);
    }
  }
  /**
   * 开始播放开场动画
   * @description 仅在加载全景时传入了 pauseAnimation=true 时需要手动调用。
   */
  ;

  _proto.playAnimation = function playAnimation() {
    if (this.debug) {
      console.log(this.krpanoWrapper.view['fov'], this.krpanoWrapper.view['fovmin'], this.krpanoWrapper.view['fovmax']);
    }

    if (this.debug) {
      console.log('playAnimation', this.animationType, this.pauseAnimation);
    }

    if (this.animationType == 0 && this.pauseAnimation) {
      this.callAnimationComplete();

      if (!this.initEnableControlSet) {
        this.enableControl(true);
      } else {
        this.initEnableControlSet = false;
      }

      if (this.type == 0) {
        this.krpanoWrapper.view.limitview = 'lookat';
      }

      return;
    }

    this.pauseAnimation = false;

    if (this.type == 2) {
      this.playFlatAnimation();
    } else {
      this.playPanoAnimation();
    }
  }
  /**
   * 开始播放开场动画
   * @description 仅在加载全景时传入了 pauseAnimation=true 时需要手动调用。
   */
  ;

  _proto.playPanoAnimation = function playPanoAnimation() {
    var _this11 = this;

    if (this.debug) {
      console.log('playPanoAnimtaion', this.animationType, this.pauseAnimation);
    }

    switch (this.animationType) {
      case 2:
        this.krpanoWrapper.call("\n                tween(\n                    view.hlookat, \n                    get(lp_hlookat),\n                    12.0, \n                    easeInOutSine,\n                    \n                );\n                ");
        setTimeout(function () {
          _this11.callAnimationComplete();

          _this11._initViewLimit();

          if (!_this11.initEnableControlSet) {
            _this11.enableControl(true);
          } else {
            _this11.initEnableControlSet = false;
          }
        }, 12300);
        break;

      case 4:
        this.krpanoWrapper.call("\n                tween(view.vlookat, 90, 9, easeInOutSine);\n                delayedcall(animation2_0,2,\n                    tween(\n                        view.hlookat, \n                        get(lp_hlookat), \n                        7.5, \n                        easeInOutSine\n                    );\n                    tween(\n                        view.fov, \n                        150.0, \n                        7.5, \n                        easeInOutSine\n                    );\n                    delayedcall(\n                        animation2_1,\n                        7.6,\n                        tween(\n                            view.fisheye, \n                            0.0,\n                            3\n                        );\n                        tween(\n                            view.vlookat, \n                            get(lp_vlookat), \n                            3, \n                            easeInOutSine\n                        );\n                        tween(\n                            view.fov, \n                            get(lp_fov), \n                            3, \n                            easeInOutSine,\n                            \n                        );\n                    );\n                );\n                ");
        setTimeout(function () {
          _this11.callAnimationComplete();

          _this11._initViewLimit();

          if (!_this11.initEnableControlSet) {
            _this11.enableControl(true);
          } else {
            _this11.initEnableControlSet = false;
          }
        }, 12800);
        break;

      case 3:
        this.krpanoWrapper.call("\n                tween(view.hlookat, get(lp_hlookat), 7.5, easeInOutSine);\n                tween(view.vlookat, get(lp_vlookat), 7.5, easeInOutSine);\n                delayedcall(3.5, tween(view.distortion,    0, 4, easeInOutSine););\n                tween(\n                    view.fov, \n                    get(lp_fov), \n                    7.5, \n                    easeInOutSine,\n\n                );\n                ");
        setTimeout(function () {
          _this11.callAnimationComplete();

          _this11._initViewLimit();

          if (!_this11.initEnableControlSet) {
            _this11.enableControl(true);
          } else {
            _this11.initEnableControlSet = false;
          }
        }, 7800);
        break;

      case 5:
        this.krpanoWrapper.call("\n                tween(view.vlookat, 90.0, 9.5, easeInOutSine);\n                tween(view.hlookat, get(lp_hlookat), 9.5, easeInOutSine);\n                delayedcall(\n                    animation3_0,\n                    9.6,\n                    tween(\n                        view.fisheye, \n                        0.0,\n                        3\n                    );\n                    tween(\n                        view.fov, \n                        get(lp_fov), \n                        3, \n                        easeInOutSine,\n\n                    );\n                    delayedcall(\n                        0.5, \n                        tween(view.vlookat, get(lp_vlookat), 2.5, easeInOutSine);\n                    );\n                );\n                ");
        setTimeout(function () {
          _this11.callAnimationComplete();

          _this11._initViewLimit();

          if (!_this11.initEnableControlSet) {
            _this11.enableControl(true);
          } else {
            _this11.initEnableControlSet = false;
          }
        }, 12800);
        break;

      case 1:
        this.krpanoWrapper.call("\n                delayedcall(0.5,\n                    set(view.vlookatmin, null);\n                    set(view.vlookatmax, null);\n                    tween(\n                        view.hlookat|view.vlookat|view.fov|view.distortion, \n                        calc('' + lp_hlookat + '|' + lp_vlookat + '|' + lp_fov + '|' + 0.0),\n                        3.0, \n                        easeOutQuad,\n\n                    );\n                );\n                ");
        setTimeout(function () {
          _this11.callAnimationComplete();

          _this11._initViewLimit();

          if (!_this11.initEnableControlSet) {
            _this11.enableControl(true);
          } else {
            _this11.initEnableControlSet = false;
          }
        }, 3800);
        break;
    }
  };

  _proto._initViewLimit = function _initViewLimit() {
    this.krpanoWrapper.call("\n                        copy(view.fovmax, lp_fovmax);\n                        copy(view.fovmin, lp_fovmin);\n                        copy(view.hlookatmin, lp_hlookatmin);\n                        copy(view.hlookatmax, lp_hlookatmax);\n                        copy(view.vlookatmin, lp_vlookatmin);\n                        copy(view.vlookatmax, lp_vlookatmax);\n                        copy(view.limitview, lookat);\n                        ");
  }
  /**
   * 初始化矩阵开场动画
   * @description 无需手动调用。
   */
  ;

  _proto.initFlatAnimation = function initFlatAnimation() {
    var _this12 = this;

    if (this.debug) {
      console.log('initFlatAnimation', this.animationType, this.pauseAnimation);
    }

    if (this.debug) {
      console.log(this.krpanoWrapper.view['fov'], this.krpanoWrapper.view['fovmin'], this.krpanoWrapper.view['fovmax']);
    }

    this.krpanoWrapper.call("\n        set(control.usercontrol, off);\n        copy(lp_scene, xml.scene);\n        copy(lp_hlookat, view.hlookat);\n        copy(lp_vlookat, view.vlookat);\n        copy(lp_fov, view.fov);\n        ");

    if (this.animationType <= 0 && !this.pauseAnimation) {
      setTimeout(function () {
        _this12.callAnimationComplete();

        if (!_this12.initEnableControlSet) {
          _this12.enableControl(true);
        } else {
          _this12.initEnableControlSet = false;
        }
      }, 500);

      if (!this.initEnableControlSet) {
        this.enableControl(true);
      } else {
        this.initEnableControlSet = false;
      }

      return;
    }

    if (this.debug) {
      console.log(this.krpanoWrapper.view['fov'], this.krpanoWrapper.view['fovmin'], this.krpanoWrapper.view['fovmax']);
    }

    if ((this.flatFovType == 0 || this.flatFovType == 2) && this.animationType != 0) {
      this.krpanoWrapper.call("\n            set(view.fov, 0);\n            set(view.hlookat, 0);\n            set(view.vlookat, 0);\n            ");
    } else if (this.animationType != 0) {
      this.krpanoWrapper.call("\n            set(view.fov, " + this.flatFovMax + ");\n            set(view.hlookat, 0);\n            set(view.vlookat, 0);\n            ");
    }

    if (this.debug) {
      console.log(this.krpanoWrapper.view['fov'], this.krpanoWrapper.view['fovmin'], this.krpanoWrapper.view['fovmax']);
    }

    if (this.pauseAnimation != true) {
      setTimeout(function () {
        _this12.playFlatAnimation();
      }, 1000);
    }
  };

  /**
   * 开始播放开场动画
   * @description 仅在加载全景时传入了 pauseAnimation=true 时需要手动调用。
   */
  _proto.playFlatAnimation = function playFlatAnimation() {
    var _this13 = this;

    if (this.debug) {
      console.log('playFlatAnimation', this.flatFovType, this.animationType, this.pauseAnimation);
    }

    if (this.flatFovType == 0) {
      this.krpanoWrapper.call("\n            tween(view.fov, " + this.flatFovMax + ", 2, easeInOutSine);\n            ");
      setTimeout(function () {
        _this13.callAnimationComplete();

        if (!_this13.initEnableControlSet) {
          _this13.enableControl(true);
        } else {
          _this13.initEnableControlSet = false;
        }
      }, 2500);
    } else {
      this.krpanoWrapper.call("\n            tween(view.fov, get(lp_fov), 2, easeInOutSine);\n            tween(view.hlookat, get(lp_hlookat), 2, easeInOutSine);\n            tween(view.vlookat, get(lp_vlookat), 2, easeInOutSine);\n            ");
      setTimeout(function () {
        _this13.callAnimationComplete();

        if (!_this13.initEnableControlSet) {
          _this13.enableControl(true);
        } else {
          _this13.initEnableControlSet = false;
        }
      }, 2500);
    }
  };

  _proto.playCustomAnimation = function playCustomAnimation(type) {
    this.krpanoWrapper.call("stop_custom_animation();animation" + type + "();");
  };

  _proto.stopCustomAnimation = function stopCustomAnimation() {
    this.krpanoWrapper.call("stop_custom_animation();");
  }
  /**
   * 对当前画面进行截图
   * @description 回调用 callbacks.onSnapshootComplete 或 callbacks.onSnapshootError 来返回结果
   */
  ;

  _proto.makeSnapshot = function makeSnapshot() {
    if (this.enableSnapshoot) {
      this.krpanoWrapper.call('make_snapshoot();');
    } else if (this.callbacks.onSnapshootError) {
      console.warn('Snapshot disabled.');
      this.callbacks.onSnapshootError('Snapshot disabled.');
    } else {
      console.warn('Snapshot disabled.');
    }
  }
  /**
   * 返回当前视角的画布
   */
  ;

  _proto.screenshotCanvas = function screenshotCanvas() {
    return global.window.players[this.krpanoWrapper.id].krpanoWebGL.makeScreenshot(0, 0, true, "canvas");
  }
  /**
   * 获取图层
   * @param {string} id - 图层id
   */
  ;

  _proto.getLayerById = function getLayerById(id) {
    return this.krpanoWrapper.layers[id];
  };

  _proto.getLayerByIndex = function getLayerByIndex(index) {
    return this.krpanoWrapper.layers[index];
  };

  _proto.getLayersCount = function getLayersCount() {
    return Object.keys(this.krpanoWrapper.layers).length;
  }
  /**
   * 新增原始图层
   */
  ;

  _proto.addOriginLayer = function addOriginLayer(_ref35) {
    var id = _ref35.id;

    if (this.debug) {
      console.log('addOriginLayer', arguments[0]);
    }

    var layer = this.krpanoWrapper.addLayerById(id, this.krpanoWrapper);

    if (this.callbacks) {
      layer.events['onLoaded'] = this.callbacks['onLayerLoaded'];
      layer.events['onClick'] = this.callbacks['onLayerClick'];
      layer.events['onOver'] = this.callbacks['onLayerOver'];
      layer.events['onOut'] = this.callbacks['onLayerOut'];
      layer.events['onDown'] = this.callbacks['onLayerDown'];
      layer.events['onUp'] = this.callbacks['onLayerUp'];
    }

    if (layer) {
      this.updateOriginLayer(arguments[0]);
    }

    return layer;
  } // addVideoLayer({ id, videourl, posterurl, ath, atv, edge, distorted, scale, scaleX, scaleY, rx, ry, rz, hFov, yaw, pitch, roll, pausedOnStart, loop, volume, muted, zOrder, dragable, titleHotspotId, autoPause, autoResume }) {
  //     // onLayerVideoReady && (this.krpanoWrapper.events['onLayerVideoReady'] = onLayerVideoReady);
  //     // onLayerVideoPlay && (this.krpanoWrapper.events['onLayerVideoPlay'] = onLayerVideoPlay);
  //     // onLayerVideoPaused && (this.krpanoWrapper.events['onLayerVideoPaused'] = onLayerVideoPaused);
  //     // onLayerVideoComplete && (this.krpanoWrapper.events['onLayerVideoComplete'] = onLayerVideoComplete);
  //     // onLayerVideoError && (this.krpanoWrapper.events['onLayerVideoError'] = onLayerVideoError);
  //     if (this.debug) {
  //         console.log('addVideoLayer', arguments[0]);
  //     }
  //     let params = JSON.parse(JSON.stringify(arguments[0]));
  //     params.url = this.__videoPlugin;
  //     params.html5Preload = "metadata";
  //     if (volume == 0) {
  //         params['muted'] = true;
  //     }
  //     let layer = this.addOriginLayer(params);
  //     this.krpanoWrapper.call('set(layer[' + id + '].onvideoready, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onLayerVideoReady({id:\'' + id + '\'});"););');
  //     this.krpanoWrapper.call('set(layer[' + id + '].onvideoplay, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onLayerVideoPlay({id:\'' + id + '\'});"););');
  //     this.krpanoWrapper.call('set(layer[' + id + '].onvideopaused, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onLayerVideoPaused({id:\'' + id + '\'});"););');
  //     this.krpanoWrapper.call('set(layer[' + id + '].onvideocomplete, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onLayerVideoComplete({id:\'' + id + '\'});"););');
  //     return layer;
  // }
  ;

  _proto.updateOriginLayer = function updateOriginLayer(_ref36) {
    var id = _ref36.id,
        url = _ref36.url,
        videourl = _ref36.videourl,
        keep = _ref36.keep,
        width = _ref36.width,
        height = _ref36.height,
        enabled = _ref36.enabled,
        type = _ref36.type,
        align = _ref36.align,
        edge = _ref36.edge,
        vcenter = _ref36.vcenter,
        ox = _ref36.ox,
        oy = _ref36.oy,
        css = _ref36.css,
        handcursor = _ref36.handcursor,
        html = _ref36.html,
        preload = _ref36.preload,
        alpha = _ref36.alpha,
        autoalpha = _ref36.autoalpha,
        visible = _ref36.visible,
        background = _ref36.background,
        parent = _ref36.parent;

    if (this.debug) {
      console.log('updateOriginLayer', arguments[0]);
    }

    var layer = this.getLayerById(id);

    if (layer == undefined) {
      return;
    }

    if (url != undefined) {
      layer.url = url;
    }

    if (videourl != undefined) {
      layer.videourl = videourl;
    }

    if (keep != undefined) {
      layer.keep = keep;
    }

    if (type != undefined) {
      layer.type = type;
    }

    if (visible != undefined) {
      layer.visible = visible;
    }

    if (width != undefined) {
      layer.width = width;
    }

    if (enabled != undefined) {
      layer.enabled = enabled;
    }

    if (height != undefined) {
      layer.height = height;
    }

    if (align != undefined) {
      layer.align = align;
    }

    if (ox != undefined) {
      layer.ox = ox;
    }

    if (oy != undefined) {
      layer.oy = oy;
    }

    if (preload != undefined) {
      layer.preload = preload;
    }

    if (css != undefined) {
      layer.css = css;
    }

    if (html != undefined) {
      layer.html = html;
    }

    if (parent != undefined) {
      layer.parent = parent;
    }

    if (edge != undefined) {
      layer.edge = edge;
    }

    if (background != undefined) {
      layer.background = background;
    }

    if (handcursor != undefined) {
      layer.handcursor = handcursor;
    }

    if (autoalpha != undefined) {
      layer.autoalpha = autoalpha;
    }

    if (alpha != undefined) {
      layer.alpha = alpha;
    }

    if (vcenter != undefined) {
      layer.vcenter = vcenter;
    }
  };

  _proto.tweenLayer = function tweenLayer(_ref37) {
    var id = _ref37.id,
        alpha = _ref37.alpha;
    this.krpanoWrapper.call("set(layer[" + id + "].autoalpha,true);");
    this.krpanoWrapper.call("tween(layer[" + id + "].alpha," + alpha + ",0.5);");
  }
  /**
   * 删除所有热点
   */
  ;

  _proto.removeAllHotspots = function removeAllHotspots() {
    if (this.debug) {
      console.log('removeAllHotspots');
    }

    this.krpanoWrapper.call("\n        copy(hotspotCount,hotspot.count);\n        createarray(needRemoveHotspots);\n        for(set(i,0),i LT hotspotCount,inc(i),\n            needRemoveHotspots.createarrayitem(get(hotspot[get(i)].name));\n        );\n        for(set(i,0),i LT needRemoveHotspots.count,inc(i),\n            removehotspot(get(needRemoveHotspots[get(i)].name));\n        );\n\n        copy(layerCount,layer.count);\n        createarray(needRemoveLayers);\n        for(set(i,0),i LT layerCount,inc(i),\n            if(layer[get(i)].keep != true,\n                needRemoveLayers.createarrayitem(get(layer[get(i)].name));\n            );\n        );\n        for(set(i,0),i LT needRemoveLayers.count,inc(i),\n            removelayer(get(needRemoveLayers[get(i)].name));\n        );\n        \n        copy(pluginCount,plugin.count);\n        createarray(needRemovePlugins);\n        for(set(i,0),i LT pluginCount,inc(i),\n            if(plugin[get(i)].keep != true AND plugin[get(i)].name !== null AND plugin[get(i)].needRemove == true,\n                needRemovePlugins.createarrayitem(get(plugin[get(i)].name));\n            );\n        );\n        for(set(i,0),i LT needRemovePlugins.count,inc(i),\n            removeplugin(get(needRemovePlugins[get(i)].name));\n        );\n        ");
  }
  /**
   * 新增原始热点
   * @description 如无特殊需求不用直接调用，使用 addImageHotspot addVideoHotspot addTextHotspot addPolygonHotspot 
   */
  ;

  _proto.addOriginHotspot = function addOriginHotspot(_ref38) {
    var id = _ref38.id,
        type = _ref38.type,
        url = _ref38.url,
        keep = _ref38.keep,
        dragable = _ref38.dragable,
        renderer = _ref38.renderer,
        visible = _ref38.visible,
        enabled = _ref38.enabled,
        handcursor = _ref38.handcursor,
        cursor = _ref38.cursor,
        maskChildren = _ref38.maskChildren,
        zOrder = _ref38.zOrder,
        capture = _ref38.capture,
        captureFocus = _ref38.captureFocus,
        children = _ref38.children,
        blendMode = _ref38.blendMode,
        alphaChannel = _ref38.alphaChannel,
        chromakey = _ref38.chromakey,
        mipmapping = _ref38.mipmapping,
        premultiplyAlpha = _ref38.premultiplyAlpha,
        style = _ref38.style,
        ath = _ref38.ath,
        atv = _ref38.atv,
        edge = _ref38.edge,
        ox = _ref38.ox,
        oy = _ref38.oy,
        oref = _ref38.oref,
        zoom = _ref38.zoom,
        distorted = _ref38.distorted,
        rotationOrder = _ref38.rotationOrder,
        rx = _ref38.rx,
        ry = _ref38.ry,
        rz = _ref38.rz,
        inverseRotation = _ref38.inverseRotation,
        depth = _ref38.depth,
        depthBuffer = _ref38.depthBuffer,
        tOrigin = _ref38.tOrigin,
        tX = _ref38.tX,
        tY = _ref38.tY,
        tZ = _ref38.tZ,
        prealign = _ref38.prealign,
        flying = _ref38.flying,
        scaleFlying = _ref38.scaleFlying,
        width = _ref38.width,
        height = _ref38.height,
        scale = _ref38.scale,
        rotate = _ref38.rotate,
        pixelHitTest = _ref38.pixelHitTest,
        accuracy = _ref38.accuracy,
        alpha = _ref38.alpha,
        autoAlpha = _ref38.autoAlpha,
        useContentSize = _ref38.useContentSize,
        scale9Grid = _ref38.scale9Grid,
        stereo = _ref38.stereo,
        crop = _ref38.crop,
        onOverCrop = _ref38.onOverCrop,
        onDownCrop = _ref38.onDownCrop,
        scaleChildren = _ref38.scaleChildren,
        onClick = _ref38.onClick,
        onLoaded = _ref38.onLoaded,
        fillColor = _ref38.fillColor,
        fillAlpha = _ref38.fillAlpha,
        borderWidth = _ref38.borderWidth,
        borderColor = _ref38.borderColor,
        borderAlpha = _ref38.borderAlpha,
        borderZoom = _ref38.borderZoom,
        borderHitTest = _ref38.borderHitTest,
        subDiv = _ref38.subDiv,
        titleHotspotId = _ref38.titleHotspotId,
        hotspotId = _ref38.hotspotId,
        pointId = _ref38.pointId,
        events = _ref38.events,
        isDiv = _ref38.isDiv,
        isComment = _ref38.isComment,
        clickTargetId = _ref38.clickTargetId;

    if (this.debug) {
      console.log('addOriginHotspot', arguments[0]);
    }

    var hotspot = this.krpanoWrapper.addHotspotById(id, this.krpanoWrapper);

    if (this.callbacks) {
      hotspot.events['onLoaded'] = this.callbacks['onHotspotLoaded'];
      hotspot.events['onClick'] = this.onHotspotClick.bind(this); //this.callbacks['onHotspotClick'];

      hotspot.events['onOver'] = this.onHotspotOver.bind(this); //this.callbacks['onHotspotOver'];

      hotspot.events['onOut'] = this.onHotspotOut.bind(this); //this.callbacks['onHotspotOut'];

      hotspot.events['onDown'] = this.onHotspotDown.bind(this); //this.callbacks['onHotspotDown'];

      hotspot.events['onUp'] = this.onHotspotUp.bind(this); //this.callbacks['onHotspotUp']
    }

    if (hotspot) {
      if (arguments[0].ath == undefined) {
        arguments[0].ath = this.getView().hlookat;
      }

      if (arguments[0].atv == undefined) {
        arguments[0].atv = this.getView().vlookat;
      }

      this.updateOriginHotspot(arguments[0]);
    }

    return hotspot;
  }
  /**
   * 更新原始热点
   * @param {} id
   * @param {} type
   * @param {} url
   * @param {} keep
   * @param {} renderer
   * @param {} visible
   * @param {} enabled
   * @param {} handcursor
   * @param {} cursor
   * @param {} maskChildren
   * @param {} zOrder
   * @param {} capture
   * @param {} children
   * @param {} blendMode
   * @param {} alphaChannel
   * @param {} chromakey
   * @param {} mipmapping
   * @param {} premultiplyAlpha
   * @param {} style
   * @param {} ath
   * @param {} atv
   * @param {} edge - 中心点， lefttop, left, leftbottom, top, center, bottom, righttop, right
   * @param {} ox
   * @param {} oy
   * @param {} oref
   * @param {} zoom
   * @param {} distorted
   * @param {} rotationOrder
   * @param {} rx
   * @param {} ry
   * @param {} rz
   * @param {} inverseRotation
   * @param {} depth
   * @param {} depthBuffer
   * @param {} tOrigin
   * @param {} tx
   * @param {} ty
   * @param {} tz
   * @param {} prealign
   * @param {} flying
   * @param {} scaleFlying
   * @param {} width
   * @param {} height
   * @param {} scale
   * @param {} rotate
   * @param {} pixelHitTest
   * @param {} accuracy
   * @param {} alpha
   * @param {} autoAlpha
   * @param {} useContentSize
   * @param {} scale9Grid
   * @param {} stereo
   * @param {} crop
   * @param {} onOverCrop
   * @param {} onDownCrop
   * @param {} scaleChildren
   * @param {} onClick
   * @param {} onLoaded
   * @param {} fillColor
   * @param {} fillAlpha
   * @param {} borderWidth
   * @param {} borderColor
   * @param {} borderAlpha
   * @param {} borderZoom
   * @param {} borderHitTest
   * @param {} subDiv
   * @param {} fadeVisibleDuration
   * 'html': 'html',
          'css': 'css',
          'vCenter': 'vcenter',
          'padding': 'padding',
          'wordwrap': 'wordwrap',
          'bg': 'bg',
          'bgColor': 'bgcolor',
          'bgAlpha': 'bgalpha',
          'bgBorder': 'bgborder',
          'bgRoundedge': 'bgroundedge',
          'bgShadow': 'bgshadow',
          'txtShadow': 'txtshadow',
          'mergedAlpha': 'mergedalpha',
          'overSampling': 'oversampling',
          'mipmapping': 'mipmapping',
   */
  ;

  _proto.updateOriginHotspot = function updateOriginHotspot(_ref39) {
    var id = _ref39.id,
        type = _ref39.type,
        url = _ref39.url,
        keep = _ref39.keep,
        dragable = _ref39.dragable,
        fontFamily = _ref39.fontFamily,
        fontSize = _ref39.fontSize,
        fontColor = _ref39.fontColor,
        fontAlpha = _ref39.fontAlpha,
        align = _ref39.align,
        renderer = _ref39.renderer,
        visible = _ref39.visible,
        enabled = _ref39.enabled,
        handcursor = _ref39.handcursor,
        cursor = _ref39.cursor,
        maskChildren = _ref39.maskChildren,
        zOrder = _ref39.zOrder,
        capture = _ref39.capture,
        captureFocus = _ref39.captureFocus,
        children = _ref39.children,
        blendMode = _ref39.blendMode,
        alphaChannel = _ref39.alphaChannel,
        chromakey = _ref39.chromakey,
        mipmapping = _ref39.mipmapping,
        premultiplyAlpha = _ref39.premultiplyAlpha,
        style = _ref39.style,
        ath = _ref39.ath,
        atv = _ref39.atv,
        edge = _ref39.edge,
        ox = _ref39.ox,
        oy = _ref39.oy,
        oref = _ref39.oref,
        zoom = _ref39.zoom,
        distorted = _ref39.distorted,
        rotationOrder = _ref39.rotationOrder,
        rx = _ref39.rx,
        ry = _ref39.ry,
        rz = _ref39.rz,
        hFov = _ref39.hFov,
        yaw = _ref39.yaw,
        pitch = _ref39.pitch,
        roll = _ref39.roll,
        inverseRotation = _ref39.inverseRotation,
        depth = _ref39.depth,
        depthBuffer = _ref39.depthBuffer,
        tOrigin = _ref39.tOrigin,
        tX = _ref39.tX,
        tY = _ref39.tY,
        tZ = _ref39.tZ,
        prealign = _ref39.prealign,
        flying = _ref39.flying,
        scaleFlying = _ref39.scaleFlying,
        width = _ref39.width,
        height = _ref39.height,
        scale = _ref39.scale,
        scaleX = _ref39.scaleX,
        scaleY = _ref39.scaleY,
        rotate = _ref39.rotate,
        pixelHitTest = _ref39.pixelHitTest,
        accuracy = _ref39.accuracy,
        alpha = _ref39.alpha,
        autoAlpha = _ref39.autoAlpha,
        useContentSize = _ref39.useContentSize,
        scale9Grid = _ref39.scale9Grid,
        stereo = _ref39.stereo,
        crop = _ref39.crop,
        onOverCrop = _ref39.onOverCrop,
        onDownCrop = _ref39.onDownCrop,
        scaleChildren = _ref39.scaleChildren,
        onClick = _ref39.onClick,
        onLoaded = _ref39.onLoaded,
        fillColor = _ref39.fillColor,
        fillAlpha = _ref39.fillAlpha,
        borderWidth = _ref39.borderWidth,
        borderColor = _ref39.borderColor,
        borderAlpha = _ref39.borderAlpha,
        normalFillColor = _ref39.normalFillColor,
        normalFillAlpha = _ref39.normalFillAlpha,
        normalBorderWidth = _ref39.normalBorderWidth,
        normalBorderColor = _ref39.normalBorderColor,
        normalBorderAlpha = _ref39.normalBorderAlpha,
        overFillColor = _ref39.overFillColor,
        overFillAlpha = _ref39.overFillAlpha,
        overBorderWidth = _ref39.overBorderWidth,
        overBorderColor = _ref39.overBorderColor,
        overBorderAlpha = _ref39.overBorderAlpha,
        borderZoom = _ref39.borderZoom,
        borderHitTest = _ref39.borderHitTest,
        subDiv = _ref39.subDiv,
        html = _ref39.html,
        vCenter = _ref39.vCenter,
        padding = _ref39.padding,
        wordwrap = _ref39.wordwrap,
        bg = _ref39.bg,
        bgColor = _ref39.bgColor,
        bgAlpha = _ref39.bgAlpha,
        bgBorder = _ref39.bgBorder,
        bgRoundedge = _ref39.bgRoundedge,
        bgShadow = _ref39.bgShadow,
        txtShadow = _ref39.txtShadow,
        mergedAlpha = _ref39.mergedAlpha,
        overSampling = _ref39.overSampling,
        titleHotspotId = _ref39.titleHotspotId,
        frameWidth = _ref39.frameWidth,
        frameHeight = _ref39.frameHeight,
        frameX = _ref39.frameX,
        frameY = _ref39.frameY,
        frameCount = _ref39.frameCount,
        frameDuration = _ref39.frameDuration,
        videoUrl = _ref39.videoUrl,
        posterUrl = _ref39.posterUrl,
        loop = _ref39.loop,
        volume = _ref39.volume,
        muted = _ref39.muted,
        pausedOnStart = _ref39.pausedOnStart,
        onVideoReady = _ref39.onVideoReady,
        onVideoPlay = _ref39.onVideoPlay,
        onVideoPaused = _ref39.onVideoPaused,
        onVideoComplete = _ref39.onVideoComplete,
        onError = _ref39.onError,
        hotspotId = _ref39.hotspotId,
        pointId = _ref39.pointId,
        autoPlayType = _ref39.autoPlayType,
        autoPlayDuration = _ref39.autoPlayDuration,
        urls = _ref39.urls,
        showImageBorder = _ref39.showImageBorder,
        extendImage = _ref39.extendImage,
        extendImageUrl = _ref39.extendImageUrl,
        extendImageWidth = _ref39.extendImageWidth,
        extendImageLength = _ref39.extendImageLength,
        autoPause = _ref39.autoPause,
        autoResume = _ref39.autoResume,
        html5Preload = _ref39.html5Preload,
        events = _ref39.events,
        blink = _ref39.blink,
        blinkDuration = _ref39.blinkDuration,
        autoResize = _ref39.autoResize,
        isLine = _ref39.isLine,
        endPointMode = _ref39.endPointMode,
        polyline = _ref39.polyline,
        css = _ref39.css,
        isDiv = _ref39.isDiv,
        isComment = _ref39.isComment,
        clickTargetId = _ref39.clickTargetId,
        fadeVisibleDuration = _ref39.fadeVisibleDuration;

    if (this.debug) {
      console.log('updateOriginHotspot', arguments[0]);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot == undefined) {
      return;
    }

    if (this.type == 2) {
      if (scale != undefined) {
        if (distorted != undefined) {
          scale = scale * (distorted ? 0.005 : 1);
        } else {
          scale = scale * (hotspot.distorted ? 0.005 : 1);
        }
      }

      if (scaleX != undefined) {
        if (distorted != undefined) {
          scaleX = scaleX * (distorted ? 0.005 : 1);
        } else {
          scaleX = scaleX * (hotspot.distorted ? 0.005 : 1);
        }
      }

      if (scaleY != undefined) {
        if (distorted != undefined) {
          scaleY = scaleY * (distorted ? 0.005 : 1);
        } else {
          scaleY = scaleY * (hotspot.distorted ? 0.005 : 1);
        }
      }

      if (ox != undefined) {
        if (distorted != undefined) {
          ox = ox * (distorted ? 0.005 : 1);
        } else {
          ox = ox * (hotspot.distorted ? 0.005 : 1);
        }
      }

      if (oy != undefined) {
        if (distorted != undefined) {
          oy = oy * (distorted ? 0.005 : 1);
        } else {
          oy = oy * (hotspot.distorted ? 0.005 : 1);
        }
      }

      if (distorted != undefined && hotspot.distorted != distorted && scale == undefined && scaleX == undefined && scaleY == undefined) {
        if (hotspot.scale) {
          scale = hotspot.scale * (distorted ? 0.005 : 1.0 / 0.005);
        }

        if (hotspot.scaleX) {
          scaleX = hotspot.scaleX * (distorted ? 0.005 : 1.0 / 0.005);
        }

        if (hotspot.scaleY) {
          scaleY = hotspot.scaleY * (distorted ? 0.005 : 1.0 / 0.005);
        }

        if (scaleX != undefined || scaleY != undefined) {
          scale = 1;
        }
      }
    }

    if (type != undefined) {
      hotspot.type = type;
    }

    if (url != undefined) {
      hotspot.url = url;

      if (scaleX != undefined || scaleY != undefined) {
        hotspot.width = 0;
        hotspot.height = 0;
      }

      if (url.toLowerCase().indexOf('.gif', url.length - '.gif'.length) !== -1) {
        hotspot.renderer = "css3d";
        this.krpanoWrapper.set("hotspot[" + id + "].isGif", true);
      } else {
        hotspot.renderer = 'webgl';
        this.krpanoWrapper.set("hotspot[" + id + "].isGif", false);
      }
    }

    if (keep != undefined) {
      hotspot.keep = keep;
    }

    if (renderer != undefined) {
      hotspot.renderer = renderer;
    }

    if (visible != undefined) {
      if (fadeVisibleDuration && fadeVisibleDuration > 0) {
        this.fadeHotspotVisible({
          id: id,
          visible: visible,
          duration: fadeVisibleDuration
        });

        if (hotspot.iconImage != undefined) {
          var _iconImageHotspot = this.getHotspotById(hotspot.iconImage);

          if (_iconImageHotspot != undefined) {
            this.fadeHotspotVisible({
              id: hotspot.iconImage,
              visible: visible,
              duration: fadeVisibleDuration
            });
          }
        }

        if (hotspot.extendImage != undefined) {
          var extendImageHotspot = this.getHotspotById(hotspot.extendImage);

          if (extendImageHotspot != undefined) {
            this.fadeHotspotVisible({
              id: hotspot.extendImage,
              visible: visible,
              duration: fadeVisibleDuration
            });
          }
        }

        if (this.krpanoWrapper.get("hotspot[" + id + "].posterId") != undefined) {
          var posterIdHotspot = this.getHotspotById(this.krpanoWrapper.get("hotspot[" + id + "].posterId"));

          if (posterIdHotspot != undefined && this.hotspotVideoIsPaused(id)) {
            this.fadeHotspotVisible({
              id: posterIdHotspot.id,
              visible: visible,
              duration: fadeVisibleDuration
            });
          }
        }

        var frameImageHotspot = this.getHotspotById(id + "_copy");

        if (frameImageHotspot != undefined) {
          this.fadeHotspotVisible({
            id: frameImageHotspot.id,
            visible: visible,
            duration: fadeVisibleDuration
          });
        }

        if (visible === false) {
          this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
        }

        if (visible === true) {
          this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, true);');
        }
      } else {
        hotspot.visible = visible;

        if (hotspot.iconImage != undefined) {
          var _iconImageHotspot2 = this.getHotspotById(hotspot.iconImage);

          if (_iconImageHotspot2 != undefined) {
            _iconImageHotspot2.visible = visible;
          }
        }

        if (hotspot.extendImage != undefined) {
          var _extendImageHotspot = this.getHotspotById(hotspot.extendImage);

          if (_extendImageHotspot != undefined) {
            _extendImageHotspot.visible = visible;
          }
        }

        if (this.krpanoWrapper.get("hotspot[" + id + "].posterId") != undefined) {
          var _posterIdHotspot = this.getHotspotById(this.krpanoWrapper.get("hotspot[" + id + "].posterId"));

          if (_posterIdHotspot != undefined && this.hotspotVideoIsPaused(id)) {
            _posterIdHotspot.visible = visible;
          }
        }

        var _frameImageHotspot = this.getHotspotById(id + "_copy");

        if (_frameImageHotspot != undefined) {
          _frameImageHotspot.visible = visible;
        }

        if (visible === false) {
          this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
        }

        if (visible === true) {
          this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, true);');
        }
      }
    }

    if (enabled != undefined) {
      hotspot.enabled = enabled;
      this.krpanoWrapper.call('set(hotspot[' + id + '_poster].enabled, ' + enabled + ');');
    }

    if (clickTargetId != undefined) {
      hotspot.clickTargetId = clickTargetId;
    }

    if (handcursor != undefined) {
      hotspot.handcursor = handcursor;
    }

    if (cursor != undefined) {
      hotspot.cursor = cursor;
    }

    if (maskChildren != undefined) {
      hotspot.maskChildren = maskChildren;
    }

    if (zOrder != undefined) {
      hotspot.zOrder = zOrder;
    }

    if (capture != undefined) {
      hotspot.capture = capture;
    }

    if (isDiv != undefined) {
      hotspot.isDiv = isDiv;
    }

    if (isComment != undefined) {
      hotspot.isComment = isComment;
    }

    if (children != undefined) {
      hotspot.children = children;
    }

    if (blendMode != undefined) {
      hotspot.blendMode = blendMode;
    }

    if (alphaChannel != undefined) {
      hotspot.alphaChannel = alphaChannel;
    }

    if (chromakey != undefined) {
      hotspot.chromakey = chromakey;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].chromakey", hotspot.chromakey);
    }

    if (mipmapping != undefined) {
      hotspot.mipmapping = mipmapping;
    }

    if (premultiplyAlpha != undefined) {
      hotspot.premultiplyAlpha = premultiplyAlpha;
    }

    if (captureFocus != undefined) {
      hotspot.captureFocus = captureFocus;
    }

    if (style != undefined) {
      hotspot.style = style;
    }

    if (ath != undefined) {
      hotspot.ath = ath;
      this.krpanoWrapper.call('if(hotspot[' + id + '].titleHotspotId !== null, set(hotspot[get(hotspot[' + id + '].titleHotspotId)].ath, ' + hotspot.ath + '););');
    }

    if (atv != undefined) {
      hotspot.atv = atv;
      this.krpanoWrapper.call('if(hotspot[' + id + '].titleHotspotId !== null, set(hotspot[get(hotspot[' + id + '].titleHotspotId)].atv, ' + hotspot.atv + '););');
    }

    if (ath != undefined || atv != undefined) {
      this.krpanoWrapper.call('if(hotspot[' + id + '].onautosized !== null, callwith(hotspot[' + id + '], onautosized););');

      if (hotspot.showImageBorder) {
        this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].ath", hotspot.ath);
        this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].atv", hotspot.atv);
      }

      this.krpanoWrapper.set("hotspot[" + id + "_poster].ath", hotspot.ath);
      this.krpanoWrapper.set("hotspot[" + id + "_poster].atv", hotspot.atv);
    }

    if (edge != undefined) {
      hotspot.edge = edge;
      this.krpanoWrapper.call('if(hotspot[' + id + '].onautosized !== null, callwith(hotspot[' + id + '], onautosized););');
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].edge", hotspot.edge);
    }

    if (ox != undefined) {
      hotspot.ox = ox;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].ox", hotspot.ox);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].ox", hotspot.ox);
    }

    if (oy != undefined) {
      hotspot.oy = oy;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].oy", hotspot.oy);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].oy", hotspot.oy);
    }

    if (oref != undefined) {
      hotspot.oref = oref;
    }

    if (zoom != undefined) {
      hotspot.zoom = zoom;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].zoom", hotspot.zoom);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].zoom", hotspot.zoom);
    }

    if (distorted != undefined) {
      hotspot.distorted = distorted;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].distorted", hotspot.distorted);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].distorted", hotspot.distorted);
    }

    if (rotationOrder != undefined) {
      hotspot.rotationOrder = rotationOrder;
    }

    if (rx != undefined) {
      hotspot.rx = rx;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].rx", hotspot.rx);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].rx", hotspot.rx);
    }

    if (ry != undefined) {
      hotspot.ry = ry;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].ry", hotspot.ry);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].ry", hotspot.ry);
    }

    if (rz != undefined) {
      hotspot.rz = rz;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].rz", hotspot.rz);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].rz", hotspot.rz);
    }

    if (hFov != undefined) {
      hotspot.hFov = hFov;
    }

    if (yaw != undefined) {
      hotspot.yaw = yaw;
    }

    if (pitch != undefined) {
      hotspot.pitch = pitch;
    }

    if (roll != undefined) {
      hotspot.roll = roll;
    }

    if (inverseRotation != undefined) {
      hotspot.inverseRotation = inverseRotation;
    }

    if (depth != undefined) {
      hotspot.depth = depth;
    }

    if (depthBuffer != undefined) {
      hotspot.depthBuffer = depthBuffer;
    }

    if (tOrigin != undefined) {
      hotspot.tOrigin = tOrigin;
    }

    if (tX != undefined) {
      hotspot.tx = tX;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].tx", hotspot.tx);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].tx", hotspot.tx);
    }

    if (tY != undefined) {
      hotspot.ty = tY;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].ty", hotspot.ty);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].ty", hotspot.ty);
    }

    if (tZ != undefined) {
      hotspot.tz = tZ;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].tz", hotspot.tz);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].tz", hotspot.tz);
    }

    if (prealign != undefined) {
      hotspot.prealign = prealign;
    }

    if (flying != undefined) {
      hotspot.flying = flying;
    }

    if (scaleFlying != undefined) {
      hotspot.scaleFlying = scaleFlying;
    }

    if (width != undefined) {
      hotspot.width = width;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].width", hotspot.width);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].width", hotspot.width);
    }

    if (height != undefined) {
      hotspot.height = height;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].height", hotspot.height);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].height", hotspot.height);
    }

    if (scale != undefined) {
      hotspot.scale = scale;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].scale", hotspot.scale);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].scale", hotspot.scale);
    }

    if (scaleY != undefined) {
      hotspot.scaleY = scaleY;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].scaleY", hotspot.scaleY);

      if (scaleX == undefined) {
        this.krpanoWrapper.call('scale_to_xy(' + id + ');');
      }
    }

    if (scaleX != undefined) {
      hotspot.scaleX = scaleX;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].scaleX", hotspot.scaleX);
      this.krpanoWrapper.call('scale_to_xy(' + id + ');');
    }

    if (scaleX != undefined || scaleY != undefined) {
      this.krpanoWrapper.call("if(hotspot[" + id + "_copy] !== null,set(hotspot[" + id + "_copy].scalex," + hotspot.scaleX + ");set(hotspot[" + id + "_copy].scaley," + hotspot.scaleY + ");scale_to_xy(" + id + "_copy);)");
    }

    if (rotate != undefined) {
      hotspot.rotate = rotate;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].rotate", hotspot.rotate);

      if (hotspot.showImageBorder) {
        this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].rotate", hotspot.rotate);
      }
    }

    if (pixelHitTest != undefined) {
      hotspot.pixelHitTest = pixelHitTest;
    }

    if (accuracy != undefined) {
      hotspot.accuracy = accuracy;
    }

    if (alpha != undefined) {
      hotspot.alpha = alpha;
      this.krpanoWrapper.set("hotspot[" + id + "_poster].alpha", hotspot.alpha);
      this.krpanoWrapper.set("hotspot[" + hotspot.borderImageId + "].alpha", hotspot.alpha);
    }

    if (autoAlpha != undefined) {
      hotspot.autoAlpha = autoAlpha;
    }

    if (useContentSize != undefined) {
      hotspot.useContentSize = useContentSize;
    }

    if (scale9Grid != undefined) {
      hotspot.scale9Grid = scale9Grid;
      hotspot.renderer = 'css3d';
    }

    if (stereo != undefined) {
      hotspot.stereo = stereo;
    }

    if (crop != undefined) {
      hotspot.crop = crop;
    }

    if (onOverCrop != undefined) {
      hotspot.onOverCrop = onOverCrop;
    }

    if (onDownCrop != undefined) {
      hotspot.onDownCrop = onDownCrop;
    }

    if (scaleChildren != undefined) {
      hotspot.scaleChildren = scaleChildren;
    }

    if (onClick != undefined) {
      hotspot.onClick = onClick;
    }

    if (onLoaded != undefined) {
      hotspot.onLoaded = onLoaded;
    }

    if (fillColor != undefined) {
      hotspot.fillColor = this.colorValue(fillColor);
    }

    if (fillAlpha != undefined) {
      hotspot.fillAlpha = fillAlpha;
    }

    if (borderWidth != undefined) {
      hotspot.borderWidth = borderWidth;
    }

    if (borderColor != undefined) {
      hotspot.borderColor = this.colorValue(borderColor);
    }

    if (borderAlpha != undefined) {
      hotspot.borderAlpha = borderAlpha;
    }

    if (normalFillColor != undefined) {
      hotspot.normalFillColor = this.colorValue(normalFillColor);
    }

    if (normalFillAlpha != undefined) {
      hotspot.normalFillAlpha = normalFillAlpha;
    }

    if (normalBorderWidth != undefined) {
      hotspot.normalBorderWidth = normalBorderWidth;
    }

    if (normalBorderColor != undefined) {
      hotspot.normalBorderColor = this.colorValue(normalBorderColor);
    }

    if (normalBorderAlpha != undefined) {
      hotspot.normalBorderAlpha = normalBorderAlpha;
    }

    if (overFillColor != undefined) {
      hotspot.overFillColor = this.colorValue(overFillColor);
    }

    if (overFillAlpha != undefined) {
      hotspot.overFillAlpha = overFillAlpha;
    }

    if (overBorderWidth != undefined) {
      hotspot.overBorderWidth = overBorderWidth;
    }

    if (overBorderColor != undefined) {
      hotspot.overBorderColor = this.colorValue(overBorderColor);
    }

    if (overBorderAlpha != undefined) {
      hotspot.overBorderAlpha = overBorderAlpha;
    }

    if (borderZoom != undefined) {
      hotspot.borderZoom = borderZoom;
    }

    if (borderHitTest != undefined) {
      hotspot.borderHitTest = borderHitTest;
    }

    if (subDiv != undefined) {
      hotspot.subDiv = subDiv;
    }

    if (autoResize != undefined) {
      hotspot.autoResize = autoResize;
    }

    if (html != undefined) {
      if (html != '' && hotspot.autoResize != false) {
        this.krpanoWrapper.call('set(hotspot[' + id + '].autowidth, true);');
        this.krpanoWrapper.call('set(hotspot[' + id + '].autoheight, true);');
        hotspot.width = '';
        hotspot.height = '';
      } else {
        this.krpanoWrapper.call('set(hotspot[' + id + '].autowidth, auto);');
        this.krpanoWrapper.call('set(hotspot[' + id + '].autoheight, auto);');
      }

      hotspot.html = html;
    } // if (css != undefined) {
    //     hotspot.css = css;
    // }


    if (vCenter != undefined) {
      hotspot.vCenter = vCenter;
    }

    if (padding != undefined) {
      hotspot.padding = padding;
    }

    if (wordwrap != undefined) {
      hotspot.wordwrap = wordwrap;
    }

    if (bg != undefined) {
      hotspot.bg = bg;
    }

    if (bgColor != undefined) {
      hotspot.bgColor = this.colorValue(bgColor);
    }

    if (bgAlpha != undefined) {
      hotspot.bgAlpha = bgAlpha;
    }

    if (bgBorder != undefined) {
      hotspot.bgBorder = bgBorder;
    }

    if (bgRoundedge != undefined) {
      hotspot.bgRoundedge = bgRoundedge;
    }

    if (bgShadow != undefined) {
      hotspot.bgShadow = bgShadow;
    }

    if (txtShadow != undefined) {
      hotspot.txtShadow = txtShadow;
    }

    if (mergedAlpha != undefined) {
      hotspot.mergedAlpha = mergedAlpha;
    }

    if (overSampling != undefined) {
      hotspot.overSampling = overSampling;
    }

    if (mipmapping != undefined) {
      hotspot.mipmapping = mipmapping;
    }

    if (titleHotspotId != undefined) {
      hotspot.titleHotspotId = titleHotspotId;
    }

    if (hotspotId != undefined) {
      hotspot.hotspotId = hotspotId;
    }

    if (pointId != undefined) {
      hotspot.pointId = pointId;
    }

    if (blink != undefined) {
      hotspot.blink = blink;
    }

    if (blinkDuration != undefined) {
      hotspot.blinkDuration = blinkDuration;
    }

    if (autoPlayType != undefined) {
      hotspot.autoPlayType = autoPlayType;
      this.krpanoWrapper.call('stopdelayedcall(image_play_call_' + id + ');set(hotspot[' + id + '].isImagePlaying, false);');
    }

    if (autoPlayDuration != undefined) {
      hotspot.autoPlayDuration = autoPlayDuration;
    }

    if (urls != undefined) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].url, ' + urls[0] + ');');
      this.krpanoWrapper.call('set(hotspot[' + id + '].autoplayindex, 1);');
      this.krpanoWrapper.call('set(hotspot[' + id + '].autoplayshow, true);'); // this.krpanoWrapper.call('set(hotspot[' + id + '].alpha, 1);');
      // this.krpanoWrapper.call('set(hotspot[' + id + '].enabled, true);');
      // this.krpanoWrapper.call('if(hotspot[' + id + '] !== null, set(hotspot[' + id + '_copy].alpha, 0); set(hotspot[' + id + '_copy].enabled, false););');

      hotspot.urls = urls;

      if (urls.length == 1 && hotspot.visible) {
        this.krpanoWrapper.call('set(hotspot[' + id + '].enabled, true);');
        this.krpanoWrapper.call('set(hotspot[' + id + '].alpha, 1);');
        this.krpanoWrapper.call('set(hotspot[' + id + '].visible, true);');
        this.krpanoWrapper.call("removehotspot(" + id + "_copy);");

        if (enabled != undefined) {
          hotspot.enabled = enabled;
        }
      }
    }

    if (frameWidth != undefined) {
      hotspot.frameWidth = frameWidth;
    }

    if (frameHeight != undefined) {
      hotspot.frameHeight = frameHeight;
    }

    if (frameCount != undefined) {
      hotspot.frame = 0;
      hotspot.latestFrame = frameCount - 1;
      hotspot.frameCount = frameCount;

      if (frameCount > 1) {
        hotspot.onLoaded = 'if(hotspot[' + id + '].start_animation != true, frame_animation(););';
      } else {
        hotspot.crop = (frameX || 0) + '|' + (frameY || 0) + '|' + frameWidth + '|' + frameHeight;
      }
    }

    if (frameDuration != undefined) {
      hotspot.frameDuration = frameDuration;
    }

    if (extendImage != undefined) {
      hotspot.extendImage = extendImage;
    }

    if (onVideoReady != undefined) {
      hotspot.onVideoReady = onVideoReady;
    }

    if (pausedOnStart != undefined) {
      hotspot.pausedOnStart = pausedOnStart;
    }

    if (videoUrl != undefined) {
      hotspot.videoUrl = videoUrl;
    }

    if (posterUrl != undefined) {
      hotspot.posterUrl = posterUrl;
    }

    if (loop != undefined) {
      hotspot.loop = loop;
    }

    if (volume != undefined) {
      hotspot.volume = volume;
    }

    if (muted != undefined) {
      hotspot.muted = muted;
    }

    if (autoPause != undefined) {
      hotspot.autoPause = autoPause;
    }

    if (autoResume != undefined) {
      hotspot.autoResume = autoResume;
    }

    if (html5Preload != undefined) {
      hotspot.html5Preload = html5Preload;
    }

    if (onVideoPlay != undefined) {
      hotspot.onVideoPlay = onVideoPlay;
    }

    if (onVideoPaused != undefined) {
      hotspot.onVideoPaused = onVideoPaused;
    }

    if (onVideoComplete != undefined) {
      hotspot.onVideoComplete = onVideoComplete;
    }

    if (onError != undefined) {
      hotspot.onError = onError;
    }

    if (fontFamily != undefined) {
      hotspot.fontFamily = fontFamily;
    }

    if (align != undefined) {
      hotspot.align = align;
    }

    if (fontSize != undefined) {
      hotspot.fontSize = fontSize;
    }

    if (fontColor != undefined) {
      hotspot.fontColor = this.hexColor(fontColor);
    }

    if (fontAlpha != undefined) {
      hotspot.fontAlpha = fontAlpha;
    }

    var cssStr = '';

    if (hotspot.align != undefined) {
      cssStr += 'text-align:' + hotspot.align + ';';
    }

    if (hotspot.fontFamily != undefined) {
      cssStr += 'font-family:' + hotspot.fontFamily + ';';
    }

    if (hotspot.fontSize != undefined) {
      cssStr += 'font-size:' + hotspot.fontSize + 'px;';
    }

    if (hotspot.fontColor != undefined) {
      cssStr += 'color:' + hotspot.fontColor + ';';
    }

    if (hotspot.fontAlpha != undefined) {
      cssStr += 'opacity:' + hotspot.fontAlpha + ';';
    }

    if (cssStr != '') {
      hotspot.css = cssStr;
    }

    if (css != undefined) {
      hotspot.css = css;
    }

    if (borderWidth != undefined) {
      hotspot.borderWidth = borderWidth;
    }

    if (borderColor != undefined) {
      hotspot.borderColor = this.colorValue(borderColor);
    }

    if (borderAlpha != undefined) {
      hotspot.borderAlpha = borderAlpha;
    }

    if (isLine != undefined) {
      hotspot.isLine = isLine;
    }

    if (endPointMode != undefined) {
      hotspot.endPointMode = endPointMode;
    }

    if (polyline != undefined) {
      hotspot.polyline = polyline;
    }

    if (hotspot.borderWidth != undefined && hotspot.border == true) {
      var border = '';
      border += hotspot.borderWidth + ' ';

      if (hotspot.borderColor != undefined) {
        border += hotspot.borderColor + ' ';

        if (hotspot.borderAlpha != undefined) {
          border += hotspot.borderAlpha;
        }
      }

      hotspot.bgBorder = border;
    }

    if (id != undefined && dragable != undefined) {
      var _hotspot = this.getHotspotById(id);

      if (_hotspot) {
        _hotspot.dragable = dragable;

        if (dragable) {
          _hotspot.events['onDown'] = this.onHotspotMoveBegan.bind(this);
          this.krpanoWrapper.call('hotspot[' + _hotspot.id + '].addevent(ondown, drag_enable(););');
          _hotspot.events['onUp'] = this.onHotspotMoveEnd.bind(this); //this.callbacks['onHotspotMoveEnd'];
        } else {
          if (panoPlayers['krp'] && panoPlayers['krp'].krpanoWrapper.get('hotspot[' + _hotspot.id + ']') && panoPlayers['krp'].krpanoWrapper.get('hotspot[' + _hotspot.id + ']').addedevents['ondown']) {
            panoPlayers['krp'].krpanoWrapper.get('hotspot[' + _hotspot.id + ']').addedevents['ondown'] = panoPlayers['krp'].krpanoWrapper.get('hotspot[' + _hotspot.id + ']').addedevents['ondown'].filter(function (item) {
              return item != 'drag_enable();';
            });
          }

          _hotspot.events['onDown'] = this.onHotspotDown.bind(this); // this.callbacks['onHotspotDown'];

          _hotspot.events['onUp'] = this.onHotspotUp.bind(this); //this.callbacks['onHotspotUp'];
        }
      }
    }

    if (extendImageUrl != undefined) {
      hotspot.extendImageUrl = extendImageUrl;
    }

    if (extendImageWidth != undefined) {
      hotspot.extendImageWidth = extendImageWidth;
    }

    if (extendImageLength != undefined) {
      hotspot.extendImageLength = extendImageLength;
    }

    if (hotspot.extendImageUrl != undefined) {
      var _hotspot2 = this.getHotspotById(id);

      var imageId = id + '_extendImage';
      var imageEdge = '';
      var imageWidth = 0;
      var imageHeight = 0;
      var hotspotEdge = _hotspot2.edge || 'bottom';

      if (hotspotEdge == 'top') {
        imageEdge = 'top';
        imageWidth = _hotspot2.extendImageWidth;
        imageHeight = _hotspot2.extendImageLength;
        _hotspot2.oy = _hotspot2.extendImageLength;
        _hotspot2.ox = 0;
      } else if (hotspotEdge == 'left') {
        imageEdge = 'left';
        imageWidth = _hotspot2.extendImageLength;
        imageHeight = _hotspot2.extendImageWidth;
        _hotspot2.ox = _hotspot2.extendImageLength;
        _hotspot2.oy = 0;
      } else if (hotspotEdge == 'right') {
        imageEdge = 'right';
        imageWidth = _hotspot2.extendImageLength;
        imageHeight = _hotspot2.extendImageWidth;
        _hotspot2.ox = -_hotspot2.extendImageLength;
        _hotspot2.oy = -0;
      } else if (hotspotEdge == 'bottom') {
        imageEdge = 'bottom';
        imageWidth = _hotspot2.extendImageWidth;
        imageHeight = _hotspot2.extendImageLength;
        _hotspot2.oy = -_hotspot2.extendImageLength;
        _hotspot2.ox = 0;
      } else {
        imageEdge = 'center';
        imageWidth = _hotspot2.extendImageWidth;
        imageHeight = _hotspot2.extendImageLength;
        _hotspot2.oy = 0;
        _hotspot2.ox = 0;
      }

      var imageHotspotParams = {
        id: imageId,
        url: _hotspot2.extendImageUrl,
        edge: imageEdge,
        width: imageWidth,
        height: imageHeight
      };

      if (_hotspot2.extendImageScale9Grid != undefined) {
        imageHotspotParams['scale9grid'] = _hotspot2.extendImageScale9Grid;
        imageHotspotParams['renderer'] = 'css3d';
      }

      if (_hotspot2.ath != undefined) {
        imageHotspotParams.ath = _hotspot2.ath;
      }

      if (_hotspot2.atv != undefined) {
        imageHotspotParams.atv = _hotspot2.atv;
      }

      if (_hotspot2.zOrder != undefined) {
        imageHotspotParams.zOrder = (_hotspot2.zOrder || 1) - 1;
      }

      if (_hotspot2.distorted != undefined) {
        imageHotspotParams['distorted'] = _hotspot2.distorted;
      }

      this.addOriginHotspot(imageHotspotParams);
      _hotspot2.extendImage = imageId;
    }

    var iconImageHotspot = this.getHotspotById(hotspot.iconImage);

    if (hotspot && iconImageHotspot) {
      this.krpanoWrapper.call('if(hotspot[' + id + '].onautosized !== null, callwith(hotspot[' + id + '], onautosized););');
    }

    if (showImageBorder != undefined) {
      var borderImageId = id + "_border_image";

      var _hotspot3 = this.getHotspotById(id);

      if (showImageBorder && _hotspot3) {
        this.krpanoWrapper.call("\n                addhotspot(" + borderImageId + ");\n                set(hotspot[" + borderImageId + "].url," + this.__imageBorderImage + ");\n                set(hotspot[" + borderImageId + "].enabled,false);\n                set(hotspot[" + borderImageId + "].scale9grid,3|3|50|50|1);\n                set(hotspot[" + borderImageId + "].renderer,css3d);\n                copy(hotspot[" + borderImageId + "].ath,hotspot[" + id + "].ath);\n                copy(hotspot[" + borderImageId + "].atv,hotspot[" + id + "].atv);\n                copy(hotspot[" + borderImageId + "].ox,hotspot[" + id + "].ox);\n                copy(hotspot[" + borderImageId + "].oy,hotspot[" + id + "].oy);\n                copy(hotspot[" + borderImageId + "].rx,hotspot[" + id + "].rx);\n                copy(hotspot[" + borderImageId + "].ry,hotspot[" + id + "].ry);\n                copy(hotspot[" + borderImageId + "].rz,hotspot[" + id + "].rz);\n                copy(hotspot[" + borderImageId + "].width,hotspot[" + id + "].width);\n                copy(hotspot[" + borderImageId + "].height,hotspot[" + id + "].height);\n                add(hotspot[" + borderImageId + "].width,10);\n                add(hotspot[" + borderImageId + "].height,10);\n                copy(hotspot[" + borderImageId + "].scale,hotspot[" + id + "].scale);\n                copy(hotspot[" + borderImageId + "].edge,hotspot[" + id + "].edge);\n                copy(hotspot[" + borderImageId + "].zorder,hotspot[" + id + "].zorder);\n                add(hotspot[" + borderImageId + "].zorder, 1);\n                copy(hotspot[" + borderImageId + "].distorted,hotspot[" + id + "].distorted);\n                copy(hotspot[" + borderImageId + "].zoom,hotspot[" + id + "].zoom);\n                ");

        if (_hotspot3) {
          _hotspot3.borderImageId = borderImageId;
          _hotspot3.showImageBorder = showImageBorder;
        }
      } else {
        this.krpanoWrapper.call("\n                removehotspot(" + borderImageId + ");\n                ");

        var _hotspot4 = this.getHotspotById(id);

        if (_hotspot4) {
          _hotspot4.borderImageId = null;
        }
      }
    }

    if (this.type == 2) {
      var borderHotpsot = this.get("hotspot[" + id + "_border_image]");

      if (borderHotpsot) {
        this.set("hotspot[" + id + "_border_image].visible", !borderHotpsot.distorted);
      }
    }

    if (id != undefined && hFov != undefined && yaw != undefined && pitch != undefined && roll != undefined) {
      hotspot.ath = this.getView().hlookat + 180;
      this.alignHotspot({
        id: id,
        hFov: hFov,
        yaw: yaw,
        pitch: pitch,
        roll: roll
      });
    }

    this.krpanoWrapper.call('if(hotspot[' + id + '].isImagePlaying != true AND hotspot[' + id + '].autoplaytype == 1, images_play(' + id + '););');
    this.copyPlayImagesAttributes(id);

    if (events && events.onHotspotMoving) {
      this.hotspotEvents['moving'][id] = events.onHotspotMoving;
    }

    if (events && events.onHotspotClick) {
      this.hotspotEvents['click'][id] = events.onHotspotClick;
    }

    if (events && events.onHotspotMoveBegan) {
      this.hotspotEvents['moveBegan'][id] = events.onHotspotMoveBegan;
    }

    if (events && events.onHotspotMoveEnd) {
      this.hotspotEvents['moveEnd'][id] = events.onHotspotMoveEnd;
    }

    if (events && events.onHotspotDown) {
      this.hotspotEvents['down'][id] = events.onHotspotDown;
    }

    if (events && events.onHotspotUp) {
      this.hotspotEvents['up'][id] = events.onHotspotUp;
    }

    if (events && events.onHotspotOver) {
      this.hotspotEvents['over'][id] = events.onHotspotOver;
    }

    if (events && events.onHotspotOut) {
      this.hotspotEvents['out'][id] = events.onHotspotOut;
    }
  };

  _proto.copyPlayImagesAttributes = function copyPlayImagesAttributes(id) {
    var hotspot = this.getHotspotById(id);

    if (this.krpanoWrapper.get('hotspot[' + id + '_copy]')) {
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].ath, hotspot[' + id + '].ath); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].visible, hotspot[' + id + '].visible); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].atv, hotspot[' + id + '].atv); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].scale, hotspot[' + id + '].scale); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].scaleX, hotspot[' + id + '].scaleX); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].scaleY, hotspot[' + id + '].scaleY); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].ox, hotspot[' + id + '].ox); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].oy, hotspot[' + id + '].oy); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].oz, hotspot[' + id + '].oz); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].edge, hotspot[' + id + '].edge); ');
      this.krpanoWrapper.call('copy(hotspot[' + id + '_copy].distorted, hotspot[' + id + '].distorted); ');
    }
  };

  _proto.fadeHotspotVisible = function fadeHotspotVisible(_ref40) {
    var id = _ref40.id,
        duration = _ref40.duration,
        visible = _ref40.visible;
    var time = duration || 0.3;
    this.call("\n        stoptween(hotspot[" + id + "].visible);\n        " + (visible ? "if(hotspot[" + id + "].visible == false, set(hotspot[" + id + "].visible, true););" : "") + "\n        tween(hotspot[" + id + "].alpha, " + (visible ? 1 : 0) + ", " + time + ", linear, " + (!visible ? "delayedcall(" + time + ",set(hotspot[" + id + "].visible, false););" : "") + " );\n        \n        if(webvr.isenabled,\n            stoptween(hotspot[" + id + "_vr].visible);\n            " + (visible ? "if(hotspot[" + id + "_vr].visible == false, set(hotspot[" + id + "_vr].visible, true););" : "") + "\n            tween(hotspot[" + id + "_vr].alpha, " + (visible ? 1 : 0) + ", " + time + ", linear, " + (!visible ? "delayedcall(" + time + ",set(hotspot[" + id + "_vr].visible, false););" : "") + " );    \n        );\n        ");
  }
  /**
   * 删除热点
   * @param {string} id - 热点id
   */
  ;

  _proto.removeHotspotById = function removeHotspotById(id) {
    if (this.krpanoWrapper.get('hotspot[' + id + '].point')) {
      var points = this.krpanoWrapper.get('hotspot[' + id + '].point').getArray();

      for (var i = 0; i < points.length; i++) {
        var pointName = points[i].name;
        this.krpanoWrapper.removeHotspotById(id + pointName + '_drag');
        this.krpanoWrapper.removeHotspotById(id + pointName + '_end');
      }
    }

    if (this.getHotspotById(id + "_container")) {
      this.krpanoWrapper.call("removeplugin(" + id + ")");
      this.krpanoWrapper.removeHotspotById(id + '_container');
    }

    if (this.get("layer[" + id + "_container]")) {
      this.krpanoWrapper.call("removelayer(" + id + "_container)");
    }

    if (this.get("plugin[" + id + "_container]")) {
      this.krpanoWrapper.call("removeplugin(" + id + "_container)");
    }

    if (this.get("plugin[" + id + "_plugin]")) {
      this.krpanoWrapper.call("removeplugin(" + id + "_plugin)");
    }

    if (this.get("plugin[" + id + "_plugin_point]")) {
      this.krpanoWrapper.call("removeplugin(" + id + "_plugin_point)");
    }

    if (this.get("layer[comment_container_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_container_" + id + ")");
    }

    if (this.get("layer[comment_line_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_line_" + id + ")");
    }

    if (this.get("layer[comment_avatar_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_avatar_" + id + ")");
    }

    if (this.get("layer[comment_text_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_text_" + id + ")");
    }

    if (this.get("layer[comment_subtitle_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_subtitle_" + id + ")");
    }

    if (this.get("layer[comment_right_" + id + "]")) {
      this.krpanoWrapper.call("removelayer(comment_right_" + id + ")");
    }

    this.krpanoWrapper.removeHotspotById(id + '_bg');
    this.krpanoWrapper.removeHotspotById(id + '_copy');
    this.krpanoWrapper.removeHotspotById(id + '_extendImage');
    this.krpanoWrapper.removeHotspotById(id + '_iconImage');
    this.krpanoWrapper.removeHotspotById(id + '_border_image');
    this.krpanoWrapper.removeHotspotById(id + '_poster');
    this.krpanoWrapper.removeHotspotById(id);
    delete this.hotspotEvents['moving'][id];
    delete this.hotspotEvents['click'][id];
    delete this.hotspotEvents['moveEnd'][id];
    delete this.hotspotEvents['moveBegan'][id];
    delete this.hotspotEvents['over'][id];
    delete this.hotspotEvents['out'][id];
    delete this.hotspotEvents['down'][id];
    delete this.hotspotEvents['up'][id];
    delete this.lineEvents['moving'][id];
    delete this.lineEvents['moveEnd'][id];
    delete this.lineEvents['moveBegan'][id];
  }
  /**
   * 获取热点
   * @param {string} id - 热点id
   */
  ;

  _proto.getHotspotById = function getHotspotById(id) {
    return this.krpanoWrapper.hotspots[id];
  }
  /**
   * 视角移动到热点
   * @param {Object} data - 参数
   * @param {string} data.id - 热点id
   * @param {number} data.fov - 目标fov
   * @param {string} data.tween - 移动效果
   * @param {function} onComplete - 完成回调
   */
  ;

  _proto.lookToHotspot = function lookToHotspot(_ref41, onComplete) {
    var id = _ref41.id,
        fov = _ref41.fov,
        tween = _ref41.tween;

    if (this.debug) {
      console.log('lookToHotspot', arguments[0], onComplete);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot) {
      if (hotspot && hotspot.points) {
        this.call("hotspot[" + id + "].getcenter(" + id + "_middle_ath," + id + "_middle_atv);");
        this.lookTo({
          hlookat: this.get(id + "_middle_ath"),
          vlookat: this.get(id + "_middle_atv"),
          fov: fov,
          tween: tween
        }, onComplete);
      } else {
        this.lookTo({
          hlookat: hotspot.ath,
          vlookat: hotspot.atv,
          fov: fov,
          tween: tween
        }, onComplete);
      }
    } else {
      this.krpanoWrapper.lookToHotspot(id);
    }
  }
  /**
   * 闪烁热点
   * @param {Object} data - 参数
   * @param {string} data.id - 热点id
   * @param {string} data.count - 闪烁次数
   * @param {number} data.duration - 闪烁持续时间，单位秒
   */
  ;

  _proto.blinkHotspot = function blinkHotspot(_ref42) {
    var id = _ref42.id,
        count = _ref42.count,
        duration = _ref42.duration;

    if (this.debug) {
      console.log('blinkHotspot', arguments[0]);
    }

    this.call("hotspot_blinking(" + id + "," + (count !== null && count !== void 0 ? count : 3) + ", " + (duration !== null && duration !== void 0 ? duration : 1) + ");");
  }
  /** 
   * 更新热点
   * @param {Object} data - 更新数据
   * @param {string} data.id - 热点id
   * @param {string} data.url - 热点图标地址
   * @param {number} data.ath - 水平方向坐标
   * @param {number} data.atv - 竖直方向坐标
   * @param {string} data.edge - 锚点， lefttop, left, leftbottom, top, center, bottom, righttop, right, rightbottom
   * @param {bool}   data.dragable - 是否可以拖动
   * @param {number} data.scale - 缩放比例
   * 
   * @description 如无特殊需求不用直接调用，使用 addImageHotspot addVideoHotspot addTextHotspot addPolygonHotspot 
   */
  ;

  _proto.updateHotspot = function updateHotspot(_ref43) {
    var id = _ref43.id,
        url = _ref43.url,
        width = _ref43.width,
        height = _ref43.height,
        ath = _ref43.ath,
        atv = _ref43.atv,
        edge = _ref43.edge,
        dragable = _ref43.dragable;

    if (this.debug) {
      console.log('updateHotspot', arguments[0]);
    }

    this.updateOriginHotspot(arguments[0]);
  }
  /**
   * 新增图片热点
   * @param {Object} data - 热点数据
   * @param {string} data.id - 热点id
   * @param {Array} data.urls - 热点图标url数组
   * @param {number} [data.ath=当前视角] - 水平方向坐标
   * @param {number} [data.atv=当前视角] - 竖直方向坐标
   * @param {number} [data.ox=0] - x轴偏移
   * @param {number} [data.oy=0] - y轴偏移
   * @param {string} [data.edge='center'] - 锚点， lefttop, left, leftbottom, top, center, bottom, righttop, right, rightbottom
   * @param {bool}   [data.dragable=false] - 是否可以拖动
   * @param {number} [data.scale=1.0] - 缩放比例
   * @param {number} [data.scaleX=1.0] - x轴缩放比例
   * @param {number} [data.scaleY=1.0] - y轴缩放比例
   * @param {number} [data.hFov] - 对齐水平视场, (hFov yaw pitch roll 在对齐模式下需要全部传入，非对齐模式不传)
   * @param {number} [data.yaw] - 对齐x旋转
   * @param {number} [data.pitch] - 对齐y旋转
   * @param {number} [data.roll] - 对齐z旋转
   * @param {number} [data.rx=0] - x轴旋转, distorted = true 时可用
   * @param {number} [data.ry=0] - y轴旋转, distorted = true 时可用
   * @param {number} [data.rz=0] - z轴旋转, distorted = true 时可用
   * @param {number} [data.zOrder] - 层级,取值 0-100，越大的在越上面
   * @param {number} [data.enabled] - 是否接受鼠标事件
   * @param {bool} [data.distorted=false] - 是否贴合全景，跟随全景缩放
   * @param {string} [data.titleHotspotId] - 为热点添加标题，先添加一个标题热点，然后设置热点的 titleHotspotId 为标题热点 id
   * @param {number} [data.autoPlayType=1] - 播放模式，0手动，1自动
   * @param {number} [data.autoPlayDuration=1] - 自动播放时间间隔，autoPlayType=1时可用
   * @param {bool} [data.showImageBorder] - 是否显示图片边框
   * @param {bool} [data.capture=true] - 是否阻止鼠标事件向下传递
   * @param {string} [data.chromakey] - 透明蒙版, "hexColor,threshold(0.0-1.0),smoothing(0.0-1.0)",例如 "0x238E54,0.3,0.1" 
   * @param {object} [data.events] - 事件回调
   * @param {function} [data.events.onHotspotClick] - 热点点击回调
   * @param {function} [data.events.onHotspotMoving] - 热点移动回调
   * @param {function} [data.events.onHotspotMoveBegan] - 热点开始移动回调
   * @param {function} [data.events.onHotspotMoveEnd] - 热点移动结束回调
   * @param {function} [data.events.onHotspotDown] - 鼠标按下热点
   * @param {function} [data.events.onHotspotUp] - 鼠标放开热点
   * @param {function} [data.events.onHotspotOver] - 鼠标进入热点
   * @param {function} [data.events.onHotspotOut] - 鼠标移出热点
   * @example
   * 
  // 系统静态 / 单张图片
  player.addImageHotspot({
  id: "image_system_static",
  urls: ["https://ssl-player2.720static.com/hotspot/80/spot15.png"],
  ath: -20,
  atv: 0,
  edge: "center",
  dragable: true,
  scaleX: 0.5,
  scaleY: 0.5,
  zOrder: 1,
  distorted: false,
  titleHotspotId: "title_text",
  });
  // 多张图片自动轮换
  player.addImageHotspot({ 
  id: "image_mulitple_auto", 
  urls: ["https://ssl-media.720static.com/@/3d2jOdsmta5/2/8e7d66d1337a98d11f2f7ac92b78e233v5.png", "https://ssl-media.720static.com/@/fc6jOdsnzn5/2/257e6fea80932f6de249e17b5aa7fee4v5.png"], 
  ath: 15, 
  atv: 0, 
  edge: "center", 
  dragable: true, 
  scaleX: 0.5,
  scaleY: 0.5,
  zOrder: 2, 
  distorted: true, 
  autoPlayType: 1, 
  autoPlayDuration: 1 
  });
  // 多张图片手动轮换
  player.addImageHotspot({ 
  id: "image_mulitple_manual", 
  urls: ["https://ssl-media.720static.com/@/3d2jOdsmta5/2/8e7d66d1337a98d11f2f7ac92b78e233v5.png", "https://ssl-media.720static.com/@/fc6jOdsnzn5/2/257e6fea80932f6de249e17b5aa7fee4v5.png"], 
  ath: 30, 
  atv: 0, 
  edge: "center", 
  dragable: true, 
  scaleX: 0.5,
  scaleY: 0.5,
  zOrder: 2, 
  distorted: true, 
  autoPlayType: 0 
  });
   */
  ;

  _proto.addImageHotspot = function addImageHotspot(_ref44) {
    var id = _ref44.id,
        urls = _ref44.urls,
        ath = _ref44.ath,
        atv = _ref44.atv,
        ox = _ref44.ox,
        oy = _ref44.oy,
        edge = _ref44.edge,
        dragable = _ref44.dragable,
        scale = _ref44.scale,
        scaleX = _ref44.scaleX,
        scaleY = _ref44.scaleY,
        hFov = _ref44.hFov,
        yaw = _ref44.yaw,
        pitch = _ref44.pitch,
        roll = _ref44.roll,
        rx = _ref44.rx,
        ry = _ref44.ry,
        rz = _ref44.rz,
        zOrder = _ref44.zOrder,
        distorted = _ref44.distorted,
        autoPlayType = _ref44.autoPlayType,
        autoPlayDuration = _ref44.autoPlayDuration,
        enabled = _ref44.enabled;

    if (this.debug) {
      console.log('addImageHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events; // if (urls.length > 0) {
    //     params["url"] = urls[0];
    // }
    // if (params.frame != undefined && Object.keys(params.frameDuration).length > 0) {
    //     if (params.frame.frameCount != undefined) {
    //         params["frameCount"] = params.frame.frameCount;
    //     }
    //     if (params.frame.frameWidth != undefined) {
    //         params["frameWidth"] = params.frame.frameWidth;
    //     }
    //     if (params.frame.frameHeight != undefined) {
    //         params["frameHeight"] = params.frame.frameHeight;
    //     }
    //     if (params.frame.frameDuration != undefined) {
    //         params["frameDuration"] = params.frame.frameDuration;
    //     }
    // }

    var hotspot = this.addOriginHotspot(params);

    if (params.visible === false) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
    }

    this.krpanoWrapper.call("\n            hotspot[" + id + "].addevent(onloaded, \n                scale_to_xy(" + id + ");\n                if(hfov !== null AND hotspot[get(image_copy)] !== null,\n                    copy(image_copy, name); \n                    txtadd(image_copy, \"_copy\");\n                    copy(width, hotspot[get(image_copy)].width);\n                    copy(height, hotspot[get(image_copy)].height);\n                );\n            );");
    this.krpanoWrapper.call('hotspot[' + id + '].addevent(onclick,  if(autoplaytype == 0,images_play(' + id + ');););');
    this.updateImageHotspot(params);
    return hotspot;
  }
  /**
   * 更新图片热点
   * @description - 参数同新增，除 id 外均为可选参数
   */
  ;

  _proto.updateImageHotspot = function updateImageHotspot(_ref45) {
    var id = _ref45.id,
        urls = _ref45.urls,
        ath = _ref45.ath,
        atv = _ref45.atv,
        ox = _ref45.ox,
        oy = _ref45.oy,
        edge = _ref45.edge,
        dragable = _ref45.dragable,
        scale = _ref45.scale,
        scaleX = _ref45.scaleX,
        scaleY = _ref45.scaleY,
        hFov = _ref45.hFov,
        yaw = _ref45.yaw,
        pitch = _ref45.pitch,
        roll = _ref45.roll,
        rx = _ref45.rx,
        ry = _ref45.ry,
        rz = _ref45.rz,
        zOrder = _ref45.zOrder,
        distorted = _ref45.distorted,
        _ref45$frame = _ref45.frame;
    _ref45$frame = _ref45$frame === void 0 ? {} : _ref45$frame;
    var frameWidth = _ref45$frame.frameWidth,
        frameHeight = _ref45$frame.frameHeight,
        frameX = _ref45$frame.frameX,
        frameY = _ref45$frame.frameY,
        frameCount = _ref45$frame.frameCount,
        frameDuration = _ref45$frame.frameDuration,
        autoPlayType = _ref45.autoPlayType,
        autoPlayDuration = _ref45.autoPlayDuration,
        titleHotspotId = _ref45.titleHotspotId;
    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.type != 'image') {
      return;
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    params.type = 'image';

    if (urls != undefined && urls.length > 0) {
      params["url"] = urls[0];
    }

    if (params.visible === false) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
    }

    if (params.visible === true) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, true);');
    }

    if (params.frame != undefined && Object.keys(params.frame).length > 0) {
      if (params.frame.frameCount != undefined) {
        params["frameCount"] = params.frame.frameCount;
      }

      if (params.frame.frameWidth != undefined) {
        params["frameWidth"] = params.frame.frameWidth;
      }

      if (params.frame.frameHeight != undefined) {
        params["frameHeight"] = params.frame.frameHeight;
      }

      if (params.frame.frameX != undefined) {
        params["frameX"] = params.frame.frameX;
      }

      if (params.frame.frameY != undefined) {
        params["frameY"] = params.frame.frameY;
      }

      if (params.frame.frameDuration != undefined) {
        params["frameDuration"] = params.frame.frameDuration;
      }
    }

    this.updateOriginHotspot(params);
  }
  /**
   * 新增序列帧/雪碧图热点
   * @param {Object} data - 热点数据
   * @param {string} data.id - 热点id
   * @param {string} data.url - 热点图片url
   * @param {number} [data.ath=当前视角] - 水平方向坐标
   * @param {number} [data.atv=当前视角] - 竖直方向坐标
   * @param {number} [data.ox=0] - x轴偏移
   * @param {number} [data.oy=0] - y轴偏移
   * @param {string} [data.edge='center'] - 锚点， lefttop, left, leftbottom, top, center, bottom, righttop, right, rightbottom
   * @param {bool}   [data.dragable=false] - 是否可以拖动
   * @param {number} [data.scale=1.0] - 缩放比例
   * @param {number} [data.scaleX=1.0] - x轴缩放比例
   * @param {number} [data.scaleY=1.0] - y轴缩放比例
   * @param {number} [data.hFov] - 对齐水平视场, (hFov yaw pitch roll 在对齐模式下需要全部传入，非对齐模式不传)
   * @param {number} [data.yaw] - 对齐x旋转
   * @param {number} [data.pitch] - 对齐y旋转
   * @param {number} [data.roll] - 对齐z旋转
   * @param {number} [data.rx=0] - x轴旋转, distorted = true 时可用
   * @param {number} [data.ry=0] - y轴旋转, distorted = true 时可用
   * @param {number} [data.rz=0] - z轴旋转, distorted = true 时可用
   * @param {number} [data.zOrder] - 层级,取值 0-100，越大的在越上面
   * @param {number} [data.enabled] - 是否接受鼠标事件
   * @param {bool} [data.distorted=false] - 是否贴合全景，跟随全景缩放
   * @param {string} [data.titleHotspotId] - 为热点添加标题，先添加一个标题热点，然后设置热点的 titleHotspotId 为标题热点 id
   * @param {Object} [data.frame] - 雪碧图/序列帧数据
   * @param {number} data.frame.frameWidth - 帧宽（原始图片的px）
   * @param {number} data.frame.frameHeight - 帧高（原始图片的px）
   * @param {number} data.frame.frameX - x坐标（原始图片的px）
   * @param {number} data.frame.frameY - y坐标（原始图片的px）
   * @param {number} data.frame.frameCount - 帧总数
   * @param {number} [data.frame.frameDuration=0.05] - 帧间隔
   * @param {bool} [data.showImageBorder] - 是否显示图片边框
   * @param {bool} [data.capture=true] - 是否阻止鼠标事件向下传递
   * @param {string} [data.chromakey] - 透明蒙版, "hexColor,threshold(0.0-1.0),smoothing(0.0-1.0)",例如 "0x238E54,0.3,0.1" 
   * @param {object} [data.events] - 事件回调
   * @param {function} [data.events.onHotspotClick] - 热点点击回调
   * @param {function} [data.events.onHotspotMoving] - 热点移动回调
   * @param {function} [data.events.onHotspotMoveBegan] - 热点开始移动回调
   * @param {function} [data.events.onHotspotMoveEnd] - 热点移动结束回调
   * @param {function} [data.events.onHotspotDown] - 鼠标按下热点
   * @param {function} [data.events.onHotspotUp] - 鼠标放开热点
   * @param {function} [data.events.onHotspotOver] - 鼠标进入热点
   * @param {function} [data.events.onHotspotOut] - 鼠标移出热点
   * @example
   * 
  // 系统动态 / 序列帧
  player.addImageFrameHotspot({
  id: "image_system_frame",
  url: "https://ssl-player2.720static.com/v2/hotspot/80/spotd5_gif.png",
  ath: -10,
  atv: 0,
  frame: { frameCount: 10, frameWidth: 128, frameHeight: 128, frameDuration: 0.05 },
  edge: "bottom",
  dragable: true,
  scaleX: 0.5,
  scaleY: 0.5,
  zOrder: 2,
  distorted: false
  });
   */
  ;

  _proto.addImageFrameHotspot = function addImageFrameHotspot(_ref46) {
    var id = _ref46.id,
        url = _ref46.url,
        ath = _ref46.ath,
        atv = _ref46.atv,
        ox = _ref46.ox,
        oy = _ref46.oy,
        edge = _ref46.edge,
        dragable = _ref46.dragable,
        scale = _ref46.scale,
        scaleX = _ref46.scaleX,
        scaleY = _ref46.scaleY,
        hFov = _ref46.hFov,
        yaw = _ref46.yaw,
        pitch = _ref46.pitch,
        roll = _ref46.roll,
        rx = _ref46.rx,
        ry = _ref46.ry,
        rz = _ref46.rz,
        zOrder = _ref46.zOrder,
        distorted = _ref46.distorted,
        _ref46$frame = _ref46.frame;
    _ref46$frame = _ref46$frame === void 0 ? {} : _ref46$frame;
    var frameWidth = _ref46$frame.frameWidth,
        frameHeight = _ref46$frame.frameHeight,
        frameX = _ref46$frame.frameX,
        frameY = _ref46$frame.frameY,
        frameCount = _ref46$frame.frameCount,
        frameDuration = _ref46$frame.frameDuration,
        autoPlayType = _ref46.autoPlayType,
        autoPlayDuration = _ref46.autoPlayDuration;

    if (this.debug) {
      console.log('addImageFrameHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events; // if (urls.length > 0) {
    //     params["url"] = urls[0];
    // }
    // if (params.frame != undefined && Object.keys(params.frameDuration).length > 0) {
    //     if (params.frame.frameCount != undefined) {
    //         params["frameCount"] = params.frame.frameCount;
    //     }
    //     if (params.frame.frameWidth != undefined) {
    //         params["frameWidth"] = params.frame.frameWidth;
    //     }
    //     if (params.frame.frameHeight != undefined) {
    //         params["frameHeight"] = params.frame.frameHeight;
    //     }
    //     if (params.frame.frameDuration != undefined) {
    //         params["frameDuration"] = params.frame.frameDuration;
    //     }
    // }

    var hotspot = this.addOriginHotspot(params);

    if (params.visible === false) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
    }

    this.krpanoWrapper.call('hotspot[' + id + '].addevent(onloaded, scale_to_xy(' + id + '););');
    this.updateImageFrameHotspot(params);
    return hotspot;
  }
  /**
   * 更新序列帧/雪碧图热点
   * @description - 参数同新增，除 id 外均为可选参数
   */
  ;

  _proto.updateImageFrameHotspot = function updateImageFrameHotspot(_ref47) {
    var id = _ref47.id,
        url = _ref47.url,
        ath = _ref47.ath,
        atv = _ref47.atv,
        ox = _ref47.ox,
        oy = _ref47.oy,
        edge = _ref47.edge,
        dragable = _ref47.dragable,
        scale = _ref47.scale,
        scaleX = _ref47.scaleX,
        scaleY = _ref47.scaleY,
        hFov = _ref47.hFov,
        yaw = _ref47.yaw,
        pitch = _ref47.pitch,
        roll = _ref47.roll,
        rx = _ref47.rx,
        ry = _ref47.ry,
        rz = _ref47.rz,
        zOrder = _ref47.zOrder,
        distorted = _ref47.distorted,
        _ref47$frame = _ref47.frame;
    _ref47$frame = _ref47$frame === void 0 ? {} : _ref47$frame;
    var frameWidth = _ref47$frame.frameWidth,
        frameHeight = _ref47$frame.frameHeight,
        frameX = _ref47$frame.frameX,
        frameY = _ref47$frame.frameY,
        frameCount = _ref47$frame.frameCount,
        frameDuration = _ref47$frame.frameDuration,
        titleHotspotId = _ref47.titleHotspotId;

    if (this.debug) {
      console.log('updateImageFrameHotspot', arguments[0]);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.type != 'image') {
      return;
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    params.type = 'image';

    if (params.visible === false) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, false);');
    }

    if (params.visible === true) {
      this.krpanoWrapper.call('set(hotspot[' + id + '].targetVisible, true);');
    }

    if (params.frame != undefined && Object.keys(params.frame).length > 0) {
      if (params.frame.frameCount != undefined) {
        params["frameCount"] = params.frame.frameCount;
      }

      if (params.frame.frameWidth != undefined) {
        params["frameWidth"] = params.frame.frameWidth;
      }

      if (params.frame.frameHeight != undefined) {
        params["frameHeight"] = params.frame.frameHeight;
      }

      if (params.frame.frameX != undefined) {
        params["frameX"] = params.frame.frameX;
      }

      if (params.frame.frameY != undefined) {
        params["frameY"] = params.frame.frameY;
      }

      if (params.frame.frameDuration != undefined) {
        params["frameDuration"] = params.frame.frameDuration;
      }
    }

    this.updateOriginHotspot(params);
  }
  /**
   * 新增文本热点
   * @param {Object} data - 热点数据
   * @param {string} data.id - 热点id
   * @param {string} data.text - 热点文本
   * @param {string} [data.ath=当前视角] - 水平坐标
   * @param {string} [data.atv=当前视角] - 垂直坐标
   * @param {string} [data.edge='center'] - 对齐方式
   * @param {string} [data.zOrder] - 层级
   * @param {number} [data.enabled] - 是否接受鼠标事件
   * @param {string} [data.padding='2'] - 内边距, '10'四个方向边距均为10，'10 20'上下10左右20，  ‘10 10 10 10’上右下左各位10
   * @param {string} [data.distorted=false] - 是否贴合全景
   * @param {string} [data.dragable=false] - 是否可以拖动
   * @param {string} [data.ox] - x轴偏移
   * @param {string} [data.oy] - y轴偏移
   * @param {string} [data.align='left'] - 文本对齐, 取值 left,center, right, justify
   * @param {string} [data.font] - 字体数据
   * @param {string} [data.font.fontFamily] - 字体名字
   * @param {string} [data.font.fontSize] - 字号
   * @param {string} [data.font.fontColor] - 字体颜色
   * @param {string} [data.background] - 背景数据
   * @param {string} [data.background.bgEnabled] - 是否启用背景
   * @param {string} [data.background.bgColor] - 背景颜色
   * @param {string} [data.background.bgAlpha] - 背景透明度
   * @param {string} [data.background.bgRoundedge] - 背景圆角
   * @param {string} [data.background.borderWidth] - 边框宽度
   * @param {string} [data.background.borderColor] - 边框颜色
   * @param {string} [data.background.borderAlpha] - 边框透明度
   * @param {string} [data.extendImage] - 扩展图片，用于文字标记热点下面那条线，见示例
   * @param {string} data.extendImage.imageUrl - 图片地址
   * @param {string} data.extendImage.imageWidth - 图片宽度
   * @param {string} data.extendImage.imageLength - 图片长度
   * @param {string} data.iconImageUrl - 文本旁边的图标
   * @param {bool} [data.capture=true] - 是否阻止鼠标事件向下传递
   * @param {object} [data.events] - 事件回调
   * @param {function} [data.events.onHotspotClick] - 热点点击回调
   * @param {function} [data.events.onHotspotMoving] - 热点移动回调
   * @param {function} [data.events.onHotspotMoveBegan] - 热点开始移动回调
   * @param {function} [data.events.onHotspotMoveEnd] - 热点移动结束回调
   * @param {function} [data.events.onHotspotDown] - 鼠标按下热点
   * @param {function} [data.events.onHotspotUp] - 鼠标放开热点
   * @param {function} [data.events.onHotspotOver] - 鼠标进入热点
   * @param {function} [data.events.onHotspotOut] - 鼠标移出热点
   * @example
   * 
  // 标题
  player.addTextHotspot({
  id: "title_text",
  text: "这是一个标题",
  zOrder: 2,
  dragable: false,
  edge: "center",
  font: { fontSize: 12, fontColor: "#ffffff" },
  background: { bgEnabled: true, bgColor: "0x000000", bgRoundedge: 4, bgAlpha: 0.8 },
  distorted: false,
  padding: "5",
  ath: -20,
  atv: -0,
  ox: 0,
  oy: -60
  });
  // 文字标记
  player.addTextHotspot({
  id: "mark_text",
  text: "这是一个文字标记",
  zOrder: 2,
  dragable: false,
  edge: "bottom",
  font: { fontSize: 14, fontColor: "#ffaaff" },
  background: { bgEnabled: true, bgColor: "0x000000", bgRoundedge: 10, bgAlpha: 0.5 },
  distorted: false,
  ath: 40,
  atv: 0,
  padding: "10",
  distorted: false,
  dragable: true,
  extendImage: {
      imageUrl: "https://ssl-media.720static.com/@/3d2jOdsmta5/2/3433853addef2fc2b0ea3f6dd337968bv5.png",
      imageWidth: 2,
      imageLength: 100,
  },
  });
   * 
   */
  ;

  _proto.addTextHotspot = function addTextHotspot(_ref48) {
    var id = _ref48.id,
        text = _ref48.text,
        ath = _ref48.ath,
        atv = _ref48.atv,
        edge = _ref48.edge,
        zOrder = _ref48.zOrder,
        padding = _ref48.padding,
        autoResize = _ref48.autoResize,
        distorted = _ref48.distorted,
        align = _ref48.align,
        css = _ref48.css,
        _ref48$font = _ref48.font;
    _ref48$font = _ref48$font === void 0 ? {} : _ref48$font;
    var fontFamily = _ref48$font.fontFamily,
        fontSize = _ref48$font.fontSize,
        fontColor = _ref48$font.fontColor,
        fontAlpha = _ref48$font.fontAlpha,
        _ref48$background = _ref48.background;
    _ref48$background = _ref48$background === void 0 ? {} : _ref48$background;
    var bgEnabled = _ref48$background.bgEnabled,
        bgColor = _ref48$background.bgColor,
        bgAlpha = _ref48$background.bgAlpha,
        bgRoundedge = _ref48$background.bgRoundedge,
        borderWidth = _ref48$background.borderWidth,
        borderColor = _ref48$background.borderColor,
        borderAlpha = _ref48$background.borderAlpha,
        dragable = _ref48.dragable,
        _ref48$extendImage = _ref48.extendImage;
    _ref48$extendImage = _ref48$extendImage === void 0 ? {} : _ref48$extendImage;
    var imageUrl = _ref48$extendImage.imageUrl,
        imageWidth = _ref48$extendImage.imageWidth,
        imageLength = _ref48$extendImage.imageLength,
        _ref48$vrEnabled = _ref48.vrEnabled,
        vrEnabled = _ref48$vrEnabled === void 0 ? true : _ref48$vrEnabled;

    if (this.debug) {
      console.log('addTextHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    params.type = 'text';
    params.renderer = 'css3d';
    var hotspot = this.addOriginHotspot(params);
    this.krpanoWrapper.set('hotspot[' + id + '].onautosized', 'if(iconImage !== null AND html.length GT 0, set(padding, "5 5 5 30"); set(hotspot[get(iconImage)].edge, center); copy(hotspot[get(iconImage)].ath, ath); copy(hotspot[get(iconImage)].atv, atv); copy(hotspot[get(iconImage)].ox, ox); copy(hotspot[get(iconImage)].oy, oy); div(offsetx, width, 2); div(offsety, height, 2); if(edge == "bottom", sub(hotspot[get(iconImage)].ox, offsetx); add(hotspot[get(iconImage)].ox, 15); sub(hotspot[get(iconImage)].oy, offsety);); if(edge == "left", add(hotspot[get(iconImage)].ox, 15);); if(edge == "right", sub(hotspot[get(iconImage)].ox, width); add(hotspot[get(iconImage)].ox, 15);); if(edge == "top", sub(hotspot[get(iconImage)].ox, offsetx); add(hotspot[get(iconImage)].ox, 15); add(hotspot[get(iconImage)].oy, offsety); ); ); if(iconImage !== null AND html.length == 0,  set(padding, "0");  copy(width, hotspot[get(iconImage)].width); add(width, 10); set(height, get(width)); set(hotspot[get(iconImage)].edge, center); copy(hotspot[get(iconImage)].ath, ath); copy(hotspot[get(iconImage)].atv, atv);  copy(hotspot[get(iconImage)].ox, ox); copy(hotspot[get(iconImage)].oy, oy); div(offset, width, 2); if(edge == "bottom", sub(hotspot[get(iconImage)].oy, offset);); if(edge == "top", add(hotspot[get(iconImage)].oy, offset);); if(edge == "left", add(hotspot[get(iconImage)].ox, offset);); if(edge == "right", sub(hotspot[get(iconImage)].ox, offset);); );');
    this.updateTextHotspot(params);
    return hotspot;
  }
  /**
   * 更新文本热点
   * @description - 参数同新增，除 id 外均为可选参数
   * 
   **/
  ;

  _proto.updateTextHotspot = function updateTextHotspot(_ref49) {
    var id = _ref49.id,
        text = _ref49.text,
        ath = _ref49.ath,
        atv = _ref49.atv,
        edge = _ref49.edge,
        zOrder = _ref49.zOrder,
        padding = _ref49.padding,
        distorted = _ref49.distorted,
        autoResize = _ref49.autoResize,
        align = _ref49.align,
        _ref49$font = _ref49.font;
    _ref49$font = _ref49$font === void 0 ? {} : _ref49$font;
    var fontFamily = _ref49$font.fontFamily,
        fontSize = _ref49$font.fontSize,
        fontColor = _ref49$font.fontColor,
        fontAlpha = _ref49$font.fontAlpha,
        _ref49$background = _ref49.background;
    _ref49$background = _ref49$background === void 0 ? {} : _ref49$background;
    var bgEnabled = _ref49$background.bgEnabled,
        bgColor = _ref49$background.bgColor,
        bgAlpha = _ref49$background.bgAlpha,
        bgRoundedge = _ref49$background.bgRoundedge,
        borderWidth = _ref49$background.borderWidth,
        borderColor = _ref49$background.borderColor,
        borderAlpha = _ref49$background.borderAlpha,
        dragable = _ref49.dragable,
        _ref49$extendImage = _ref49.extendImage;
    _ref49$extendImage = _ref49$extendImage === void 0 ? {} : _ref49$extendImage;
    var imageUrl = _ref49$extendImage.imageUrl,
        imageWidth = _ref49$extendImage.imageWidth,
        imageLength = _ref49$extendImage.imageLength,
        iconImageUrl = _ref49.iconImageUrl;

    if (this.debug) {
      console.log('updateTextHotspot', arguments[0]);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.type != 'text') {
      return;
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    params.type = 'text';

    if (text != undefined) {
      text = text.replace(/\r\n/g, "[br]");
      text = text.replace(/\n/g, "[br]");
      params['html'] = text;
    }

    if (params.font != undefined && Object.keys(params.font).length > 0) {
      if (params.font.fontFamily != undefined) {
        params.fontFamily = params.font.fontFamily;
      }

      if (params.font.fontSize != undefined) {
        params.fontSize = params.font.fontSize;
      }

      if (params.font.fontColor != undefined) {
        params.fontColor = String(params.font.fontColor).replace('0x', '#');
      }

      if (params.font.fontAlpha != undefined) {
        params.fontAlpha = params.font.fontAlpha;
      }
    }

    if (params.background != undefined && Object.keys(params.background).length > 0) {
      if (params.background.bgEnabled != undefined) {
        params.bg = params.background.bgEnabled;
      }

      if (params.background.bgColor != undefined) {
        params.bgColor = String(params.background.bgColor).replace('#', '0x');
        ;
      }

      if (params.background.bgAlpha != undefined) {
        params.bgAlpha = params.background.bgAlpha;
      }

      if (params.background.bgRoundedge != undefined) {
        params.bgRoundedge = params.background.bgRoundedge;
      }

      if (params.background.borderWidth != undefined) {
        params.borderWidth = params.background.borderWidth;
      }

      if (params.background.borderColor != undefined) {
        params.borderColor = params.background.borderColor;
      }

      if (params.background.borderAlpha != undefined) {
        params.borderAlpha = params.background.borderAlpha;
      }
    }

    if (params.extendImage != undefined && Object.keys(params.extendImage).length > 0) {
      var _hotspot5 = this.getHotspotById(id);

      var imageId = id + '_extendImage';
      var imageEdge = '';
      var _imageWidth = 0;
      var imageHeight = 0;
      var hotspotEdge = edge || 'bottom';

      if (hotspotEdge == 'top') {
        imageEdge = 'top';
        _imageWidth = params.extendImage.imageWidth;
        imageHeight = params.extendImage.imageLength;
        _hotspot5.oy = params.extendImage.imageLength;
      } else if (hotspotEdge == 'left') {
        imageEdge = 'left';
        _imageWidth = params.extendImage.imageLength;
        imageHeight = params.extendImage.imageWidth;
        _hotspot5.ox = params.extendImage.imageLength;
      } else if (hotspotEdge == 'right') {
        imageEdge = 'right';
        _imageWidth = params.extendImage.imageLength;
        imageHeight = params.extendImage.imageWidth;
        _hotspot5.ox = -params.extendImage.imageLength;
      } else if (hotspotEdge == 'bottom') {
        imageEdge = 'bottom';
        _imageWidth = params.extendImage.imageWidth;
        imageHeight = params.extendImage.imageLength;
        _hotspot5.oy = -params.extendImage.imageLength;
      } else {
        imageEdge = 'center';
        _imageWidth = params.extendImage.imageWidth;
        imageHeight = params.extendImage.imageLength;
      }

      var imageHotspotParams = {
        id: imageId,
        url: params.extendImage.imageUrl,
        edge: imageEdge,
        width: _imageWidth,
        height: imageHeight
      };

      if (params.extendImage.imageScale9Grid != undefined) {
        imageHotspotParams['scale9grid'] = params.extendImage.imageScale9Grid;
        imageHotspotParams['renderer'] = params.extendImage.renderer;
      }

      if (ath != undefined) {
        imageHotspotParams.ath = _hotspot5.ath;
      }

      if (atv != undefined) {
        imageHotspotParams.atv = _hotspot5.atv;
      }

      if (zOrder != undefined) {
        imageHotspotParams.zOrder = (_hotspot5.zOrder || 1) - 1;
      }

      if (distorted != undefined) {
        imageHotspotParams['distorted'] = _hotspot5.distorted;
      }

      this.addOriginHotspot(imageHotspotParams);
      _hotspot5.extendImage = imageId;

      if (params.extendImage.imageUrl != undefined) {
        params.extendImageUrl = params.extendImage.imageUrl;
      }

      if (params.extendImage.imageWidth != undefined) {
        params.extendImageWidth = params.extendImage.imageWidth;
      }

      if (params.extendImage.imageLength != undefined) {
        params.extendImageLength = params.extendImage.imageLength;
      }
    }

    if (iconImageUrl !== undefined) {
      var _hotspot6 = this.getHotspotById(id);

      if (iconImageUrl == '' || iconImageUrl == null) {
        if (_hotspot6.iconImage != undefined) {
          this.krpanoWrapper.set('hotspot[' + id + '].iconImage', null);
          this.removeHotspotById(id + '_iconImage');
          params.padding = '5 10';
        }
      } else {
        var iconImage = this.addOriginHotspot({
          id: id + '_iconImage',
          width: 20,
          height: 20,
          url: iconImageUrl,
          ath: _hotspot6.ath,
          atv: _hotspot6.atv,
          ox: _hotspot6.ox,
          oy: _hotspot6.oy,
          edge: 'center',
          enabled: false,
          renderer: "css3d",
          zOrder: (_hotspot6.zOrder || 1) + 1
        });
        params.padding = '5 5 5 30';
        this.krpanoWrapper.set('hotspot[' + id + '].iconImage', id + '_iconImage');
        this.krpanoWrapper.set('hotspot[' + id + '].zorder', _hotspot6.zOrder);
      }
    }

    this.updateOriginHotspot(params);
  }
  /**
   * 新增评论热点
   * @param {Object} data - 热点的原始数据
   * @param {string} data.id - 热点id
   * @param {string} data.ath - 热点 ath
   * @param {string} data.atv - 热点 atv
   * @param {string} data.title - 评论
   * @param {string} data.subtilte - 点赞回复
   * @param {string} data.avatarURL - 头像 url
   * @param {string} data.iconURL - 点赞 url
   * @param {string} data.bgAlpha - 背景透明度
   * @param {string} data.bgColor - 背景颜色, 格式 0xfffff
   * @param {string} data.dragable - 是否可以拖动
   * @example
   * 
   * 
   */
  ;

  _proto.addCommentHotspot = function addCommentHotspot(_ref50) {
    var id = _ref50.id,
        ath = _ref50.ath,
        atv = _ref50.atv,
        title = _ref50.title,
        titleColor = _ref50.titleColor,
        subtitle = _ref50.subtitle,
        avatarURL = _ref50.avatarURL,
        iconURL = _ref50.iconURL,
        bgAlpha = _ref50.bgAlpha,
        bgColor = _ref50.bgColor,
        dragable = _ref50.dragable;

    if (this.debug) {
      console.log('addCommentHotspot', arguments[0]);
    }

    var hotspot = this.addOriginHotspot({
      id: id,
      isComment: true,
      type: 'text',
      edge: 'bottom',
      ath: ath,
      atv: atv,
      width: '0',
      height: '17',
      children: false,
      captureFocus: false,
      dragable: true
    });
    this.call("\n        addlayer(comment_container_" + id + ");\n        set(layer[comment_container_" + id + "].x, -17);\n        set(layer[comment_container_" + id + "].y, -34);\n        set(layer[comment_container_" + id + "].bgroundedge,17);\n        set(layer[comment_container_" + id + "].type, container);\n        set(layer[comment_container_" + id + "].height, 34);\n        set(layer[comment_container_" + id + "].edge, lefttop);\n        set(layer[comment_container_" + id + "].children, false);\n        set(layer[comment_container_" + id + "].bgcapture, true);\n        set(layer[comment_container_" + id + "].visible, false);\n        set(layer[comment_container_" + id + "].ondown, showlog();trace(123););\n        set(layer[comment_container_" + id + "].parent, hotspot[" + id + "]);\n\n\n        addlayer(comment_line_" + id + ");\n        set(layer[comment_line_" + id + "].scale, 0.5);\n        set(layer[comment_line_" + id + "].align, left);\n        set(layer[comment_line_" + id + "].x, 16);\n        set(layer[comment_line_" + id + "].y, 25);\n        set(layer[comment_line_" + id + "].url, 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAiCAYAAABiOJjbAAAAAXNSR0IArs4c6QAAAGNJREFUOE/tk0sOgDAIRN/czJ5MPZm92RgaMX6iblyWDTS8DClhxBa2nXVkSWq5A30P/R52a/zsC9sLMBytB1RJRQ/NZOcvgABOrr6NsT0B46WRz9pu/0WlJBA/SJWoZ0mhzArZ7IxRWjBxrwAAAABJRU5ErkJggg==');\n        set(layer[comment_line_" + id + "].parent,layer[comment_container_" + id + "]);\n\n        addlayer(comment_avatar_" + id + ");\n        set(layer[comment_avatar_" + id + "].width, 30);\n        set(layer[comment_avatar_" + id + "].height, 30);\n        set(layer[comment_avatar_" + id + "].x, 2);\n        set(layer[comment_avatar_" + id + "].y, 2);\n        set(layer[comment_avatar_" + id + "].edge, lefttop);\n        set(layer[comment_avatar_" + id + "].bgroundedge,30);\n        set(layer[comment_avatar_" + id + "].parent,layer[comment_container_" + id + "]);\n\n        addlayer(comment_text_" + id + ");\n        set(layer[comment_text_" + id + "].height, auto);\n        set(layer[comment_text_" + id + "].type, text);\n        set(layer[comment_text_" + id + "].x, 37);\n        set(layer[comment_text_" + id + "].y, 0);\n        set(layer[comment_text_" + id + "].html, '');\n        set(layer[comment_text_" + id + "].background, false);\n        set(layer[comment_text_" + id + "].parent,layer[comment_container_" + id + "]);\n        set(layer[comment_text_" + id + "].onautosized, \n            if(layer[comment_text_" + id + "].width GT layer[comment_subtitle_" + id + "].width, set(layer[comment_container_" + id + "].width, calc(layer[comment_text_" + id + "].width + 70));,set(layer[comment_container_" + id + "].width, calc(layer[comment_subtitle_" + id + "].width + 70)););set(layer[comment_container_" + id + "].visible, true);  \n        );\n\n        addlayer(comment_subtitle_" + id + ");\n        set(layer[comment_subtitle_" + id + "].height, auto);\n        set(layer[comment_subtitle_" + id + "].type, text);\n        set(layer[comment_subtitle_" + id + "].x, 37);\n        set(layer[comment_subtitle_" + id + "].background, false);\n        set(layer[comment_subtitle_" + id + "].html, '');\n        set(layer[comment_subtitle_" + id + "].css, font-family: PingFangSC-Regular; max-width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 12px;color: rgba(0,0,0,0.5););\n        set(layer[comment_subtitle_" + id + "].parent,layer[comment_container_" + id + "]);\n        set(layer[comment_subtitle_" + id + "].onautosized, \n            if(layer[comment_text_" + id + "].width GT layer[comment_subtitle_" + id + "].width, set(layer[comment_container_" + id + "].width, calc(layer[comment_text_" + id + "].width + 70));,set(layer[comment_container_" + id + "].width, calc(layer[comment_subtitle_" + id + "].width + 70)););\n        );\n\n        addlayer(comment_right_" + id + ");\n        set(layer[comment_right_" + id + "].width, 16);\n        set(layer[comment_right_" + id + "].height, 16);\n        set(layer[comment_right_" + id + "].align, right);\n        set(layer[comment_right_" + id + "].x, 10);\n        set(layer[comment_right_" + id + "].parent,layer[comment_container_" + id + "]);\n        ");

    var params = _extends({}, arguments[0]);

    this.updateCommentHotspot(params);
    return hotspot;
  }
  /**
   * 更新评论 文本热点
   * @param {Object} data - 热点的原始数据
   * @param {string} data.id - 热点id
   * @param {string} data.ath - 热点 ath
   * @param {string} data.atv - 热点 atv
   * @param {string} data.title - 评论
   * @param {string} data.subtilte - 点赞回复
   * @param {string} data.avatarURL - 头像 url
   * @param {string} data.iconURL - 点赞 url
   * @param {string} data.bgAlpha - 背景透明度
   * @param {string} data.bgColor - 背景颜色, 格式 0xfffff
   * @param {string} data.dragable - 是否可以拖动
   **/
  ;

  _proto.updateCommentHotspot = function updateCommentHotspot(_ref51) {
    var id = _ref51.id,
        ath = _ref51.ath,
        atv = _ref51.atv,
        title = _ref51.title,
        titleColor = _ref51.titleColor,
        subtitle = _ref51.subtitle,
        avatarURL = _ref51.avatarURL,
        iconURL = _ref51.iconURL,
        bgAlpha = _ref51.bgAlpha,
        bgColor = _ref51.bgColor,
        dragable = _ref51.dragable,
        zOrder = _ref51.zOrder;

    if (this.debug) {
      console.log('updateCommentHotspot', arguments[0]);
    }

    this.updateOriginHotspot({
      id: id,
      ath: ath,
      atv: atv,
      dragable: dragable,
      zOrder: zOrder
    });
    this.call("\n        " + (bgAlpha != undefined ? "set(layer[comment_container_" + id + "].bgalpha, " + bgAlpha + ");" : '') + "\n        " + (bgColor != undefined ? "set(layer[comment_container_" + id + "].bgcolor, " + bgColor + ");" : '') + "\n        " + (avatarURL != undefined ? "set(layer[comment_avatar_" + id + "].url, '" + avatarURL + "');" : '') + "\n        " + (title != undefined ? "set(layer[comment_text_" + id + "].html, '" + (title ? title.replace(/\n/g, " ").replace(/\r\n/g, " ") : '') + "');" : '') + "\n        " + (titleColor != undefined ? "set(layer[comment_text_" + id + "].css, font-family: PingFangSC-Regular; max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 12px;color: " + titleColor + ";);" : '') + "\n        " + (subtitle != undefined ? "set(layer[comment_subtitle_" + id + "].html, '" + (subtitle ? subtitle.replace(/\n/g, " ").replace(/\r\n/g, " ") : '') + "');" : '') + "\n        " + (iconURL != undefined ? "set(layer[comment_right_" + id + "].url, '" + iconURL + "');" : '') + "\n        ");
    this.call("\n        if(layer[comment_subtitle_" + id + "].html == '', set(layer[comment_text_" + id + "].align, leftcenter);, set(layer[comment_text_" + id + "].align, lefttop););\n        if(layer[comment_title_" + id + "].html == '', set(layer[comment_subtitle_" + id + "].align, leftcenter);, set(layer[comment_subtitle_" + id + "].align, leftbottom););\n        ");
  }
  /**
   * 新增DIV热点
   * @param {Object} data - 热点的原始数据
   * @param {string} data.id - 热点id
   * @example
   * 
   * 
   */
  ;

  _proto.addDivHotspot = function addDivHotspot(_ref52, html) {
    var _params$enabled, _params$capture, _params$cursor;

    var id = _ref52.id,
        vrEnabled = _ref52.vrEnabled;

    if (this.debug) {
      console.log('addDivHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.type = 'text';
    params.renderer = 'css3d';
    var hotspot = this.addOriginHotspot({
      id: params.id,
      type: 'text',
      renderer: 'css3d',
      isDiv: true,
      enabled: (_params$enabled = params.enabled) !== null && _params$enabled !== void 0 ? _params$enabled : true,
      capture: (_params$capture = params.capture) !== null && _params$capture !== void 0 ? _params$capture : true,
      cursor: (_params$cursor = params.cursor) !== null && _params$cursor !== void 0 ? _params$cursor : "default"
    });
    this.addTextHotspot({
      id: params.id + "_vr",
      text: "" + params.title,
      clickTargetId: params.id,
      ox: params.titleSetting.ox,
      oy: params.titleSetting.oy,
      padding: 8,
      distorted: params.distorted,
      ath: params.icon.ath,
      atv: params.icon.atv,
      edge: params.icon.edge,
      visible: false,
      font: {
        fontColor: 0xfff
      },
      background: {
        bgEnabled: true,
        bgColor: 0,
        bgAlpha: 0.6,
        bgRoundedge: 5
      }
    });
    this.call("\n        addplugin(" + id + "_plugin);\n        set(plugin[" + id + "_plugin].type, text);\n        set(plugin[" + id + "_plugin].bg, false);\n        set(plugin[" + id + "_plugin].padding, 0);\n        set(plugin[" + id + "_plugin].capture, false);\n        set(plugin[" + id + "_plugin].bgcapture, true);\n        set(plugin[" + id + "_plugin].parent, hotspot[" + id + "]);\n        ");
    this.call("\n        addplugin(" + id + "_plugin_point);\n        set(plugin[" + id + "_plugin_point].type, text);\n        set(plugin[" + id + "_plugin_point].bg, false);\n        set(plugin[" + id + "_plugin_point].width, 10);\n        set(plugin[" + id + "_plugin_point].height, 10);\n        set(plugin[" + id + "_plugin_point].padding, 0);\n        set(plugin[" + id + "_plugin_point].edge, center);\n        set(plugin[" + id + "_plugin_point].capture, false);\n        set(plugin[" + id + "_plugin_point].parent, hotspot[" + id + "]);\n        ");
    this.updateDivHotspot(params, html); // this.call(`
    // if(webvr.isenabled == true,
    //     copy(hotspot[${params.id}].oldvisible, hotspot[${params.id}].visible);
    //     set(hotspot[${params.id}].visible, false);
    //     set(hotspot[${params.id}_vr].visible, true);
    //     ,
    //     copy(hotspot[${params.id}].visible, hotspot[${params.id}].oldvisible);
    //     set(hotspot[${params.id}_vr].visible, false);
    //   );`);

    return hotspot;
  };

  _proto.rgbHex = function rgbHex(red, green, blue, alpha) {
    var isPercent = (red + (alpha || '')).toString().includes('%');

    if (typeof red === 'string') {
      var _red$match$map = red.match(/(0?\.?\d{1,3})%?\b/g).map(Number);

      red = _red$match$map[0];
      green = _red$match$map[1];
      blue = _red$match$map[2];
      alpha = _red$match$map[3];
    } else if (alpha !== undefined) {
      alpha = parseFloat(alpha);
    }

    if (typeof red !== 'number' || typeof green !== 'number' || typeof blue !== 'number' || red > 255 || green > 255 || blue > 255) {
      throw new TypeError('Expected three numbers below 256');
    }

    if (typeof alpha === 'number') {
      if (!isPercent && alpha >= 0 && alpha <= 1) {
        alpha = Math.round(255 * alpha);
      } else if (isPercent && alpha >= 0 && alpha <= 100) {
        alpha = Math.round(255 * alpha / 100);
      } else {
        throw new TypeError("Expected alpha value (" + alpha + ") as a fraction or percentage");
      }

      alpha = (alpha | 1 << 8).toString(16).slice(1);
    } else {
      alpha = '';
    }

    return (blue | green << 8 | red << 16 | 1 << 24).toString(16).slice(1) + alpha;
  };

  _proto.colorStringToObj = function colorStringToObj(str) {
    var _str$split$map = str.split(',').map(Number),
        _str$split$map$ = _str$split$map[0],
        r = _str$split$map$ === void 0 ? 0 : _str$split$map$,
        _str$split$map$2 = _str$split$map[1],
        g = _str$split$map$2 === void 0 ? 0 : _str$split$map$2,
        _str$split$map$3 = _str$split$map[2],
        b = _str$split$map$3 === void 0 ? 0 : _str$split$map$3,
        _str$split$map$4 = _str$split$map[3],
        a = _str$split$map$4 === void 0 ? 1 : _str$split$map$4;

    return {
      r: r,
      g: g,
      b: b,
      a: a
    };
  };

  _proto.colorStringToRGBAndAlpha = function colorStringToRGBAndAlpha(str) {
    var _this$colorStringToOb = this.colorStringToObj(str),
        r = _this$colorStringToOb.r,
        g = _this$colorStringToOb.g,
        b = _this$colorStringToOb.b,
        alpha = _this$colorStringToOb.a;

    try {
      return {
        rgb: "0x" + this.rgbHex(r, g, b),
        alpha: alpha
      };
    } catch (e) {
      return {
        rgb: '0x000000',
        alpha: alpha
      };
    }
  }
  /**
   * 更新 div 文本热点
   * @description - 参数同新增，除 id 外均为可选参数
   * 
   **/
  ;

  _proto.updateDivHotspot = function updateDivHotspot(_ref53, html) {
    var id = _ref53.id;

    if (this.debug) {
      console.log('updateDivHotspot', arguments[0]);
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.type != 'text') {
      return;
    }

    var paramsClone = JSON.parse(JSON.stringify(arguments[0]));
    var params = {
      id: id
    };

    if (paramsClone.zOrder != undefined) {
      params.zOrder = paramsClone.zOrder;
    }

    if (paramsClone.titleSetting && paramsClone.titleSetting.edge != undefined) {
      params.edge = paramsClone.titleSetting.edge;
    }

    if (paramsClone.titleSetting && paramsClone.titleSetting.ox != undefined && paramsClone.icon.type != 5) {
      params.ox = paramsClone.titleSetting.ox;
    }

    if (paramsClone.titleSetting && paramsClone.titleSetting.oy != undefined && paramsClone.icon.type != 5) {
      params.oy = paramsClone.titleSetting.oy;
    }

    if (paramsClone.icon && paramsClone.icon.ath != undefined) {
      params.ath = paramsClone.icon.ath;
    }

    if (paramsClone.icon && paramsClone.icon.atv != undefined) {
      params.atv = paramsClone.icon.atv;
    }

    if (paramsClone.icon && paramsClone.icon.stick != undefined) {
      params.distorted = paramsClone.icon.stick == 1;
    }

    if (paramsClone.icon && paramsClone.icon.data != undefined && paramsClone.icon.data.code == 10) {
      params.enabled = false;
    }

    if (paramsClone.showTitle != undefined) {
      params.visible = paramsClone.showTitle != 0;
    }

    if (paramsClone.visible == 0 || paramsClone.visible == false) {
      params.visible = false;
    }

    if (paramsClone.dragable != undefined) {
      params.dragable = paramsClone.dragable;
    }

    if (paramsClone.icon && paramsClone.icon.zoom != undefined) {
      params.zoom = paramsClone.icon.zoom;
    }

    if (paramsClone.titleSetting && paramsClone.titleSetting.edge != undefined && paramsClone.icon.type != 5) {
      this.call("set(plugin[" + id + "_plugin].edge, " + paramsClone.titleSetting.edge + ");");
    }

    if (paramsClone.icon && paramsClone.icon.type == 0) {
      if (paramsClone.icon.stick == undefined) {
        paramsClone.icon.stick = 0;
      }
    }

    if (paramsClone.titleSetting) {
      if (paramsClone.titleSetting.styleType == undefined) {
        paramsClone.titleSetting.styleType = 0;
      }

      if (paramsClone.titleSetting.specialStyleId == undefined) {
        paramsClone.titleSetting.specialStyleId = 0;
      }

      if (paramsClone.titleSetting.writingMode == undefined) {
        paramsClone.titleSetting.writingMode = 0;
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.type == undefined) {
        paramsClone.titleSetting.background.type = 0;
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.bgColor == undefined) {
        paramsClone.titleSetting.background.bgColor = '0,0,0,0.5';
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.bgRoundedge == undefined) {
        paramsClone.titleSetting.background.bgRoundedge = 5;
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.borderWidth == undefined) {
        paramsClone.titleSetting.background.borderWidth = 0;
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.borderColor == undefined) {
        paramsClone.titleSetting.background.borderColor = '0,0,0,0.5';
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.gradientAngle == undefined) {
        paramsClone.titleSetting.background.gradientAngle = 0;
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.gradientStartColor == undefined) {
        paramsClone.titleSetting.background.gradientStartColor = '0,0,0,1';
      }

      if (paramsClone.titleSetting.background && paramsClone.titleSetting.background.gradientEndColor == undefined) {
        paramsClone.titleSetting.background.gradientEndColor = '0,0,0,1';
      }
    }

    var icon = paramsClone.icon;
    var font = paramsClone.titleSetting.font; // 文字标记单独处理

    if (icon && icon.type == 1) {
      if (paramsClone.icon.stick == undefined) {
        paramsClone.icon.stick = 0;
      }

      if (paramsClone.icon.lineType == undefined) {
        paramsClone.icon.lineType = 0;
      }

      if (paramsClone.icon.lineWidth == undefined) {
        paramsClone.icon.lineWidth = 1;
      }

      if (paramsClone.icon.lineColor == undefined) {
        paramsClone.icon.lineColor = '255,255,255,1';
      } // 三角形标记


      if (icon.lineType == 1) {
        this.call("\n                set(plugin[" + id + "_plugin_point].visible, false);\n                set(plugin[" + id + "_plugin].edge, " + icon.edge + ");\n                set(hotspot[" + id + "].width, 0);\n                set(hotspot[" + id + "].height, 0);\n                ");
        params.ox = 0;
        params.oy = 0;

        switch (icon.edge) {
          case 'top':
            this.call("\n                            set(plugin[" + id + "_plugin].ox, 0);\n                            set(plugin[" + id + "_plugin].oy, 6);\n                        ");
            break;

          case 'right':
            this.call("\n                            set(plugin[" + id + "_plugin].ox, -6);\n                            set(plugin[" + id + "_plugin].oy, 0);\n                        ");
            break;

          case 'left':
            this.call("\n                            set(plugin[" + id + "_plugin].ox, 6);\n                            set(plugin[" + id + "_plugin].oy, 0);\n                        ");
            break;

          default:
            this.call("\n                            set(plugin[" + id + "_plugin].ox, 0);\n                            set(plugin[" + id + "_plugin].oy, -6);\n                        ");
            break;
        }
      } else {
        // 线条标记
        params.edge = icon.edge;
        this.call("\n                set(plugin[" + id + "_plugin_point].visible, " + (icon.lineType == 0 ? false : true) + ");\n                set(plugin[" + id + "_plugin].edge, " + icon.edge + ");\n                ");
        params.bg = true;
        params.bgColor = this.colorStringToRGBAndAlpha(icon.lineColor).rgb;
        params.bgAlpha = this.colorStringToRGBAndAlpha(icon.lineColor).alpha;

        switch (icon.edge) {
          case 'top':
            params.width = icon.lineWidth;
            params.height = icon.length;
            this.call("\n                            set(plugin[" + id + "_plugin].ox, " + icon.lineWidth / 2 + ");\n                            set(plugin[" + id + "_plugin].oy, " + icon.length + ");\n                            set(plugin[" + id + "_plugin_point].ox, " + icon.lineWidth / 2 + ");\n                            set(plugin[" + id + "_plugin_point].oy, 0);\n                        ");
            params.ox = 0;
            params.oy = icon.lineWidth * 1.5 + 3;
            break;

          case 'right':
            params.width = icon.length;
            params.height = icon.lineWidth;
            this.call("\n                            set(plugin[" + id + "_plugin].oy, " + icon.lineWidth / 2 + ");\n                            set(plugin[" + id + "_plugin].ox, 0);\n                            if(device.safari OR device.wechat OR device.ioswebkit,sub(plugin[" + id + "_plugin].ox," + (paramsClone.titleSetting.styleType != 0 || paramsClone.titleSetting.writingMode != 1 ? '0' : "" + (font.fontSize + 5)) + "););\n                            set(plugin[" + id + "_plugin_point].oy, " + icon.lineWidth / 2 + ");\n                            set(plugin[" + id + "_plugin_point].ox, " + icon.length + ");\n                        ");
            params.oy = 0;
            params.ox = -(icon.lineWidth * 1.5 + 3);
            break;

          case 'left':
            params.width = icon.length;
            params.height = icon.lineWidth;
            this.call("\n                        set(plugin[" + id + "_plugin].ox, " + icon.length + ");\n                        set(plugin[" + id + "_plugin].oy, " + icon.lineWidth / 2 + ");\n                        set(plugin[" + id + "_plugin_point].ox, 0);\n                        set(plugin[" + id + "_plugin_point].oy, " + icon.lineWidth / 2 + ");\n                        ");
            params.oy = 0;
            params.ox = icon.lineWidth * 1.5 + 3;
            break;

          default:
            params.width = icon.lineWidth;
            params.height = icon.length;
            this.call("\n                            set(plugin[" + id + "_plugin].oy, 0);\n                            set(plugin[" + id + "_plugin].ox, " + icon.lineWidth / 2 + ");\n                            if(device.safari OR device.wechat OR device.ioswebkit,sub(plugin[" + id + "_plugin].ox," + (paramsClone.titleSetting.styleType != 0 || paramsClone.titleSetting.writingMode != 1 ? '0' : "" + (font.fontSize / 2 + 3)) + "););\n                            set(plugin[" + id + "_plugin_point].ox, " + icon.lineWidth / 2 + ");\n                            set(plugin[" + id + "_plugin_point].oy, " + icon.length + ");\n                        ");
            params.ox = 0;
            params.oy = -(icon.lineWidth * 1.5 + 3);
            break;
        }
      }

      switch (icon.lineType) {
        case (0, 1):
          this.call("\n                    set(plugin[" + id + "_plugin_point].bg, false);\n                    ");
          break;

        case 2:
          this.call("\n                    set(plugin[" + id + "_plugin_point].bg, true);\n                    set(plugin[" + id + "_plugin_point].bgcolor, " + params.bgColor + ");\n                    set(plugin[" + id + "_plugin_point].bgalpha, " + params.bgAlpha + ");\n                    set(plugin[" + id + "_plugin_point].width, " + (icon.lineWidth * 2 + 6) + ");\n                    set(plugin[" + id + "_plugin_point].height, " + (icon.lineWidth * 2 + 6) + ");\n                    set(plugin[" + id + "_plugin_point].bgroundedge, " + (icon.lineWidth + 3) + ");\n                    set(plugin[" + id + "_plugin_point].bgborder, 0);\n                    ");
          break;

        case 3:
          this.call("\n                    set(plugin[" + id + "_plugin_point].bg, true);\n                    set(plugin[" + id + "_plugin_point].bgcolor, " + params.bgColor + ");\n                    set(plugin[" + id + "_plugin_point].bgalpha, 0);\n                    set(plugin[" + id + "_plugin_point].width, " + (icon.lineWidth * 3 + 6) + ");\n                    set(plugin[" + id + "_plugin_point].height, " + (icon.lineWidth * 3 + 6) + ");\n                    set(plugin[" + id + "_plugin_point].bgroundedge, " + (icon.lineWidth * 1.5 + 3) + ");\n                    set(plugin[" + id + "_plugin_point].bgborder, " + icon.lineWidth + " " + params.bgColor + " " + params.bgAlpha + ");\n                    ");

          if (icon.edge == 'left' || icon.edge == 'right') {
            this.call("\n                        add(plugin[" + id + "_plugin_point].oy, " + (icon.lineWidth - 0.5) + ");\n                        add(plugin[" + id + "_plugin_point].ox, " + (icon.edge == 'right' ? icon.lineWidth * 1.5 + 3 : icon.lineWidth == 1 ? -(icon.lineWidth * 1 + 3) : -icon.lineWidth) + ");");
          } else {
            this.call("\n                        add(plugin[" + id + "_plugin_point].oy, " + (icon.edge == 'bottom' ? icon.lineWidth * 1.5 + 3 : icon.lineWidth == 1 ? -(icon.lineWidth * 1 + 3) : -icon.lineWidth) + ");\n                        add(plugin[" + id + "_plugin_point].ox, " + (icon.lineWidth - 0.5) + ");");
          }

          break;
      }
    }

    if (paramsClone.showTitle == 1 && paramsClone.titleSetting && paramsClone.titleSetting.writingMode == 1 && paramsClone.titleSetting.styleType == 0 && paramsClone.icon.type != 1) {
      switch (paramsClone.titleSetting.edge) {
        case 'top':
          this.call("\n                        if(plugin[" + id + "_plugin].ox === null, set(plugin[" + id + "_plugin].ox, 0););\n                        if(device.safari OR device OR device.ioswebkit,sub(plugin[" + id + "_plugin].ox," + (font.fontSize / 2 + 3) + "););\n                    ");
          break;

        case 'right':
          this.call("\n                        if(plugin[" + id + "_plugin].ox === null, set(plugin[" + id + "_plugin].ox, 0););\n                        if(device.safari OR device.wechat OR device.ioswebkit,sub(plugin[" + id + "_plugin].ox," + (font.fontSize + 5) + "););\n                    ");
          break;

        case 'left':
          this.call("\n                    \n                    ");
          break;

        default:
          this.call("\n                        if(plugin[" + id + "_plugin].ox === null, set(plugin[" + id + "_plugin].ox, 0););\n                        if(device.safari OR device.wechat OR device.ioswebkit,sub(plugin[" + id + "_plugin].ox," + (font.fontSize / 2 + 3) + "););\n                    ");
          break;
      }
    }

    params.border = false;
    params.borderWidth = 0;
    params.padding = '0';
    this.updateOriginHotspot(params);

    if (html) {
      this.call("\n            set(plugin[" + id + "_plugin].html, " + html + ");\n            ");
    } else {
      var hotspotData = _extends({}, paramsClone);

      hotspotData.title = hotspotData.title.replace(',', '&comma;');
      this.call("\n            set(plugin[" + id + "_plugin].html, " + this.generateHotspotDivHtml(hotspotData, {
        sysDomain: this.__sysMediaPath,
        mediaDomain: this.__mediaPath
      }) + ");\n            ");
    }
  };

  _proto.generateHotspotDivHtml = function generateHotspotDivHtml(data, domains) {
    if (domains === void 0) {
      domains = {};
    }

    // 原标记图标
    var oldMarkIcons = {
      0: "/hotspots/word/chaolianjie/1.png",
      1: "/hotspots/word/dianhua/1.png",
      2: "/hotspots/word/daohang/1.png",
      3: "/hotspots/word/tupian/1.png",
      4: "/hotspots/word/wenzi/1.png",
      5: "/hotspots/word/wenzhang/1.png",
      6: "/hotspots/word/yinyue/1.png",
      7: "/hotspots/word/shiping/1.png",
      8: "/hotspots/word/zhuzheng/1.png",
      9: "/hotspots/word/changjingqiehuan/1.png"
    };
    var widthMap = {
      0: 14,
      1: 14,
      2: 19,
      3: 19,
      4: 23,
      5: 20,
      6: 20,
      7: 25,
      8: 30
    };
    var _domains = domains,
        _domains$sysDomain = _domains.sysDomain,
        sysDomain = _domains$sysDomain === void 0 ? 'https://ssl-static2.720static.com' : _domains$sysDomain,
        _domains$mediaDomain = _domains.mediaDomain,
        mediaDomain = _domains$mediaDomain === void 0 ? 'https://ssl-media.720static.com/@' : _domains$mediaDomain;
    var title = data.title,
        titleSetting = data.titleSetting,
        icon = data.icon;
    var align = titleSetting.align,
        font = titleSetting.font,
        background = titleSetting.background,
        writingMode = titleSetting.writingMode,
        _titleSetting$styleTy = titleSetting.styleType,
        styleType = _titleSetting$styleTy === void 0 ? 0 : _titleSetting$styleTy,
        _titleSetting$special = titleSetting.specialStyleId,
        specialStyleId = _titleSetting$special === void 0 ? 0 : _titleSetting$special;
    var isMark = icon.type === 1;
    var isVertical = writingMode === 1;
    var _background$type = background.type,
        bgType = _background$type === void 0 ? 1 : _background$type,
        _background$bgColor = background.bgColor,
        bgColor = _background$bgColor === void 0 ? '0,0,0,0.5' : _background$bgColor,
        _background$bgRounded = background.bgRoundedge,
        bgRoundedge = _background$bgRounded === void 0 ? 5 : _background$bgRounded,
        _background$borderWid = background.borderWidth,
        borderWidth = _background$borderWid === void 0 ? 0 : _background$borderWid,
        _background$borderCol = background.borderColor,
        borderColor = _background$borderCol === void 0 ? '255,255,255,1' : _background$borderCol,
        _background$gradientA = background.gradientAngle,
        gradientAngle = _background$gradientA === void 0 ? 0 : _background$gradientA,
        _background$gradientS = background.gradientStartColor,
        gradientStartColor = _background$gradientS === void 0 ? '0,0,0,0.5' : _background$gradientS,
        _background$gradientE = background.gradientEndColor,
        gradientEndColor = _background$gradientE === void 0 ? '0,0,0,0.5' : _background$gradientE;
    var bgStr = bgType === 1 ? "linear-gradient(" + gradientAngle + "deg, rgba(" + gradientStartColor + "), rgba(" + gradientEndColor + "))" : "rgba(" + bgColor + ")";
    var borderStr = borderWidth + "px solid rgba(" + borderColor + ")";
    var paddingStr = isVertical ? '10px 6px' : '6px 10px';
    var spaceStr = isVertical ? "line-height: 1.6; letter-spacing: 4px;" : "line-height: 1.4;";
    var titleStr = "<div style=\"text-align: " + align + "; font-size: " + font.fontSize + "px; color: rgba(" + font.fontColor + "); " + spaceStr + "\">" + title + "</div>";

    var imgStr = function () {
      if (!isMark) return '';
      var src = '';

      if (!icon.media) {
        var oldIcon = oldMarkIcons[data.data.code];

        if (oldIcon) {
          src = "" + sysDomain + oldIcon;
        }
      } else if (icon.media.enabled) {
        src = icon.media.type === 0 ? "" + sysDomain + icon.media.url : "" + mediaDomain + icon.media.url;
      }

      if (!src) return '';
      var margin = isVertical ? 'margin-bottom: 5px;' : 'margin-right: 5px;';
      return "<img src=" + src + " alt='' style='width: 24px; height: 24px; " + margin + "'>";
    }();

    var triangleStr = function () {
      if (!isMark) return '';
      var edge = icon.edge,
          _icon$lineType = icon.lineType,
          lineType = _icon$lineType === void 0 ? 0 : _icon$lineType,
          _icon$lineColor = icon.lineColor,
          lineColor = _icon$lineColor === void 0 ? '255,255,255,1' : _icon$lineColor;
      if (lineType !== 1) return '';
      var borderC = "rgba(" + lineColor + ") transparent transparent";
      var posStr = '';
      var offset = 12 + borderWidth;

      if (edge === 'top') {
        posStr = "top: -" + offset + "px; transform: rotate(180deg);";
      } else if (edge === 'bottom') {
        posStr = "bottom: -" + offset + "px;";
      } else if (edge === 'left') {
        posStr = "left: -" + offset + "px; transform: rotate(90deg);";
      } else if (edge === 'right') {
        posStr = "right: -" + offset + "px; transform: rotate(270deg);";
      }

      return "<div style=\"position: absolute; " + posStr + " width: 0px; border-width: 6px; border-style: solid; border-color: " + borderC + "; border-image: initial;\"></div>";
    }();

    var wMode = isVertical ? "writing-mode: vertical-lr;" : '';

    if (styleType === 1) {
      if (isVertical) {
        var _sUrl = function _sUrl(i) {
          return sysDomain + "/hotspots/special/s" + specialStyleId + "_v" + i + ".png";
        };

        var _imgStyle = "display: block; width: 40px; height: " + widthMap[specialStyleId] + "px;";

        return "<div style=\"display: flex; align-items: center; justify-content: center; position: relative; flex-direction: column;\"><img src=\"" + _sUrl(1) + "\" style=\"" + _imgStyle + "\"><div style=\"display: flex; align-items: center; width: 40px; background-image: url(" + _sUrl(2) + "); background-size: contain; writing-mode: vertical-lr;\">\n      " + imgStr + "\n      " + titleStr + "\n      </div><img src=\"" + _sUrl(3) + "\" style=\"" + _imgStyle + "\">\n      " + triangleStr + "\n      </div>";
      }

      var sUrl = function sUrl(i) {
        return sysDomain + "/hotspots/special/s" + specialStyleId + "_h" + i + ".png";
      };

      var imgStyle = "display: inline-block; height: 40px; vertical-align: middle; width: " + widthMap[specialStyleId] + "px;";
      return "<div style=\"display: flex; align-items: center; justify-content: center; position: relative;\"><img src=\"" + sUrl(1) + "\" style=\"" + imgStyle + "\"><div style=\"display: inline-flex; align-items: center; height: 40px; background-image: url(" + sUrl(2) + "); background-size: contain; vertical-align: middle;\">\n      " + imgStr + "\n      " + titleStr + "\n      </div><img src=\"" + sUrl(3) + "\" style=\"" + imgStyle + "\">\n      " + triangleStr + "\n      </div>";
    }

    return "<div style=\"display: flex; align-items: center; justify-content: center; position: relative; border: " + borderStr + "; padding: " + paddingStr + "; white-space: pre; border-radius: " + bgRoundedge + "px; background: " + bgStr + "; " + wMode + "\">\n      " + imgStr + "\n      " + titleStr + "\n      " + triangleStr + "\n      </div>";
  }
  /**
   * 新增多边形热点
   * @param {Object} data - 多边形数据
   * @param {string} data.id - 热点id
   * @param {Array} data.points - 多边形点数组, [{ath: 0, atv: 10, selected: true}, {ath: 10, atv: 0}, {ath: 0, atv: 0}]
   * @param  {number} [data.fillColor=0xAAAAAA] - 热点填充颜色
   * @param  {number} [data.fillAlpha=0.5] - 热点填充透明度
   * @param  {number} [data.borderWidth=3] - 边框宽度
   * @param  {number} [data.borderColor=0xAAAAAA] - 边框颜色 0xBBBBBB
   * @param  {number} [data.borderAlpha=1.0] - 边框透明度
   * @param  {number} [data.overFillColor] - 鼠标移入热点填充颜色 0xAAAAAA
   * @param  {number} [data.overFillAlpha] - 鼠标移入热点填充透明度
   * @param  {number} [data.overBorderWidth] - 鼠标移入边框宽度
   * @param  {number} [data.overBorderColor] - 鼠标移入边框颜色 0xBBBBBB
   * @param  {number} [data.overBorderAlpha] - 鼠标移入边框透明度
   * @param  {number} [data.zOrder] - 层级
   * @param {number} [data.enabled] - 是否接受鼠标事件
   * @param {bool}   [data.dragable=false] - 是否可以拖动
   * @param {bool}   [data.blink=false] - 是否闪烁
   * @param {string} [data.titleHotspotId] - 为热点关联一个标题id
   * @param {bool} [data.capture=true] - 是否阻止鼠标事件向下传递
   * 
   * @example
   * 
  // 多边形
  player.addPolygonHotspot({
  id: "polygon",
  zOrder: 10,
  points: [{ ath: 0, atv: 20 }, { ath: 10, atv: 20 }, { ath: 10, atv: 30 }, { ath: 0, atv: 30 }],
  fillColor: 0x99999,
  fillAlpha: 1,
  borderWidth: 10,
  borderColor: 0x333888,
  borderAlpha: 0.2,
  overFillColor: 0x000000,
  overFillAlpha: 0.5,
  overBorderWidth: 5,
  overBorderWidth: 2,
  overBorderColor: 0x222333,
  overBorderAlpha: 0.9,
  });
   */
  ;

  _proto.addPolygonHotspot = function addPolygonHotspot(_ref54) {
    var id = _ref54.id,
        points = _ref54.points,
        fillColor = _ref54.fillColor,
        fillAlpha = _ref54.fillAlpha,
        borderWidth = _ref54.borderWidth,
        borderColor = _ref54.borderColor,
        borderAlpha = _ref54.borderAlpha,
        overFillColor = _ref54.overFillColor,
        overFillAlpha = _ref54.overFillAlpha,
        overBorderWidth = _ref54.overBorderWidth,
        overBorderColor = _ref54.overBorderColor,
        overBorderAlpha = _ref54.overBorderAlpha,
        zOrder = _ref54.zOrder,
        dragable = _ref54.dragable,
        titleHotspotId = _ref54.titleHotspotId,
        blink = _ref54.blink,
        blinkDuration = _ref54.blinkDuration,
        polyline = _ref54.polyline;

    if (this.debug) {
      console.log('addPolygonHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events; // if (fillColor != undefined) {
    //     params['normalFillColor'] = fillColor;
    // }
    // if (fillAlpha != undefined) {
    //     params['normalFillAlpha'] = fillAlpha;
    // }
    // if (borderWidth != undefined) {
    //     params['normalBorderWidth'] = borderWidth;
    // }
    // if (borderColor != undefined) {
    //     params['normalBorderColor'] = borderColor;
    // }
    // if (borderAlpha != undefined) {
    //     params['normalBorderAlpha'] = borderAlpha;
    // }

    var hotspot = this.addOriginHotspot(params); // for (let i = 0; i < points.length; i++) {
    //     const point = points[i];
    //     this.krpanoWrapper.set('hotspot[' + id + '].point[p' + i + '].ath', point.ath);
    //     this.krpanoWrapper.set('hotspot[' + id + '].point[p' + i + '].atv', point.atv);
    // }

    this.krpanoWrapper.call('hotspot[' + id + '].addevent(onover, on_polygon_over(););');
    this.krpanoWrapper.call('hotspot[' + id + '].addevent(onout, on_polygon_out(););');
    this.krpanoWrapper.call('hotspot[' + id + '].addevent(ondown, if(device.touch, on_polygon_over();););');
    this.krpanoWrapper.call('hotspot[' + id + '].addevent(onup, if(device.touch, on_polygon_out();););');
    this.updatePolygonHotspot(params);
    return hotspot;
  }
  /**
   * 更新多边形热点
   * @description - 参数同新增，除 id 外均为可选参数
   */
  ;

  _proto.updatePolygonHotspot = function updatePolygonHotspot(_ref55) {
    var id = _ref55.id,
        points = _ref55.points,
        fillColor = _ref55.fillColor,
        fillAlpha = _ref55.fillAlpha,
        borderWidth = _ref55.borderWidth,
        borderColor = _ref55.borderColor,
        borderAlpha = _ref55.borderAlpha,
        overFillColor = _ref55.overFillColor,
        overFillAlpha = _ref55.overFillAlpha,
        overBorderWidth = _ref55.overBorderWidth,
        overBorderColor = _ref55.overBorderColor,
        overBorderAlpha = _ref55.overBorderAlpha,
        zOrder = _ref55.zOrder,
        dragable = _ref55.dragable,
        blink = _ref55.blink,
        blinkDuration = _ref55.blinkDuration,
        polyline = _ref55.polyline;
    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;

    if (fillColor != undefined) {
      params['normalFillColor'] = fillColor;
    }

    if (fillAlpha != undefined) {
      params['normalFillAlpha'] = fillAlpha;
    }

    if (borderWidth != undefined) {
      params['normalBorderWidth'] = borderWidth;
    }

    if (borderColor != undefined) {
      params['normalBorderColor'] = borderColor;
    }

    if (borderAlpha != undefined) {
      params['normalBorderAlpha'] = borderAlpha;
    }

    if (polyline != undefined) {
      params['polyline'] = polyline;
    }

    if (points != undefined) {
      var oldHotspot = this.krpanoWrapper.get('hotspot[' + id + '].point');

      if (oldHotspot) {
        var oldPoints = oldHotspot.getArray();

        for (var i = 0; i < oldPoints.length; i++) {
          var point = oldPoints[i];
          var dragPointId = id + point.name + '_drag';
          this.removeHotspotById(dragPointId);
        }
      }

      this.krpanoWrapper.set('hotspot[' + id + '].point.count', 0);

      for (var _i = 0; _i < points.length; _i++) {
        var _point = points[_i];
        this.krpanoWrapper.set('hotspot[' + id + '].point[p' + _i + '].ath', _point.ath);
        this.krpanoWrapper.set('hotspot[' + id + '].point[p' + _i + '].atv', _point.atv);
        this.krpanoWrapper.set('hotspot[' + id + '].point[p' + _i + '].selected', _point.selected);
        this.krpanoWrapper.set('hotspot[' + id + '].point[p' + _i + '].imageUrl', _point.imageUrl);
        this.krpanoWrapper.set('hotspot[' + id + '].point[p' + _i + '].imageAlpha', _point.imageAlpha);
      }
    }

    var hotspot = this.getHotspotById(id);

    if (hotspot && (dragable != undefined || hotspot.dragable)) {
      params['dragable'] = dragable;
      hotspot.dragable = dragable == undefined ? hotspot.dragable : dragable;

      var _points = this.krpanoWrapper.get('hotspot[' + id + '].point').getArray();

      for (var _i2 = 0; _i2 < _points.length; _i2++) {
        var _point2 = _points[_i2];

        var _dragPointId = id + _point2.name + '_drag';

        if (hotspot.dragable) {
          var pointHotspot = this.addOriginHotspot({
            id: _dragPointId,
            url: _point2.imageurl ? _point2.imageurl : _point2.selected ? 'https://ssl-player2.720static.com/krp/edit/polygon_point_selected.png' : 'https://ssl-player2.720static.com/krp/edit/polygon_point.png',
            alpha: _point2.imagealpha == undefined ? 1 : _point2.imagealpha,
            ath: _point2.ath,
            atv: _point2.atv,
            bgColor: 0xff0000,
            background: true,
            zOrder: this.getHotspotById(id).zOrder,
            hotspotId: id,
            pointId: _point2.name
          });
          this.krpanoWrapper.set('hotspot[' + _dragPointId + '].ondown', 'drag_enable_polygon();jscall(window.players[\'' + this.krpanoWrapper.id + '\'].getHotspotById("' + id + '").events.onDown({id:"' + id + '", index: ' + _i2 + '});)');
          this.krpanoWrapper.set('hotspot[' + _dragPointId + '].onclick', 'jscall(window.players[\'' + this.krpanoWrapper.id + '\'].getHotspotById("' + id + '").events.onClick({id: "' + id + '", index:' + _i2 + '}););');
          this.krpanoWrapper.set('hotspot[' + _dragPointId + '].onup', 'jscall(window.players[\'' + this.krpanoWrapper.id + '\'].getHotspotById("' + id + '").events.onUp({id:"' + id + '", index: ' + _i2 + '});)');
        } else {
          this.removeHotspotById(_dragPointId);
        }

        if (hotspot.isLine) {
          this.updateLineEndPoints(hotspot.id);
        }
      }
    }

    this.updateOriginHotspot(params);

    if (hotspot && dragable != undefined) {
      if (dragable) {
        this.getHotspotById(id).events['onDown'] = this.onHotspotPointMoveBegan.bind(this); // this.callbacks['onHotspotPointMoveBegan'];

        this.getHotspotById(id).events['onUp'] = this.onHotspotPointMoveEnd.bind(this); //this.callbacks['onHotspotPointMoveEnd'];

        this.getHotspotById(id).events['onClick'] = this.onHotspotPointClick.bind(this); //this.callbacks['onHotspotPointClick'];
      } else {
        this.getHotspotById(id).events['onDown'] = this.onHotspotDown.bind(this); //this.callbacks['onHotspotDown'];

        this.getHotspotById(id).events['onUp'] = this.onHotspotUp.bind(this); //this.callbacks['onHotspotUp'];

        this.getHotspotById(id).events['onClick'] = this.onHotspotClick.bind(this); //this.callbacks['onHotspotClick'];
      }
    }

    if (blink != undefined) {
      if (blink == 1 || blink == true) {
        params['blink'] = true;
        this.krpanoWrapper.call("polygon_blink_enable(" + id + ");");
      } else {
        params['blink'] = false;
        this.krpanoWrapper.call("polygon_blink_disable(" + id + ");");
      }
    }
  }
  /**
   * 新增视频热点
   * @param {Object} data - 热点数据
   * @param {string} data.id - 热点 id
   * @param {string} data.videoUrl - 视频地址
   * @param {string} [data.posterUrl] - 封面图地址
   * @param {number} [data.ath=当前视角] - 水平坐标
   * @param {number} [data.atv=当前视角] - 垂直坐标
   * @param {string} [data.edge='center'] - 锚点， lefttop, left, leftbottom, top, center, bottom, righttop, right, rightbottom
   * @param {bool} [data.distorted=true] - 是否贴合全景，跟随全景缩放
   * @param {number} [data.scale=1.0] - 缩放比例 
   * @param {number} [data.scaleX=1.0] - x轴缩放比例
   * @param {number} [data.scaleY=1.0] - y轴缩放比例
   * @param {number} [data.rx=0] - x轴旋转
   * @param {number} [data.ry=0] - y轴旋转
   * @param {number} [data.rz=0] - z轴旋转
   * @param {number} [data.hFov] - 对齐水平视场, (hFov yaw pitch roll 在对齐模式下需要全部传入，非对齐模式不传)
   * @param {number} [data.yaw] - 对齐x旋转
   * @param {number} [data.pitch] - 对齐y旋转
   * @param {number} [data.roll] - 对齐z旋转
   * @param {bool} [data.pausedOnStart=false] - 开始时暂停
   * @param {bool} [data.loop=false] - 循环播放
   * @param {number} [data.volume=1.0] - 音量
   * @param {bool} [data.muted=false] - 静音
   * @param {number} [data.zOrder] - 层级
   * @param {number} [data.enabled] - 是否接受鼠标事件
   * @param {bool} [data.dragable=false] - 是否可拖动
   * @param {string} [data.titleHotspotId] - 为热点添加标题，先添加一个标题热点，然后设置热点的 titleHotspotId 为标题热点 id
   * @param {bool} [data.autoPause=true] - 浏览器标签页隐藏后自动暂停
   * @param {bool} [data.autoResume=false] - 浏览器标签页恢复后自动播放
   * @param {bool} [data.capture=true] - 是否阻止鼠标事件向下传递
   * @param {string} [data.chromakey] - 透明蒙版, "hexColor,threshold(0.0-1.0),smoothing(0.0-1.0)",例如 "0x238E54,0.3,0.1" 
   * @param {object} [data.events] - 事件回调
   * @param {function} [data.events.onHotspotClick] - 热点点击回调
   * @param {function} [data.events.onHotspotMoving] - 热点移动回调
   * @param {function} [data.events.onHotspotMoveBegan] - 热点开始移动回调
   * @param {function} [data.events.onHotspotMoveEnd] - 热点移动结束回调
   * @param {function} [data.events.onHotspotDown] - 鼠标按下热点
   * @param {function} [data.events.onHotspotUp] - 鼠标放开热点
   * @param {function} [data.events.onHotspotOver] - 鼠标进入热点
   * @param {function} [data.events.onHotspotOut] - 鼠标移出热点
   * @example
   * 
  // 视频
  player.addVideoHotspot({
  id: "video",
  videoUrl: "https://ssl-media.720static.com/@/fc6jOdsnzn5/3/b2920db4592e7a601ab62ed699f9ef2av5.mp4",
  scale: 0.15,
  ath: -40,
  atv: 0,
  pausedOnStart: false,
  loop: true,
  zOrder: 4,
  dragable: true,
  distorted: true,
  });
   */
  ;

  _proto.addVideoHotspot = function addVideoHotspot(_ref56) {
    var id = _ref56.id,
        videoUrl = _ref56.videoUrl,
        posterUrl = _ref56.posterUrl,
        ath = _ref56.ath,
        atv = _ref56.atv,
        edge = _ref56.edge,
        distorted = _ref56.distorted,
        zoom = _ref56.zoom,
        visible = _ref56.visible,
        scale = _ref56.scale,
        scaleX = _ref56.scaleX,
        scaleY = _ref56.scaleY,
        rx = _ref56.rx,
        ry = _ref56.ry,
        rz = _ref56.rz,
        hFov = _ref56.hFov,
        yaw = _ref56.yaw,
        pitch = _ref56.pitch,
        roll = _ref56.roll,
        pausedOnStart = _ref56.pausedOnStart,
        loop = _ref56.loop,
        volume = _ref56.volume,
        muted = _ref56.muted,
        zOrder = _ref56.zOrder,
        dragable = _ref56.dragable,
        titleHotspotId = _ref56.titleHotspotId,
        autoPause = _ref56.autoPause,
        autoResume = _ref56.autoResume;

    if (this.debug) {
      console.log('addVideoHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    params.url = this.__videoPlugin;
    params.html5Preload = "metadata";

    if (distorted == undefined) {
      params['distorted'] = true;
    }

    if (volume == 0) {
      params['muted'] = true;
    }

    var hotspot = this.addOriginHotspot(params);
    this.krpanoWrapper.call('set(hotspot[' + id + '].onvideoready, scale_to_xy(' + id + ');jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onHotspotVideoReady({id:\'' + id + '\'});"););');
    this.krpanoWrapper.call('set(hotspot[' + id + '].onvideoplay, set(hotspot[' + id + '_poster].visible, false); jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onHotspotVideoPlay({id:\'' + id + '\'});"););');
    this.krpanoWrapper.call('set(hotspot[' + id + '].onvideopaused, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onHotspotVideoPaused({id:\'' + id + '\'});"););');
    this.krpanoWrapper.call('set(hotspot[' + id + '].onvideocomplete, jscall("window.players[\'' + this.krpanoWrapper.id + '\'].events.onHotspotVideoComplete({id:\'' + id + '\'});"););');
    this.krpanoWrapper.call('set(hotspot[' + id + '].posterId, ' + id + '_poster);');
    var posterParams = params;
    posterParams.id = id + '_poster';
    posterParams.url = '';
    posterParams.visible = false;
    posterParams.enabled = false;
    var posterImage = this.addOriginHotspot(posterParams);

    if (posterUrl != undefined) {
      posterImage.url = posterUrl;
      posterImage.visible = false;

      if (hFov == undefined && yaw == undefined && pitch == undefined && roll == undefined) {
        if (visible) {
          this.krpanoWrapper.call('set(hotspot[' + id + '_poster' + '].onloaded, scale_to_xy(' + id + '_poster' + '); copy(visible, hotspot[' + id + '].ispaused););');
        } else {
          this.krpanoWrapper.call('set(hotspot[' + id + '_poster' + '].onloaded, scale_to_xy(' + id + '_poster' + '); set(visible, false););');
        }
      } else {
        this.krpanoWrapper.call("set(hotspot[" + id + "_poster].targetVisible, " + (visible == undefined ? true : visible) + ");");
      }
    }

    return hotspot;
  }
  /**
   * 更新视频热点
   * @description - 参数同新增，除 id 外均为可选参数
   */
  ;

  _proto.updateVideoHotspot = function updateVideoHotspot(_ref57) {
    var id = _ref57.id,
        videoUrl = _ref57.videoUrl,
        posterUrl = _ref57.posterUrl,
        ath = _ref57.ath,
        atv = _ref57.atv,
        edge = _ref57.edge,
        distorted = _ref57.distorted,
        scale = _ref57.scale,
        rx = _ref57.rx,
        ry = _ref57.ry,
        rz = _ref57.rz,
        hFov = _ref57.hFov,
        yaw = _ref57.yaw,
        pitch = _ref57.pitch,
        roll = _ref57.roll,
        pausedOnStart = _ref57.pausedOnStart,
        loop = _ref57.loop,
        volume = _ref57.volume,
        muted = _ref57.muted,
        zOrder = _ref57.zOrder,
        dragable = _ref57.dragable,
        titleHotspotId = _ref57.titleHotspotId,
        autoPause = _ref57.autoPause,
        autoResume = _ref57.autoResume;

    if (this.debug) {
      console.log('updateVideoHotspot', arguments[0]);
    }

    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;
    this.updateOriginHotspot(params);
    var posterParams = JSON.parse(JSON.stringify(arguments[0]));
    posterParams.id = id + '_poster';

    if (posterUrl != undefined) {
      posterParams.url = posterUrl;
    }

    posterParams.visible = undefined;
    this.updateOriginHotspot(posterParams);
  }
  /**
   * 视频热点是否暂停
   * @param {string} id - 热点 id
   */
  ;

  _proto.hotspotVideoIsPaused = function hotspotVideoIsPaused(id) {
    return this.krpanoWrapper.get('hotspot[' + id + '].ispaused');
  }
  /**
   * 继续/暂停视频热点
   * @param {string} id - 热点 id
   */
  ;

  _proto.toggleHotspotVideo = function toggleHotspotVideo(id) {
    if (this.debug) {
      console.log('toggleHotspotVideo', arguments[0]);
    }

    this.krpanoWrapper.call('hotspot[' + id + '].togglepause();');
  }
  /**
   * 暂停播放全景视频
   * @param {string} id - 热点 id
   */
  ;

  _proto.pauseHotspotVideo = function pauseHotspotVideo(id) {
    if (this.debug) {
      console.log('pauseHotspotVideo', arguments[0]);
    }

    this.krpanoWrapper.call('hotspot[' + id + '].pause();');
  }
  /**
   * 设置当前视频时间
   * @param {number} time - 播放位置（秒)
   */
  ;

  _proto.seekHotspotVideo = function seekHotspotVideo(id, time) {
    if (this.debug) {
      console.log('seekHotspotVideo', arguments[0]);
    }

    this.krpanoWrapper.call('hotspot[' + id + '].seek(' + time + ');');
  }
  /**
   * 播放或恢复播放全景视频
   * @param {string} id - 热点 id
   */
  ;

  _proto.playHotspotVideo = function playHotspotVideo(id) {
    var _this14 = this;

    if (this.debug) {
      console.log('playHotspotVideo', arguments[0]);
    }

    if (!this.krpanoWrapper.get('hotspot[' + id + ']')) {
      return;
    }

    if (this.krpanoWrapper.get('hotspot[' + id + '].loaded')) {
      setTimeout(function () {
        _this14.krpanoWrapper.call('hotspot[' + id + '].play();');
      }, 500);
    } else {
      setTimeout(function () {
        _this14.playHotspotVideo(id);
      }, 300);
    }
  }
  /**
   * 切换视频
   * @param {string} id - 热点 id
   * @param {string} videoUrl - 全景视频数据
   */
  ;

  _proto.switchHotspotVideo = function switchHotspotVideo(id, videoUrl) {
    var startTime = this.videoTime();
    var loop = this.krpanoWrapper.get('hotspot[' + id + '].loop');
    this.krpanoWrapper.call('hotspot[' + id + '].playvideo(' + videoUrl + ', null, ' + loop + ', ' + startTime + '));');
  }
  /**
   * 当前视频时间，单位 秒
   * @param {string} id - 热点 id
   */
  ;

  _proto.hotspotVideoTime = function hotspotVideoTime(id) {
    return this.krpanoWrapper.get('hotspot[' + id + '].time');
  }
  /**
   * 视频总时长，单位 秒
   * @param {string} id - 热点 id
   */
  ;

  _proto.hotspotVideoTotalTime = function hotspotVideoTotalTime(id) {
    return this.krpanoWrapper.get('hotspot[' + id + '].totaltime');
  }
  /**
   * 热点对齐
   * @param {Object} data - 热点数据
   * @param {string} data.id - 热点 id
   * @param {number} data.hFov - 对齐水平视场
   * @param {number} data.yaw - 对齐x旋转
   * @param {number} data.pitch - 对齐y旋转
   * @param {number} data.roll - 对齐z旋转
   */
  ;

  _proto.alignHotspot = function alignHotspot(_ref58) {
    var _this15 = this;

    var id = _ref58.id,
        hFov = _ref58.hFov,
        yaw = _ref58.yaw,
        pitch = _ref58.pitch,
        roll = _ref58.roll;

    if (this.debug) {
      console.log('alignHotspot', arguments[0]);
    }

    if (id && hFov != undefined && yaw != undefined && pitch != undefined && roll != undefined) {
      var hotspot = this.getHotspotById(id);

      if (hotspot && hotspot.width > 0 && hotspot.height > 0) {
        this.krpanoWrapper.call('calc_pos_from_hfov_yaw_pitch_roll(' + id + ', ' + hFov + ', ' + yaw + ', ' + pitch + ', ' + roll + ');' + 'if(hotspot[' + id + '].borderImageId !== null ,' + 'calc_pos_from_hfov_yaw_pitch_roll(get(hotspot[' + id + '].borderImageId), ' + hFov + ', ' + yaw + ', ' + pitch + ', ' + roll + '););' + 'if(hotspot[' + id + '].posterId !== null ,' + 'calc_pos_from_hfov_yaw_pitch_roll(get(hotspot[' + id + '].posterId), ' + hFov + ', ' + yaw + ', ' + pitch + ', ' + roll + '););' + 'if(hotspot[' + id + '].titlehotspotid !== null ,' + 'copy(hotspot[get(hotspot[' + id + '].titlehotspotid)].ath, hotspot[' + id + '].ath);' + 'copy(hotspot[get(hotspot[' + id + '].titlehotspotid)].atv, hotspot[' + id + '].atv);' + ');');
        setTimeout(function () {
          _this15.krpanoWrapper.call('if(hotspot[' + id + '].borderImageId !== null , ' + 'copy(hotspot[get(hotspot[' + id + '].borderImageId)].width, hotspot[' + id + '].width);' + 'copy(hotspot[get(hotspot[' + id + '].borderImageId)].height, hotspot[' + id + '].width);' + 'mul(hotspot[get(hotspot[' + id + '].borderImageId)].height, hotspot[' + id + '].imageheight);' + 'div(hotspot[get(hotspot[' + id + '].borderImageId)].height, hotspot[' + id + '].imagewidth);' + ');');
        }, 200);
      } else if (hotspot) {
        setTimeout(function () {
          _this15.alignHotspot({
            id: id,
            hFov: hFov,
            yaw: yaw,
            pitch: pitch,
            roll: roll
          });
        }, 300);
      }
    }
  }
  /**
   * 新增视频贴片
   * @param {Object} data - 视频贴片数据
   * @param {string} data.id - 视频贴片 id
   * @param {string} data.videoUrl - 视频地址
   * @param {string} [data.x] - x坐标,基于像素
   * @param {number} [data.y] - y坐标
   * @param {number} [data.width] - 视频宽度, 高度会自适应
   * @param {string} [data.chromakey='0x26e229|0.1863|0.1781'] - 透明蒙版, "hexColor,threshold(0.0-1.0),smoothing(0.0-1.0)",例如 "0x238E54,0.3,0.1" 
   * @param {bool} [data.pausedOnStart=false] - 开始时暂停, 基于浏览器规则, 一般情况下只有 volume = 0 或者 muted = true 才能自动播放
   * @param {bool} [data.loop=false] - 循环播放
   * @param {number} [data.volume=1.0] - 音量
   * @param {bool} [data.muted=false] - 静音
   */
  ;

  _proto.addVideoLayer = function addVideoLayer(_ref59) {
    var id = _ref59.id,
        videoUrl = _ref59.videoUrl,
        x = _ref59.x,
        y = _ref59.y,
        width = _ref59.width,
        chromakey = _ref59.chromakey,
        pausedOnStart = _ref59.pausedOnStart,
        loop = _ref59.loop,
        volume = _ref59.volume,
        muted = _ref59.muted;

    if (this.debug) {
      console.log('addVideoLayer', arguments[0]);
    }

    this.krpanoWrapper.addPlugin(id);
    this.krpanoWrapper.call("set(plugin[" + id + "].y," + (y || 0) + "); ");
    this.krpanoWrapper.call("set(plugin[" + id + "].x," + (x || 0) + "); ");
    var onPlayJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoPlay){window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoPlay('" + id + "');}";
    this.krpanoWrapper.call("set(plugin[" + id + "].onplayjs," + onPlayJs + "); ");
    var onPauseJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoPaused){window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoPaused('" + id + "');}";
    this.krpanoWrapper.call("set(plugin[" + id + "].onpausejs," + onPauseJs + "); ");
    var onEndedJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoComplete){window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoComplete('" + id + "');}";
    this.krpanoWrapper.call("set(plugin[" + id + "].onendedjs," + onEndedJs + "); ");
    var onErrorJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoError){window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoError('" + id + "');}";
    this.krpanoWrapper.call("set(plugin[" + id + "].onerrorjs," + onErrorJs + "); ");
    var onReadyJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoReady){window.players['" + this.krpanoWrapper.id + "'].events.onLayerVideoReady('" + id + "');}";
    this.krpanoWrapper.call("set(plugin[" + id + "].onreadyjs," + onReadyJs + "); ");

    if (muted != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].muted," + muted + "); ");
    }

    if (pausedOnStart != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].pausedonstart," + pausedOnStart + "); ");
    }

    if (loop != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].loop," + loop + "); ");
    }

    if (volume != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].volume," + volume + "); ");
    }

    if (width != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].width," + width + "); ");
    }

    if (videoUrl != undefined) {
      this.krpanoWrapper.call("set(plugin[" + id + "].videourl," + videoUrl + "); ");
    }

    if (chromakey) {
      var args = chromakey.split("|").map(function (item) {
        return item.trim();
      });

      if (args.length == 3) {
        this.krpanoWrapper.call("set(plugin[" + id + "].keycolor," + args[0].replace('0x', '#') + "); ");
        this.krpanoWrapper.call("set(plugin[" + id + "].threshold," + args[1] + "); ");
        this.krpanoWrapper.call("set(plugin[" + id + "].smoothing," + args[2] + "); ");
      } else {
        console.warn("invalid argument: chromakey: ", chromakey);
      }
    }

    this.krpanoWrapper.call("set(plugin[" + id + "].preload,true);set(plugin[" + id + "].url," + this.__videoLayerPlugin + ");set(plugin[" + id + "].keep,true);");
  }
  /**
   * 更新视频贴片
   * @description - 参数同新增，除 id 外均为可选参数
   */
  ;

  _proto.updateVideoLayer = function updateVideoLayer(_ref60) {
    var id = _ref60.id,
        videoUrl = _ref60.videoUrl,
        x = _ref60.x,
        y = _ref60.y,
        chromakey = _ref60.chromakey,
        width = _ref60.width,
        loop = _ref60.loop,
        volume = _ref60.volume,
        muted = _ref60.muted;

    if (this.debug) {
      console.log('updateVideoLayer', arguments[0]);
    }

    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      if (videoUrl != undefined) {
        plugin.setVideoUrl(videoUrl);
      }

      if (x != undefined) {
        plugin.setX(x);
      }

      if (y != undefined) {
        plugin.setY(y);
      }

      if (width != undefined) {
        plugin.setSize(width);
      }

      if (loop != undefined) {
        plugin.setLoop(loop);
      }

      if (volume != undefined) {
        plugin.setVolume(volume);
      }

      if (muted != undefined) {
        plugin.setMuted(muted);
      }

      if (chromakey) {
        var args = chromakey.split("|").map(function (item) {
          return item.trim();
        });

        if (args.length == 3) {
          plugin.setKeyColor(args[0].replace('0x', '#'));
          plugin.setThreshold(args[1]);
          plugin.setSmoothness(args[2]);
        } else {
          console.warn("invalid argument: chromakey: ", chromakey);
        }
      }
    }
  }
  /**
   * 视频贴片是否暂停
   * @param {string} id - 热点 id
   */
  ;

  _proto.layerVideoIsPaused = function layerVideoIsPaused(id) {
    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      return plugin.getPaused();
    }

    return undefined;
  }
  /**
   * 继续/暂停视频贴片
   * @param {string} id - 热点 id
   */
  ;

  _proto.toggleLayerVideo = function toggleLayerVideo(id) {
    if (this.debug) {
      console.log('toggleHotspotVideo', arguments[0]);
    }

    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      plugin.togglePause();
    }
  }
  /**
   * 暂停播放视频贴片
   * @param {string} id - 热点 id
   */
  ;

  _proto.pauseLayerVideo = function pauseLayerVideo(id) {
    if (this.debug) {
      console.log('pauseHotspotVideo', arguments[0]);
    }

    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      plugin.pause();
    }
  }
  /**
   * 设置当前视频贴片播放位置
   * @param {number} time - 播放位置（秒)
   */
  ;

  _proto.seekLayerVideo = function seekLayerVideo(id, time) {
    if (this.debug) {
      console.log('seekHotspotVideo', arguments[0]);
    }

    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      plugin.seek(time);
    }
  }
  /**
   * 播放或恢复播放视频贴片
   * @param {string} id - 热点 id
   */
  ;

  _proto.playLayerVideo = function playLayerVideo(id) {
    if (this.debug) {
      console.log('playLayerVideo', arguments[0]);
    }

    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      plugin.resume();
    }
  }
  /**
   * 移除视频贴片
   * @param {string} id - 热点 id
   */
  ;

  _proto.removeVideoLayer = function removeVideoLayer(id) {
    if (this.debug) {
      console.log('removeLayerVideo', arguments[0]);
    }

    if (id) {
      this.krpanoWrapper.call('removeplugin(' + id + ')');
    }
  }
  /**
   * 当前视频时间，单位 秒
   * @param {string} id - 热点 id
   */
  ;

  _proto.layerVideoTime = function layerVideoTime(id) {
    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      return plugin.videoTime();
    }

    return undefined;
  }
  /**
   * 视频总时长，单位 秒
   * @param {string} id - 热点 id
   */
  ;

  _proto.layerVideoTotalTime = function layerVideoTotalTime(id) {
    var plugin = this.krpanoWrapper.get("plugin[" + id + "]").jsplugin;

    if (plugin) {
      return plugin.videoTotalTime();
    }

    return undefined;
  }
  /**
   * 新增图形热点
   * @param {Object} data - 图形热点数据
   * @param {string} data.id - 图形热点 id
   * @param {number} data.ath - 水平坐标
   * @param {number} data.atv - 垂直坐标
   * @param {number} data.zOrder - 层级
   * @param {number} data.dragable - 是否能拖动
   * @param {number} data.width - 宽度
   * @param {number} data.height - 高度
   * @param {number} data.showImageBorder - 是否显示边框
   * @param {number} data.roundedge - 圆角, 如需圆形可将该值设为 (width / 2 + lineWidth)
   * @param {number} data.fillColor - 填充颜色
   * @param {number} data.fillAlpha - 填充透明度 
   * @param {number} data.linewidth - 描边粗细
   * @param {number} data.lineColor - 描边颜色
   * @param {number} data.lineAlpha - 描边透明度
   */
  ;

  _proto.addShapeHotspot = function addShapeHotspot(_ref61) {
    var id = _ref61.id,
        ath = _ref61.ath,
        atv = _ref61.atv,
        zOrder = _ref61.zOrder,
        dragable = _ref61.dragable,
        width = _ref61.width,
        height = _ref61.height,
        roundedge = _ref61.roundedge,
        fillColor = _ref61.fillColor,
        fillAlpha = _ref61.fillAlpha,
        lineWidth = _ref61.lineWidth,
        lineColor = _ref61.lineColor,
        lineAlpha = _ref61.lineAlpha,
        showImageBorder = _ref61.showImageBorder;

    if (this.debug) {
      console.log('addShapeHotspot', arguments[0]);
    }

    if (id == undefined) {
      return;
    }

    var hotspot = this.addOriginHotspot({
      id: id,
      type: "container",
      children: true,
      edge: "center",
      showImageBorder: showImageBorder,
      distorted: false,
      width: width,
      height: height
    });

    if (this.callbacks) {
      hotspot.events['onLoaded'] = this.callbacks['onHotspotLoaded'];
      hotspot.events['onClick'] = this.onHotspotClick.bind(this); //this.callbacks['onHotspotClick'];

      hotspot.events['onOver'] = this.onHotspotOver.bind(this); //this.callbacks['onHotspotOver'];

      hotspot.events['onOut'] = this.onHotspotOut.bind(this); //this.callbacks['onHotspotOut'];

      hotspot.events['onDown'] = this.onHotspotDown.bind(this); //this.callbacks['onHotspotDown'];

      hotspot.events['onUp'] = this.onHotspotUp.bind(this); //this.callbacks['onHotspotUp']
    }

    var layer = this.krpanoWrapper.addLayerById(id + "_container");
    this.set("layer[" + id + "_container].parent", "hotspot[" + id + "]");
    this.set("layer[" + id + "_container].edge", "center");
    this.set("layer[" + id + "_container].type", "container");
    this.set("layer[" + id + "_container].bgcapture", true);
    this.set("layer[" + id + "_container].hotspotID", id);

    if (this.callbacks) {
      layer.events['onClick'] = this.onHotspotClick.bind(this); // this.callbacks['onHotspotClick'];

      layer.events['onOver'] = this.onHotspotOver.bind(this); // this.callbacks['onHotspotOver'];

      layer.events['onOut'] = this.onHotspotOut.bind(this); // this.callbacks['onHotspotOut'];

      layer.events['onDown'] = this.onHotspotDown.bind(this); // this.callbacks['onHotspotDown'];

      layer.events['onUp'] = this.onHotspotUp.bind(this); // this.callbacks['onHotspotUp'];
    }

    this.updateShapeHotspot(arguments[0]);
  }
  /**
   * 更新图形热点
   * @param {Object} data - 同新增接口
   */
  ;

  _proto.updateShapeHotspot = function updateShapeHotspot(_ref62) {
    var id = _ref62.id,
        ath = _ref62.ath,
        atv = _ref62.atv,
        zOrder = _ref62.zOrder,
        dragable = _ref62.dragable,
        width = _ref62.width,
        height = _ref62.height,
        roundedge = _ref62.roundedge,
        fillColor = _ref62.fillColor,
        fillAlpha = _ref62.fillAlpha,
        lineWidth = _ref62.lineWidth,
        lineColor = _ref62.lineColor,
        lineAlpha = _ref62.lineAlpha,
        showImageBorder = _ref62.showImageBorder;

    if (this.debug) {
      console.log('updateShapeHotspot', arguments[0]);
    }

    if (ath != undefined) {
      this.set("hotspot[" + id + "].ath", ath);
    }

    if (atv != undefined) {
      this.set("hotspot[" + id + "].atv", atv);
    }

    if (zOrder != undefined) {
      this.set("hotspot[" + id + "].zorder", zOrder);
    }

    if (showImageBorder != undefined) {
      this.updateOriginHotspot({
        id: id,
        showImageBorder: showImageBorder
      });
    }

    if (fillColor != undefined) {
      this.set("layer[" + id + "_container].bgcolor", fillColor.replace('#', '0x'));
    }

    if (fillAlpha != undefined) {
      this.set("layer[" + id + "_container].bgalpha", fillAlpha);
    }

    if (roundedge != undefined) {
      this.set("layer[" + id + "_container].bgroundedge", roundedge);
    }

    if (width != undefined) {
      this.set("layer[" + id + "_container].width", width);
      this.set("layer[" + id + "_container].x", width / 2);
    }

    if (height != undefined) {
      this.set("layer[" + id + "_container].height", height);
      this.set("layer[" + id + "_container].x", height / 2);
    }

    if (lineWidth != undefined) {
      if (lineWidth == 0) {
        this.set("layer[" + id + "_container].bgborder", "" + lineWidth);
      } else {
        this.set("layer[" + id + "_container].bgborder", lineWidth + " " + lineColor.replace('#', '0x') + " " + lineAlpha);
      }

      this.set("layer[" + id + "_container].lineWidth", lineWidth);
    }

    if (width != undefined || height != undefined) {
      this.updateOriginHotspot({
        id: id,
        width: width,
        height: height,
        "showImageBorder": showImageBorder == undefined ? this.getHotspotById(id).showImageBorder : showImageBorder
      });
      this.set("layer[" + id + "_container].x", width / 2);
      this.set("layer[" + id + "_container].y", height / 2);
    }

    if (this.get("layer[" + id + "_container].lineWidth") != undefined && this.get("layer[" + id + "_container].lineWidth") > 0) {
      this.set("layer[" + id + "_container].x", width / 2 + this.get("layer[" + id + "_container].lineWidth"));
      this.set("layer[" + id + "_container].y", height / 2 + this.get("layer[" + id + "_container].lineWidth"));
    } else {
      this.set("layer[" + id + "_container].x", width / 2);
      this.set("layer[" + id + "_container].y", height / 2);
    }

    if (dragable != undefined) {
      var layer = this.getLayerById(id + "_container");

      if (dragable) {
        this.set("layer[" + id + "_container].ondown", "drag_enable_shape();");
        layer.events['onUp'] = this.callbacks['onHotspotMoveEnd'];
      } else {
        layer.events['onDown'] = this.callbacks['onHotspotDown'];
        layer.events['onUp'] = this.callbacks['onHotspotUp'];
      }
    }
  }
  /**
   * 新增雷达光热点
   * @param {Object} data - 雷达光热点数据
   * @param {string} data.id - 雷达光热点 id
   * @param {number} data.ath - 水平坐标
   * @param {number} data.atv - 垂直坐标
   * @param {number} data.zOrder - 层级
   * @param {number} data.fov - 对应全景 fov
   * @param {number} data.offset - 雷达偏移, [-180, 180], 向上为0, 正数为顺时针方向
   * @param {number} data.radius - 雷达光半径
   * @param {number} data.fillColor - 填充颜色
   * @param {number} data.fillAlpha - 填充透明度 
   * @param {number} data.linewidth - 描边粗细
   * @param {number} data.lineColor - 描边颜色
   * @param {number} data.lineAlpha - 描边透明度
   * @param {function} data.onOffsetChanged - 手动旋转雷达光回调, 参数为当前 offset
   */
  ;

  _proto.addRadarHotspot = function addRadarHotspot(_ref63) {
    var id = _ref63.id,
        ath = _ref63.ath,
        atv = _ref63.atv,
        zOrder = _ref63.zOrder,
        fov = _ref63.fov,
        offset = _ref63.offset,
        radius = _ref63.radius,
        fillColor = _ref63.fillColor,
        fillAlpha = _ref63.fillAlpha,
        lineWidth = _ref63.lineWidth,
        lineColor = _ref63.lineColor,
        lineAlpha = _ref63.lineAlpha,
        onOffsetChanged = _ref63.onOffsetChanged;

    if (this.debug) {
      console.log('addRadarHotspot', arguments[0]);
    }

    if (id == undefined) {
      return;
    }

    var hotspot = this.addOriginHotspot({
      id: id,
      type: "container",
      edge: "center"
    });
    this.krpanoWrapper.addPlugin(id + '_container');
    this.set("plugin[" + id + "_container].parent", "hotspot[" + id + "]");
    this.set("plugin[" + id + "_container].x", 0);
    this.set("plugin[" + id + "_container].y", 0);
    this.set("plugin[" + id + "_container].zorder", zOrder);
    this.set("plugin[" + id + "_container].edge", "center");
    this.set("plugin[" + id + "_container].needRemove", true);
    this.set("plugin[" + id + "_container].url", this.__radarPlugin); // this.set(`plugin[${id}].url`, "http://127.0.0.1:5501/dist/plugins/radar.js");

    this.updateRadarHotspot(arguments[0]);
  }
  /**
   * 更新雷达光热点
   * @param {Object} data - 同新增接口
   */
  ;

  _proto.updateRadarHotspot = function updateRadarHotspot(_ref64) {
    var id = _ref64.id,
        ath = _ref64.ath,
        atv = _ref64.atv,
        fov = _ref64.fov,
        zOrder = _ref64.zOrder,
        radius = _ref64.radius,
        offset = _ref64.offset,
        fillColor = _ref64.fillColor,
        fillAlpha = _ref64.fillAlpha,
        lineWidth = _ref64.lineWidth,
        lineColor = _ref64.lineColor,
        lineAlpha = _ref64.lineAlpha,
        onOffsetChanged = _ref64.onOffsetChanged;

    if (this.debug) {
      console.log('updateRadarHotspot', arguments[0]);
    }

    if (id == undefined) {
      return;
    }

    if (ath != undefined) {
      this.set("hotspot[" + id + "].ath", ath);
    }

    if (atv != undefined) {
      this.set("hotspot[" + id + "].atv", atv);
    }

    if (zOrder != undefined) {
      this.set("hotspot[" + id + "].zorder", zOrder);
    }

    if (fov != undefined) {
      this.set("plugin[" + id + "_container].fov", fov);
    }

    if (fov != undefined) {
      this.set("plugin[" + id + "_container].fov", fov);
    }

    if (offset != undefined) {
      this.set("plugin[" + id + "_container].offset", offset);
    }

    if (fillColor != undefined) {
      this.set("plugin[" + id + "_container].fillColor", fillColor.replace('#', '0x'));
    }

    if (fillAlpha != undefined) {
      this.set("plugin[" + id + "_container].fillAlpha", fillAlpha);
    }

    if (lineWidth != undefined) {
      this.set("plugin[" + id + "_container].lineWidth", lineWidth);
    }

    if (lineColor != undefined) {
      this.set("plugin[" + id + "_container].lineColor", lineColor.replace('#', '0x'));
    }

    if (lineAlpha != undefined) {
      this.set("plugin[" + id + "_container].lineAlpha", lineAlpha);
    }

    if (radius != undefined) {
      this.set("plugin[" + id + "_container].scale", radius / 128);
    }

    if (onOffsetChanged) {
      this.krpanoWrapper.events || (this.krpanoWrapper.events = {});
      this.krpanoWrapper.events.onOffsetChanged || (this.krpanoWrapper.events.onOffsetChanged = {});
      this.krpanoWrapper.events.onOffsetChanged["onOffsetChanged_" + id] = onOffsetChanged;
      var onRaderJs = "if(window.players['" + this.krpanoWrapper.id + "'].events.onOffsetChanged){window.players['" + this.krpanoWrapper.id + "'].events.onOffsetChanged['" + ("onOffsetChanged_" + id) + "'](%1);}";
      this.krpanoWrapper.set("plugin[" + id + "_container].onOffsetChanged", "jscall(\"" + onRaderJs + "\");");
    }
  }
  /**
   * 新增直线
   * @param {Object} data - 直线数据
   * @param {string} data.id - 直线 id
   * @param {number} data.startAth - 
   * @param {number} data.startAtv - 
   * @param {number} data.endAth - 
   * @param {number} data.endAtv - 
   * @param {boolean} data.dragable - 是否能拖动
   * @param {number} data.endPointMode - 端点类型 0无端点 1圆点 2刻度 3箭头
   * @param {number} data.linewidth - 描边粗细
   * @param {string} data.lineColor - 描边颜色
   * @param {number} data.lineAlpha - 描边透明度
   */
  ;

  _proto.addLine = function addLine(_ref65) {
    var id = _ref65.id,
        startAth = _ref65.startAth,
        startAtv = _ref65.startAtv,
        endAth = _ref65.endAth,
        endAtv = _ref65.endAtv,
        lineWidth = _ref65.lineWidth,
        lineColor = _ref65.lineColor,
        lineAlpha = _ref65.lineAlpha,
        dragable = _ref65.dragable,
        endPointColor = _ref65.endPointColor,
        endPointAlpha = _ref65.endPointAlpha,
        endPointMode = _ref65.endPointMode,
        enabled = _ref65.enabled,
        events = _ref65.events;

    if (this.debug) {
      console.log('addLine', arguments[0]);
    }

    if (id == undefined) {
      return;
    }

    this.addPolygonHotspot({
      id: id,
      isLine: true
    });
    var params = JSON.parse(JSON.stringify(arguments[0]));
    params.events = arguments[0].events;

    if (endPointMode == undefined) {
      params.endPointMode = 0;
    }

    this.updateLine(params);
  }
  /**
   * 删除直线
   */
  ;

  _proto.removeLine = function removeLine(id) {
    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.points) {
      var points = hotspot.points;

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        var pointId = id + point.name + '_end';
        this.removeHotspotById(pointId);
      }
    }

    this.removeHotspotById(id);
  }
  /**
   * 更新直线
   * @param {Object} data - 同新增
   */
  ;

  _proto.updateLine = function updateLine(_ref66) {
    var id = _ref66.id,
        startAth = _ref66.startAth,
        startAtv = _ref66.startAtv,
        endAth = _ref66.endAth,
        endAtv = _ref66.endAtv,
        lineWidth = _ref66.lineWidth,
        lineColor = _ref66.lineColor,
        lineAlpha = _ref66.lineAlpha,
        dragable = _ref66.dragable,
        endPointColor = _ref66.endPointColor,
        endPointAlpha = _ref66.endPointAlpha,
        endPointMode = _ref66.endPointMode,
        enabled = _ref66.enabled,
        events = _ref66.events;

    if (this.debug) {
      console.log('updateLine', arguments[0]);
    }

    if (id == undefined || this.getHotspotById(id) == undefined) {
      return;
    }

    var params = {
      id: id
    };

    if (lineWidth != undefined) {
      params.borderWidth = lineWidth;
    }

    if (dragable != undefined) {
      params.dragable = dragable;
    }

    if (lineColor != undefined) {
      params.borderColor = lineColor;
      params.overBorderColor = lineColor;
    }

    if (lineAlpha != undefined) {
      params.borderAlpha = lineAlpha;
      params.overBorderAlpha = lineAlpha;
    }

    if (endPointMode != undefined) {
      params.endPointMode = endPointMode;
    }

    if (enabled != undefined) {
      params.enabled = enabled;
    }

    if (startAth != undefined || startAtv != undefined || endAth != undefined || endAtv != undefined) {
      var hotspot = this.getHotspotById(id);

      if (hotspot && hotspot.points && hotspot.points.length == 2) {
        var points = hotspot.points;
        startAth = startAth || points[0].ath;
        startAtv = startAtv || points[0].atv;
        endAth = endAth || points[1].ath;
        endAtv = endAtv || points[1].atv;
      }

      params.points = [{
        ath: startAth,
        atv: startAtv,
        imageAlpha: 0
      }, {
        ath: endAth,
        atv: endAtv,
        imageAlpha: 0
      }];
    }

    this.updatePolygonHotspot(params);
    this.updateLineEndPoints(id);

    if (endPointColor != undefined) {
      var _hotspot7 = this.getHotspotById(id);

      if (_hotspot7) {
        var _points2 = _hotspot7.points;

        for (var i = 0; i < _points2.length; i++) {
          var point = _points2[i];
          var pointId = id + point.name + '_end';

          if (_hotspot7.endPointMode == 1) {
            this.updateTextHotspot({
              id: pointId,
              background: {
                bgColor: endPointColor
              }
            });
          } else if (_hotspot7.endPointMode == 2) {
            this.updatePolygonHotspot({
              id: pointId,
              borderAlpha: 1,
              borderColor: endPointColor,
              overBorderColor: endPointColor,
              polyline: true
            });
          } else if (_hotspot7.endPointMode == 3) {
            this.updatePolygonHotspot({
              id: pointId,
              borderAlpha: 0,
              fillColor: endPointColor,
              overFillColor: endPointColor,
              polyline: false
            });
          }
        }
      }
    }

    if (endPointAlpha != undefined) {
      var _hotspot8 = this.getHotspotById(id);

      if (_hotspot8 && _hotspot8.points) {
        var _points3 = _hotspot8.points;

        for (var _i3 = 0; _i3 < _points3.length; _i3++) {
          var _point3 = _points3[_i3];

          var _pointId = id + _point3.name + '_end';

          if (_hotspot8.endPointMode == 1) {
            this.updateTextHotspot({
              id: _pointId,
              background: {
                bgAlpha: endPointAlpha
              }
            });
          } else {
            this.updatePolygonHotspot({
              id: _pointId,
              borderAlpha: endPointAlpha,
              overBorderAlpha: endPointAlpha,
              fillAlpha: endPointAlpha,
              overFillAlpha: endPointAlpha
            });
          }
        }
      }
    } // if (lineWidth != undefined) {
    //     let hotspot = this.getHotspotById(id);
    //     if (hotspot && hotspot.endPointMode > 1) {
    //         let points = hotspot.points;
    //         for (let i = 0; i < points.length; i++) {
    //             const point = points[i];
    //             let pointId = id + point.name + '_end';
    //             this.updatePolygonHotspot({
    //                 id: pointId,
    //                 borderWidth: lineWidth
    //             });
    //         }
    //     }
    // }


    if (events && events.onLineMoving) {
      this.lineEvents['moving'][id] = events.onLineMoving;
    }

    if (events && events.onLineMoveBegan) {
      this.lineEvents['moveBegan'][id] = events.onLineMoveBegan;
    }

    if (events && events.onLineMoveEnd) {
      this.lineEvents['moveEnd'][id] = events.onLineMoveEnd;
    }
  }
  /**
   * 计算直线角度
   * @param {string} id - line id
   */
  ;

  _proto.calcLineDegree = function calcLineDegree(id) {
    var hotspot = this.getHotspotById(id);

    function mod(n, m) {
      return (n % m + m) % m;
    }

    if (hotspot && hotspot.points && hotspot.points.length == 2) {
      var radian = Math.atan2(hotspot.points[1].atv - hotspot.points[0].atv, hotspot.points[1].ath - hotspot.points[0].ath); // 返回来的是弧度

      if (hotspot.points[1].ath * hotspot.points[0].ath < 0 && (Math.abs(hotspot.points[1].ath % 360) > 90 || Math.abs(hotspot.points[0].ath % 360) > 90)) {
        radian = Math.atan2(hotspot.points[1].atv - hotspot.points[0].atv, mod(hotspot.points[1].ath, 360) - mod(hotspot.points[0].ath, 360)); // 返回来的是弧度
      }

      var angle = 180 / Math.PI * radian;
      return angle;
    }

    return undefined;
  }
  /**
   * 计算直线中点
   * @param {string} id - line id
   * @returns {{ath,atv}} - 返回的中点数据 {ath, atv} 
   */
  ;

  _proto.calcLineMiddlePoint = function calcLineMiddlePoint(id) {
    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.points && hotspot.points.length == 2) {
      this.call("hotspot[" + id + "].getcenter(" + id + "_middle_ath," + id + "_middle_atv);");
      return {
        ath: this.get(id + "_middle_ath"),
        atv: this.get(id + "_middle_atv")
      };
    }

    return undefined;
  };

  _proto.updateLineEndPoints = function updateLineEndPoints(id) {
    var hotspot = this.getHotspotById(id);

    if (hotspot && hotspot.points) {
      var points = hotspot.points;

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        var pointId = id + point.name + '_end';
        var pointHotspot = this.getHotspotById(pointId);

        switch (hotspot.endPointMode) {
          case 1:
            if (pointHotspot && pointHotspot.type != 'text') {
              this.removeHotspotById(pointId);
            }

            var pointSize = hotspot.borderWidth ? 8 + hotspot.borderWidth * 2 : 10;
            this.addTextHotspot({
              id: pointId,
              width: pointSize,
              height: pointSize,
              autoResize: false,
              text: '',
              ath: point.ath,
              atv: point.atv,
              edge: 'center',
              distorted: false,
              dragable: false,
              align: 'center',
              enabled: false,
              vCenter: true,
              background: {
                bgEnabled: true,
                bgColor: hotspot.borderColor,
                bgAlpha: 1,
                bgRoundedge: pointSize / 2,
                borderWidth: 0
              }
            });
            break;

          case 2:
            if (pointHotspot && pointHotspot.type == 'text') {
              this.removeHotspotById(pointId);
            }

            var angle = this.calcLineDegree(id);
            var offsetDegree = angle - 90;
            var radian = offsetDegree * Math.PI / 180;
            var endPointLength = hotspot.borderWidth ? 0.5 + hotspot.borderWidth * 0.1 : 0.6;
            var targetAth = point.ath - Math.cos(radian) * endPointLength;
            var targetAtv = point.atv - Math.sin(radian) * endPointLength;
            var angle2 = this.calcLineDegree(id);
            var offsetDegree2 = angle2 - 270;
            var radian2 = offsetDegree2 * Math.PI / 180;
            var endPointLength2 = endPointLength;
            var targetAth2 = point.ath - Math.cos(radian2) * endPointLength2;
            var targetAtv2 = point.atv - Math.sin(radian2) * endPointLength2;
            var _points4 = [{
              ath: targetAth,
              atv: targetAtv
            }, {
              ath: targetAth2,
              atv: targetAtv2
            }];
            this.addPolygonHotspot({
              id: pointId,
              points: _points4,
              enabled: false,
              dragable: false,
              overBorderColor: hotspot.borderColor,
              borderColor: hotspot.borderColor,
              fillAlpha: 0,
              borderAlpha: 1,
              borderWidth: hotspot.borderWidth,
              polyline: true
            });
            break;

          case 3:
            if (pointHotspot && pointHotspot.type == 'text') {
              this.removeHotspotById(pointId);
            }

            var angleL = this.calcLineDegree(id);
            var offsetDegreeL = angleL - (i == 0 ? -135 : -45);
            var radianL = offsetDegreeL * Math.PI / 180;
            var endPointLengthL = hotspot.borderWidth ? 0.6 + hotspot.borderWidth * 0.2 : 1;
            var targetAthL = point.ath - Math.cos(radianL) * endPointLengthL;
            var targetAtvL = point.atv - Math.sin(radianL) * endPointLengthL;
            var offsetDegreeR = angleL - (i == 0 ? 135 : 45);
            var radianR = offsetDegreeR * Math.PI / 180;
            var endPointLengthR = endPointLengthL;
            var targetAthR = point.ath - Math.cos(radianR) * endPointLengthR;
            var targetAtvR = point.atv - Math.sin(radianR) * endPointLengthR;
            var extAth = i == 0 ? point.ath - Math.cos(angleL * Math.PI / 180) * endPointLengthL * 0.5 : point.ath + Math.cos(angleL * Math.PI / 180) * endPointLengthL * 0.5;
            var extAtv = i == 0 ? point.atv - Math.sin(angleL * Math.PI / 180) * endPointLengthL * 0.5 : point.atv + Math.sin(angleL * Math.PI / 180) * endPointLengthL * 0.5;
            var points2 = [{
              ath: targetAthL,
              atv: targetAtvL
            }, {
              ath: extAth,
              atv: extAtv
            }, {
              ath: targetAthR,
              atv: targetAtvR
            }];
            this.addPolygonHotspot({
              id: pointId,
              points: points2,
              fillColor: hotspot.borderColor,
              fillAlpha: 1,
              borderWidth: 0,
              borderColor: 0,
              borderAlpha: 0,
              overFillColor: hotspot.borderColor,
              overFillAlpha: 1,
              overBorderWidth: 0,
              overBorderColor: 0,
              overBorderAlpha: 0,
              polyline: false,
              enabled: false
            });
            break;

          default:
            this.removeHotspotById(pointId);
            break;
        }
      }
    }
  }
  /**
   * 新增雨/雪效果, 可添加多个
   * @param {Object} data - 雨/雪数据
   * @param {string} data.id - 插件 id
   * @param {number} data.mode - 模式,雪snow(默认), 雨rain, 自定义图片image
   * @param {number} data.imageUrl - 自定义图片URL 
   * @param {number} data.imageScale - 自定义图片缩放, 默认1
   * @param {number} data.flakes - 雨/雪数量,默认4000
   * @param {number} data.color - 雨/雪颜色,默认 0xffffff
   * @param {number} data.floor - 地面高度,0-1,默认 0.3
   * @param {number} data.speed - 下落速度,默认1.0
   * @param {number} data.spreading - 深度范围,默认 4.0
   * @param {number} data.shake - 雪花随机振动,默认4.0
   * @param {number} data.speedVariance - 下降速度随机变化, 默认2.0
   * @param {number} data.wind - 风力,可改变雪花下降方向, 默认0.0
   * @param {number} data.windDir - 风力方向, 0-360
   * @param {number} data.rainWidth - 雨点大小, 默认0.5
   * @param {number} data.rainAlpha - 雨点透明度, 默认0.5
   * @param {number} data.invert - 反转方向, 默认 false 为 true 则是从下到上
   */
  ;

  _proto.addSnowPlugin = function addSnowPlugin(_ref67) {
    var id = _ref67.id,
        mode = _ref67.mode,
        imageUrl = _ref67.imageUrl,
        imageScale = _ref67.imageScale,
        flakes = _ref67.flakes,
        color = _ref67.color,
        floor = _ref67.floor,
        speed = _ref67.speed,
        spreading = _ref67.spreading,
        shake = _ref67.shake,
        speedVariance = _ref67.speedVariance,
        wind = _ref67.wind,
        windDir = _ref67.windDir,
        rainWidth = _ref67.rainWidth,
        rainAlpha = _ref67.rainAlpha,
        invert = _ref67.invert;

    if (this.debug) {
      console.log('addRainPlugin', arguments[0]);
    }

    this.krpanoWrapper.addPlugin(id);
    this.set("plugin[" + id + "].url", this.__snowPlugin);
    this.updateSnowPlugin(arguments[0]);
  }
  /**
   * 更新雨雪效果
   * @param {Object} data - 同新增
   */
  ;

  _proto.updateSnowPlugin = function updateSnowPlugin(_ref68) {
    var id = _ref68.id,
        mode = _ref68.mode,
        imageUrl = _ref68.imageUrl,
        imageScale = _ref68.imageScale,
        flakes = _ref68.flakes,
        color = _ref68.color,
        floor = _ref68.floor,
        speed = _ref68.speed,
        spreading = _ref68.spreading,
        shake = _ref68.shake,
        speedVariance = _ref68.speedVariance,
        wind = _ref68.wind,
        windDir = _ref68.windDir,
        rainWidth = _ref68.rainWidth,
        rainAlpha = _ref68.rainAlpha,
        invert = _ref68.invert;

    if (this.debug) {
      console.log('updateRainPlugin', arguments[0]);
    }

    if (mode != undefined) {
      this.set("plugin[" + id + "].mode", mode);
    }

    if (imageUrl != undefined) {
      this.set("plugin[" + id + "].imageUrl", imageUrl);
    }

    if (imageScale != undefined) {
      this.set("plugin[" + id + "].imageScale", imageScale);
    }

    if (flakes != undefined) {
      this.set("plugin[" + id + "].flakes", flakes);
    }

    if (color != undefined) {
      this.set("plugin[" + id + "].color", color);
    }

    if (floor != undefined) {
      this.set("plugin[" + id + "].floor", floor);
    }

    if (speed != undefined) {
      this.set("plugin[" + id + "].speed", speed);
    }

    if (spreading != undefined) {
      this.set("plugin[" + id + "].spreading", spreading);
    }

    if (shake != undefined) {
      this.set("plugin[" + id + "].shake", shake);
    }

    if (speedVariance != undefined) {
      this.set("plugin[" + id + "].speedvariance", speedVariance);
    }

    if (wind != undefined) {
      this.set("plugin[" + id + "].wind", wind);
    }

    if (windDir != undefined) {
      this.set("plugin[" + id + "].windDir", windDir);
    }

    if (rainWidth != undefined) {
      this.set("plugin[" + id + "].rainWidth", rainWidth);
    }

    if (rainAlpha != undefined) {
      this.set("plugin[" + id + "].rainAlpha", rainAlpha);
    }

    if (invert != undefined) {
      this.set("plugin[" + id + "].invert", invert);
    }
  };

  /**
   * 新增太阳光插件
   * @param {Object} data - 太阳光数据
   * @param {string} data.id - 插件 id
   * @param {string} data.style - 光晕风格, 必填, blinkstyle1-9, 例如 blinkstyle2
   * @param {number} data.ath - ath
   * @param {number} data.atv - atv
   * @param {bool} data.dustmode - 灰尘效果 true/false
   */
  _proto.addLensFlarePlugin = function addLensFlarePlugin(_ref69) {
    var id = _ref69.id,
        style = _ref69.style,
        ath = _ref69.ath,
        atv = _ref69.atv,
        dustmode = _ref69.dustmode;

    if (this.debug) {
      console.log('addLensFlarePlugin', arguments[0]);
    }

    this.lensflareData[id] = {
      style: style || 'blinkstyle1',
      ath: ath == undefined ? this.getView().ath : ath,
      atv: atv == undefined ? this.getView().atv : atv,
      dustmode: dustmode == undefined ? false : dustmode
    };
    this.call("add_single_lensflare(" + id + ", " + style + ", " + ath + ", " + atv + ", " + dustmode + ");");
  }
  /**
   * 更新太阳光插件
   * @param {Object} data - 同新增
   */
  ;

  _proto.updateLensFlarePlugin = function updateLensFlarePlugin(_ref70) {
    var _this16 = this;

    var id = _ref70.id,
        style = _ref70.style,
        ath = _ref70.ath,
        atv = _ref70.atv,
        dustmode = _ref70.dustmode;

    if (this.debug) {
      console.log('updateLensFlarePlugin', arguments[0]);
    }

    this.lensflareData[id] = {
      style: style || this.lensflareData[id].style,
      ath: ath == undefined ? this.lensflareData[id].ath : ath,
      atv: atv == undefined ? this.lensflareData[id].atv : atv,
      dustmode: dustmode == undefined ? this.lensflareData[id].dustmode : dustmode
    };

    if (style) {
      this.call("remove_single_lensflare(" + id + ")");
      setTimeout(function () {
        _this16.call("add_single_lensflare(" + id + ", " + _this16.lensflareData[id].style + ", " + _this16.lensflareData[id].ath + ", " + _this16.lensflareData[id].atv + ", " + _this16.lensflareData[id].dustmode + ");");
      }, 500);
      setTimeout(function () {
        _this16.addImageFrameHotspot({
          "id": "lensflare_update_helper",
          "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAQAAAAziH6sAAAADklEQVR42mNkYGBkYAAAAA8AA7qm8EcAAAAASUVORK5CYII=",
          "ath": _this16.lensflareData[id].ath + 1,
          "atv": _this16.lensflareData[id].atv + 1,
          "frame": {
            "frameWidth": 1,
            "frameHeight": 1,
            "frameCount": 2,
            "frameDuration": 0.1
          }
        });
      }, 1000);
      setTimeout(function () {
        _this16.addImageFrameHotspot({
          "id": "lensflare_update_helper",
          "url": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAQAAAAziH6sAAAADklEQVR42mNkYGBkYAAAAA8AA7qm8EcAAAAASUVORK5CYII=",
          "ath": _this16.lensflareData[id].ath + 2,
          "atv": _this16.lensflareData[id].atv + 2,
          "frame": {
            "frameWidth": 1,
            "frameHeight": 1,
            "frameCount": 2,
            "frameDuration": 0.1
          }
        });
      }, 1500);
    } else {
      this.call("set_new_lensflare_coordinates(" + id + ", " + this.lensflareData[id].ath + ", " + this.lensflareData[id].atv + ", " + this.lensflareData[id].dustmode + ");");
    }
  }
  /**
   * 移除插件
   * @param {String} id - 插件id
   */
  ;

  _proto.removePlugin = function removePlugin(id) {
    this.krpanoWrapper.removePlugin(id);
    this.call("remove_single_lensflare(" + id + ")");
  }
  /**
   * 将一个热点绑定到另一个上,可跟随拖动, (要绑定到新的热点上时需先调用 unbindDragableHotspot 取消绑定)
   * @param {String} data.followingHotspotID - 跟随拖动的热点ID
   * @param {String} data.dragableHotspotID - 可拖动的热点ID
   */
  ;

  _proto.bindDragableHotspot = function bindDragableHotspot(_ref71) {
    var followingHotspotID = _ref71.followingHotspotID,
        dragableHotspotID = _ref71.dragableHotspotID;
    this.krpanoWrapper.call("\n            set(hotspot[" + dragableHotspotID + "].bindItems[" + followingHotspotID + "].bindingHotspotID," + followingHotspotID + ");\n        ");
  }
  /**
   * 取消热点绑定
   * @param {String} data.followingHotspotID - 跟随拖动的热点ID
   * @param {String} data.dragableHotspotID - 可拖动的热点ID
   */
  ;

  _proto.unbindDragableHotspot = function unbindDragableHotspot(_ref72) {
    var followingHotspotID = _ref72.followingHotspotID,
        dragableHotspotID = _ref72.dragableHotspotID;
    this.krpanoWrapper.call("delete(hotspot[" + dragableHotspotID + "].bindItems[" + followingHotspotID + "]);");
  }
  /**
   * 判断是否是 iOS 系统
   */
  ;

  _proto.iOS = function iOS() {
    return this.krpanoWrapper.get('device.ios');
  }
  /**
   * 判断是否是 Android 系统
   */
  ;

  _proto.Android = function Android() {
    return this.krpanoWrapper.get('device.android');
  };

  _proto.get = function get(key) {
    return this.krpanoWrapper.get(key);
  };

  _proto.set = function set(key, value) {
    this.krpanoWrapper.set(key, value);
  }
  /**
   * 全景坐标转换为屏幕坐标，返回数据 {x: 0.1, y: 0.2}
   * @param {number} ath - 水平坐标
   * @param {number} atv - 垂直坐标
   */
  ;

  _proto.sphereToScreen = function sphereToScreen(ath, atv) {
    this.krpanoWrapper.call("\n        set(tmp_h," + ath + ");\n        set(tmp_v," + atv + ");\n        spheretoscreen(tmp_h,tmp_v,tmp_x,tmp_y);");
    return {
      x: this.krpanoWrapper.get('tmp_x') * this.krpanoWrapper.get('stagescale'),
      y: this.krpanoWrapper.get('tmp_y') * this.krpanoWrapper.get('stagescale')
    };
  }
  /**
   * 屏幕转换为全景坐标，返回数据 {ath: 0.1, atv: 0.2}
   * @param {number} x - x轴坐标，左上方为原点
   * @param {number} y - y轴坐标
   */
  ;

  _proto.screenToSphere = function screenToSphere(x, y) {
    this.krpanoWrapper.call("\n        set(tmp_x," + x + ");\n        set(tmp_y," + y + ");\n        screentosphere(tmp_x,tmp_y,tmp_h,tmp_v);");
    return {
      ath: this.krpanoWrapper.get('tmp_h'),
      atv: this.krpanoWrapper.get('tmp_v')
    };
  }
  /**
   * 当前鼠标的全景坐标，返回数据 {ath: 0.1, atv: 0.2}
   */
  ;

  _proto.mousePositionToSphere = function mousePositionToSphere() {
    this.krpanoWrapper.call("screentosphere(mouse.x,mouse.y,tmp_h,tmp_v);");
    return {
      ath: this.krpanoWrapper.get('tmp_h'),
      atv: this.krpanoWrapper.get('tmp_v')
    };
  }
  /**
   * 加载多个对比全景
   * @param {{id, url, view, multires, x, y, width, height, type, alpha}[]} panos - 全景对比数据，数组中的每个元素都是一个全景数据
   * @param {string} panos.id - 全景id
   * @param {string} data.url - 图片地址路径 [ "" ]，域名 + 原始数据的 path 字段
   * @param {string} data.view - 初始视角数据 + 原始数据的 view 字段
   * @param {Object} data.multires - 碎片图数据，原始数据的 multires 
   * @param {number | string} panos.[x,y,width,height] - 全景位置和大小，可以是百分比或者数字，x,y为左上角坐标，width,height为宽高
   * @param {0 | 1} panos.type - 0独立全景，1融合全景
   * @param {number} panos.alpha - 透明度 0.0-1.0
   * @param {Object} panos.viewOffset - 视角偏移，视角偏移会将偏移量加上第一个pano的视角
   * @param {number} panos.viewOffset.hLookAt - 视角偏移 hlookat
   * @param {number} panos.viewOffset.vLookAt - 视角偏移 vlookat
   * @param {number} panos.viewOffset.fov - 视角偏移 fov
   */
  ;

  _proto.loadComparePanos = function loadComparePanos(panos) {
    var _this17 = this;

    if (this.debug) {
      console.log('loadComparePanos', panos);
    }

    this.clearPlayer();
    this.clearComparePanos();
    this.panosCompareData = {};

    var _loop = function _loop(i) {
      var _panos$i = panos[i],
          id = _panos$i.id,
          url = _panos$i.url,
          view = _panos$i.view,
          viewOffset = _panos$i.viewOffset,
          multires = _panos$i.multires;

      _this17.krpanoWrapper.call("\n                addlayer(" + id + "_container);\n                set(layer[" + id + "_container].type, container);\n                set(layer[" + id + "_container].maskchildren, true);\n                set(layer[" + id + "_container].capture, false);\n                \n                addlayer(" + id + ");\n                set(layer[" + id + "].parent,layer[" + id + "_container]);\n                set(layer[" + id + "].capture, false);\n            ");

      _this17.krpanoWrapper.get("layer[" + id + "]").onloaded = function () {
        _this17.updateComparePano(_extends({}, panos[i], {
          viewOffset: _extends({}, panos[i].viewOffset)
        }));

        _this17.get("layer[" + id + "]").krpano.events.onviewchanged = function () {
          _this17.comparePanosViewChanged(id);

          var currentView = _this17.get("layer[" + id + "]").krpano.get('view');

          if (id === _this17.originComparePanoID && (!_this17.comparePanosExtendData || _this17.comparePanosExtendData.hlookat !== currentView.hlookat || _this17.comparePanosExtendData.vlookat !== currentView.vlookat || _this17.comparePanosExtendData.fov !== currentView.fov)) {
            _this17.comparePanosExtendData = {
              hlookat: currentView.hlookat,
              vlookat: currentView.vlookat,
              fov: currentView.fov
            };
            _this17.callbacks['onViewChange'] && _this17.callbacks['onViewChange'](currentView);
          }
        }; // this.currentMoveComparePanoID = 


        _this17.get("layer[" + id + "]").ondown = function () {
          _this17.currentMoveComparePanoID = id;
        };

        _this17.get("layer[" + id + "]").krpano.events.onloadcomplete = panos[i].onLoadComplete;
      };

      _this17.krpanoWrapper.call("\n                set(layer[" + id + "].type,krpano);\n            ");

      _this17.panosCompareData[id] = _extends({}, panos[i], {
        viewOffset: _extends({}, panos[i].viewOffset)
      });
    };

    for (var i = 0; i < panos.length; i++) {
      _loop(i);
    }

    this.originComparePanoID = panos[0].id;

    this.krpanoWrapper.events.onResize = function () {
      for (var key in _this17.panosCompareData) {
        _this17.updateComparePano({
          x: _this17.panosCompareData[key].x,
          y: _this17.panosCompareData[key].y,
          width: _this17.panosCompareData[key].width,
          height: _this17.panosCompareData[key].height,
          id: key
        });
      }
    };
  }
  /**
   * 更新对比全景，参数同 loadComparePanos 中的单个全景数据
   */
  ;

  _proto.updateComparePano = function updateComparePano(_ref73) {
    var id = _ref73.id,
        url = _ref73.url,
        multires = _ref73.multires,
        view = _ref73.view,
        viewOffset = _ref73.viewOffset,
        x = _ref73.x,
        y = _ref73.y,
        width = _ref73.width,
        height = _ref73.height,
        type = _ref73.type,
        alpha = _ref73.alpha;

    if (this.debug) {
      console.log('updateComparePano', {
        id: id,
        url: url,
        multires: multires,
        view: view,
        viewOffset: viewOffset,
        x: x,
        y: y,
        width: width,
        height: height,
        type: type,
        alpha: alpha
      });
    }

    if (id === undefined || this.panosCompareData === undefined || this.panosCompareData[id] === undefined) {
      return;
    }

    if (url) {
      var xml = '<krpano>';
      xml += '<preview url="' + url + "/imgs/preview.jpg" + '" />';

      if (multires === undefined || Object.keys(multires).length === 0 || Object.keys(multires.tiledimage) === 0) {
        xml += '<image><cube url="' + url + "/imgs/mobile_%s.jpg" + '" />';
        xml += '</image>';
      } else {
        xml += '<image tilesize="512">';

        if (multires.tiledimage != undefined) {
          multires.tiledimage.forEach(function (element) {
            xml += '<level tiledimagewidth="' + element.w + '" tiledimageheight="' + element.h + '" ><cube url="' + url + element.url + '" /></level>';
          });
        }

        xml += '</image>';
      }

      xml += this._generateViewXml(_extends({}, view !== null && view !== void 0 ? view : this.panosCompareData[id].view, {
        limitview: 'lookat'
      }), _extends({}, viewOffset !== null && viewOffset !== void 0 ? viewOffset : this.panosCompareData[id].viewOffset));
      xml += '</krpano>';
      this.get("layer[" + id + "].krpano").actions.loadxml(xml);
    } else if (url === '') {
      this.get("layer[" + id + "].krpano").actions.loadxml('<krpano></krpano>');
    }

    if (type !== undefined) {
      this.panosCompareData[id].type = type;
    }

    switch (this.panosCompareData[id].type) {
      case 0:
        x !== undefined && this.set("layer[" + id + "_container].x", x);
        y !== undefined && this.set("layer[" + id + "_container].y", y);
        width !== undefined && this.set("layer[" + id + "_container].width", width);
        height !== undefined && this.set("layer[" + id + "_container].height", height);
        x !== undefined && (this.panosCompareData[id].x = x);
        y !== undefined && (this.panosCompareData[id].y = y);
        width !== undefined && (this.panosCompareData[id].width = width);
        height !== undefined && (this.panosCompareData[id].height = height);
        this.set("layer[" + id + "].x", '0');
        this.set("layer[" + id + "].y", '0');
        this.set("layer[" + id + "].width", '100%');
        this.set("layer[" + id + "].height", '100%');
        break;

      case 1:
        x !== undefined && this.set("layer[" + id + "_container].x", x);
        y !== undefined && this.set("layer[" + id + "_container].y", y);
        width !== undefined && this.set("layer[" + id + "_container].width", width);
        height !== undefined && this.set("layer[" + id + "_container].height", height);
        x !== undefined && (this.panosCompareData[id].x = x);
        y !== undefined && (this.panosCompareData[id].y = y);
        width !== undefined && (this.panosCompareData[id].width = width);
        height !== undefined && (this.panosCompareData[id].height = height);
        var stagewidth = this.get('stagewidth');
        var stageheight = this.get('stageheight');

        if (x !== undefined) {
          var targetX = x.includes('%') ? parseFloat(x.replace('%', '')) / 100.0 * stagewidth : parseFloat(x);
          this.set("layer[" + id + "].x", "-" + targetX);
        }

        if (y !== undefined) {
          var targetY = y.includes('%') ? parseFloat(y.replace('%', '')) / 100.0 * stageheight : parseFloat(y);
          this.set("layer[" + id + "].y", "-" + targetY);
        }

        this.call("set(layer[" + id + "].width, " + stagewidth + ");");
        this.call("set(layer[" + id + "].height, " + stageheight + ");");
        break;

      default:
        break;
    }

    alpha !== undefined && this.set("layer[" + id + "].alpha", alpha);

    if (viewOffset) {
      this.panosCompareData[id].viewOffset === undefined && (this.panosCompareData[id].viewOffset = {});
      (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.hLookAt) !== undefined && (this.panosCompareData[id].viewOffset.hLookAt = viewOffset.hLookAt);
      (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.vLookAt) !== undefined && (this.panosCompareData[id].viewOffset.vLookAt = viewOffset.vLookAt);
      (viewOffset === null || viewOffset === void 0 ? void 0 : viewOffset.fov) !== undefined && (this.panosCompareData[id].viewOffset.fov = viewOffset.fov);
    }

    if (view && this.get("layer[" + id + "].krpano")) {
      var _this$panosCompareDat, _this$panosCompareDat2, _this$panosCompareDat3, _this$panosCompareDat4, _this$panosCompareDat5, _this$panosCompareDat6, _this$panosCompareDat7, _this$panosCompareDat8, _this$panosCompareDat9, _this$panosCompareDat10, _this$panosCompareDat11, _this$panosCompareDat12, _this$panosCompareDat13, _this$panosCompareDat14, _this$panosCompareDat15, _this$panosCompareDat16, _this$panosCompareDat17, _this$panosCompareDat18;

      var hlookat = view.hlookat !== undefined ? view.hlookat : view.hLookAt;
      hlookat !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookat', hlookat + ((_this$panosCompareDat = (_this$panosCompareDat2 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat2 === void 0 ? void 0 : _this$panosCompareDat2.hLookAt) !== null && _this$panosCompareDat !== void 0 ? _this$panosCompareDat : 0));
      var hlookatmin = view.hlookatmin || view.hLookAtMin;
      hlookatmin !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookatmin', hlookatmin + ((_this$panosCompareDat3 = (_this$panosCompareDat4 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat4 === void 0 ? void 0 : _this$panosCompareDat4.hLookAt) !== null && _this$panosCompareDat3 !== void 0 ? _this$panosCompareDat3 : 0));
      var hlookatmax = view.hlookatmax || view.hLookAtMax;
      hlookatmax !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookatmax', hlookatmax + ((_this$panosCompareDat5 = (_this$panosCompareDat6 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat6 === void 0 ? void 0 : _this$panosCompareDat6.hLookAt) !== null && _this$panosCompareDat5 !== void 0 ? _this$panosCompareDat5 : 0));
      var vlookat = view.vlookat !== undefined ? view.vlookat : view.vLookAt;
      vlookat !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookat', vlookat + ((_this$panosCompareDat7 = (_this$panosCompareDat8 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat8 === void 0 ? void 0 : _this$panosCompareDat8.vLookAt) !== null && _this$panosCompareDat7 !== void 0 ? _this$panosCompareDat7 : 0));
      var vlookatmin = view.vlookatmin || view.vLookAtMin;
      vlookatmin !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookatmin', vlookatmin + ((_this$panosCompareDat9 = (_this$panosCompareDat10 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat10 === void 0 ? void 0 : _this$panosCompareDat10.vLookAt) !== null && _this$panosCompareDat9 !== void 0 ? _this$panosCompareDat9 : 0));
      var vlookatmax = view.vlookatmax || view.vLookAtMax;
      vlookatmax !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookatmax', vlookatmax + ((_this$panosCompareDat11 = (_this$panosCompareDat12 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat12 === void 0 ? void 0 : _this$panosCompareDat12.vLookAt) !== null && _this$panosCompareDat11 !== void 0 ? _this$panosCompareDat11 : 0));
      view.fov !== undefined && this.get("layer[" + id + "].krpano").set('view.fov', view.fov + ((_this$panosCompareDat13 = (_this$panosCompareDat14 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat14 === void 0 ? void 0 : _this$panosCompareDat14.fov) !== null && _this$panosCompareDat13 !== void 0 ? _this$panosCompareDat13 : 0));
      var fovmax = view.fovmax || view.fovMax;
      fovmax !== undefined && this.get("layer[" + id + "].krpano").set('view.fovmax', fovmax + ((_this$panosCompareDat15 = (_this$panosCompareDat16 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat16 === void 0 ? void 0 : _this$panosCompareDat16.fov) !== null && _this$panosCompareDat15 !== void 0 ? _this$panosCompareDat15 : 0));
      var fovmin = view.fovmin || view.fovMin;
      fovmin !== undefined && this.get("layer[" + id + "].krpano").set('view.fovmin', fovmin + ((_this$panosCompareDat17 = (_this$panosCompareDat18 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat18 === void 0 ? void 0 : _this$panosCompareDat18.fov) !== null && _this$panosCompareDat17 !== void 0 ? _this$panosCompareDat17 : 0));
    } else if (viewOffset && this.get("layer[" + id + "].krpano")) {
      var _this$panosCompareDat19, _this$panosCompareDat20, _ref74, _this$panosCompareDat21, _this$panosCompareDat22, _this$panosCompareDat23, _this$panosCompareDat24, _ref75, _this$panosCompareDat25, _this$panosCompareDat26, _this$panosCompareDat27, _this$panosCompareDat28, _this$panosCompareDat29, _ref76, _this$panosCompareDat30, _this$panosCompareDat31, _this$panosCompareDat32, _this$panosCompareDat33, _ref77, _this$panosCompareDat34, _this$panosCompareDat35, _this$panosCompareDat36, _this$panosCompareDat37, _this$panosCompareDat38, _ref78, _this$panosCompareDat39, _this$panosCompareDat40, _this$panosCompareDat41, _this$panosCompareDat42, _ref79, _this$panosCompareDat43, _this$panosCompareDat44, _this$panosCompareDat45;

      ((_this$panosCompareDat19 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat19 === void 0 ? void 0 : _this$panosCompareDat19.hLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookat', this.get("layer[" + this.originComparePanoID + "].krpano").get('view.hlookat') + this.panosCompareData[id].viewOffset.hLookAt);
      ((_this$panosCompareDat20 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat20 === void 0 ? void 0 : _this$panosCompareDat20.hLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookatmin', ((_ref74 = (_this$panosCompareDat21 = (_this$panosCompareDat22 = this.panosCompareData[id].view) === null || _this$panosCompareDat22 === void 0 ? void 0 : _this$panosCompareDat22.hlookatmin) !== null && _this$panosCompareDat21 !== void 0 ? _this$panosCompareDat21 : (_this$panosCompareDat23 = this.panosCompareData[id].view) === null || _this$panosCompareDat23 === void 0 ? void 0 : _this$panosCompareDat23.hLookAtMin) !== null && _ref74 !== void 0 ? _ref74 : 0) + this.panosCompareData[id].viewOffset.hLookAt);
      ((_this$panosCompareDat24 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat24 === void 0 ? void 0 : _this$panosCompareDat24.hLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.hlookatmax', ((_ref75 = (_this$panosCompareDat25 = (_this$panosCompareDat26 = this.panosCompareData[id].view) === null || _this$panosCompareDat26 === void 0 ? void 0 : _this$panosCompareDat26.hlookatmax) !== null && _this$panosCompareDat25 !== void 0 ? _this$panosCompareDat25 : (_this$panosCompareDat27 = this.panosCompareData[id].view) === null || _this$panosCompareDat27 === void 0 ? void 0 : _this$panosCompareDat27.hLookAtMax) !== null && _ref75 !== void 0 ? _ref75 : 0) + this.panosCompareData[id].viewOffset.hLookAt);
      ((_this$panosCompareDat28 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat28 === void 0 ? void 0 : _this$panosCompareDat28.vLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookat', this.get("layer[" + this.originComparePanoID + "].krpano").get('view.vlookat') + this.panosCompareData[id].viewOffset.vLookAt);
      ((_this$panosCompareDat29 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat29 === void 0 ? void 0 : _this$panosCompareDat29.vLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookatmin', ((_ref76 = (_this$panosCompareDat30 = (_this$panosCompareDat31 = this.panosCompareData[id].view) === null || _this$panosCompareDat31 === void 0 ? void 0 : _this$panosCompareDat31.vlookatmin) !== null && _this$panosCompareDat30 !== void 0 ? _this$panosCompareDat30 : (_this$panosCompareDat32 = this.panosCompareData[id].view) === null || _this$panosCompareDat32 === void 0 ? void 0 : _this$panosCompareDat32.vLookAtMin) !== null && _ref76 !== void 0 ? _ref76 : 0) + this.panosCompareData[id].viewOffset.vLookAt);
      ((_this$panosCompareDat33 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat33 === void 0 ? void 0 : _this$panosCompareDat33.vLookAt) !== undefined && this.get("layer[" + id + "].krpano").set('view.vlookatmax', ((_ref77 = (_this$panosCompareDat34 = (_this$panosCompareDat35 = this.panosCompareData[id].view) === null || _this$panosCompareDat35 === void 0 ? void 0 : _this$panosCompareDat35.vlookatmax) !== null && _this$panosCompareDat34 !== void 0 ? _this$panosCompareDat34 : (_this$panosCompareDat36 = this.panosCompareData[id].view) === null || _this$panosCompareDat36 === void 0 ? void 0 : _this$panosCompareDat36.vLookAtMax) !== null && _ref77 !== void 0 ? _ref77 : 0) + this.panosCompareData[id].viewOffset.vLookAt);
      ((_this$panosCompareDat37 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat37 === void 0 ? void 0 : _this$panosCompareDat37.fov) !== undefined && this.get("layer[" + id + "].krpano").set('view.fov', this.get("layer[" + this.originComparePanoID + "].krpano").get('view.fov') + this.panosCompareData[id].viewOffset.fov);
      ((_this$panosCompareDat38 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat38 === void 0 ? void 0 : _this$panosCompareDat38.fov) !== undefined && this.get("layer[" + id + "].krpano").set('view.fovmin', ((_ref78 = (_this$panosCompareDat39 = (_this$panosCompareDat40 = this.panosCompareData[id].view) === null || _this$panosCompareDat40 === void 0 ? void 0 : _this$panosCompareDat40.fovmin) !== null && _this$panosCompareDat39 !== void 0 ? _this$panosCompareDat39 : (_this$panosCompareDat41 = this.panosCompareData[id].view) === null || _this$panosCompareDat41 === void 0 ? void 0 : _this$panosCompareDat41.fovMin) !== null && _ref78 !== void 0 ? _ref78 : 0) + this.panosCompareData[id].viewOffset.fov);
      ((_this$panosCompareDat42 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat42 === void 0 ? void 0 : _this$panosCompareDat42.fov) !== undefined && this.get("layer[" + id + "].krpano").set('view.fovmax', ((_ref79 = (_this$panosCompareDat43 = (_this$panosCompareDat44 = this.panosCompareData[id].view) === null || _this$panosCompareDat44 === void 0 ? void 0 : _this$panosCompareDat44.fovmax) !== null && _this$panosCompareDat43 !== void 0 ? _this$panosCompareDat43 : (_this$panosCompareDat45 = this.panosCompareData[id].view) === null || _this$panosCompareDat45 === void 0 ? void 0 : _this$panosCompareDat45.fovMax) !== null && _ref79 !== void 0 ? _ref79 : 0) + this.panosCompareData[id].viewOffset.fov);
    }

    this.comparePanosViewChanged(id);
  }
  /**
   * 清除对比全景
   */
  ;

  _proto.clearComparePanos = function clearComparePanos() {
    if (this.debug) {
      console.log('clearComparePanos');
    }

    for (var key in this.panosCompareData) {
      // const element = this.panosCompareData[key];
      // this.get(`layer[${key}].krpano`).actions.loadxml('<krpano></krpano>');
      this.krpanoWrapper.get("layer[" + key + "]").onloaded = undefined;
      this.krpanoWrapper.get("layer[" + key + "]").krpano && (this.krpanoWrapper.get("layer[" + key + "]").krpano.events.onviewchanged = undefined);
      this.krpanoWrapper.get("layer[" + key + "]").krpano && (this.krpanoWrapper.get("layer[" + key + "]").krpano.events.onloadcomplete = undefined);
      this.krpanoWrapper.get("layer[" + key + "]").krpano && this.krpanoWrapper.get("layer[" + key + "]").krpano.unload();
      this.krpanoWrapper.get("layer[" + key + "]").krpano && this.krpanoWrapper.call("\n                removelayer(" + key + "_container, true);\n            ");
    }

    this.panosCompareData = undefined;
    this.originComparePanoID = undefined;
    this.krpanoWrapper.events.onResize = undefined;
  };

  _proto.comparePanosViewChanged = function comparePanosViewChanged(id) {
    if (this.currentMoveComparePanoID !== id) {
      return;
    }

    if (this.get("layer[" + id + "].krpano.image.loadstate") == 1 || this.get("layer[" + id + "].krpano.image.loadstate") == 1) {
      return;
    }

    var currentView = this.get("layer[" + id + "].krpano").view;

    for (var key in this.panosCompareData) {
      if (key !== id && this.get("layer[" + key + "].krpano")) {
        if (this.panosCompareViewChangedSync !== false) {
          if (this.panosCompareData[id].viewOffset.hLookAt == this.panosCompareData[key].viewOffset.hLookAt) {
            this.get("layer[" + key + "].krpano").view.hlookat = currentView.hlookat;
          } else {
            var _this$panosCompareDat46, _this$panosCompareDat47, _this$panosCompareDat48, _this$panosCompareDat49, _this$panosCompareDat50, _this$panosCompareDat51, _this$panosCompareDat52, _this$panosCompareDat53;

            this.get("layer[" + key + "].krpano").view.hlookat = currentView.hlookat + (this.originComparePanoID === id ? ((_this$panosCompareDat46 = (_this$panosCompareDat47 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat47 === void 0 ? void 0 : _this$panosCompareDat47.hLookAt) !== null && _this$panosCompareDat46 !== void 0 ? _this$panosCompareDat46 : 0) - ((_this$panosCompareDat48 = (_this$panosCompareDat49 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat49 === void 0 ? void 0 : _this$panosCompareDat49.hLookAt) !== null && _this$panosCompareDat48 !== void 0 ? _this$panosCompareDat48 : 0) : ((_this$panosCompareDat50 = (_this$panosCompareDat51 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat51 === void 0 ? void 0 : _this$panosCompareDat51.hLookAt) !== null && _this$panosCompareDat50 !== void 0 ? _this$panosCompareDat50 : 0) - ((_this$panosCompareDat52 = (_this$panosCompareDat53 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat53 === void 0 ? void 0 : _this$panosCompareDat53.hLookAt) !== null && _this$panosCompareDat52 !== void 0 ? _this$panosCompareDat52 : 0));
          }

          if (this.panosCompareData[id].viewOffset.vLookAt == this.panosCompareData[key].viewOffset.vLookAt) {
            this.get("layer[" + key + "].krpano").view.vlookat = currentView.vlookat;
          } else {
            var _this$panosCompareDat54, _this$panosCompareDat55, _this$panosCompareDat56, _this$panosCompareDat57, _this$panosCompareDat58, _this$panosCompareDat59, _this$panosCompareDat60, _this$panosCompareDat61;

            this.get("layer[" + key + "].krpano").view.vlookat = currentView.vlookat + (this.originComparePanoID === id ? ((_this$panosCompareDat54 = (_this$panosCompareDat55 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat55 === void 0 ? void 0 : _this$panosCompareDat55.vLookAt) !== null && _this$panosCompareDat54 !== void 0 ? _this$panosCompareDat54 : 0) - ((_this$panosCompareDat56 = (_this$panosCompareDat57 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat57 === void 0 ? void 0 : _this$panosCompareDat57.vLookAt) !== null && _this$panosCompareDat56 !== void 0 ? _this$panosCompareDat56 : 0) : ((_this$panosCompareDat58 = (_this$panosCompareDat59 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat59 === void 0 ? void 0 : _this$panosCompareDat59.vLookAt) !== null && _this$panosCompareDat58 !== void 0 ? _this$panosCompareDat58 : 0) - ((_this$panosCompareDat60 = (_this$panosCompareDat61 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat61 === void 0 ? void 0 : _this$panosCompareDat61.vLookAt) !== null && _this$panosCompareDat60 !== void 0 ? _this$panosCompareDat60 : 0));
          }
        }

        if (this.panosCompareViewChangedLockFov !== false) {
          if (this.panosCompareData[id].viewOffset == this.panosCompareData[key].viewOffset) {
            this.get("layer[" + key + "].krpano").view.fov = currentView.fov;
          } else {
            var _this$panosCompareDat62, _this$panosCompareDat63, _this$panosCompareDat64, _this$panosCompareDat65, _this$panosCompareDat66, _this$panosCompareDat67, _this$panosCompareDat68, _this$panosCompareDat69;

            this.get("layer[" + key + "].krpano").view.fov = currentView.fov + (this.originComparePanoID === id ? ((_this$panosCompareDat62 = (_this$panosCompareDat63 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat63 === void 0 ? void 0 : _this$panosCompareDat63.fov) !== null && _this$panosCompareDat62 !== void 0 ? _this$panosCompareDat62 : 0) - ((_this$panosCompareDat64 = (_this$panosCompareDat65 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat65 === void 0 ? void 0 : _this$panosCompareDat65.fov) !== null && _this$panosCompareDat64 !== void 0 ? _this$panosCompareDat64 : 0) : ((_this$panosCompareDat66 = (_this$panosCompareDat67 = this.panosCompareData[key].viewOffset) === null || _this$panosCompareDat67 === void 0 ? void 0 : _this$panosCompareDat67.fov) !== null && _this$panosCompareDat66 !== void 0 ? _this$panosCompareDat66 : 0) - ((_this$panosCompareDat68 = (_this$panosCompareDat69 = this.panosCompareData[id].viewOffset) === null || _this$panosCompareDat69 === void 0 ? void 0 : _this$panosCompareDat69.fov) !== null && _this$panosCompareDat68 !== void 0 ? _this$panosCompareDat68 : 0));
          }
        }
      }
    }
  }
  /**
   * 锁定所有全景的视角同步
   */
  ;

  _proto.lockComparePanosView = function lockComparePanosView() {
    this.panosCompareViewChangedSync = true;
  }
  /**
   * 解锁所有全景的视角同步
   * @param {bool} lockFov - 是否锁定 fov，true不传为锁定
  */
  ;

  _proto.unlockComparePanosView = function unlockComparePanosView(_temp2) {
    var _ref80 = _temp2 === void 0 ? {} : _temp2,
        lockFov = _ref80.lockFov;

    this.panosCompareViewChangedSync = false;
    this.panosCompareViewChangedLockFov = lockFov;

    if (lockFov !== false) {
      this.comparePanosViewChanged(this.originComparePanoID);
    }
  };

  _proto.addComparePanosImage = function addComparePanosImage(_ref81) {
    var _ref82;

    var id = _ref81.id,
        url = _ref81.url,
        ath = _ref81.ath,
        atv = _ref81.atv,
        edge = _ref81.edge,
        scaleX = _ref81.scaleX,
        scaleY = _ref81.scaleY,
        zOrder = _ref81.zOrder,
        distorted = _ref81.distorted,
        capture = _ref81.capture,
        rotate = _ref81.rotate,
        cursor = _ref81.cursor,
        targetPanoId = _ref81.targetPanoId;
    var krp = this.get("layer[" + targetPanoId + "].krpano");

    if (!krp) {
      return;
    }

    krp.call("\n            addhotspot(" + id + ");\n            set(hotspot[" + id + "].url," + url + ");\n            set(hotspot[" + id + "].ath," + (ath !== null && ath !== void 0 ? ath : 0) + ");\n            set(hotspot[" + id + "].atv," + (atv !== null && atv !== void 0 ? atv : 0) + ");\n            set(hotspot[" + id + "].edge," + (edge !== null && edge !== void 0 ? edge : 'center') + ");\n            set(hotspot[" + id + "].scale," + ((_ref82 = scaleX !== null && scaleX !== void 0 ? scaleX : scaleY) !== null && _ref82 !== void 0 ? _ref82 : 1) + ");\n            set(hotspot[" + id + "].zorder," + (zOrder !== null && zOrder !== void 0 ? zOrder : 0) + ");\n            set(hotspot[" + id + "].distorted," + (distorted !== null && distorted !== void 0 ? distorted : false) + ");\n            set(hotspot[" + id + "].capture," + (capture !== null && capture !== void 0 ? capture : false) + ");\n            set(hotspot[" + id + "].rotate," + (rotate !== null && rotate !== void 0 ? rotate : 0) + ");\n            set(hotspot[" + id + "].cursor," + (cursor !== null && cursor !== void 0 ? cursor : 'default') + ");\n            ");
  };

  _proto.__krpanoCommonXML = function __krpanoCommonXML() {
    return '' + '<action name="startup" autorun="onstart"> if(device.mobile, set(customScale, 1); if(stagewidth LT stageheight, div(customScale, stagewidth,540); , div(customScale, stageheight,360); ); if(customScale LT 0.5, set(customScale,0.7); ); if(customScale GT 0.8, set(customScale, 0.75); ); copy(stagescale,customScale); ); setup_webgl(); setup_krpano(); </action>' + '<display autofullscreen="false" />' + "\n            <action name=\"images_play\">\n if (hotspot[%1].urls.length GT 1,  \n  if(hotspot[%1].gifIndex === null,\n    set(hotspot[%1].gifIndex, 0);  \n  );\n  if(hotspot[%1].autoplaytype === null, \n   set(hotspot[%1].autoplaytype, 1); \n  ); \n  \n\n  if(hotspot[%1].autoplaytype == 0 , \n   if(hotspot[%1].autoplayindex == hotspot[%1].urls.length, \n    set(hotspot[%1].autoplayindex, 0);\n   ); \n   images_play_change(%1); \n  );\n\n  if(hotspot[%1].autoplaytype == 1 ,\n   if(hotspot[%1].autoplayindex == hotspot[%1].urls.length, \n    set(hotspot[%1].autoplayindex, 0);\n   ); \n   if (hotspot[%1].autoplayduration === null, \n    set(hotspot[%1].autoplayduration, 1); \n   );  \n   txtadd(image_play_call_id, \"image_play_call_\", %1);\n   delayedcall(get(image_play_call_id), get(hotspot[%1].autoplayduration), \n    images_play(%1); \n    images_play_change(%1); \n   ); \n   set(hotspot[%1].isImagePlaying,true); \n  );\n\n ); \n </action>\n\n<action name=\"images_play_change\"> \nif (hotspot[%1].urls.length GT 1, \n if(hotspot[%1].titleHotspotId !== null, \n  inc(hotspot[get(hotspot[%1].titleHotspotId)].zorder);\n ); \n copy(targeturl, hotspot[%1].urls[get(hotspot[%1].autoplayindex)]);\n indexoftxt(imageIsGif , get(targeturl), '.gif');\n if(imageIsGif GT -1,\n    txtadd(targeturl,'?v=');\n    txtadd(targeturl,get(hotspot[%1].name));\n    txtadd(targeturl,get(hotspot[%1].gifIndex));\n    inc(hotspot[%1].gifIndex);\n );\n inc(hotspot[%1].autoplayindex);\n copy(hotspot[%1].url, targeturl);\n set(hotspot[%1].enabled, true); \n set(hotspot[%1].autoplayshow, true);  \n);\n</action>\n            " + '<action name="scale_to_xy"> if(hotspot[%1].scalex !== null, if(hotspot[%1].imagewidth GT 0, mul(hotspot[%1].width,hotspot[%1].imagewidth,hotspot[%1].scalex); if(hotspot[%1].scaley !== null, mul(hotspot[%1].height,hotspot[%1].imageheight,hotspot[%1].scaley); if(hotspot[%1].framecount GT 1 AND hotspot[%1].crop === null,  div(hotspot[%1].height, hotspot[%1].framecount); );, mul(hotspot[%1].height,hotspot[%1].imageheight,hotspot[%1].scalex); if(hotspot[%1].framecount GT 1 AND crop === null, div(hotspot[%1].height, hotspot[%1].framecount);); ); ); if(hotspot[%1].videowidth GT 0, mul(hotspot[%1].width,hotspot[%1].videowidth,hotspot[%1].scalex); if(hotspot[%1].scaley !== null, mul(hotspot[%1].height,hotspot[%1].videoheight,hotspot[%1].scaley); , mul(hotspot[%1].height,hotspot[%1].videowidth,hotspot[%1].scalex); ); ); ); if(hotspot[%1].posterId !== null, copy(hotspot[get(hotspot[%1].posterId)].width, hotspot[%1].width);copy(hotspot[get(hotspot[%1].posterId)].height, hotspot[%1].height);); if(hotspot[%1].borderImageId !== null, add(hotspot[get(hotspot[%1].borderImageId)].width, hotspot[%1].width, 10);add(hotspot[get(hotspot[%1].borderImageId)].height, hotspot[%1].height, 10);); if(hotspot[%1].posterId !== null, copy(hotspot[get(hotspot[%1].posterId)].width, hotspot[%1].width);copy(hotspot[get(hotspot[%1].posterId)].height, hotspot[%1].height);); if(hotspot[%1].targetVisible != false, set(hotspot[%1].visible, true););</action>' + "<action name=\"calc_pos_from_hfov_yaw_pitch_roll\"> div(hfov,%2,57.295779); div(yaw,%3,-57.295779); div(pitch,%4,57.295779); div(roll,%5,-57.295779); mul(hfov,0.5);Math.tan(hfov);mul(hotspot[%1].width,hfov,1000); Math.cos(ch,yaw);Math.sin(sh,yaw); Math.cos(ca,pitch);Math.sin(sa,pitch); Math.cos(cb,roll);Math.sin(sb,roll); mul(m0,ca,ch); mul(tmp,cb,sa);mul(tmp,ch);mul(tmp2,sb,sh);add(m3,tmp,tmp2); mul(m4,cb,ca); mul(tmp,cb,sa);mul(tmp,sh);mul(tmp2,sb,ch);sub(m5n,tmp,tmp2);mul(m5n,-1); mul(tmp,sb,sa);mul(tmp,ch);mul(tmp2,cb,sh);sub(m6n,tmp,tmp2);mul(m6n,-1); Math.atan2(yaw,m6n,m0); Math.atan2(roll,m5n,m4); Math.asin(pitch,m3); mul(hotspot[%1].ath,yaw,57.295779); mul(hotspot[%1].atv,pitch,57.295779); mul(hotspot[%1].rotate,roll,57.295779);copy(hotspot[%1].height,hotspot[%1].width);mul(hotspot[%1].height,hotspot[%1].imageheight);div(hotspot[%1].height,hotspot[%1].imagewidth);</action>" + '<action name="frame_animation">set(hotspot[get(name)].start_animation, true);if(latestframe GT 0, inc(frame,1,get(latestframe),0); mul(ypos,frame,frameheight); txtadd(crop,"0|",get(ypos),"|",get(framewidth),"|",get(frameheight)); delayedcall(get(frameduration), frame_animation()); ); </action>' + '<action name="on_polygon_over"> if(blink == true, stoptween(fillcolor); stoptween(fillalpha); stoptween(bordercolor); stoptween(borderalpha); ); if(overfillcolor !== null, copy(fillcolor, overfillcolor););if(overfillalpha !== null, copy(fillalpha, overfillalpha););if(bordercolor !== null, copy(bordercolor, overbordercolor););if(overborderwidth !== null, copy(borderwidth, overborderwidth););if(overborderalpha !== null, copy(borderalpha, overborderalpha);); </action>' + '<action name="on_polygon_out">if(normalfillcolor !== null, copy(fillcolor, normalfillcolor););if(normalfillalpha !== null, copy(fillalpha, normalfillalpha););if(bordercolor !== null, copy(bordercolor, normalbordercolor););if(normalborderwidth !== null, copy(borderwidth, normalborderwidth););if(normalborderalpha !== null, copy(borderalpha, normalborderalpha);); if(blink == true, polygon_blink_enable(get(name););); </action>' + '<plugin name="gyro_plugin" keep="true" url="' + this.__pluginPath + 'gyro2.js" devices="html5" enabled="false"  />' + '<action name="make_snapshoot" type="Javascript"><![CDATA[ if (krpano.webGL && krpano.webGL.context.getContextAttributes().preserveDrawingBuffer) { try { var img_src = krpano.webGL.canvas.toDataURL("image/' + this.snapshootImageType + '",' + this.snapshootImageQuality + '); window.players[\'' + this.krpanoWrapper.id + '\'].events.onSnapshootComplete(img_src); } catch(err) { window.players[\'' + this.krpanoWrapper.id + '\'].events.onSnapshootError(err); } } else { window.players[\'' + this.krpanoWrapper.id + '\'].events.onSnapshootError("no webgl or no preserveDrawingBuffer"); } ]]></action>' + '<action name="setup_webgl" type="Javascript"><![CDATA[ window.players[\'' + this.krpanoWrapper.id + '\'].krpanoWebGL = krpano.webGL; ]]></action>' + '<action name="setup_krpano" type="Javascript"><![CDATA[ window.players[\'' + this.krpanoWrapper.id + '\'].krpanoObj = krpano; ]]></action>' + '<action name="drag_enable_polygon">if(%1 != dragging, spheretoscreen(ath, atv, hotspotcenterx, hotspotcentery); sub(drag_adjustx, mouse.stagex, hotspotcenterx); sub(drag_adjusty, mouse.stagey, hotspotcentery); drag_enable_polygon(dragging); , if(pressed, sub(dx, mouse.stagex, drag_adjustx); sub(dy, mouse.stagey, drag_adjusty); screentosphere(dx, dy, ath, atv); copy(print_ath, ath); copy(print_atv, atv); roundval(print_ath, 8); roundval(print_atv, 8); set(ath,get(print_ath)); set(atv,get(print_atv)); if(hotspotid !== null AND pointid !== null, set(hotspot[get(hotspotid)].point[get(pointid)].ath,get(print_ath)); set(hotspot[get(hotspotid)].point[get(pointid)].atv,get(print_atv)); if(hotspot[get(hotspotid)].isLine, jscall(calc("window.panoPlayers[\'' + this.id + '\'].updateLineEndPoints(\'" + get(hotspotid) + "\');")); jscall(calc("window.panoPlayers[\'' + this.id + '\'].onLineMoving({id:\'" + get(hotspotid) + "\', points:" + get(points) + "});")); ); );  delayedcall(0, drag_enable_polygon(dragging) ); ); ); </action>' + '<action name="drag_enable"> if(%1 != dragging, spheretoscreen(ath, atv, hotspotcenterx, hotspotcentery); sub(drag_adjustx, mouse.stagex, hotspotcenterx); sub(drag_adjusty, mouse.stagey, hotspotcentery); drag_enable(dragging); , if(pressed, sub(dx, mouse.stagex, drag_adjustx); sub(dy, mouse.stagey, drag_adjusty); screentosphere(dx, dy, ath, atv); copy(print_ath, ath); copy(print_atv, atv); roundval(print_ath, 8); roundval(print_atv, 8); set(ath,get(print_ath)); set(atv,get(print_atv)); if(iconImage !== null, set(hotspot[get(iconImage)].ath,get(print_ath)); set(hotspot[get(iconImage)].atv,get(print_atv)); ); if(titlehotspotid !== null, set(hotspot[get(titlehotspotid)].ath,get(print_ath)); set(hotspot[get(titlehotspotid)].atv,get(print_atv)); ); if(posterId !== null, set(hotspot[get(posterId)].ath,get(print_ath)); set(hotspot[get(posterId)].atv,get(print_atv)); ); if(borderImageId !== null, set(hotspot[get(borderImageId)].ath,get(print_ath)); set(hotspot[get(borderImageId)].atv,get(print_atv)); ); if(extendimage !== null, set(hotspot[get(extendimage)].ath,get(print_ath)); set(hotspot[get(extendimage)].atv,get(print_atv)); ); for(set(i,0), i LT bindItems.count, inc(i), set(hotspot[get(bindItems[get(i)].name)].ath,get(print_ath)); set(hotspot[get(bindItems[get(i)].name)].atv,get(print_atv)); ); jscall(calc("window.players[\'' + this.krpanoWrapper.id + '\'].events.onHotspotMoving({id:\'" + get(originid) + "\', ath:" + get(print_ath) + ", atv:" + get(print_atv) + "});")); delayedcall(0, drag_enable(dragging)); ); ); </action>' + '<action name="drag_enable_shape">copy(shape_hotspot_name, hotspotID); if(%1 != dragging, spheretoscreen(hotspot[get(shape_hotspot_name)].ath, hotspot[get(shape_hotspot_name)].atv, hotspot[get(shape_hotspot_name)].hotspotcenterx, hotspot[get(shape_hotspot_name)].hotspotcentery); sub(hotspot[get(shape_hotspot_name)].drag_adjustx, mouse.stagex, hotspot[get(shape_hotspot_name)].hotspotcenterx); sub(hotspot[get(shape_hotspot_name)].drag_adjusty, mouse.stagey, hotspot[get(shape_hotspot_name)].hotspotcentery); drag_enable_shape(dragging); , if(pressed, sub(dx, mouse.stagex, hotspot[get(shape_hotspot_name)].drag_adjustx); sub(dy, mouse.stagey, hotspot[get(shape_hotspot_name)].drag_adjusty); screentosphere(dx, dy, hotspot[get(shape_hotspot_name)].ath, hotspot[get(shape_hotspot_name)].atv); copy(print_ath, hotspot[get(shape_hotspot_name)].ath); copy(print_atv, hotspot[get(shape_hotspot_name)].atv); roundval(print_ath, 8); roundval(print_atv, 8); set(hotspot[get(shape_hotspot_name)].ath,get(print_ath)); set(hotspot[get(shape_hotspot_name)].atv,get(print_atv));  if(iconImage !== null, set(hotspot[get(iconImage)].ath,get(print_ath)); set(hotspot[get(iconImage)].atv,get(print_atv)); ); if(titlehotspotid !== null, set(hotspot[get(titlehotspotid)].ath,get(print_ath)); set(hotspot[get(titlehotspotid)].atv,get(print_atv)); ); if(posterId !== null, set(hotspot[get(posterId)].ath,get(print_ath)); set(hotspot[get(posterId)].atv,get(print_atv)); );  if(hotspot[get(hotspotID)].borderImageId !== null, set(hotspot[get(hotspot[get(hotspotID)].borderImageId)].ath,get(print_ath)); set(hotspot[get(hotspot[get(hotspotID)].borderImageId)].atv,get(print_atv)); );  if(extendimage !== null, set(hotspot[get(extendimage)].ath,get(print_ath)); set(hotspot[get(extendimage)].atv,get(print_atv));); for(set(i,0), i LT hotspot[get(hotspotID)].bindItems.count, inc(i), set(hotspot[get(hotspot[get(shape_hotspot_name)].bindItems[get(i)].name)].ath,get(print_ath)); set(hotspot[get(hotspot[get(shape_hotspot_name)].bindItems[get(i)].name)].atv,get(print_atv)););  delayedcall(0, drag_enable_shape(dragging) ); ); ); </action>' + '<action name="polygon_blink_enable" > if(hotspot[%1].blink == true, if(hotspot[%1].blink_duration === null, set(hotspot[%1].blink_duration, 4); ); if(hotspot[%1].fillcolor === hotspot[%1].normalfillcolor, copy(dest_color, hotspot[%1].overfillcolor); copy(dest_alpha, hotspot[%1].overfillalpha); copy(dest_border_color, hotspot[%1].overbordercolor); copy(dest_border_alpha, hotspot[%1].overborderalpha); , copy(dest_color, hotspot[%1].normalfillcolor); copy(dest_alpha, hotspot[%1].normalfillalpha); copy(dest_border_color, hotspot[%1].normalbordercolor); copy(dest_border_alpha, hotspot[%1].normalborderalpha); ); tween(hotspot[%1].fillalpha, get(dest_alpha), get(hotspot[%1].blink_duration), linear); tween(hotspot[%1].fillcolor, get(dest_color), get(hotspot[%1].blink_duration), linear, polygon_blink_enable(%1);); tween(hotspot[%1].borderalpha, get(dest_border_alpha), get(hotspot[%1].blink_duration), linear); tween(hotspot[%1].bordercolor, get(dest_border_color), get(hotspot[%1].blink_duration), linear); ); </action>' + '<action name="polygon_blink_disable" > stoptween(hotspot[%1].fillcolor); stoptween(hotspot[%1].fillalpha); stoptween(hotspot[%1].bordercolor); stoptween(hotspot[%1].borderalpha); callwith(hotspot[%1] ,on_polygon_out); </action>' + '<action name="hotspot_blinking" > if(hotspot[%1].blinking !== true, set(hotspot[%1].blinkCount, 1); ); set(hotspot[%1].blinking, true); tween(hotspot[%1].alpha, 0.4, %3, linear, tween(hotspot[%1].alpha, 1, %3, linear, if(hotspot[%1].blinkCount LT %2, add(hotspot[%1].blinkCount, 1); hotspot_blinking(%1, %2, %3); , set(hotspot[%1].blinking, false); ); ); ); </action>' + '<action name="on_vr_available" type="Javascript"><![CDATA[ if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVrAvailable){window.players[\'' + this.krpanoWrapper.id + '\'].events.onVrAvailable();} ]]></action>' + '<action name="on_vr_unavailable" type="Javascript"><![CDATA[ if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onVrUnavailable){window.players[\'' + this.krpanoWrapper.id + '\'].events.onVrUnavailable();} ]]></action>' + '<action name="on_enter_vr" type="Javascript"><![CDATA[ if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onEnterVr){window.players[\'' + this.krpanoWrapper.id + '\'].events.onEnterVr(true);}; window.players[\'' + this.krpanoWrapper.id + '\'].call("update_vr_hotspot();"); ]]></action>' + '<action name="on_exit_vr" type="Javascript"><![CDATA[ if(window.players[\'' + this.krpanoWrapper.id + '\'].events.onExitVr){window.players[\'' + this.krpanoWrapper.id + '\'].events.onExitVr();}; window.players[\'' + this.krpanoWrapper.id + '\'].call("update_vr_hotspot();"); ]]></action>' + (" <plugin name=\"webvr\" devices=\"html5\" keep=\"true\" url=\"" + this.__pluginPath + "webvr.js\" mobilevr_support=\"true\" mobilevr_touch_support=\"true\" mobilevr_fake_support=\"true\" mobilevr_profile.normal=\"90|60|42|0|0|0\" mobilevr_profile.mobile=\"80|60|42|35|0.441|0.156\" mobilevr_wakelock=\"true\" fullscreen_mirroring=\"false\" mouse_pointerlock=\"true\" vr_cursor_onover=\"if(handcursor, tween(hotspot[vr_cursor].scale,0.4,0.1); vr_auto_click(get(vr_timeout)); );\" vr_cursor_onout=\"tween(hotspot[vr_cursor].scale,0.3,0.1);\" onavailable=\"webvr_onavailable();\" onunavailable=\"webvr_onunavailable();\" onunknowndevice=\"webvr_onunknowndevice();\" onvrcontrollers=\"webvr_onvrcontrollers();\" onentervr=\"webvr_onentervr();\" onexitvr=\"webvr_onexitvr();\" /> <style name=\"vr_cursor_style\" url=\"" + this.__skinPath + "webvr_cursor_80x80_17f.png\" visible=\"false\" enabled=\"false\" distorted=\"true\" crop=\"0|0|80|80\" scale=\"0.3\" depth=\"120\" /> <action name=\"webvr_load_vr_cursor_hs\" scope=\"local\"> addhotspot('vr_cursor', hs); hs.loadstyle(vr_cursor_style); set(hs.keep, true); set(webvr.vr_cursor, 'hotspot[vr_cursor]'); </action> <action name=\"webvr_load_vr_controller_hs\" scope=\"private:VRCONTROLLERS\" args=\"controllerstyle\"> removehotspot('vr_controller_l'); removehotspot('vr_controller_r'); addhotspot('vr_controller_l', vr_ctrl_l); addhotspot('vr_controller_r', vr_ctrl_r); set(vr_ctrl_l.keep, true); set(vr_ctrl_r.keep, true); vr_ctrl_l.loadstyle(calc(controllerstyle ? controllerstyle : 'vrcontroller_light_and_point')); vr_ctrl_r.loadstyle(calc(controllerstyle ? controllerstyle : 'vrcontroller_light_and_point')); if(!global.webvr.iswebxr, vr_ctrl_l.addevent('onvrcontrollerbutton', 'if(vrbuttonindex == 3 AND vrbuttonstate == \"up\", vrsetup_open(); );' ); vr_ctrl_r.addevent('onvrcontrollerbutton', 'if(vrbuttonindex == 3 AND vrbuttonstate == \"up\", vrsetup_open(); );' ); ); set(global.webvr.vr_controller, 'vr_controller_l,vr_controller_r'); set(global.have_vr_controllers, true); if(global.webvr.isvrbrowser AND global.webvr.vrcontrollers[0].buttons.length LE 2, addhotspot('webvr_vrsetup', vr_setup_hs); vr_setup_hs.loadstyle('webvr_button_style'); set(vr_setup_hs, keep=true, ath=0, atv=90, depth=160, zorder=999, torigin=view, html='VR SETUP', oversampling=3, scale=0.2, onclick='vrsetup_open();', onloaded='renderloop( copy(ath,view.hlookat); );'); ); </action> <action name=\"webvr_onvrcontrollers\" scope=\"private:VRCONTROLLERS\"> if(!global.have_vr_controllers, webvr_load_vr_controller_hs(); ); </action> <style name=\"vrcontroller_laser\" url=\"" + this.__skinPath + "webvr_laser.png\" distorted=\"true\" enabled=\"false\" visible=\"false\" width=\"0.5\" height=\"1000\" edge=\"bottom\" oref=\"1\" oy=\"0\" torigin=\"world\" tx=\"0\" ty=\"0\" tz=\"0\" depth=\"0\" zorder=\"99999\" depthbuffer=\"true\" onloaded=\"asyncloop(loaded, calc(height, (target AND target.hitd GT 0 ? target.hitd : 1000) / display.hotspotworldscale); );\" /> <style name=\"vrcontroller_light_and_point\" url=\"" + this.__skinPath + "webvr_light.png\" distorted=\"true\" enabled=\"false\" visible=\"false\" width=\"0.5\" height=\"18\" edge=\"bottom\" oref=\"1\" oy=\"0\" torigin=\"world\" tx=\"0\" ty=\"0\" tz=\"0\" depth=\"0\" zorder=\"99999\" depthbuffer=\"true\" onloaded=\"vrcontroller_target_point();\" /> <style name=\"vrcontroller_handcursor_and_point\" url=\"" + this.__skinPath + "webvr_handcursor.png\" distorted=\"true\" enabled=\"false\" visible=\"false\" width=\"10\" height=\"10\" edge=\"center\" oref=\"1\" oy=\"-1\" torigin=\"world\" tx=\"0\" ty=\"0\" tz=\"0\" depth=\"0\" zorder=\"99999\" depthbuffer=\"true\" onloaded=\"vrcontroller_target_point();\" /> <action name=\"vrcontroller_target_point\" scope=\"localonly\"> addhotspot(auto, hs); set(hs, keep=true, type=text, bgcolor=0xFFFFFF, bgalpha=1.0, width=10, height=10, bgroundedge=5, bgborder='1 0x000000 1.0', oversampling=2, scale=0.4, torigin=world, depth=0, distorted=false, zoom=true, zorder=99998, enabled=false ); renderloop( if(!caller.loaded, removehotspot(get(hs.name)); stoprenderloop(); , if(global.display.havedepthmap, removehotspot(get(hs.name)); stoprenderloop(); webvr_load_vr_controller_hs('vrcontroller_laser'); , calc(hs.bgcolor, caller.pressed ? 0x049AFF : (caller.hovering ? 0x00FF00 : 0xFFFFFF)); calc(distance, (caller.target AND caller.target.hitd GT 0 ? caller.target.hitd : 1000)); calc(hs.scale, 0.4 * (distance GT 1000 ? distance / 1000 : (distance LT 200 ? 0.25 : (0.25 + (distance - 200)/800 * 0.75)))); calc(hs.tx, caller.tx + caller.dx * distance); calc(hs.ty, caller.ty + caller.dy * distance); calc(hs.tz, caller.tz + caller.dz * distance); ); ); ); </action> <action name=\"vr_auto_click\" scope=\"local\" args=\"vr_aclk_timeout\"> if(webvr.isenabled, if(vr_aclk_timeout == null, set(vr_aclk_timeout, 2000)); copy(vr_aclk_t1, timertick); set(vr_aclk_waiting, true); copy(webvr.vr_aclk_hotspot, caller.name); set(hotspot[vr_cursor].crop,'0|0|80|80'); asyncloop(vr_aclk_waiting AND webvr.vr_aclk_hotspot == caller.name, sub(dt, timertick, vr_aclk_t1); if(!caller.hovering, set(vr_aclk_waiting, false); set(hotspot[vr_cursor].crop,'0|0|80|80'); , div(f, dt, vr_aclk_timeout); mul(f, 16); roundval(f); Math.min(f, 16); mul(f, 80); txtadd(hotspot[vr_cursor].crop,get(f),'|0|80|80'); sub(dt, 100); if(dt GT vr_aclk_timeout, set(vr_aclk_waiting,false); set(hotspot[vr_cursor].crop,'0|0|80|80'); callwith(caller, scope(global, ondown();onup();onclick(); ); ); ); ); ); ); </action> <events name=\"webvr_events\" devices=\"html5\" keep=\"true\" onmousedown=\"if(webvr AND webvr.isenabled, webvr_showbuttons() );\" /> <action name=\"webvr_onavailable\"> webvr.loadsettings(); on_vr_available(); </action> <action name=\"webvr_onunavailable\"> on_vr_unavailable(); </action> <action name=\"webvr_onunknowndevice\"> if(webvr.isfake AND device.desktop AND webvr.havesettings == false, set(webvr.mobilevr_lens_overlap, 1.0); set(webvr.mobilevr_lens_fov, 96.0); set(webvr.mobilevr_lens_dist, 0.0); set(webvr.mobilevr_lens_dist2, '1|0|0|0'); set(webvr.mobilevr_lens_ca, 0.0); set(webvr.mobilevr_lens_vign, 100); ); </action> <action name=\"webvr_onentervr\"> webvr_showbuttons(); webvr_hide_all_non_vr_layers(); if(webvr.isfake, webvr_show_fakemode_info(true); ); webvr_load_vr_cursor_hs(); on_enter_vr(); </action> <action name=\"webvr_onexitvr\"> removehotspot('vr_cursor'); removehotspot('vr_controller_l'); removehotspot('vr_controller_r'); set(have_vr_controllers, false); stopdelayedcall(vr_button_fadeout); tween(layer[webvr_exitbutton].alpha,0); tween(layer[webvr_setupbutton].alpha,0); webvr_show_fakemode_info(false); webvr_restore_layers(); on_exit_vr(); </action> <action name=\"webvr_hide_all_non_vr_layers\" scope=\"local\"> for(set(i,0), i LT layer.count, inc(i), copy(lr, layer[get(i)]); if(lr.vr !== true, copy(lr.vr_backup_visible, lr.visible); set(lr.visible, false); ); ); </action> <action name=\"webvr_restore_layers\" scope=\"local\"> for(set(i,0), i LT layer.count, inc(i), copy(lr, layer[get(i)]); if(lr.vr_backup_visible, copy(lr.visible, lr.vr_backup_visible); delete(lr.vr_backup_visible); ); ); </action> <action name=\"webvr_show_fakemode_info\" scope=\"local\" args=\"show\"> if(show == true, addlayer(webvr_fakemode_info); set(layer[webvr_fakemode_info], type='text', keep=true, align='bottom', y=80, bg=false, css='color:#FFFFFF;text-align:center;', html='[i][u]Simulated WebVR Mode![/u][br]For real WebVR with headset tracking use a [a href=\"http://webvr.info\" target=\"_blank\" style=\"color:#FFFFFF;\"]WebVR-capable[/a] browser or a mobile device and a VR headset.[/i]' ); , removelayer(webvr_fakemode_info); ); </action> <krpano webvr_setup_scale=\"calc:(1.0 + 1.0*(device.mobile AND stagescale LT 1.0)) / (1.0 + 1.0*device.mobile)\" webvr_button_scale.normal=\"1.0\" webvr_button_scale.mobile=\"1.6\" /> <style name=\"webvr_button_style\" type=\"text\" bgcolor=\"0x000000\" bgalpha=\"0.5\" bgroundedge=\"0\" css=\"calc:'color:#FFFFFF;font-size:' + 20*webvr_setup_scale*webvr_button_scale + 'px;'\" padding=\"calc:6*webvr_setup_scale*webvr_button_scale + ' ' + 10*webvr_setup_scale*webvr_button_scale\" /> <layer name=\"webvr_exitbutton\" keep=\"true\" vr=\"true\" style=\"webvr_button_style\" html=\"Exit VR\" align=\"top\" y=\"24\" autoalpha=\"true\" alpha=\"0.0\" onclick=\"webvr.exitVR();\" /> <layer name=\"webvr_setupbutton\" keep=\"true\" vr=\"true\" style=\"webvr_button_style\" html=\"VR Setup\" align=\"bottom\" y=\"24\" autoalpha=\"true\" alpha=\"0.0\" onclick=\"vrsetup_open();\" /> <action name=\"webvr_showbuttons\"> stopdelayedcall(vr_button_fadeout); tween(layer[webvr_exitbutton].alpha|layer[webvr_setupbutton].alpha, 1.0|1.0, 0.25); delayedcall(vr_button_fadeout, 3.0, tween(layer[webvr_exitbutton].alpha|layer[webvr_setupbutton].alpha, 0.0|0.0, 1.0); ); </action> <mobilevr_presets> <headset name=\"cbv1\" caption=\"Cardboard V1\" profile=\"80|60|42|35|0.441|0.156\" /> <headset name=\"cbv2\" caption=\"Cardboard V2\" profile=\"120|64|39|35|0.34|0.55\" /> <headset name=\"dydm\" caption=\"Daydream\" profile=\"104|60|41|35|0.42|0.51\" /> <headset name=\"nodt\" caption=\"No Distortion\" profile=\"90|60|42|0|0|0\" /> </mobilevr_presets> <action name=\"vrsetup_open\"> if(!vrsetup_open_js, vrsetup_init(); ); vrsetup_open_js(); </action> <action name=\"vrsetup_init\"> jscall('vrSetupInit();'); </action>") + //` <plugin name="webvr" devices="html5" keep="true" url="https://ssl-player2.720static.com/krp/1.20.7/plugins/webvr.js" mobilevr_support="true" mobilevr_touch_support="true" mobilevr_fake_support="true" mobilevr_profile.normal="90|60|42|0|0|0" mobilevr_profile.mobile="80|60|42|35|0.441|0.156" mobilevr_wakelock="true" fullscreen_mirroring="false" mouse_pointerlock="true" vr_cursor_onover="if(handcursor, tween(hotspot[vr_cursor].scale,0.4,0.1); vr_auto_click(get(vr_timeout)); );" vr_cursor_onout="tween(hotspot[vr_cursor].scale,0.3,0.1);" onavailable="webvr_onavailable();" onunavailable="webvr_onunavailable();" onunknowndevice="webvr_onunknowndevice();" onvrcontrollers="webvr_onvrcontrollers();" onentervr="webvr_onentervr();" onexitvr="webvr_onexitvr();" /> <style name="vr_cursor_style" url="https://ssl-player2.720static.com/krp/1.19-pr16/skin/webvr_cursor_80x80_17f.png" visible="false" enabled="false" distorted="true" crop="0|0|80|80" scale="0.3" depth="120" /> <action name="webvr_load_vr_cursor_hs" scope="local"> addhotspot('vr_cursor', hs); hs.loadstyle(vr_cursor_style); set(hs.keep, true); set(webvr.vr_cursor, 'hotspot[vr_cursor]'); </action> <action name="webvr_load_vr_controller_hs" scope="private:VRCONTROLLERS" args="controllerstyle"> removehotspot('vr_controller_l'); removehotspot('vr_controller_r'); addhotspot('vr_controller_l', vr_ctrl_l); addhotspot('vr_controller_r', vr_ctrl_r); set(vr_ctrl_l.keep, true); set(vr_ctrl_r.keep, true); vr_ctrl_l.loadstyle(calc(controllerstyle ? controllerstyle : 'vrcontroller_light_and_point')); vr_ctrl_r.loadstyle(calc(controllerstyle ? controllerstyle : 'vrcontroller_light_and_point')); if(!global.webvr.iswebxr, vr_ctrl_l.addevent('onvrcontrollerbutton', 'if(vrbuttonindex == 3 AND vrbuttonstate == "up", vrsetup_open(); );' ); vr_ctrl_r.addevent('onvrcontrollerbutton', 'if(vrbuttonindex == 3 AND vrbuttonstate == "up", vrsetup_open(); );' ); ); set(global.webvr.vr_controller, 'vr_controller_l,vr_controller_r'); set(global.have_vr_controllers, true); if(global.webvr.isvrbrowser AND global.webvr.vrcontrollers[0].buttons.length LE 2, addhotspot('webvr_vrsetup', vr_setup_hs); vr_setup_hs.loadstyle('webvr_button_style'); set(vr_setup_hs, keep=true, ath=0, atv=90, depth=160, zorder=999, torigin=view, html='VR SETUP', oversampling=3, scale=0.2, onclick='vrsetup_open();', onloaded='renderloop( copy(ath,view.hlookat); );'); ); </action> <action name="webvr_onvrcontrollers" scope="private:VRCONTROLLERS"> if(!global.have_vr_controllers, webvr_load_vr_controller_hs(); ); </action> <style name="vrcontroller_laser" url="https://ssl-player2.720static.com/krp/1.19-pr16/skin/webvr_laser.png" distorted="true" enabled="false" visible="false" width="0.5" height="1000" edge="bottom" oref="1" oy="0" torigin="world" tx="0" ty="0" tz="0" depth="0" zorder="99999" depthbuffer="true" onloaded="asyncloop(loaded, calc(height, (target AND target.hitd GT 0 ? target.hitd : 1000) / display.hotspotworldscale); );" /> <style name="vrcontroller_light_and_point" url="https://ssl-player2.720static.com/krp/1.19-pr16/skin/webvr_light.png" distorted="true" enabled="false" visible="false" width="0.5" height="18" edge="bottom" oref="1" oy="0" torigin="world" tx="0" ty="0" tz="0" depth="0" zorder="99999" depthbuffer="true" onloaded="vrcontroller_target_point();" /> <style name="vrcontroller_handcursor_and_point" url="https://ssl-player2.720static.com/krp/1.19-pr16/skin/webvr_handcursor.png" distorted="true" enabled="false" visible="false" width="10" height="10" edge="center" oref="1" oy="-1" torigin="world" tx="0" ty="0" tz="0" depth="0" zorder="99999" depthbuffer="true" onloaded="vrcontroller_target_point();" /> <action name="vrcontroller_target_point" scope="localonly"> addhotspot(auto, hs); set(hs, keep=true, type=text, bgcolor=0xFFFFFF, bgalpha=1.0, width=10, height=10, bgroundedge=5, bgborder='1 0x000000 1.0', oversampling=2, scale=0.4, torigin=world, depth=0, distorted=false, zoom=true, zorder=99998, enabled=false ); renderloop( if(!caller.loaded, removehotspot(get(hs.name)); stoprenderloop(); , if(global.display.havedepthmap, removehotspot(get(hs.name)); stoprenderloop(); webvr_load_vr_controller_hs('vrcontroller_laser'); , calc(hs.bgcolor, caller.pressed ? 0x049AFF : (caller.hovering ? 0x00FF00 : 0xFFFFFF)); calc(distance, (caller.target AND caller.target.hitd GT 0 ? caller.target.hitd : 1000)); calc(hs.scale, 0.4 * (distance GT 1000 ? distance / 1000 : (distance LT 200 ? 0.25 : (0.25 + (distance - 200)/800 * 0.75)))); calc(hs.tx, caller.tx + caller.dx * distance); calc(hs.ty, caller.ty + caller.dy * distance); calc(hs.tz, caller.tz + caller.dz * distance); ); ); ); </action> <action name="vr_auto_click" scope="local" args="vr_aclk_timeout"> if(webvr.isenabled, if(vr_aclk_timeout == null, set(vr_aclk_timeout, 2000)); copy(vr_aclk_t1, timertick); set(vr_aclk_waiting, true); copy(webvr.vr_aclk_hotspot, caller.name); set(hotspot[vr_cursor].crop,'0|0|80|80'); asyncloop(vr_aclk_waiting AND webvr.vr_aclk_hotspot == caller.name, sub(dt, timertick, vr_aclk_t1); if(!caller.hovering, set(vr_aclk_waiting, false); set(hotspot[vr_cursor].crop,'0|0|80|80'); , div(f, dt, vr_aclk_timeout); mul(f, 16); roundval(f); Math.min(f, 16); mul(f, 80); txtadd(hotspot[vr_cursor].crop,get(f),'|0|80|80'); sub(dt, 100); if(dt GT vr_aclk_timeout, set(vr_aclk_waiting,false); set(hotspot[vr_cursor].crop,'0|0|80|80'); callwith(caller, scope(global, ondown();onup();onclick(); ); ); ); ); ); ); </action> <events name="webvr_events" devices="html5" keep="true" onmousedown="if(webvr AND webvr.isenabled, webvr_showbuttons() );" /> <action name="webvr_onavailable"> webvr.loadsettings(); on_vr_available(); </action> <action name="webvr_onunavailable"> on_vr_unavailable(); </action> <action name="webvr_onunknowndevice"> if(webvr.isfake AND device.desktop AND webvr.havesettings == false, set(webvr.mobilevr_lens_overlap, 1.0); set(webvr.mobilevr_lens_fov, 96.0); set(webvr.mobilevr_lens_dist, 0.0); set(webvr.mobilevr_lens_dist2, '1|0|0|0'); set(webvr.mobilevr_lens_ca, 0.0); set(webvr.mobilevr_lens_vign, 100); ); </action> <action name="webvr_onentervr"> webvr_showbuttons(); webvr_hide_all_non_vr_layers(); if(webvr.isfake, webvr_show_fakemode_info(true); ); webvr_load_vr_cursor_hs(); on_enter_vr(); </action> <action name="webvr_onexitvr"> removehotspot('vr_cursor'); removehotspot('vr_controller_l'); removehotspot('vr_controller_r'); set(have_vr_controllers, false); stopdelayedcall(vr_button_fadeout); tween(layer[webvr_exitbutton].alpha,0); tween(layer[webvr_setupbutton].alpha,0); webvr_show_fakemode_info(false); webvr_restore_layers(); on_exit_vr(); </action> <action name="webvr_hide_all_non_vr_layers" scope="local"> for(set(i,0), i LT layer.count, inc(i), copy(lr, layer[get(i)]); if(lr.vr !== true, copy(lr.vr_backup_visible, lr.visible); set(lr.visible, false); ); ); </action> <action name="webvr_restore_layers" scope="local"> for(set(i,0), i LT layer.count, inc(i), copy(lr, layer[get(i)]); if(lr.vr_backup_visible, copy(lr.visible, lr.vr_backup_visible); delete(lr.vr_backup_visible); ); ); </action> <action name="webvr_show_fakemode_info" scope="local" args="show"> if(show == true, addlayer(webvr_fakemode_info); set(layer[webvr_fakemode_info], type='text', keep=true, align='bottom', y=80, bg=false, css='color:#FFFFFF;text-align:center;', html='[i][u]Simulated WebVR Mode![/u][br]For real WebVR with headset tracking use a [a href="http://webvr.info" target="_blank" style="color:#FFFFFF;"]WebVR-capable[/a] browser or a mobile device and a VR headset.[/i]' ); , removelayer(webvr_fakemode_info); ); </action> <krpano webvr_setup_scale="calc:(1.0 + 1.0*(device.mobile AND stagescale LT 1.0)) / (1.0 + 1.0*device.mobile)" webvr_button_scale.normal="1.0" webvr_button_scale.mobile="1.6" /> <style name="webvr_button_style" type="text" bgcolor="0x000000" bgalpha="0.5" bgroundedge="0" css="calc:'color:#FFFFFF;font-size:' + 20*webvr_setup_scale*webvr_button_scale + 'px;'" padding="calc:6*webvr_setup_scale*webvr_button_scale + ' ' + 10*webvr_setup_scale*webvr_button_scale" /> <layer name="webvr_exitbutton" keep="true" vr="true" style="webvr_button_style" html="Exit VR" align="top" y="24" autoalpha="true" alpha="0.0" onclick="webvr.exitVR();" /> <layer name="webvr_setupbutton" keep="true" vr="true" style="webvr_button_style" html="VR Setup" align="bottom" y="24" autoalpha="true" alpha="0.0" onclick="vrsetup_open();" /> <action name="webvr_showbuttons"> stopdelayedcall(vr_button_fadeout); tween(layer[webvr_exitbutton].alpha|layer[webvr_setupbutton].alpha, 1.0|1.0, 0.25); delayedcall(vr_button_fadeout, 3.0, tween(layer[webvr_exitbutton].alpha|layer[webvr_setupbutton].alpha, 0.0|0.0, 1.0); ); </action> <mobilevr_presets> <headset name="cbv1" caption="Cardboard V1" profile="80|60|42|35|0.441|0.156" /> <headset name="cbv2" caption="Cardboard V2" profile="120|64|39|35|0.34|0.55" /> <headset name="dydm" caption="Daydream" profile="104|60|41|35|0.42|0.51" /> <headset name="nodt" caption="No Distortion" profile="90|60|42|0|0|0" /> </mobilevr_presets> <action name="vrsetup_open"> if(!vrsetup_open_js, vrsetup_init(); ); vrsetup_open_js(); </action> <action name="vrsetup_init"> jscall('vrSetupInit();'); </action>` +
    "<action name=\"update_vr_hotspot\">\n            copy(hotspotCount,hotspot.count);\n            for(set(i,0),i LT hotspotCount,inc(i),\n              if(hotspot[get(i)].isdiv == true || hotspot[get(i)].iscomment == true,\n                if(webvr.isenabled == true,\n                  copy(hotspot[get(i)].oldvisible, hotspot[get(i)].visible);\n                  set(hotspot[get(i)].visible, false);\n                  copy(hotspot[calc(hotspot[get(i)].name + '_vr')].visible, hotspot[get(i)].oldvisible);\n                  ,\n                  copy(hotspot[get(i)].visible, hotspot[get(i)].oldvisible);\n                  set(hotspot[calc(hotspot[get(i)].name + '_vr')].visible, false);\n                );\n              ,\n                if(hotspot[get(i)].isgif == true OR hotspot[get(i)].type == 'text',\n                    indexoftxt(hs_title_by_end_index, get(hotspot[get(i)].name), _end);\n                    if(webvr.isenabled == true,\n                        set(hotspot[get(i)].renderer, webgl);\n                        ,\n                        if(hs_title_by_end_index == -1,\n                            set(hotspot[get(i)].renderer, css3d);\n                        );\n                    );\n                    if(hotspot[get(i)].type == 'text',\n                        copy(texthtml, hotspot[get(i)].html);\n                        set(hotspot[get(i)].html, '');\n                        copy(hotspot[get(i)].html, texthtml);\n                    );\n                );\n              );\n            );\n            </action>" + "\n            <action name=\"vrsetup_init\" type=\"Javascript\"><![CDATA[\n                \n                var webvr = krpano.webvr;\n                var padding = 20;\n                \n                function vrsetup_dlg_create(type)\n                {\n                    var dlg = {type:type};\n                    dlg.bg = null;\n                    dlg.y = 0;\n                    dlg.scale = 1;\n                    dlg.elements = [];\n                \n                    if (type == 'layer')\n                    {\n                        dlg.bg = krpano.addlayer();\n                        dlg.bg.keep = true;\n                        dlg.bg.type = 'container';\n                        dlg.bg.align = 'center';\n                    }\n                    else\t\n                    {\n                        dlg.scale = 0.15;\n                        dlg.bg = krpano.addhotspot();\n                        dlg.bg.keep = true;\n                        dlg.bg.type = 'text';\n                        dlg.bg.distorted = true;\n                        dlg.bg.ath = krpano.view.hlookat;\n                        dlg.bg.atv = 0;\n                        dlg.bg.depth = 150;\n                        dlg.bg.torigin = 'world';\n                        dlg.bg.tx = krpano.view.tx;\n                        dlg.bg.ty = krpano.view.ty;\n                        dlg.bg.tz = krpano.view.tz;\n                    }\n                    \n                    dlg.bg.bgcolor = 0x000000;\n                    dlg.bg.bgalpha = 0.5;\n                    dlg.bg.bgcapture = true;\n                    dlg.bg.handcursor = false;\n                    dlg.bg.capture = false;\n                    dlg.bg.zorder = 100;\n                    dlg.bg.visible = false;\n                    \n                    dlg.y = 0;\n                    \n                    return dlg;\n                };\n                function vrsetup_dlg_addline(dlg, linetext, customcss, onclick)\n                {\n                var txt;\n                \n                if (dlg.type == 'layer')\n                {\n                    txt = krpano.addlayer();\n                    txt.keep = true;\n                    txt.type = 'text';\n                    txt.align = 'center';\n                    txt.zorder = 101;\n                }\n                else\t\n                {\n                    txt = krpano.addhotspot();\n                    txt.keep = true;\n                    txt.type = 'text';\n                    txt.distorted = true;\n                    txt.zorder = 101;\n                    txt.ath = dlg.bg.ath;\n                    txt.atv = dlg.bg.atv;\n                    txt.depth = dlg.bg.depth - 1;\n                    txt.oversampling = 2;\n                    txt.scale = dlg.scale;\n                    txt.torigin = dlg.bg.torigin;\n                    txt.tx = dlg.bg.tx;\n                    txt.ty = dlg.bg.ty;\n                    txt.tz = dlg.bg.tz;\n                }\n                \n                txt.onautosized = function()\n                {\n                    txt.havesize = true;\n                }\n                \n                txt.edge = 'top';\n                txt.visible = false;\n                txt.bg = false;\n                txt.html = \"\" + linetext;\n                txt.css = 'font-size:32px;font-weight:bold;color:#FFFFFF; line-height:90%;' + (customcss || '');\n                \n                if (onclick)\n                {\n                    txt.onclick = onclick;\n                }\n                else\n                {\n                    txt.enabled = false;\n                }\n                \n                dlg.elements.push( txt );\n                \n                return txt;\n            };\n            function vrsetup_dlg_addctrl(dlg, changedelay, callback)\n\t\t{\n\t\t\tvar txt = vrsetup_dlg_addline(dlg, callback(0) );\n\t\t\t\n\t\t\tvar inc;\n\t\t\tvar dec;\n\t\t\t\n\t\t\tif(dlg.type == 'layer')\n\t\t\t{\n\t\t\t\tinc = krpano.addlayer();\n\t\t\t\tinc.keep = true;\n\t\t\t\tinc.type = 'text';\n\t\t\t\tinc.align = 'center';\n\t\t\t\tinc.zorder = 101;\n\t\t\t\t\n\t\t\t\tdec = krpano.addlayer();\n\t\t\t\tdec.keep = true;\n\t\t\t\tdec.type = 'text';\n\t\t\t\tdec.align = 'center';\n\t\t\t\tdec.zorder = 101;\n\t\t\t}\n\t\t\telse\t\n\t\t\t{\n\t\t\t\tinc = krpano.addhotspot();\n\t\t\t\tinc.keep = true;\n\t\t\t\tinc.type = 'text';\n\t\t\t\tinc.distorted = true;\n\t\t\t\tinc.zorder = 101;\n\t\t\t\tinc.ath = dlg.bg.ath;\n\t\t\t\tinc.atv = dlg.bg.atv;\n\t\t\t\tinc.depth = dlg.bg.depth - 1;\n\t\t\t\tinc.oversampling = 2;\n\t\t\t\tinc.scale = dlg.scale;\n\t\t\t\tinc.torigin = dlg.bg.torigin;\n\t\t\t\tinc.tx = dlg.bg.tx;\n\t\t\t\tinc.ty = dlg.bg.ty;\n\t\t\t\tinc.tz = dlg.bg.tz;\n\t\t\t\t\n\t\t\t\tdec = krpano.addhotspot();\n\t\t\t\tdec.keep = true;\n\t\t\t\tdec.type = 'text';\n\t\t\t\tdec.distorted = true;\n\t\t\t\tdec.zorder = 101;\n\t\t\t\tdec.ath = dlg.bg.ath;\n\t\t\t\tdec.atv = dlg.bg.atv;\n\t\t\t\tdec.depth = dlg.bg.depth - 1;\n\t\t\t\tdec.oversampling = 2;\n\t\t\t\tdec.scale = dlg.scale;\n\t\t\t\tdec.torigin = dlg.bg.torigin;\n\t\t\t\tdec.tx = dlg.bg.tx;\n\t\t\t\tdec.ty = dlg.bg.ty;\n\t\t\t\tdec.tz = dlg.bg.tz;\n\t\t\t}\n\t\t\t\n\t\t\tinc.edge = 'top';\n\t\t\tinc.visible = false;\n\t\t\tinc.bg = false;\n\t\t\tinc.html = '&#62;';\n\t\t\tinc.css = 'font-size:32px;font-weight:bold;color:#FFFFFF; line-height:90%;';\n\t\t\tinc.padding = '0 10';\n\t\t\t\t\t\n\t\t\tdec.edge = 'top';\n\t\t\tdec.visible = false;\n\t\t\tdec.bg = false;\n\t\t\tdec.html = '&#60;';\n\t\t\tdec.css = 'font-size:32px;font-weight:bold;color:#FFFFFF; line-height:90%;';\n\t\t\tdec.padding = '0 10';\n\t\t\t\n\t\t\tinc.vr_timeout = changedelay * 1000;\n\t\t\tdec.vr_timeout = changedelay * 1000;\n\t\t\tinc.ondown = function(){ txt.html = \"\"+callback(+1); inc.enabled = false; setTimeout(function(){ inc.enabled = true; },0); };\n\t\t\tdec.ondown = function(){ txt.html = \"\"+callback(-1); dec.enabled = false; setTimeout(function(){ dec.enabled = true; },0); };\n\t\t\t\n\t\t\ttxt.ctrlchilds = [];\n            txt.ctrlchilds[0] = inc;\n            txt.ctrlchilds[1] = dec;\n\t\t\t\n\t\t\ttxt.updateControl = function()\n\t\t\t{\n\t\t\t\ttxt.html = callback(0);\n\t\t\t}\n\t\t\t\n\t\t\treturn txt;\n\t\t};\n        function vrsetup_dlg_addspace(dlg, customspace)\n\t\t{\n\t\t\tdlg.elements.push(customspace|| padding);\n\t\t};\n\t\t\n\t\tfunction vrsetup_dlg_finish(dlg)\n\t\t{\n\t\t\tvar i;\n            var w=0;\n            var h=0;\n\t\t\tvar waitforsizes=false;\n\t\t\t\n\t\t\tfor (i=0; i < dlg.elements.length; i++)\n\t\t\t{\n\t\t\t\tvar e = dlg.elements[i];\n\t\t\t\tif ( isNaN(e) )\n\t\t\t\t{\n\t\t\t\t\tif ( e.havesize )\n\t\t\t\t\t{\n\t\t\t\t\t\tw = Math.max( w, e.width * 1);\n\t\t\t\t\t\th += e.height * 1;\n\t\t\t\t\t}\n\t\t\t\t\telse\n\t\t\t\t\t{\n\t\t\t\t\t\twaitforsizes = true;\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\telse\n\t\t\t\t{\n\t\t\t\t\th += e;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\tif (waitforsizes)\n\t\t\t{\n\t\t\t\tsetTimeout( function(){ vrsetup_dlg_finish(dlg); }, 16 ); \n\t\t\t}\n\t\t\telse\n\t\t\t{\n\t\t\t\tvar y = 0;\n\t\t\t\t\n\t\t\t\tdlg.bg.width = Math.ceil((w + padding*2)*dlg.scale);\n\t\t\t\tdlg.bg.height = Math.ceil((h + padding*2)*dlg.scale);\n\t\t\t\t\t\n\t\t\t\tfor (i=0; i < dlg.elements.length; i++)\n\t\t\t\t{\n\t\t\t\t\tvar e = dlg.elements[i];\n\t\t\t\t\tif ( isNaN(e) )\n\t\t\t\t\t{\n\t\t\t\t\t\te.oy = Math.round((-h/2 + y) * dlg.scale);\n\t\t\t\t\t\te.visible = true;\n\t\t\t\t\t\t\n\t\t\t\t\t\ty += e.height * 1;\n\t\t\t\t\t\t\n\t\t\t\t\t\tif (e.ctrlchilds )\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tfor (var j=0; j < e.ctrlchilds.length; j++)\n\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\tvar sube = e.ctrlchilds[j];\n\t\t\t\t\t\t\t\tsube.ox = Math.round(((j&1)-0.5) * (-w) * dlg.scale);\n\t\t\t\t\t\t\t\tsube.oy = e.oy;\n\t\t\t\t\t\t\t\tsube.visible = true;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\telse\n\t\t\t\t\t{\n\t\t\t\t\t\ty += e;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\tdlg.bg.visible = true;\n\t\t\t}\n\t\t};\n        function vrsetup_dlg_remove(dlg)\n\t\t{\n\t\t\tvar removefu = dlg.type == 'layer' ? krpano.removelayer : krpano.removehotspot;\n\t\t\t\n\t\t\tvar i;\n            var j;\n\t\t\tfor (i=0; i < dlg.elements.length; i++)\n\t\t\t{\n\t\t\t\tvar e = dlg.elements[i];\n\t\t\t\tif ( isNaN(e) )\n\t\t\t\t{\n\t\t\t\t\tif (e.ctrlchilds )\n\t\t\t\t\t{\n\t\t\t\t\t\tfor (j=0; j < e.ctrlchilds.length; j++)\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tvar sube = e.ctrlchilds[j];\n\t\t\t\t\t\t\tremovefu(sube.name);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\tremovefu(e.name);\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\tremovefu(dlg.bg.name);\n\t\t};\n\t\t\n\t\t\n\t\tfunction vrsetup_webvr_dialog()\n\t\t{\n\t\t\t\n\t\t\tvar dlg = vrsetup_dlg_create('hotspot');\n\t\t\tvrsetup_dlg_addline(dlg, 'WebVR Setup');\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\t\n\t\t\tvrsetup_dlg_addline(dlg, 'Oversampling:', 'font-size:16px;')\n\t\t\tvar ctrl_ss = vrsetup_dlg_addctrl(dlg, 1.0, function(change)\n\t\t\t{\n\t\t\t\tvar p = webvr.oversampling;\n\t\t\t\t\n\t\t\t\tif (change < 0) { p = Math.max(0.2, Number(p) - 0.1); webvr.oversampling = p;  } else \n\t\t\t\tif (change > 0) { p = Math.min(4.0, Number(p) + 0.1); webvr.oversampling = p;  }\n\t\t\t\t\n\t\t\t\tkrpano.actions.delayedcall(0.3, function()\n\t\t\t\t{\n\t\t\t\t\trenderres.html = webvr.renderwidth + \"x\" + webvr.renderheight;\n\t\t\t\t});\n\t\t\t\t\n\t\t\t\treturn p.toFixed(1);\n\t\t\t});\n\t\t\tvrsetup_dlg_addspace(dlg,8);\n\t\t\tvrsetup_dlg_addline(dlg, 'Rendering Resolution:', 'font-size:16px;');\n\t\t\tvar renderres = vrsetup_dlg_addline(dlg, '');\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'CLOSE', '', vrsetup_close);\n\t\t\tvrsetup_dlg_finish(dlg);\n\t\t\t\n\t\t\treturn dlg;\n\t\t};\n\n        function vrsetup_mobilevr_dialog()\n\t\t{\n\t\t\tvar dlg = vrsetup_dlg_create(0 ? 'hotspot' : 'layer');\n\t\t\tvrsetup_dlg_addline(dlg, 'MobileVR SETUP');\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'Screensize (inch):', 'font-size:16px;')\n\t\t\tvrsetup_dlg_addctrl(dlg, 1.0, function(change){ var ss = Number(webvr.mobilevr_screensize); if (isNaN(ss)) ss = 5.0; if (change < 0) { ss = Math.max(4.0, ss - 0.1); webvr.mobilevr_screensize = ss; } else if (change > 0) { ss = Math.min(10.0, ss + 0.1); webvr.mobilevr_screensize = ss; } return ss.toFixed(1); });\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'VR Headset Preset:', 'font-size:16px;')\n\t\t\tvar ctrl_ps = vrsetup_dlg_addctrl(dlg, 1.0, function(change)\n\t\t\t{\n\t\t\t\tvar preset_index = -1;\n\t\t\t\tvar i;\n\t\t\t\t\n\t\t\t\tvar profile = webvr.mobilevr_profile;\n\t\t\t\tvar presets = krpano.get(\"mobilevr_presets.headset\");\n\t\t\t\tif (presets)\n\t\t\t\t{\n\t\t\t\t\tpresets = presets.getArray();\n\t\t\t\t\t\n\t\t\t\t\tfor (i=0; i < presets.length; i++)\n\t\t\t\t\t{\n\t\t\t\t\t\tif ( profile == presets[i].profile )\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tpreset_index = i;\n\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\tif (change < 0)\n\t\t\t\t\t{\n\t\t\t\t\t\tpreset_index--;\n\t\t\t\t\t\tif (preset_index < 0)\n\t\t\t\t\t\t\tpreset_index = presets.length - 1;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\twebvr.mobilevr_profile = presets[preset_index].profile;\n\t\t\t\t\t}\n\t\t\t\t\telse if (change > 0)\n\t\t\t\t\t{\n\t\t\t\t\t\tpreset_index++;\n\t\t\t\t\t\tif (preset_index >= presets.length)\n\t\t\t\t\t\t\tpreset_index = 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\twebvr.mobilevr_profile = presets[preset_index].profile;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\tif (preset_index >= 0)\n\t\t\t\t{\n\t\t\t\t\treturn presets[preset_index].caption;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\treturn 'Custom';\n\t\t\t});\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'Customize Headset', 'font-size:25px;', function()\n\t\t\t{\n\t\t\t\tvrsetup_dlg_remove(dlg); \n\t\t\t\tdlg=null; \n\t\t\t\t\n\t\t\t\tvrsetup_dialog = vrsetup_mobilevr_interactive_dialog();\n\t\t\t\t\n\t\t\t});\n\t\t\tvrsetup_dlg_addline(dlg, '(Interactive Adjustment in VR)', 'font-size:12px;');\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'CLOSE', '', vrsetup_close);\n\t\t\tvrsetup_dlg_finish(dlg);\n\t\t\t\n\t\t\treturn dlg;\n\t\t};\n\t\t\n\t\tfunction vrsetup_mobilevr_interactive_dialog()\n\t\t{\n\t\t\t\n\t\t\tvar ctrl_preset;\n            var ctrl_fov;\n            var ctrl_ild;\n            var ctrl_stl;\n            var ctrl_ttl;\n            var ctrl_k1;\n            var ctrl_k2;\n            var ctrl_os;\n\t\t\t\n\t\t\tvar dlg = vrsetup_dlg_create('hotspot');\n\t\t\tvrsetup_dlg_addline(dlg, 'MobileVR SETUP');\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'Preset:', 'font-size:16px;')\n\t\t\t\n\t\t\tctrl_preset = vrsetup_dlg_addctrl(dlg, 1.0, function(change)\n\t\t\t{\n\t\t\t\tvar preset_index = -1;\n\t\t\t\tvar i;\n\t\t\t\t\n\t\t\t\tvar profile = webvr.mobilevr_profile;\n\t\t\t\tvar presets = krpano.get(\"mobilevr_presets.headset\");\n\t\t\t\tif (presets)\n\t\t\t\t{\n\t\t\t\t\tpresets = presets.getArray();\n\t\t\t\t\t\n\t\t\t\t\tfor (i=0; i < presets.length; i++)\n\t\t\t\t\t{\n\t\t\t\t\t\tif ( profile == presets[i].profile )\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tpreset_index = i;\n\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\tif (change < 0)\n\t\t\t\t\t{\n\t\t\t\t\t\tpreset_index--;\n\t\t\t\t\t\tif (preset_index < 0)\n\t\t\t\t\t\t\tpreset_index = presets.length - 1;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\twebvr.mobilevr_profile = presets[preset_index].profile;\n\t\t\t\t\t}\n\t\t\t\t\telse if (change > 0)\n\t\t\t\t\t{\n\t\t\t\t\t\tpreset_index++;\n\t\t\t\t\t\tif (preset_index >= presets.length)\n\t\t\t\t\t\t\tpreset_index = 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\twebvr.mobilevr_profile = presets[preset_index].profile;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\tif (change != 0)\n\t\t\t\t\t{\n\t\t\t\t\t\tctrl_fov.updateControl();\n\t\t\t\t\t\tctrl_ild.updateControl();\n\t\t\t\t\t\tctrl_stl.updateControl();\n\t\t\t\t\t\tif (ctrl_ttl) ctrl_ttl.updateControl();\n\t\t\t\t\t\tctrl_k1.updateControl();\n\t\t\t\t\t\tctrl_k2.updateControl();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t\tif (preset_index >= 0)\n\t\t\t\t{\n\t\t\t\t\treturn presets[preset_index].caption;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\treturn 'Custom';\n\t\t\t});\n\t\t\t\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'Lens-Field-of-View:', 'font-size:16px;');\n\t\t\tctrl_fov = vrsetup_dlg_addctrl(dlg, 0.25, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[0] = Number(p[0]) - 1.0; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[0] = Number(p[0]) + 1.0; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[0]).toFixed(0); });\n\t\t\tvrsetup_dlg_addspace(dlg, 8);\n\t\t\tvrsetup_dlg_addline(dlg, 'Inter-Lens-Distance (mm):', 'font-size:16px;');\n\t\t\tctrl_ild = vrsetup_dlg_addctrl(dlg, 0.25, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[1] = Number(p[1]) - 1.0; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[1] = Number(p[1]) + 1.0; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[1]).toFixed(0); });\n\t\t\tvrsetup_dlg_addspace(dlg, 8);\n\t\t\tvrsetup_dlg_addline(dlg, 'Screen-to-Lens-Distance (mm):', 'font-size:16px;');\n\t\t\tctrl_stl = vrsetup_dlg_addctrl(dlg, 0.25, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[2] = Number(p[2]) - 1.0; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[2] = Number(p[2]) + 1.0; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[2]).toFixed(0); });\n\t\t\tvrsetup_dlg_addspace(dlg, 8);\n\t\t\tif (!webvr.isfake)\n\t\t\t{\n\t\t\t\tvrsetup_dlg_addline(dlg, 'Tray-to-Lens-Center-Distance: (mm):', 'font-size:16px;');\n\t\t\t\tctrl_ttl = vrsetup_dlg_addctrl(dlg, 0.25, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[3] = Number(p[3]) - 1.0; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[3] = Number(p[3]) + 1.0; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[3]).toFixed(0); });\n\t\t\t\tvrsetup_dlg_addspace(dlg, 8);\n\t\t\t}\n\t\t\tvrsetup_dlg_addline(dlg, 'Lens-Distortion Coefficients:', 'font-size:16px;');\n\t\t\tctrl_k1 = vrsetup_dlg_addctrl(dlg, 0.1, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[4] = Number(p[4]) - 0.01; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[4] = Number(p[4]) + 0.01; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[4]).toFixed(3); });\n\t\t\tctrl_k2 = vrsetup_dlg_addctrl(dlg, 0.1, function(change){ var p = webvr.mobilevr_profile.split(\"|\"); if (change < 0) { p[5] = Number(p[5]) - 0.01; webvr.mobilevr_profile = p.join(\"|\"); } else if (change > 0) { p[5] = Number(p[5]) + 0.01; webvr.mobilevr_profile = p.join(\"|\"); } if (change != 0) ctrl_preset.updateControl(); return Number(p[5]).toFixed(3); });\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'Oversampling:', 'font-size:16px;');\n\t\t\tctrl_os = vrsetup_dlg_addctrl(dlg, 0.25, function(change){ var p = webvr.oversampling; if (change < 0) { p = Math.max(0.2, Number(p) - 0.1); webvr.oversampling = p;  } else if (change > 0) { p = Math.min(4.0, Number(p) + 0.1); webvr.oversampling = p;  } return p.toFixed(1); });\n\t\t\tvrsetup_dlg_addspace(dlg);\n\t\t\tvrsetup_dlg_addline(dlg, 'CLOSE', '', vrsetup_close);\n\t\t\tvrsetup_dlg_finish(dlg);\n\t\t\t\n\t\t\treturn dlg;\n\t\t};\n\t\t\n\t\tvar vrsetup_dialog = null;\n\t\tvar vrsetup_events = null;\n\t\t\n\n\t\tfunction vrsetup_close()\n\t\t{\n\t\t\tif (vrsetup_dialog)\n\t\t\t{\n\t\t\t\twebvr.savesettings();\n\t\t\t\n\t\t\t\tvrsetup_dlg_remove(vrsetup_dialog); \n\t\t\t\tvrsetup_dialog = null;\n\t\t\t}\n\t\t\n\t\t\tif (vrsetup_events)\n\t\t\t{\n\t\t\t\tkrpano.events.removeItem(vrsetup_events.name);\n\t\t\t\tvrsetup_events = null;\n\t\t\t}\n\t\t};\n\t\t\n\t\tkrpano.vrsetup_close = function()\n\t\t{\n\t\t\tvrsetup_close();\n\t\t};\n\t\t\n\t\tkrpano.vrsetup_open_js = function()\n\t\t{\n\t\t\tif (vrsetup_dialog != null)\n\t\t\t{\n\t\t\t\t\n\t\t\t\treturn;\n\t\t\t}\n\t\t\t\t\n\t\t\tif (webvr.iswebvr)\n\t\t\t{\n\t\t\t\tvrsetup_dialog = vrsetup_webvr_dialog();\n\t\t\t}\n\t\t\telse\n\t\t\t{\n\t\t\t\tvrsetup_dialog = vrsetup_mobilevr_dialog();\n\t\t\t}\n\t\t\t\n\t\t\tvrsetup_events = krpano.events.createItem(\"auto\");\n\t\t\tvrsetup_events.keep = true;\n\t\t\t\n\t\t\tvrsetup_events.webvr_onexitvr = function()\n\t\t\t{\n\t\t\t\tvrsetup_close();\n\t\t\t}\n\t\t};\n                \n            ]]></action>\n            " + ("\n        <action name=\"animation0\">\n    skin_view_littleplanet_immediately();\n    set(view.fov, 105);\n    set(view.vlookat, 0);\n    copy(toHlookatValue, view.hlookat);\n    add(toHlookatValue,360);\n    tween(view.hlookat, get(toHlookatValue), 15, easeInOutSine,\n        complate_animation();\n    );\n</action>\n\n<action name=\"animation2\">\n    skin_view_ball_immediately();\n    set(view.fov, 70);\n    set(view.fovmax, 179);\n    set(view.vlookat, 0);\n    tween(view.hlookat, 360.0, 7.5, easeInOutSine);\n    tween(view.fov, 120.0, 7.5, easeInOutSine,\n        tween(view.hlookat, 720.0, 7.5, easeInOutSine);\n        tween(view.fov, 70.0, 7.5, easeInOutSine,\n            complate_animation();\n        );\n    );\n</action>\n\n<action name=\"animation1\">\n    skin_view_littleplanet_immediately();\n    set(view.fov, 70);\n    set(view.vlookat, -40);\n    tween(view.vlookat, 90, 9, easeInOutSine);\n    delayedcall(animation2_0,2,\n        tween(view.hlookat, 360.0, 7.5, easeInOutSine);\n        tween(view.fov, 150.0, 7.5, easeInOutSine);\n        delayedcall(animation2_1,8,\n            tween(view.vlookat, 20.0, 5, easeInOutSine);\n            tween(view.fov, 100.0, 5, easeInOutSine,\n                complate_animation();\n            );\n        );\n    );\n</action>\n\n<action name=\"animation3\">\n    skin_view_littleplanet_immediately();\n    set(view.fov, 150);\n    set(view.vlookat, -65);\n    tween(view.vlookat, 90.0, 9.5, easeInOutSine);\n    tween(view.hlookat, -360.0, 9.5, easeInOutSine);\n    delayedcall(animation3_0,10,\n        tween(view.fov, 100.0, 5, easeInOutSine);\n        tween(view.vlookat, 20.0, 5, easeInOutSine,\n            complate_animation();\n        );\n    );\n</action>\n\n<action name=\"animation4\">\n    set(view.fov, 105);\n    set(view.vlookat, 0);\n    tween(view.hlookat, 360.0, 7, easeInOutSine);\n    delayedcall(animation4_0,3,\n        tween(view.fov, 150, 4, easeInOutSine);\n        tween(view.vlookat, 90, 4, easeInOutSine);\n        tween(view.fisheye, 1.0, 4, easeInOutSine,\n            \n            delayedcall(animation4_1,1,\n                tween(view.hlookat, 720.0, 7, easeInOutSine,\n                    complate_animation();\n                );\n                tween(view.fisheye, 0, 4, easeInOutSine);\n                tween(view.vlookat, 0, 4, easeInOutSine);\n                tween(view.fov, 105, 4, easeInOutSine);\n            );\n            \n        );\n    );\n</action>\n<action name=\"skin_view_littleplanet_immediately\">\n  set(view.architectural, 0.0);\n  set(backtonormalfirst,false);\n  set(view.pannini, false);\n  set(view.stereographic, true);\n  set(view.fovmax, 150);\n  set(view.fov, 150);\n  set(view.fisheye, 1.0);\n</action>\n\n<action name=\"skin_view_ball_immediately\">\n  set(view.architectural, 0.0);\n  set(view.pannini, 0.0);\n  set(view.distortion,    1.8);\n</action>\n<action name=\"stop_custom_animation\">\n    stoptween(view.fisheye);\n    set(view.fisheye,0);\n    stoptween(view.fov);\n    stoptween(view.hlookat);\n    stoptween(view.vlookat);\n    stopdelayedcall(animation2_0);\n    stopdelayedcall(animation2_1);\n    stopdelayedcall(animation3_0);\n    stopdelayedcall(animation4_0);\n    stopdelayedcall(animation4_1);\n</action>\n<action name=\"complate_animation\">\n    jscall(\"if(window.panoPlayers['" + this.id + "'].callbacks.onPlayCustomAnimationComplete){window.panoPlayers['" + this.id + "'].callbacks.onPlayCustomAnimationComplete();};\");\n</action>\n\n        ");
  };

  _proto.hexColor = function hexColor(str) {
    if (str[0] == '#') {
      return str;
    }

    return '#' + parseInt(str).toString(16);
  };

  _proto.colorValue = function colorValue(str) {
    if (str[0] == '#') {
      return parseInt(str.replace(/#/g, ''), 16);
    }

    return parseInt(str);
  };

  _createClass(Player, [{
    key: "__videoPlugin",
    get: // debug = false;
    function get() {
      return this.__pluginPath + "videoplayer1.js";
    }
  }, {
    key: "__videoLayerPlugin",
    get: function get() {
      return "./three.krpanoplugin.js"; // __videoLayerPlugin = "http://192.168.1.106:5501/src/three.krpanoplugin.js";
    }
  }, {
    key: "__imageBorderImage",
    get: function get() {
      return "https://ssl-player2.720static.com/krp/edit/hotspot_selected_bg.png";
    }
  }, {
    key: "__radarPlugin",
    get: function get() {
      return this.__pluginPath + "radar_hotspot_plugin.js";
    }
  }, {
    key: "__snowPlugin",
    get: // __radarPlugin = "http://127.0.0.1:5501/dist/plugins/radar.js.backup-2022-01-05-15-29-56.js"
    function get() {
      return this.__pluginPath + "snow.js";
    }
  }, {
    key: "__lensFlarePlugin",
    get: function get() {
      return this.__pluginPath + "lensflare45";
    }
  }, {
    key: "__customAnimationPlugin",
    get: function get() {
      return this.__pluginPath + "moretweentypes.js";
    }
  }]);

  return Player;
}();

export { Player as default };